import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const STORAGE_KEY = "buildflow.lang";

const resources = {
  en: {
    translation: {
      brand: "BuildProject360",
      tagline: "Photos, logs, and the whole job. Simpler. Cheaper. Bilingual.",
      // Nav
      nav_home: "Home",
      nav_projects: "Projects",
      nav_photos: "Photos",
      nav_schedule: "Schedule",
      nav_crew: "Crew",
      // Actions
      action_new_project: "New Project",
      action_add_photo: "Add Photo",
      action_new_log: "New Log",
      action_share: "Share with customer",
      action_save: "Save",
      action_edit: "Edit",
      bg_title: "360 Assistant",
      bg_subtitle: "Your AI project assistant",
      bg_welcome: "Hi, {{name}}. I’m your 360 Assistant. I can answer questions, find project information, create projects, build schedules, prepare updates and help with everyday tasks. You’ll always review changes before I save them. What can I help with?",
      bg_new_chat: "New chat",
      bg_no_history: "No previous chats",
      bg_empty: "Ask anything about your projects, schedule, or the app. I can also draft customer updates for you to review.",
      bg_chip1: "Summarize my active projects",
      bg_chip2: "Draft a customer update",
      bg_chip3: "Where do I find invoices?",
      bg_error: "360 Assistant is unavailable right now. Please try again.",
      bg_actions: "AI Drafts (review before saving)",
      bg_pick_project: "Pick a project…",
      bg_draft_morning_plan: "Morning plan",
      bg_draft_evening_report: "Evening report",
      bg_draft_customer_update: "Customer update",
      bg_draft_badge: "Draft",
      bg_draft_saved: "Saved ✓",
      bg_confirm_save: "Confirm & save",
      tc_offline_saved: "Saved offline — will sync when back online",
      fin_labor_title: "Labor vs Estimates",
      portal_ask_title: "Ask about your project",
      portal_ask_empty: "Ask anything about this project — progress, schedule, what's next.",
      portal_ask_placeholder: "Type your question…",
      bg_briefing_title: "Today's briefing",
      bg_briefing_none: "No jobs scheduled today.",
      bg_briefing_reviews: "{{count}} timecard(s) need review",
      bgv_title: "Ask Assistant",
      bgv_prompt: "What would you like me to do?",
      bgv_listening: "Listening… tap to stop",
      bgv_tap_to_speak: "Tap to speak",
      bgv_transcript_ph: "Your request (edit if needed)…",
      bgv_submit: "Submit",
      bgv_try_again: "Try again",
      bgv_review_create_project: "Create New Project",
      bgv_review_create_customer: "Create New Customer",
      bgv_review_find_project: "Projects Found",
      bgv_review_find_customer: "Customers Found",
      bgv_row_customer: "Customer",
      bgv_row_new_customer: "New customer",
      bgv_row_project: "Project",
      bgv_row_project_type: "Type",
      bgv_row_address: "Address",
      bgv_row_start_date: "Start date",
      bgv_row_notes: "Notes",
      bgv_row_customer_name: "Customer name",
      bgv_row_project_name: "Project name",
      bgv_choose_customer: "Which customer did you mean?",
      bgv_create_new_customer: "Create new customer",
      bgv_confirm: "Confirm",
      bgv_pending_approval: "Sent for approval",
      bgv_review_delete_project: "Delete Project",
      bgv_review_delete_customer: "Delete Customer",
      bgv_review_delete_photos: "Delete Photos",
      bgv_open_projects: "Open Projects",
      bgv_open_customers: "Open Customers",
      bgv_open_photos: "Open Photos",
      bgv_row_photo_date: "Photos from",
      apr_title: "Pending Approvals",
      apr_sub: "Destructive assistant requests waiting for an owner/admin decision.",
      apr_approve: "Approve & Execute",
      apr_reject: "Reject",
      apr_approved: "Approved and executed",
      apr_rejected: "Request rejected",
      apr_requested_by: "Requested by",
      apr_already_decided: "Already decided by another admin",
      ref3_headline: "Refer 3. Yours Is Free.",
      ref3_desc: "Every contractor you refer who stays an active paying customer for 60+ days takes 1/3 off your base plan — one referral is 1/3 off, two is 2/3 off, three or more and your base plan is free. Extra seats are never discounted. They get their first paid month free.",
      ref3_of3: "{{n}} of 3 active referrals",
      ref3_away: "Right now you're getting {{pct}}% off your base plan — {{n}} more active referral(s) and BuildProject360 is free.",
      gantt_add_task: "Add task",
      gantt_new_task: "New task",
      gantt_edit_task: "Edit task",
      gantt_task_name: "Task name",
      gantt_start_date: "Start date",
      gantt_depends_on: "Depends on",
      gantt_no_dependency: "None (chain after previous)",
      gantt_assignee_label: "Assignee",
      gantt_locked_label: "Locked — never moves in cascades",
      gantt_undo: "Undo",
      gantt_moved: "Moved — {{n}} dependent task(s) shifted",
      gantt_undone: "Change undone",
      gantt_delete_task: "Delete",
      gantt_delete_confirm: "Tap again to delete",
      gantt_empty: "No tasks yet — add one or apply a template.",
      tpl_deck: "Deck build",
      tpl_d_1: "Tear off old deck",
      tpl_d_2: "Footings & posts",
      tpl_d_3: "Framing",
      tpl_d_4: "Decking boards",
      tpl_d_5: "Rails & finish",
      ref3_qualified: "You did it! Three contractors joined through your referral. Your base BuildProject360 subscription is now free while all three accounts remain active.",
      ref3_share_msg: "I've been using BuildProject360 to organize project photos, schedules, job updates, customers and paperwork. I thought it might help your company too. You can try it here: {{link}}",
      ref3_facebook: "Facebook",
      ref3_grace: "Grace period active: your free base plan continues until {{date}}. Add a replacement referral to keep it free.",
      brand_logo_updated: "Logo updated — all previews refreshed.",
      brand_logo_hint: "PNG, JPG, WebP, HEIC or SVG up to 15 MB. Transparent PNG supported — your aspect ratio is always preserved.",
      brand_err_size: "That logo is too large (max 15 MB). Export a smaller copy and try again.",
      brand_err_type: "That file type isn't supported. Use PNG, JPG, WebP, HEIC or SVG.",
      brand_err_decode: "We couldn't read that image file. Try re-exporting it as PNG or JPG.",
      brand_err_storage: "The upload reached us but storage failed — your current logo is untouched. Please try again.",
      photo_err_too_large: "That photo is too large (max 25 MB). Try a smaller copy.",
      photo_err_type: "That file type isn't supported. Use JPG, PNG, HEIC or WebP.",
      photo_err_decode: "We couldn't read that image. Try exporting it as JPG or PNG.",
      photo_err_network: "Connection interrupted — nothing was saved and your crop is still here. Tap Retry.",
      billing_promo_discount: "Promotional discount",
      billing_discount_expires: "Discount ends",
      billing_comp_seats: "Complimentary seats",
      billing_referral_card_title: "3 & Free",
      billing_referral_card_body: "Refer three contractors. When all three become paying customers, your base plan is free.",
      billing_referral_card_cta: "View referrals",
      perms_title: "Team Permissions",
      perms_sub: "Override role defaults per person. Allow grants a permission; Deny blocks it.",
      perm_default: "Default",
      perm_allow: "Allow",
      perm_deny: "Deny",
      perm_bg_use: "Use Assistant",
      perm_customer_create: "Create customers",
      perm_project_create: "Create projects",
      perm_project_update: "Edit projects",
      perm_schedule_view: "View schedule",
      perm_schedule_create: "Create schedule entries",
      perm_crew_assign: "Assign crew",
      perm_project_update_create: "Post job updates",
      perm_time_self: "Clock in/out",
      perm_correction_create: "Time corrections",
      perm_message_draft: "Draft messages",
      perm_message_send: "Send messages",
      perm_estimate_draft: "Draft estimates",
      perm_co_draft: "Draft change orders",
      perm_fin_view: "View financials",
      perm_delete_records: "Delete records (approval)",
      prof_theme_dark: "Dark",
      bgv_voice_confirm: "Say “Confirm”",
      bgv_unclear: "I didn't clearly hear the confirmation. Please tap Confirm or say Confirm again.",
      bgv_tap_required: "This action needs a tap on Confirm.",
      bgv_edit_hint: "To change something, cancel and edit your request.",
      bgv_similar: "A similar project may already exist.",
      bgv_open_existing: "Open Existing",
      bgv_warn_address: "Address could not be verified — please review it.",
      bgv_warn_newcust: "A new customer record will be created.",
      bgv_missing: "Still needed",
      bgv_success: "Done",
      bgv_failed: "The action failed — nothing was saved.",
      bgv_perm_denied: "You don't have permission for that action.",
      bgv_done: "Done",
      bgv_no_results: "No matches found.",
      bgv_open_project: "Open Project",
      bgv_open_customer: "Open Customer",
      bgv_open_shares: "Manage Share Links",
      bgv_review_find_photos: "Find Photos",
      bgv_review_share_photos: "Share Photos",
      bgv_review_navigate: "Navigate",
      bgv_review_install_app: "Install App",
      bgv_row_photos: "Photos",
      ap_title: "360 Assistant",
      ap_launcher: "360 Assistant",
      sched_prev_period: "Previous",
      sched_next_period: "Next",
      sched_saved_on: "Saved for {{date}}",
      np_name_optional_hint: "optional — defaults to the street address",
      ap_welcome: "Hi! I can schedule work, find photos, draft estimates and more — right from this page. What do you need?",
      ap_start_360: "360 Assistant",
      ap_back_chat: "Back to chat",
      ap_helping: "Helping with: {{name}}",
      ap_general: "General assistance",
      ap_clear_context: "Clear context",
      ap_placeholder: "Ask or tell me what to do…",
      ap_send: "Send",
      ap_clear: "Clear conversation",
      ap_expand: "Open full assistant page",
      ap_close: "Close assistant",
      ap_stop: "Stop recording",
      ap_tap_mic: "Speak",
      ap_total: "{{count}} total — open the page to see all",
      ap_qa_create_project: "Create Project",
      ap_qa_create_project_sample: "Create a project for ",
      ap_qa_build_schedule: "Build Schedule",
      ap_qa_build_schedule_sample: "Build a workday-only schedule for this project",
      ap_qa_add_update: "Add Job Update",
      ap_qa_add_update_sample: "Add a job update: ",
      ap_qa_find_photos: "Find Photos",
      ap_qa_find_photos_sample: "Find photos taken yesterday",
      ap_qa_schedule_work: "Schedule Work",
      ap_qa_schedule_work_sample: "Schedule work for this project on ",
      ap_qa_money_collected: "Collected this month",
      ap_qa_money_collected_sample: "How much did I collect this month?",
      ap_qa_money_who_owes: "Who owes me",
      ap_qa_money_who_owes_sample: "Who owes me money right now, and how much?",
      ap_qa_money_losing: "Jobs losing money",
      ap_qa_money_losing_sample: "Which jobs are losing money, and by how much?",
      ap_qa_share_photos: "Share Photos",
      ap_qa_share_photos_sample: "Share all photos from this project",
      ap_qa_create_task: "Create Task",
      ap_qa_create_task_sample: "Add a task to ",
      ap_qa_assign_photos: "Assign Photos",
      ap_qa_assign_photos_sample: "Assign the selected photos to ",
      ap_qa_share_selected: "Share Selected",
      ap_qa_share_selected_sample: "Share the selected photos",
      ap_qa_create_report: "Create Report",
      ap_qa_create_report_sample: "Create a photo report for ",
      ap_qa_view_projects: "View Projects",
      ap_qa_view_projects_sample: "Show this customer's active projects",
      ap_qa_draft_message: "Draft Message",
      ap_qa_draft_message_sample: "Draft a message to the customer: ",
      ap_qa_reschedule: "Reschedule Work",
      ap_qa_reschedule_sample: "Move scheduled work to ",
      ap_qa_available_days: "Show Available Days",
      ap_qa_available_days_sample: "Show available days this week",
      ap_qa_draft_estimate: "Draft Estimate",
      ap_qa_draft_estimate_sample: "Draft an estimate for ",
      ap_qa_find_invoice: "Find Invoice",
      ap_qa_find_invoice_sample: "Find invoice ",
      ap_qa_payment_reminder: "Draft Payment Reminder",
      ap_qa_payment_reminder_sample: "Draft a payment reminder for ",
      ap_qa_create_project_customer: "Create Project",
      ap_qa_create_project_customer_sample: "Create a project for this customer",
      bgv_audit: "Action history",
      bgv_none: "No actions yet",
      bgv_chip_create_customer: "Create a Customer",
      bgv_chip_create_project: "Create a Project",
      bgv_chip_schedule: "Schedule Work",
      bgv_chip_job_update: "Add a Job Update",
      bgv_chip_task: "Add a Task",
      bgv_chip_find_project: "Find a Project",
      bgv_chip_start_day: "Start My Day",
      bgv_chip_finish_day: "Finish My Day",
      bgv_chip_estimate: "Draft an Estimate",
      bgv_chip_change_order: "Draft a Change Order",
      bgv_chip_customer_message: "Draft a Customer Message",
      bgv_chip_create_customer_sample: "Create a customer named ",
      bgv_chip_create_project_sample: "Create a new project for ",
      bgv_chip_schedule_sample: "Schedule work on ",
      bgv_chip_job_update_sample: "Add an update that ",
      bgv_chip_task_sample: "Add a task to ",
      bgv_chip_find_project_sample: "Find the project ",
      bgv_chip_start_day_sample: "Start my day",
      bgv_chip_finish_day_sample: "Finish my day",
      bgv_chip_estimate_sample: "Draft an estimate for ",
      bgv_chip_change_order_sample: "Draft a change order for ",
      bgv_chip_customer_message_sample: "Tell the customer ",
      bgv_driving: "Driving Mode",
      bgv_driving_note: "Driving Mode: searches and drafts only. Requests are saved as drafts — review them when you are safely stopped. Never interact while driving.",
      bgv_draft_saved_msg: "I prepared this request as a draft. Please review it when you are safely stopped.",
      bgv_pending_drafts: "Drafts to review",
      bgv_choose: "Which one did you mean?",
      bgv_need_ack: "There is a schedule conflict. Confirm again to double-book.",
      bgv_ack_conflicts: "Keep Anyway (double-book)",
      bgv_outside_geofence: "You appear to be outside the project area — use the Time Card screen with a reason.",
      bgv_review_view_schedule: "Schedule",
      bgv_review_check_availability: "Availability",
      bgv_review_create_schedule: "Schedule Work",
      bgv_review_reschedule: "Reschedule Work",
      bgv_review_add_update: "Add Job Update",
      bgv_review_start_day: "Start My Day",
      bgv_review_finish_day: "Finish My Day",
      bgv_review_break_start: "Start Break",
      bgv_review_break_end: "End Break",
      bgv_review_switch_project: "Switch Project",
      bgv_review_correction_request: "Correction Request",
      bgv_review_draft_message: "Send Customer Message",
      bgv_review_draft_estimate: "Draft Estimate",
      bgv_review_draft_change_order: "Draft Change Order",
      bgv_row_date: "Date",
      bgv_row_end_date: "End date",
      bgv_row_time: "Time",
      bgv_row_employees: "Crew",
      bgv_row_update: "Update",
      bgv_row_message: "Message",
      bgv_row_items: "Items",
      bgv_row_phases: "Phases",
      bgv_row_finish_date: "Finish date",
      bgv_review_help: "How-To",
      bgv_row_activity: "Activity",
      bgv_row_project_name: "Project name",
      bgv_row_local_time: "Local time",
      bgv_row_customer_name: "Customer name",
      bgv_open_schedule: "Open Schedule",
      bgv_open_timecard: "Open Time Card",
      bgv_open_financials: "Open Estimates & Invoices",
      nav_plan_billing: "Plan & Billing",
      nav_my_day: "My Day",
      nav_help: "Help",
      photos_filter_open: "Filter",
      photos_clear_filters: "Clear all",
      action_done: "Done",
      nav_group_work: "Work",
      nav_group_team: "Team",
      nav_group_sales: "Sales",
      nav_group_company: "Company",
      nav_group_account: "Account",
      nav_assistant_activity: "Assistant Activity",
      nav_language: "Language",
      profile_menu: "Account menu",
      home_today_title: "Today's jobs",
      home_coming_up: "Coming up",
      home_start_day: "Start My Day",
      home_finish_day: "Finish My Day",
      home_clocked_in_at: "Clocked in at {{project}}",
      home_not_clocked: "Not clocked in",
      home_est_awaiting: "Estimates awaiting approval",
      home_inv_overdue: "Overdue invoices",
      home_missing_evening: "Missing evening updates",
      home_all_clear: "Nothing pending — nice work.",
      home_ask_bg: "Ask Assistant",
      home_add_update: "Add Job Update",
      home_next_up: "Next up",
      home_stats_title: "Business snapshot",
      proj_search_ph: "Search projects…",
      proj_filter_active: "Active",
      proj_filter_completed: "Completed",
      proj_filter_archived: "Archived",
      proj_sort_recent: "Recently updated",
      proj_sort_name: "Name",
      proj_sort_customer: "Customer",
      proj_sort_next: "Next scheduled",
      proj_sort_label: "Sort",
      proj_filter_status: "Status",
      proj_filter_my: "My Projects",
      proj_filter_attention: "Needs Attention",
      proj_badge_overdue: "Overdue",
      proj_updated: "Updated",
      proj_more_filters: "Filter",
      home_recent_progress: "Recent Progress",
      home_needs_attention: "Needs Attention",
      home_add_schedule: "Add to Schedule",
      home_nothing_today: "Nothing scheduled today",
      proj_view_list: "List view",
      proj_view_cards: "Card view",
      proj_view_detailed: "Detailed list",
      proj_view_map: "Map view",
      proj_menu_open: "Open Project",
      proj_menu_photo: "Take Photo",
      proj_menu_schedule: "Add to Schedule",
      proj_menu_task: "Add Task",
      proj_menu_share: "Share with Customer",
      proj_status_confirm_title: "Update project status",
      proj_status_confirm_ok: "Yes, continue",
      proj_last_activity: "Last activity",
      proj_open_tasks: "{{count}} open tasks",
      proj_docs_count: "{{count}} files",
      proj_map_no_loc: "{{count}} projects have no map location yet",
      proj_map_empty: "No project locations to show yet",
      proj_next_none: "No upcoming work",
      proj_next_prefix: "Next",
      proj_menu_duplicate: "Duplicate project",
      nav_time_crew: "Time & Crew",
      notif_eod_uses_cal: "End-of-day reminder fires at your Work hours end time (Settings › Work calendar).",
      photos_loading_more: "Loading more photos…",
      brand_legal_name: "Legal name (shown on estimates & invoices)",
      proj_photos_count: "{{count}} Photos",
      proj_logs_count: "{{count}} Logs",
      proj_menu_edit: "Edit",
      proj_menu_complete: "Complete",
      proj_menu_archive: "Archive",
      proj_menu_restore: "Restore project",
      proj_status_lead: "Lead",
      proj_status_scheduled: "Scheduled",
      proj_status_in_progress: "In progress",
      proj_status_on_hold: "On hold",
      proj_status_done: "Completed",
      pd_complete_title: "Project completed",
      pd_complete_body: "Nice work. Send the final photos or build the closeout package?",
      pd_complete_photos: "Send final photos to customer",
      pd_complete_closeout: "Create closeout package",
      pd_complete_review: "Ask for a Google review",
      proj_gone_title: "This project was deleted or archived",
      proj_gone_body: "The link you opened is no longer available.",
      proj_gone_back: "Back to Projects",
      rev_title: "Ask for a Google review",
      rev_subtitle: "Happy customers grow your business. Send a quick review request.",
      rev_tab_text: "Text",
      rev_tab_email: "Email",
      rev_name_ph: "Customer name",
      rev_phone_ph: "Customer phone",
      rev_email_ph: "Customer email",
      rev_link_label: "Your Google review link",
      rev_link_help: "Google Business Profile › Ask for reviews. Paste the link here — we'll save it.",
      rev_msg_label: "Message",
      rev_msg_default: "Hi {{name}}, thank you for choosing {{company}}! Would you mind leaving us a quick Google review? It takes a minute and helps our small business a lot. {{link}}",
      rev_send_text: "Open Messages to send",
      rev_send_email: "Send email",
      rev_sent_email: "Review request emailed",
      rev_no_link: "Add your Google review link first",
      rev_no_phone: "Add the customer's phone first",
      rev_no_email: "Add the customer's email first",
      cl_title: "Starter checklists",
      cl_subtitle: "Add a proven checklist to this project. Check items off right here on the job page.",
      cl_apply: "Add",
      cl_added_short: "Added",
      cl_added: "Checklist added — {{count}} tasks created",
      cl_already: "That checklist is already on this project",
      cl_items: "{{count}} items",
      cl_photo_req: "Photo",
      cl_open: "Checklists",
      cl_progress: "{{done}} of {{total}} done",
      pd_act_checklist: "Checklist started: {{name}}",
      cl_photo_add: "Add photo",
      task_photo_chip: "Photo required",
      task_photo_required: "Attach a photo before marking this done",
      ep_type: "Project type",
      ep_crew: "Assigned crew",
      ep_start: "Start date",
      ep_end: "End date",
      ep_status: "Status",
      ep_notes: "Notes",
      ap_working: "Working…",
      ap_opened_review: "Opened the 360 review — approve to save.",
      u360_mic_blocked_type: "Microphone blocked — type instead",
      proj_restored_toast: "Project restored",
      proj_archive_future: "This job has {{count}} upcoming item(s). Remove them?",
      proj_archive_future_one: "This job has {{count}} upcoming item. Remove it?",
      proj_archive_remove: "Remove",
      proj_archive_keep: "Keep",
      err_project_archived: "This project is archived — restore it before scheduling new work.",
      proj_menu_delete: "Delete",
      proj_delete_title: "Delete project?",
      proj_delete_body: "This permanently deletes the project and cannot be undone.",
      proj_delete_confirm: "Yes, delete",
      dz_title: "Danger Zone",
      dz_explain: "Deleting a project removes it from your active workspace. The project can be restored from Trash for 30 days before permanent deletion.",
      dz_move: "Move Project to Trash",
      dz_confirm_title: "Move project to Trash?",
      dz_type_hint: "Type the exact project name to confirm:",
      dz_share_warn: "Customer share links will be disabled.",
      dz_stats: "Photos: {{photos}} · Documents: {{docs}} · Estimates: {{est}} · Invoices: {{inv}}",
      dz_moved: "Project moved to Trash",
      trash_title: "Trash",
      trash_hint: "Projects in Trash can be restored within 30 days. Permanent deletion is only possible here and never removes legally required financial records.",
      trash_empty: "Trash is empty.",
      trash_deleted_on: "Deleted",
      trash_days_left_one: "{{count}} day remaining",
      trash_days_left_other: "{{count}} days remaining",
      trash_restore: "Restore",
      trash_restored: "Project restored",
      trash_restore_note: "Share links stay disabled — create a new share link if needed.",
      trash_perm: "Delete permanently",
      trash_perm_title: "Permanently delete project?",
      trash_perm_body: "This cannot be undone. Photos, documents and non-financial data will be removed. Type DELETE to confirm.",
      trash_perm_done: "Project permanently deleted",
      trash_retained_title: "Financial records must be kept",
      trash_retained_body: "This project has invoices or payments. Financial records must be retained under the Terms and record-keeping rules, so this project cannot be permanently deleted. It can stay in Trash (hidden from your workspace) or be restored.",
      settings_tools: "Settings & Tools",
      settings_trash: "Trash",
      settings_trash_hint: "Restore or permanently delete projects moved to Trash.",
      photos_create_project: "Create New Project",
      photos_search_projects: "Search projects…",
      photos_no_matches: "No matching projects",
      photos_select_to_add: "Select a project to add photos.",
      share_link_ready: "Share link created",
      land_gps_hero_benefit: "Capture photo proof with automatic date, time, and GPS location.",
      land_gps_hero_sub: "Every jobsite photo can create a trustworthy record of when and where the work happened—helping document progress, verify field activity, support insurance claims, and reduce disputes.",
      land_gps_title: "Photo Proof You Can Trust",
      land_gps_body: "Turn every jobsite photo into reliable project documentation. BuildProject360 automatically records the date, time, and GPS location when a photo is captured, giving contractors a clear record of work completed in the field.",
      land_gps_b1_t: "Automatic date and time stamp",
      land_gps_b2_t: "Automatic GPS location record",
      land_gps_b3_t: "Organized by customer and project",
      land_gps_b4_t: "Reliable documentation for progress, insurance, and disputes",
      land_gps_permission_note: "Location stamping requires the user to grant location permission on their device. You control whether recorded location appears in customer-facing galleries or shared links — it is never shown publicly by default.",
      feat_gps_photos: "Time & Location-Stamped Photos",
      feat_gps_photos_d: "Capture organized jobsite photos with automatic date, local time, and GPS location records.",
      land_gps_cta_callout: "Know what happened, when it happened, and where it happened.",
      land_gps_cta_sub: "Build a dependable visual record of every project from start to finish.",
      land_gps_mock_badge: "Verified capture",
      land_gps_mock_alt: "Construction photo inside the BuildProject360 app with its capture details panel",
      land_gps_mock_ontag: "On-site photo",
      land_gps_mock_project_lbl: "Project",
      land_gps_mock_project_val: "Smith Residence — Roof Replacement",
      land_gps_mock_captured_lbl: "Captured",
      land_gps_mock_captured_val: "Mar 12, 2026 · 2:41 PM",
      land_gps_mock_location_lbl: "Location",
      land_gps_mock_location_val: "Columbus, OH — recorded location",
      land_gps_mock_by_lbl: "Taken by",
      land_gps_mock_by_val: "Mike R. — Crew Lead",
      land_gps_mock_note_lbl: "Note",
      land_gps_mock_note: "Day 3 — roof decking complete.",
      nav_questions: "Questions",
      hero2_h1: "Take the photo. Keep the job moving.",
      hero2_sub: "Jobsite photos with recorded capture details, a clear crew schedule, and updates you can review in one place.",
      cta_start_free: "Start free — 14 days",
      hero2_trust: "No credit card required · 3 users included",
      hero2_shot_alt: "360 Assistant review screen showing drafted daily log, task, schedule entry, and change order waiting for approval",
      a360_eyebrow: "360 Assistant",
      a360_title: "Say the update. Review the next steps.",
      a360_shot_cap: "The real review screen — shown with a demo project.",
      a360_example: "Finished the Smith roof tear-off. Three guys, eight hours. Found six damaged sheets — draft a change order and schedule install tomorrow.",
      a360_out_daily_log: "Daily log",
      a360_out_crew_time: "Crew time",
      a360_out_schedule: "Schedule",
      a360_out_task: "Task",
      a360_out_customer: "Customer update (draft)",
      a360_out_co: "Change order (draft)",
      a360_approval: "Review and edit each draft. Nothing is saved or sent until you approve it.",
      photos3_title: "A clear photo record for every job.",
      photos3_body: "Keep photos organized by project, with capture date and time and recorded location when permission is granted. Review the details before sharing progress with a customer.",
      photos3_gallery_cap: "Share a clean, branded gallery your customer can open without an account.",
      photos3_privacy_note: "Location is recorded only with device permission and is not shown publicly by default.",
      sched3_title: "A schedule the crew can find and follow.",
      sched3_body: "See today's work, plan ahead, and keep jobs connected to the right project and crew.",
      sched3_shot_alt: "BuildProject360 schedule day view showing job names, times, projects, and crew clearly",
      price3_title: "One plan, clear pricing.",
      price3_save: "Save $98 a year",
      price3_seats: "3 users included · Extra users $5/month each",
      price3_g1: "Projects, customers, and leads",
      price3_g2: "Jobsite photos and customer galleries",
      price3_g3: "Crew scheduling, daily logs, and timecards",
      price3_g4: "360 Assistant, tasks, and change orders",
      price3_g5: "Estimates, invoices, and payment tracking",
      price3_g6: "Contractor website and English/Spanish support",
      price3_payments_cs: "Online customer payments",
      price3_no_card: "No credit card required · Cancel anytime",
      faq3_title: "Questions",
      faq3_q1: "How does the 14-day trial work?",
      faq3_a1: "You get full access for 14 days — no credit card up front. When the trial ends, choose a plan to keep working; your photos and records stay in place.",
      faq3_q2: "What does it cost afterward?",
      faq3_a2: "Essentials: $59/month or $49/month billed yearly ($588), 3 users included. Pro: $129/month or $109/month billed yearly ($1,308), 5 users included. Extra users $10/month each.",
      faq3_q3: "How many users are included?",
      faq3_a3: "Three — for example you, an office manager, and a crew lead. Add more anytime for $5/month each.",
      faq3_q4: "Is photo storage limited?",
      faq3_a4: "Your plan sets no photo limit, and originals are preserved.",
      faq3_q5: "Is my data private?",
      faq3_a5: "Yes. Only people in your company see your projects. Customers see only what you share through a gallery link, and recorded photo locations stay inside your account.",
      faq3_q6: "Can I cancel anytime?",
      faq3_a6: "Yes — cancel from the Billing page in the app. You keep access until the end of the paid period.",
      faq3_q7: "How do I install it on my phone?",
      faq3_a7: "Open buildproject360.com in your phone's browser and choose 'Add to Home Screen' — it works like an app, no app store needed.",
      cta3_title: "Ready to document your next job?",
      cta3_body: "Start with a project, a photo, and a clear plan for your crew.",
      hero2_bg_alt_a: "Contractor on a wood-framing jobsite, houses under construction behind him",
      hero2_bg_alt_b: "Nearly finished new-build home with ladder and materials still on site",
      hero2_card_loc_lbl: "Recorded location",
      hero2_card_loc_val: "Columbus, OH",
      hero2_card360_ready: "Drafts ready for review",
      hero2_card360_note: "Nothing is saved until you approve",
      hero2_card360_example: "Example",
      hero2_card_photo_badge: "Photo with recorded location",
      hero2_tag_time: "7:42 AM",
      hero2_tag_title: "Example of the details recorded with each photo",
      pd_tab_overview: "Overview",
      pd_tab_activity: "Activity",
      pd_tab_schedule: "Schedule",
      pd_tab_financials: "Estimates & Invoices",
      pd_tab_more: "More",
      pd_tab_costs: "Costs",
      jc_total_label: "Actual costs so far",
      jc_summary_hint: "Tap a total or category to see the receipts behind it.",
      jc_overlap_badge: "Overlap?",
      jc_overlap_save: "Heads up: this asset's rate already includes {{include}} — possible double-count.",
      jc_overlap_banner: "{{count}} receipt(s) may double-count — already covered by an asset rate.",
      jc_overlap_detail: "This category is already included in the linked asset's rate. Counting both would double-charge this cost.",
      jc_alloc_enable: "Allocate company overhead to projects",
      jc_alloc_hint: "Company-scope expenses are spread across active projects and shown separately — never mixed into direct job costs.",
      jc_alloc_equal: "Split equally across active projects",
      jc_alloc_prorata: "Pro-rata by each project's direct expenses",
      jc_alloc_chip: "Allocated overhead",
      jc_total_with_overhead: "Total incl. allocated overhead",
      jc_billable_row: "Billable value (labor + equipment)",
      jc_pending_banner: "{{count}} receipt(s) waiting for your approval.",
      jc_add_receipt: "Add receipt",
      jc_empty: "No receipts yet",
      jc_empty_hint: "Photograph a receipt and the 360 Assistant will read it for you.",
      jc_no_vendor: "No vendor",
      jc_refund: "Refund",
      jc_dup: "Possible duplicate",
      jc_dup_detail: "A similar receipt (same vendor, date, and total, or the same image) already exists. Check before saving.",
      jc_status_pending: "Pending",
      jc_status_approved: "Approved",
      jc_status_rejected: "Rejected",
      jc_cat_materials: "Materials",
      jc_cat_equipment: "Equipment",
      jc_cat_rental: "Rental",
      jc_cat_subcontractor: "Subcontractor",
      jc_cat_fuel: "Fuel",
      jc_cat_other: "Other",
      jc_cat_repairs: "Repairs",
      jc_cat_maintenance: "Maintenance",
      jc_cat_tools: "Tools",
      jc_cat_insurance: "Insurance",
      jc_cat_registration: "Registration",
      jc_cat_disposal: "Disposal",
      jc_cat_delivery: "Delivery",
      jc_cat_office: "Office",
      jc_scope: "Where does this expense belong?",
      jc_scope_project: "Project expense",
      jc_scope_company: "Company expense",
      jc_asset_optional: "Truck / tool / machine (optional)",
      jc_asset_none: "No asset",
      jc_cat_search_ph: "Search or create category…",
      jc_cat_create: "Create category",
      jc_cat_exists: "That category already exists.",
      jc_cat_archived_note: "Archived — kept for history",
      jc_cats_title: "Custom categories",
      jc_cats_hint: "Reusable across all your projects. Rename or archive anytime — history is preserved.",
      jc_cat_name_ph: "Category name",
      jc_cat_add: "Add category",
      jc_cat_rename: "Rename",
      jc_cat_archive: "Archive",
      jc_cat_unarchive: "Restore",
      jc_cat_empty: "No custom categories yet.",
      jc_expenses: "Expenses",
      fin_expenses: "Expenses",
      jc_filter_vendor: "Vendor",
      jc_filter_from: "From",
      jc_filter_to: "To",
      jc_filter_all_projects: "All projects",
      jc_filter_all_cats: "All categories",
      jc_filter_all_status: "All statuses",
      jc_filter_all_assets: "All assets",
      jc_filter_search: "Search vendor, notes, #",
      jc_filter_apply: "Apply",
      jc_filter_clear: "Clear",
      fin_new_receipt: "Receipt / Expense",
      jc_status_lbl: "Status",
      jc_submitted_by: "Submitted by",
      jc_approved_by: "Approved by",
      jc_number: "Receipt #",
      jc_view_file: "View receipt",
      jc_edit: "Edit",
      jc_approve: "Approve",
      jc_reject: "Reject",
      jc_approved: "Receipt approved",
      jc_rejected: "Receipt rejected",
      jc_saved: "Receipt saved",
      jc_take_photo: "Take a photo",
      jc_upload_file: "Upload image or PDF",
      jc_manual: "Enter manually",
      jc_reading: "Reading your receipt…",
      jc_reading_hint: "The 360 Assistant extracts the vendor, date, and total.",
      jc_ocr_failed: "We couldn't read this receipt clearly. Enter the details manually — nothing was guessed.",
      jc_retry: "Retry",
      jc_reextract_ok: "Receipt re-read — check the fields",
      jc_reextract_fail: "Still couldn't read it. Please enter the details.",
      jc_project: "Project",
      jc_vendor: "Vendor",
      jc_vendor_ph: "e.g. Home Depot",
      jc_date: "Date",
      jc_category: "Category",
      jc_expense: "Expense",
      jc_subtotal: "Subtotal",
      jc_tax: "Tax",
      jc_discount: "Discount / adjustment",
      jc_total: "Total",
      jc_total_required: "Enter the receipt total before saving.",
      jc_total_confirm: "We weren't sure about the total — please confirm it.",
      jc_notes: "Notes",
      jc_save: "Save receipt",
      jc_receipt_img_alt: "Receipt photo",
      jc_file_attached: "Receipt file attached",
      jc_eq_section: "Equipment hours",
      jc_eq_log_btn: "Log equipment",
      jc_eq_manage: "Manage equipment",
      jc_eq_empty: "No equipment hours logged yet",
      jc_eq_empty_hint: "Log hours or meter readings for owned or rented equipment.",
      jc_eq_pending_banner: "{{count}} equipment log(s) waiting for your approval.",
      jc_eq_date: "Work date",
      jc_eq_hours: "Hours",
      jc_eq_mode_hours: "Hours",
      jc_eq_mode_meter: "Meter",
      jc_eq_meter_start: "Meter start",
      jc_eq_meter_end: "Meter end",
      jc_eq_note: "Note",
      jc_eq_save: "Save equipment log",
      jc_eq_saved: "Equipment log saved",
      jc_eq_approved: "Equipment log approved",
      jc_eq_rejected: "Equipment log rejected",
      jc_eq_deleted: "Deleted",
      jc_eq_none: "No equipment yet. An owner or admin can add machines under Manage equipment.",
      jc_eq_none_fin: "No equipment yet — add your first machine to start logging hours.",
      jc_eq_none_machines: "No machines yet — add your first one to start logging hours.",
      jc_eq_kind_personal: "Personal",
      jc_eq_odometer: "Odometer",
      jc_eq_driver: "Assigned driver",
      jc_eq_fuel_type: "Fuel type",
      jc_eq_fuel_gas: "Gas",
      jc_eq_fuel_diesel: "Diesel",
      jc_eq_fuel_electric: "Electric",
      jc_eq_fuel_hybrid: "Hybrid",
      jc_eq_payment_monthly: "Payment / lease (per month)",
      jc_eq_insurance_monthly: "Insurance (per month)",
      jc_eq_personal_vehicle: "Personal vehicle — pay IRS mileage rate",
      jc_eq_add_truck_title: "Add truck",
      jc_trip_none_trucks: "No trucks yet",
      jc_trip_add_truck: "Add a truck",
      jc_eq_truck_name: "Truck name",
      jc_eq_truck_name_ph: "e.g. White F-250",
      jc_eq_save_truck: "Save truck",
      jc_eq_save_equipment: "Save equipment",
      ad_start_trip: "Start trip",
      ad_trip_in_progress: "Trip in progress — Finish trip",
      ad_add_fuel: "Add fuel",
      ad_add_service: "Add service",
      jc_service_type: "Service type",
      jc_service_oil_change: "Oil change",
      jc_service_tires: "Tires",
      jc_service_repair: "Repair",
      jc_service_other: "Other",
      jc_service_oil_reset: "Resets the oil change reminder to today + 5,000 mi.",
      myday_trip_in_progress: "Trip in progress — Finish trip",
      nav_fleet: "Trucks & Equipment",
      nav_subs: "Subs",
      subs_subtitle: "Your subcontractors — insurance, W-9s and pay in one place.",
      subs_add: "Add sub",
      subs_add_first: "Add your first sub",
      subs_empty: "No subs yet — add one and text them their private link.",
      subs_add_title: "Add sub",
      subs_edit_title: "Edit sub",
      subs_name: "Name",
      subs_name_ph: "e.g. Mike's Electric",
      subs_trade: "Trade",
      subs_trade_ph: "e.g. Electrician",
      subs_phone: "Phone",
      subs_email: "Email",
      subs_company: "Company",
      subs_notes: "Notes",
      subs_liab: "Liability",
      subs_comp: "Workers comp",
      subs_liab_exp: "Liability expires",
      subs_comp_exp: "Workers comp expires",
      subs_w9_on: "W-9 on file",
      subs_w9_missing: "W-9 missing",
      subs_ins_missing: "Missing",
      subs_ins_expired: "Expired",
      subs_ins_days: "{{days}}d left",
      subs_ins_ok: "OK",
      subs_paid_year: "Paid {{year}}",
      subs_portal_title: "Sub portal link",
      subs_portal_hint: "Private link — the sub uploads insurance and W-9 here. No login needed.",
      subs_portal_msg: "Here's your private link from us. Keep it handy — upload insurance/W-9 when we ask:",
      subs_link_on: "Link is on",
      subs_link_off: "Link is off",
      subs_share_link: "Text / copy link",
      subs_new_link: "New link",
      subs_turn_off: "Turn off",
      subs_link_rotated: "New link created — the old one stopped working",
      subs_link_off_done: "Link turned off",
      subs_deleted: "Sub removed",
      subp_hi: "Hi {{name}}!",
      subp_intro: "This is your private link from {{company}}.",
      subp_empty: "Nothing needed right now — when {{company}} needs your insurance or W-9, you'll upload it right here.",
      subp_keep: "Keep this link. For your security it expires after 90 days; we'll send you a new one.",
      subs_link_expires: "Link expires {{date}}",
      subs_send_new_link: "Send new link",
      nb_title: "Notifications",
      nb_empty: "Nothing new — you're all caught up.",
      nb_mark_all: "Mark all read",
      subs_docs: "Documents",
      subs_doc_liab: "Liability COI",
      subs_doc_comp: "Workers comp cert",
      subs_doc_w9: "W-9",
      subs_doc_license: "License",
      subs_doc_agreement: "Agreement",
      subs_doc_missing: "Missing",
      subs_doc_upload: "Upload",
      subs_doc_replace: "Replace",
      subs_doc_uploaded: "Uploaded {{date}}",
      subs_doc_w9_note: "W-9 files stay private — only you and admins can open them.",
      subs_doc_read_ai: "Read with AI",
      subs_doc_no_read: "Couldn't read it — type the dates yourself",
      subs_doc_confirm_title: "Check what AI read",
      subs_doc_confirm_hint: "Fix anything wrong, then save.",
      subs_doc_insurer: "Insurer",
      subs_doc_policy: "Policy #",
      subs_doc_expiry: "Expiry date",
      subs_doc_confirm_save: "Save — looks right",
      subp_docs_title: "Documents {{company}} needs",
      subp_upload: "Upload",
      subp_upload_hint: "Tap to snap a photo or choose a PDF.",
      subp_uploaded: "Received {{date}} — thank you!",
      subp_doc_sent: "Received — thank you!",
      subs_alert_title: "Sub insurance",
      subs_ask_cert: "Ask for new certificate",
      subs_cert_msg: "Hi — your insurance certificate with us is expiring or has expired. Please upload the new one here (takes a minute):",
      assign_ins_missing: "no insurance on file",
      assign_ins_expired: "insurance expired",
      assign_ins_warn: "Insurance issue — ask for a new certificate before they start.",
      subs_bills: "Bills & payments",
      subs_bill_add: "Add bill",
      subs_bill_job: "Job",
      subs_bill_amount: "Amount",
      subs_bill_desc: "What for",
      subs_bill_retainage: "Retainage %",
      subs_bill_ret_short: "retainage",
      subs_bill_ret_held: "retainage held",
      subs_release_retainage: "Release retainage · {{amount}}",
      subs_w9_marked: "W-9 marked received — no file",
      subs_bill_none: "No bills yet — add one when a sub bills you.",
      subs_bill_pending: "Needs approval",
      subs_bill_owed: "Owed",
      subs_bill_partial: "Partial",
      subs_bill_paid: "Paid",
      subs_bill_paid_of: "{{paid}} paid",
      subs_bill_approve: "Approve",
      subs_bill_pay: "Record payment",
      subs_pay_method: "Check, Zelle…",
      subs_waiver_signed: "waiver signed",
      subs_1099: "1099 report",
      subs_1099_hint: "Threshold by payment year: $600 through 2025, $2,000 from 2026 (new law). Ask your accountant each January.",
      subs_1099_threshold: "Threshold for {{year}}",
      subs_1099_override_ph: "Override ($, optional)",
      subs_1099_over: "File 1099",
      subs_1099_under: "Under",
      subs_1099_none: "No sub payments in {{year}}.",
      fin_subs_title: "Subs",
      fin_subs_owed: "Owed to subs",
      fin_subs_paid: "Paid {{year}}",
      fin_subs_unpaid: "{{count}} unpaid bill(s) — tap to open Subs",
      subp_jobs_title: "Your jobs with {{company}}",
      subp_inv_title: "Send an invoice",
      subp_inv_amount: "Amount ($)",
      subp_inv_job: "Job",
      subp_inv_desc: "What is it for?",
      subp_inv_photo: "Photo of invoice (optional)",
      subp_inv_send: "Send invoice",
      subp_inv_sent: "Invoice sent — {{company}} will review it.",
      subp_bills_title: "Your invoices & payments",
      subp_st_pending: "In review",
      subp_st_owed: "Approved — not paid yet",
      subp_st_partial: "Partially paid",
      subp_st_paid: "Paid",
      subp_waiver_title: "Lien waiver",
      subp_waiver_sign_btn: "Sign lien waiver",
      subp_waiver_name: "Type your full legal name to sign",
      subp_waiver_consent: "I agree to sign this waiver electronically.",
      subp_waiver_sign: "Sign waiver",
      subp_waiver_done: "Signed {{date}}",
      subp_none: "Nothing here yet.",
      subs_doc_each_occ: "Each occurrence ($)",
      subs_doc_aggregate: "Aggregate ($)",
      subp_inv_no_jobs: "Your builder hasn't scheduled you on a job yet — ask them to add you before sending an invoice.",
      subs_bill_pick_job: "Pick a job",
      subs_bill_due: "Due date (optional)",
      subs_bill_due_short: "due",
      fin_subs_retainage: "Retainage held",
      mn_coming_in: "Coming in",
      mn_overdue_line: "{{amount}} overdue",
      mn_going_out: "Going out",
      mn_going_out_sub: "Owed to subs & bills",
      mn_retainage_held: "{{amount}} retainage held",
      mn_subbill_pick: "Who is the bill from?",
      mn_collected: "Collected this month",
      mn_collected_sub: "{{count}} payments",
      mn_needs_you: "Needs you",
      mn_all_caught_up: "All caught up.",
      mn_ny_overdue: "{{count}} overdue — {{names}}",
      mn_ny_est: "{{count}} estimates waiting for approval",
      mn_ny_subs: "{{count}} sub bills to pay",
      mn_ny_receipts: "{{count}} receipts not tied to a job",
      mn_est_cos: "Estimates & change orders",
      mn_no_budget: "{{count}} jobs have no budget yet, so profit can't be tracked.",
      mn_add_budgets: "Add budgets",
      mn_see_all: "See all jobs",
      mn_show_less: "Show less",
      mn_rep_aging: "Who owes me",
      mn_rep_1099: "1099 report",
      mn_rep_mileage: "Mileage log",
      mn_rep_profit: "Profit by job",
      mn_new_estimate_sub: "Price a job",
      mn_new_invoice_sub: "Bill a customer",
      mn_new_co_sub: "Add to a contract",
      mn_new_expense_sub: "Snap a receipt",
      mn_new_subbill: "Sub bill",
      mn_new_subbill_sub: "A sub billed you",
      mn_win_detail: "{{won}} of {{sent}} estimates won in the last 90 days",
      mn_st_owed: "Owed",
      mn_st_partial: "Partly paid",
      mn_st_pending: "Pending approval",
      mn_subs_empty: "No sub bills yet — they'll show here when a sub bills you.",
      mn_days_overdue: "{{n}}d overdue",
      mn_reports: "Reports",
      mn_ny_overdue_one: "{{count}} invoice overdue — {{names}}",
      mn_ny_overdue_other: "{{count}} invoices overdue — {{names}}",
      mn_ny_est_one: "{{count}} estimate waiting for approval",
      mn_ny_est_other: "{{count}} estimates waiting for approval",
      mn_ny_subs_one: "{{count}} sub bill to pay",
      mn_ny_subs_other: "{{count}} sub bills to pay",
      mn_ny_receipts_one: "{{count}} receipt not tied to a job",
      mn_ny_receipts_other: "{{count}} receipts not tied to a job",
      subp_waiver_disclaimer: "Lien waiver forms vary by state — check with your attorney. (Default wording is Ohio-friendly.)",
      subp_waiver_type_conditional_progress: "Conditional — progress payment",
      subp_waiver_type_unconditional_progress: "Unconditional — progress payment",
      subp_waiver_type_conditional_final: "Conditional — final payment",
      subp_waiver_type_unconditional_final: "Unconditional — final payment",
      pjt_title: "Profit by job",
      pjt_job: "Job", pjt_contract: "Contract", pjt_materials: "Materials",
      pjt_labor: "Labor", pjt_equipment: "Equipment", pjt_mileage: "Mileage",
      pjt_spent: "Spent", pjt_profit: "Profit", pjt_margin: "Margin",
      pjt_csv: "Download CSV", pjt_empty: "No jobs with a contract yet",
      subp_expired: "This link expired — ask {{company}} to send you a new one.",
      subp_verify_title: "Quick security check",
      subp_verify_body: "To sign or send invoices, we send a 6-digit code to your email on file.",
      subp_verify_send: "Send me the code",
      subp_verify_sent: "Code sent to {{dest}} — good for 10 minutes.",
      subp_verify_already: "We already sent you a code — check your email (good for 10 minutes).",
      subp_verify_ph: "6-digit code",
      subp_verify_btn: "Verify",
      subp_verify_wrong: "Wrong code — {{left}} tries left",
      subp_verify_locked: "Too many tries — wait 15 minutes and request a new code.",
      subp_verify_expired: "That code expired — request a new one.",
      subp_verify_sms_off: "Text codes aren't set up yet — ask {{company}} to finish setup.",
      subp_no_phone: "Ask {{company}} to add your phone to sign",
      subp_no_email: "Ask {{company}} to add your email to sign",
      subp_verified: "Verified on this device for 30 days.",
      subs_agent_title: "Insurance agent link",
      subs_agent_hint: "For their insurance agent — they can only drop off a certificate. Nothing else is visible.",
      subs_agent_on: "Agent link is on",
      subs_agent_off: "Agent link is off",
      subs_agent_expired: "Agent link expired — send a new one",
      subs_link_expired: "Link expired — send a new one",
      subs_share_agent: "Text / copy agent link",
      subp_agent_title: "Insurance certificate drop-off",
      subp_agent_hint: "Upload the current certificate for {{sub}}. Only {{company}} can see it.",
      fleet_subtitle: "Your vehicles, trailers, equipment and tools in one place.",
      fleet_add: "Add",
      fleet_add_first: "Add your first one",
      fleet_empty: "Nothing here yet — add a truck or machine to get started.",
      fleet_group_truck: "Trucks",
      fleet_group_trailer: "Trailers",
      fleet_group_equipment: "Equipment",
      fleet_group_tool: "Tools",
      cs_fleet_t: "Trucks & Equipment",
      cs_fleet_d: "Vehicles, trailers and machines",
      cs_vehicles_t: "Vehicles",
      cs_irs_rate: "IRS mileage rate",
      cs_irs_rate_hint: "Check irs.gov each January.",
      cs_mileage_cost: "Mileage cost",
      cs_mileage_irs: "IRS rate",
      cs_mileage_irs_d: "Automatic by trip date ({{rate}}/mi now)",
      cs_mileage_custom: "My own $ per mile",
      cs_mileage_custom_d: "One rate you set, for every trip",
      cs_custom_rate: "Your rate",
      cs_mileage_hint: "IRS rate auto by trip date, or your own $/mile",
      cs_mileage_irs_hint: "Trips price by date: 72.5¢ through Jun 2026, 76¢ from Jul 1, 2026. Check irs.gov each January.",
      jc_fuel_which_truck: "Fuel for which truck?",
      jc_fuel_gallons: "Gallons",
      jc_fuel_odometer: "Odometer (optional)",
      fleet_add_fuel: "Add fuel",
      jc_eq_this_month: "This month",
      jc_eq_this_year: "This year",
      jc_eq_ad_miles: "Miles",
      jc_eq_ad_mpg: "MPG",
      jc_eq_ad_fuel: "Fuel",
      jc_eq_ad_maint: "Maintenance",
      jc_eq_ad_fixed: "Fixed",
      jc_eq_ad_total: "Total",
      jc_eq_cost_per_mile: "Cost per mile",
      jc_eq_trips: "Trips",
      fin_trucks_month: "Trucks this month",
      fin_tab_expenses: "Expenses",
      fleet_reports_title: "Reports for your accountant",
      fleet_reports_hint: "IRS-ready mileage log and fuel + vehicle costs. Pick the dates, tap to download.",
      fleet_report_mileage_pdf: "Mileage log (PDF)",
      fleet_report_mileage: "Mileage log (CSV)",
      fleet_report_mileage_hint: "Date, driver, odometer start/end, miles, job & purpose — IRS-ready.",
      fleet_report_costs: "Fuel + vehicle costs (CSV)",
      fleet_report_costs_hint: "Per truck: miles, MPG, fuel, maintenance, fixed, total, cost per mile.",
      fleet_report_all_trucks: "All trucks",
      fleet_report_from: "From",
      fleet_report_to: "To",
      myday_maintenance_title: "Truck reminders",
      jc_fuel_price_gal: "Price / gallon",
      jc_eq_add_title: "Add equipment",
      jc_eq_edit_title: "Edit equipment",
      jc_eq_name: "Equipment name",
      jc_eq_name_ph: "e.g. Skid Steer #2",
      jc_eq_identifier: "Identifier / plate",
      jc_eq_kind: "Type",
      jc_eq_kind_owned: "Owned",
      jc_eq_kind_rented: "Rented",
      jc_eq_internal_rate: "Internal cost per hour",
      jc_eq_billable_rate: "Billable rate per hour (optional)",
      jc_eq_add: "Save equipment",
      jc_eq_added: "Equipment saved",
      jc_eq_retire: "Archive",
      jc_eq_type: "Asset type",
      jc_eq_type_truck: "Truck / Van",
      jc_eq_type_trailer: "Trailer",
      jc_eq_type_equipment: "Equipment",
      jc_eq_type_tool: "Tool",
      jc_eq_more: "More details (optional)",
      jc_eq_less: "Hide details",
      jc_eq_plate: "Plate number",
      jc_eq_purchase_date: "Purchase date",
      jc_eq_purchase_price: "Purchase price $",
      jc_eq_rate_mile: "Cost per mile",
      jc_eq_rate_includes: "This rate covers",
      jc_eq_inc_fuel: "Fuel",
      jc_eq_inc_maintenance: "Maintenance",
      jc_eq_inc_insurance: "Insurance",
      jc_eq_rental_daily: "Rental $/day",
      jc_eq_rental_weekly: "Rental $/week",
      jc_eq_assets_title: "Vehicles & Equipment",
      jc_eq_detail_title: "Asset details",
      jc_eq_linked_receipts: "Linked receipts",
      jc_eq_maintenance: "Maintenance history",
      jc_eq_total_month: "This month",
      jc_eq_total_year: "This year",
      jc_eq_total_lifetime: "Lifetime",
      jc_eq_current_project: "Current project",
      jc_eq_no_assignment: "No assignment recorded",
      jc_eq_total_hours: "Hours logged",
      jc_eq_next_service: "Next service date",
      jc_eq_next_service_meter: "Next service at meter",
      jc_eq_oil_due: "Oil change due in {{n}} mi",
      jc_eq_oil_overdue: "Oil change {{n}} mi overdue",
      jc_eq_oil_due: "Oil change due in {{n}} mi",
      jc_eq_oil_overdue: "Oil change {{n}} mi overdue",
      jc_eq_archive_note: "Archiving keeps the full history.",
      jc_eq_on_job: "Equipment on this job",
      jc_eq_dropoff: "Drop-off date",
      jc_eq_pickup: "Pickup date",
      jc_eq_save_onjob: "Save — equipment on job",
      jc_eq_save_full: "Save completed log",
      jc_eq_complete: "Complete equipment log",
      jc_eq_update_reading: "Update reading",
      jc_eq_record_pickup: "Record pickup",
      jc_eq_open_badge: "On job",
      jc_eq_pending_hours: "Hours pending",
      jc_eq_op_hours: "Operating hours",
      jc_eq_days_site: "days on site",
      jc_eq_rental_cost: "Rental cost",
      jc_eq_dup: "This equipment already has an open record on a job.",
      jc_eq_dup_override: "Start anyway (explain)",
      jc_eq_override_reason: "Reason (required)",
      jc_eq_enter_now: "Enter full hours now",
      jc_eq_quick: "Quick drop-off",
      jc_eq_review: "Review before completing",
      jc_trips_title: "Mileage",
      jc_log_mileage: "Log mileage",
      jc_trip_start: "Start trip",
      jc_trip_finish: "Finish trip",
      jc_trip_vehicle: "Vehicle",
      jc_trip_purpose: "Business purpose (optional)",
      jc_trip_odo_start: "Starting odometer (optional)",
      jc_trip_odo_end: "Ending odometer",
      jc_trip_manual: "Enter miles manually",
      jc_trip_miles: "Miles",
      jc_trip_open_badge: "Open trip",
      jc_trip_done_badge: "Completed",
      jc_trip_saved_open: "Trip started — finish it when you arrive.",
      jc_trip_saved_done: "Trip completed.",
      jc_trip_none: "No trips yet.",
      jc_trip_company_use: "Company use",
      jc_trip_est_cost: "Estimated internal cost",
      jc_trip_err_odo: "Ending odometer must be greater than the start.",
      jc_trip_err_miles: "Enter miles greater than 0.",
      jc_trip_dup: "This vehicle already has an open trip.",
      jc_trip_pick: "Pick a vehicle first.",
      jc_trip_purpose_required: "Company settings require a trip purpose.",
      jc_set_require_purpose: "Require business purpose on trips",
      jc_eq_retire_confirm: "Retire this equipment? Its logged hours stay on record.",
      jc_eq_retired: "Equipment retired",
      jc_eq_active: "Active",
      jc_eq_inactive: "Inactive",
      jc_eq_cost: "Cost",
      jc_eq_no_rate: "No internal rate set — counts hours only",
      jc_eq_owned_chip: "Owned equipment",
      jc_eq_equipment: "Equipment",
      jc_eq_pick: "Please pick a piece of equipment first.",
      jc_eq_err_hours: "Enter hours greater than 0.",
      jc_eq_err_hours_max: "Hours must be 16 or less per day.",
      jc_eq_err_meter: "Enter both meter readings.",
      jc_eq_err_meter_order: "Meter end must be greater than meter start.",
      jc_eq_err_meter_max: "Meter readings must be 16 hours or less apart.",
      jc_eq_name_required: "Enter the equipment name to save.",
      jc_eq_per_hour: "/hr",
      jc_delete: "Delete",
      jc_cat_labor: "Labor",
      jc_bd_title: "Cost breakdown",
      jc_bd_empty: "No records in this bucket yet.",
      jc_labor_no_rate: "Set an internal labor rate in Cost settings to price labor hours.",
      jc_settings_title: "Cost settings",
      jc_labor_internal: "Internal labor cost per hour",
      jc_labor_billable: "Billable labor rate per hour (optional)",
      jc_settings_saved: "Cost settings saved",
      pd_customer: "Customer",
      pd_crew_today: "Today's crew",
      pd_next_activity: "Next scheduled",
      pd_open_tasks: "Open tasks",
      pd_latest_update: "Latest update",
      pd_none_yet: "Nothing yet",
      pd_today: "Today",
      pd_tomorrow: "Tomorrow",
      pd_co_gate_title: "Create an estimate first",
      pd_co_gate_body: "Change orders modify an approved estimate or contract. Create an estimate for this project first.",
      pd_more_tasks: "Tasks",
      pd_more_sharing: "Customer Sharing",
      pd_more_reports: "Reports",
      pd_more_settings: "Project Settings",
      pd_no_activity: "No activity yet",
      pd_no_schedule: "Nothing scheduled",
      pd_schedule_add: "Open Schedule",
      pd_ev_log: "log",
      pd_ev_clock_in: "clock in",
      pd_ev_manual_entry: "Timecard",
      pd_ev_clock_out: "clock out",
      pd_ev_break_start: "break start",
      pd_ev_break_end: "break end",
      pd_ev_day_update: "update",
      pd_ev_evening_update: "evening update",
      pd_ev_morning_plan: "morning plan",
      pd_ev_project_switch: "project switch",
      pd_ev_correction_request: "correction",
      tc_flagged: "flagged",
      task_attach: "Attach photo",
      fin_more_details: "More financial details",
      fin_new: "New",
      fin_new_invoice: "New Invoice",
      fin_record_payment: "Record Payment",
      fin_settings_menu: "Financial settings",
      fin_settings_title: "Financial Settings",
      fin_products_menu: "Products & Services",
      fin_pick_project: "Pick a project",
      fin_record_hint: "Open an invoice to record a payment.",
      bgv_stage_interpret: "Request understood",
      bgv_stage_proposed: "Review shown",
      bgv_stage_answered: "Answered",
      bgv_stage_choose: "Selection made",
      bgv_stage_cancel: "Cancelled",
      bgv_stage_draft_parked: "Saved as draft",
      bgv_stage_perm_change: "Permissions updated",
      bgv_stage_confirm: "Completed",
      bgv_result_failure: "Failed",
      bgv_dismiss: "Dismiss",
      bgv_review_create_task: "Add Task",
      bgv_row_task: "Task",
      action_cancel: "Cancel",
      action_delete: "Delete",
      action_invite: "Invite crew",
      action_signout: "Sign out",
      action_get_started: "Start 14-day free trial",
      action_signin: "Sign In",
      action_open_app: "Open App",
      action_load_more: "Load more",
      showing_x_of_y: "Showing {{shown}} of {{total}}",
      action_create_account: "Create account",
      // Landing
      hero_headline: "Every job photo. Every schedule. One simple app.",
      hero_sub: "Jobsite photos with time-and-location proof, a schedule your crew actually reads, and a 360 Assistant that turns one spoken update into your daily log, schedule, and change orders.",
      hero_support: "Built for contractors who want one simple place to manage every customer, every project, and every detail.",
      action_start_free: "Start Free for 14 Days",
      feat_coming_soon: "Coming Soon",
      feat_payments_d_coming: "Send invoices and prepare to accept secure online payments—all from BuildProject360.",
      payments_coming_toast: "Customer payments are coming soon.",
      nav_app_updates: "App Updates",
      upd_available_title: "Update Available",
      upd_available_body: "A new version of BuildProject360 is ready.",
      upd_now: "Update Now",
      upd_later: "Later",
      upd_title: "App Updates",
      upd_subtitle: "Version info, updates and repair tools.",
      upd_version: "App version",
      upd_build: "Build",
      upd_last_update: "Last update",
      upd_status: "Update status",
      upd_status_current: "Up to date",
      upd_status_available: "Update available",
      upd_uptodate: "You're on the latest version",
      upd_check: "Check for Updates",
      upd_refresh: "Refresh Application",
      upd_refresh_hint: "Reloads the latest app files. Your projects, photos, drafts and account are not touched.",
      upd_connection: "Connection",
      upd_online: "Online",
      upd_offline: "Offline",
      upd_offline_uploads: "Offline uploads",
      upd_queue_empty: "None pending",
      upd_queue_count: "{{count}} pending",
      upd_repair: "Repair App",
      upd_repair_confirm_title: "Repair BuildProject360?",
      upd_repair_li1: "Signs you out and clears old app caches.",
      upd_repair_li2: "Re-registers the app and returns you to the login screen.",
      upd_repair_li3: "Keeps queued photo uploads and offline data.",
      upd_repair_go: "Repair Now",
      upd_repair_hint: "Only use Repair if the app misbehaves — it's not needed for normal updates.",
      login_trouble_title: "Trouble signing in?",
      login_try_again: "Try Again",
      login_check_connection: "Check Connection",
      login_refresh_app: "Refresh Application",
      login_reset_password: "Reset Password",
      login_contact_support: "Contact Support",
      login_diag_code: "Support code",
      login_online: "Connection looks good — try signing in again.",
      login_offline: "You appear to be offline. Check your connection and try again.",
      nav_admin: "Admin",
      admin_denied: "Admin access required.",
      ob_checklist_title: "Get started with BuildProject360",
      ob_progress: "{{done}} of {{total}} completed",
      ob_hide: "Hide",
      ob_step_company_info: "Complete company information",
      ob_step_first_customer: "Add your first customer",
      ob_step_first_project: "Create your first project",
      ob_step_first_photo: "Take your first project photo",
      ob_step_first_schedule: "Schedule your first job",
      ob_step_buildguide_used: "Ask Assistant to help",
      ob_reminder_first_project_one: "You have {{count}} day left. Create a project to see how BuildProject360 organizes your work.",
      ob_reminder_first_project_other: "You have {{count}} days left. Create a project to see how BuildProject360 organizes your work.",
      ob_reminder_first_photo: "You created your first project. Take a photo to start its visual timeline.",
      ob_reminder_trial_last_one: "You have {{count}} day left. Choose a plan to keep full access.",
      ob_reminder_trial_last_other: "You have {{count}} days left. Choose a plan to keep full access.",
      ob_reminder_go: "Go",
      bg_greeting: "Hi! I’m your 360 Assistant. I can answer questions, find project information, create projects, build schedules, prepare updates and help with everyday tasks. You’ll always review changes before I save them. What can I help with?",
      bg_greeting_customer: "Create a Customer",
      bg_greeting_project: "Create a Project",
      bg_greeting_schedule: "Build a Schedule",
      bg_greeting_tour: "Show Me How",
      aob_title: "Onboarding Emails",
      aob_subtitle: "Trial sequence status, templates, tests and conversion analytics.",
      aob_pause: "Pause Sequence",
      aob_resume: "Resume Sequence",
      aob_steps: "Sequence steps",
      aob_sent: "sent",
      aob_failed: "failed",
      aob_suppressed: "{{count}} suppressed addresses (unsubscribed/bounced)",
      aob_funnel: "Conversion funnel",
      aob_f_verify: "Signup → email verified",
      aob_f_customer: "Signup → first customer",
      aob_f_project: "Signup → first project",
      aob_f_photo: "Signup → first photo",
      aob_f_schedule: "Signup → first schedule item",
      aob_f_paid: "Trial → paid",
      aob_f_unsub: "Unsubscribe rate",
      aob_f_bounce: "Bounce/failure rate",
      aob_per_reminder: "Conversion by reminder (within 7 days)",
      aob_subjects: "Subject lines (overrides)",
      aob_test_title: "Send a test email",
      aob_test_to: "Recipient (default: you)",
      aob_test_send: "Send Test",
      aob_test_sent: "Test email sent",
      aob_test_failed: "Test email failed",
      aob_recent: "Recent deliveries",
      aob_none: "No onboarding emails sent yet.",
      pd_tab_tasks: "Tasks & Reports",
      pd_details: "Project Details",
      pd_description: "Description",
      pd_collaborators: "Collaborators & guest access",
      pm_group_project: "Project",
      pm_group_photos: "Photos",
      pm_group_access: "Access & Sharing",
      pm_group_danger: "Danger Zone",
      pm_edit: "Edit Project",
      pm_map: "View Map",
      pm_time: "View Time Entries",
      pm_qr: "Project QR Code",
      pm_archive: "Archive Project",
      pm_trash: "View Project Trash",
      pm_restore: "Restore",
      pm_download_all: "Download All Photos",
      pm_report: "Export Photo Report",
      pm_manage_links: "Manage Shared Links",
      pm_collaborators: "Manage Collaborators",
      pm_delete: "Delete Project",
      pm_delete_title: "Delete this project?",
      pm_delete_body: "Type the project name \"{{name}}\" to confirm. The project is soft-deleted and can be restored from Trash.",
      pm_delete_soft: "Soft delete: restorable from Trash by an owner/admin.",
      photos_all: "All",
      photos_count: "{{count}} photos",
      photos_unknown_date: "Unknown date",
      photos_filter_date: "Filter by date",
      photos_filter_member: "Filter by team member",
      photos_all_members: "All members",
      photos_filter_tags: "Filter by tag",
      photos_all_tags: "All tags",
      photos_sort: "Sort",
      photos_newest: "Newest first",
      photos_oldest: "Oldest first",
      photos_view: "Grid/list view",
      photos_more: "Scroll for more",
      photos_select_date: "Select all photos from {{date}}",
      sel_all_project: "All Photos ({{total}})",
      sel_all_filter: "Current Filter Results ({{count}})",
      sel_filter_hint: "Selects everything currently matching your filters.",
      sel_loaded_only: "{{count}} photos selected — all {{total}} in this project are included once loaded pages match.",
      sel_count: "{{count}} selected",
      sel_all_cross: "{{count}} photos selected. Select all {{total}} photos in this project?",
      sel_select_rest: "Select all {{total}}",
      sel_done: "Done",
      sel_add_tags: "Add Tags",
      sel_set_cover: "Set as project cover",
      sel_cover_done: "Cover photo set",
      sel_cover_soon: "Open the photo to set it as cover.",
      sel_mark_before: "Mark as Before",
      sel_mark_progress: "Mark as Progress",
      sel_mark_after: "Mark as After",
      sel_favorite: "Favorite",
      sel_move_copy: "Move or Copy",
      sel_move_title: "Move or copy {{count}} photos",
      sel_move_dest: "Destination project",
      sel_move_btn: "Move",
      sel_copy_btn: "Copy",
      photos_open_a11y: "Open photo {{index}} of {{total}}, captured {{date}} by {{by}}",
      pd_no_address: "No address added",
      share_all_photos: "Share All Photos",
      share_select_photos: "Select Photos to Share",
      share_select_hint: "Long-press or use the checkboxes to select photos, then tap Share.",
      share_customer_gallery: "Share Customer Gallery",
      share_invite_guest: "Invite Customer or Guest",
      share_manage_links: "Manage Shared Links",
      fin_search_doc: "Search estimate, invoice, customer, project or number…",
      sched_delete_title: "Delete this event?",
      sched_delete_body: "You can undo this right after deleting.",
      sched_undo: "Undo",
      sched_deleted: "Event deleted",
      cust_dup_title: "A similar customer already exists.",
      cust_dup_body: "Use this customer or create a new one?",
      cust_dup_use: "Use this customer",
      cust_dup_create: "Create new anyway",
      cust_dup_reason_email: "same email",
      cust_dup_reason_name: "same name",
      cust_dup_reason_company: "same company",
      cust_dup_reason_phone: "same phone",
      tz_banner_text: "Your account timezone is {{account}}, but this device is set to {{device}}.",
      tz_banner_update: "Use {{tz}}",
      tz_banner_dismiss: "Dismiss",
      tz_banner_updated: "Timezone updated",
      brand_wm_title: "Photo Watermark",
      brand_sec_company: "Company info", brand_sec_photos: "Photo settings",
      brand_wm_body: "Choose what appears on photos you take. Originals are always stored without a watermark.",
      brand_wm_none: "No watermark",
      brand_wm_simple: "Simple (company · project · local time)",
      brand_wm_proof: "Proof (adds GPS, user, photo ID)",
      pm_closeout: "Closeout package",
      closeout_title: "Project Closeout Package",
      closeout_body: "Pick what to include. A branded PDF and a secure share link are generated — nothing is sent automatically.",
      closeout_sec_before: "Before photos",
      closeout_sec_progress: "Progress photos",
      closeout_sec_after: "After photos",
      closeout_sec_logs: "Daily logs",
      closeout_sec_estimate: "Approved estimate",
      closeout_sec_change_orders: "Approved change orders",
      closeout_sec_invoices: "Paid invoices",
      closeout_completion: "Completion date",
      closeout_warranty: "Warranty information",
      closeout_warranty_ph: "e.g. 5-year workmanship warranty…",
      closeout_message: "Email-ready message",
      closeout_message_ph: "Optional note for the customer…",
      closeout_generate: "Preview & Generate",
      closeout_ready: "Closeout package ready",
      closeout_counts: "Included: {{photos}} photos, {{logs}} logs, {{estimate}} estimate, {{change_orders}} change orders, {{invoices}} invoices.",
      closeout_copy: "Copy link",
      closeout_preview: "Preview",
      closeout_download: "Download closeout PDF",
      closeout_public_body: "Your contractor prepared this closeout package for your records.",
      closeout_no_send_note: "Nothing was emailed or texted — share the link when you're ready.",
      ai_summary_btn: "Draft daily summary with 360 Assistant",
      ai_summary_label: "AI Draft",
      ai_summary_hint: "Review and edit before saving. Nothing is sent automatically.",
      ai_summary_working: "Reading today's photos, logs and time — about 30 seconds…",
      log_hours_offer: "Add {{hours}}h × {{crew}} crew to timecards?",
      log_hours_yes: "Add draft",
      log_hours_added: "Draft timecard added — approve it in Time > Review",
      cs_adv_t: "Advanced", cs_adv_d: "Device reset and power-user options",
      inbox_title: "Photo Inbox",
      inbox_count: "{{count}} photos need a project",
      inbox_assign: "Assign to project",
      inbox_assign_done: "{{count}} photos assigned",
      inbox_suggested: "Suggested",
      inbox_select_all: "Select all",
      inbox_empty: "Inbox zero — every photo has a project.",
      nav_integrations: "Integrations",
      integ_title: "Integrations",
      integ_subtitle: "Connect the tools you already use. Connections use secure sign-in — we never ask for your passwords.",
      integ_companycam_name: "CompanyCam import",
      integ_companycam_body: "Import projects and photos from CompanyCam.",
      integ_quickbooks_name: "QuickBooks sync",
      integ_quickbooks_body: "Sync customers, invoices and payments.",
      integ_google_calendar_name: "Google Calendar",
      integ_google_calendar_body: "See your schedule in Google Calendar.",
      integ_roofr_name: "Roofr",
      integ_roofr_body: "Import Roofr measurements where supported.",
      integ_connect: "Connect",
      integ_coming_soon: "This connection opens once the provider approves our app. We'll email you.",
      integ_badge_coming_soon: "Coming soon",
      integ_oauth_note: "Integrations connect with secure sign-in (OAuth). BuildProject360 never stores your passwords.",
      ccam_title: "Switch from CompanyCam",
      ccam_subtitle: "Bring your projects and photos with you. Runs in the background — you can keep working.",
      ccam_tab_token: "Connect account",
      ccam_tab_zip: "Upload ZIP",
      ccam_token_label: "CompanyCam access token",
      ccam_token_help: "In CompanyCam, go to Resources › Access Tokens, create a token, and paste it here. We never store it.",
      ccam_token_placeholder: "Paste token",
      ccam_zip_label: "CompanyCam ZIP file",
      ccam_zip_help: "In CompanyCam open a project, choose Download All Photos, then upload the ZIP here.",
      ccam_zip_project: "Add photos to",
      ccam_zip_choose: "Choose a project",
      ccam_zip_new: "New project name",
      ccam_start_import: "Start import",
      ccam_importing: "Importing in the background…",
      ccam_progress: "{{projects}} projects · {{photos}} photos",
      ccam_can_close: "You can close this — we'll notify you when it's done.",
      ccam_done_title: "Import complete",
      ccam_summary: "Imported {{projects}} projects, {{photos}} photos.",
      ccam_summary_matched: "{{count}} matched to existing projects.",
      ccam_skipped: "{{count}} skipped",
      ccam_skip_duplicate: "already imported",
      ccam_skip_no_file: "file unavailable",
      ccam_skip_not_photo: "not a photo",
      ccam_skip_download: "download failed",
      ccam_failed: "Import failed",
      ccam_reauth: "Token expired or rejected — paste a fresh token.",
      ccam_bad_token: "That token didn't work. Check it and try again.",
      ccam_too_large: "ZIP is too large (max 400 MB).",
      ccam_bad_zip: "That file isn't a ZIP from CompanyCam.",
      ccam_start_toast: "Import started — runs in the background",
      imp_title: "Bring your data in",
      imp_subtitle: "Switching from another app? Bring your customers, jobs and photos with you.",
      imp_beta: "Beta",
      imp_opt_companycam_t: "From CompanyCam",
      imp_opt_companycam_d: "Paste your CompanyCam access token — we pull in projects and photos for you.",
      imp_opt_spreadsheet_t: "From a spreadsheet",
      imp_opt_spreadsheet_d: "Upload a CSV or Excel file of customers or jobs. We match the columns for you.",
      imp_opt_photos_t: "From a folder of photos",
      imp_opt_photos_d: "Pick photos from your phone — we group them into jobs by place and date.",
      imp_recent: "Recent imports",
      imp_undo: "Undo this import",
      imp_undone: "Import undone: {{photos}} photos, {{projects}} jobs, {{customers}} customers removed.",
      imp_undo_expired: "Undo is available for 7 days after an import — this one is older.",
      imp_job_undone: "Undone",
      imp_kind_companycam: "CompanyCam import",
      imp_kind_spreadsheet: "Spreadsheet import",
      imp_kind_photos: "Photo import",
      imp_status_queued: "Waiting to start…",
      imp_status_running: "Importing…",
      imp_status_staging: "Receiving photos…",
      imp_status_failed: "Import failed",
      imp_status_complete: "Import complete",
      imp_progress_jobs: "jobs",
      imp_progress_photos: "photos",
      imp_sheet_title: "Import a spreadsheet",
      imp_sheet_subtitle: "Customers or jobs from any app — export a CSV or Excel file and drop it here.",
      imp_sheet_pick: "Choose a CSV or Excel file",
      imp_reading: "Reading your file…",
      imp_cant_read: "We couldn't read that file. Try a CSV or Excel export.",
      imp_file_large: "That file is too large (max 15 MB).",
      imp_no_name: "We need a name column — make sure your sheet has one.",
      imp_sheet_found: "Found {{count}} rows",
      imp_sheet_mapping_help: "We matched your columns. Fix anything that looks wrong:",
      imp_field_name: "Name",
      imp_field_email: "Email",
      imp_field_phone: "Phone",
      imp_field_address: "Address",
      imp_field_project: "Job",
      imp_field_notes: "Notes",
      imp_map_none: "— skip —",
      imp_start: "Start import",
      imp_photos_title: "Import photos",
      imp_photos_subtitle: "Pick photos from your phone or computer. We read each photo's place and date and group them into jobs for you.",
      imp_photos_pick: "Choose photos",
      imp_photos_pick_hint: "You can pick 200+ at once",
      imp_photos_uploading: "Uploading {{done}} of {{total}}…",
      imp_photos_lock_hint: "Keeps going if your screen locks — leave this page open.",
      imp_too_many: "Too many photos — split into groups of 400.",
      imp_photos_grouped: "Grouped {{photos}} photos into {{groups}} {{jobsLabel}}",
      imp_photos_review_help: "Check the job names, or attach a group to a job you already have:",
      imp_photos_count: "photos",
      imp_group_new: "Create a new job",
      imp_group_name_ph: "Job name",
      imp_field_city: "City",
      imp_field_state: "State",
      imp_field_zip: "Zip",
      imp_job_one: "job",
      imp_job_many: "jobs",
      jp_is_off: "This job page is turned off.",
      jp_reenable: "Turn it back on",
      jp_try_later: "Something went wrong — try again in a moment.",
      setup_import_row: "Coming from another app? Bring your jobs and photos",
      jp_menu: "Customer job page",
      pd_complete_referral: "Ask for a referral",
      jp_sheet_title: "Customer job page",
      jp_sheet_subtitle: "One private link for this job. Your customer sees this week's schedule, photos, documents to sign and invoices — no login needed.",
      jp_copy: "Copy link",
      jp_text: "Text the link",
      jp_email: "Email it", jp_preview: "Preview as customer",
      jp_rotate: "New link",
      jp_disable: "Turn off",
      jp_link_copied: "Link copied",
      jp_rotated: "New link created — the old one no longer works.",
      jp_disabled: "Job page turned off.",
      jp_text_msg: "Here's the page for {{name}} — schedule, photos and paperwork all in one place: {{url}}",
      jp_not_found: "This link is not valid.",
      jp_off: "This page has been turned off.",
      jp_welcome: "Hi {{name}} — here's your job page",
      jp_there: "there",
      jp_this_week: "This week",
      jp_week_empty: "Nothing scheduled this week — check back soon.",
      jp_photos: "Photos",
      jp_photos_empty: "No photos yet — they'll show up here as the job moves along.",
      jp_docs: "Documents to sign",
      jp_docs_hint: "Tap to review and sign — we record the date automatically.",
      jp_sign: "Review & sign",
      jp_invoices: "Invoices",
      jp_balance: "Balance due",
      jp_due: "Due {{date}}",
      jp_how_to_pay: "How to pay",
      jp_pay_check: "Check payable to {{to}}, mail to {{at}}",
      jp_pay_ach: "Bank transfer — {{bank}}, routing {{routing}}, account {{account}}",
      jp_pay_zelle: "Zelle: {{handle}}",
      jp_pay_venmo: "Venmo: {{handle}}",
      jp_pay_cash: "Cash accepted",
      jp_review_t: "How did we do?",
      jp_review_d: "A quick review means the world to a small business.",
      jp_review_btn: "Leave a Google review",
      jp_overdue: "Overdue",
      jp_docs_empty: "Nothing to sign right now — new estimates and change orders will appear here.",
      jp_inv_empty: "No open invoices right now.",
      jp_msg_t: "Message us",
      jp_msg_ph: "Question about the job? Type it here…",
      jp_msg_send: "Send message",
      jp_msg_sent: "Sent! We'll get back to you shortly.",
      jp_what_see: "What your customer can see",
      jp_views: "{{count}} views",
      jp_last_viewed: "Last viewed {{date}}",
      jp_never_viewed: "Not opened yet",
      jp_approved: "Approved",
      near_youre_here: "You're here",
      home_youre_at: "You're at {{name}}",
      notif_nearby_first: "Put the job I'm at first",
      notif_nearby_first_hint: "When you open the app near a job, that job shows at the top.",
      brand_review_link: "Google review link",
      brand_review_hint: "Paste your Google review link — happy customers get it after you mark a job complete.",
      ccam_done: "Done",
      ccam_import_btn: "Import",
      land_small_title: "Built for small contractors—not enterprise complexity.",
      land_small_body: "No modules to configure, no consultants required. Open the app, take a photo, share it. That's the whole learning curve.",
      land_small_1_t: "Ready in minutes",
      land_small_1_d: "Create a project, snap photos, share a gallery — all before your coffee cools.",
      land_small_2_t: "Priced for crews",
      land_small_2_d: "One simple plan. No per-feature upsells, no seats you don't need.",
      land_small_3_t: "Works in the field",
      land_small_3_d: "Offline queue, fast thumbnails and big tap targets — built for gloves and sunlight.",
      land_gallery_title: "A customer gallery they'll actually open",
      land_gallery_body: "Every share is a clean, branded page — no account needed for your customer.",
      land_gallery_cap_1: "Foundation",
      land_gallery_cap_2: "Framing",
      land_gallery_cap_3: "Sheathing",
      land_gallery_cap_4: "Exterior Progress",
      land_gallery_cap_5: "Near Completion",
      land_gallery_cap_6: "Finished Home",
      land_gallery_demo_note: "Real photos from one project — start to finish.",
      land_h1: "Simple Construction Project Management for Small Contractors",
      land_h1_sub: "Manage customers, projects, jobsite photos, schedules, crews, estimates and invoices from one easy platform.",
      seo_home_title: "BuildProject360 — Jobsite Photos, Job Costing & Crew Scheduling",
      seo_home_desc: "Every jobsite photo, dated and on file. Crew schedule, daily logs and job costs in one app. From $49/month billed yearly. Free for 14 days.",
      v2_nav_features: "Features",
      v2_nav_pricing: "Pricing",
      v2_nav_login: "Log in",
      v2_menu: "Menu",
      v2_cta: "Start free — 14 days",
      v2_cta_short: "Start free",
      v2_hero_pill: "For contractors and small crews",
      v2_hero_h1: "Every jobsite photo, dated and on file — before anyone asks.",
      v2_hero_sub: "Snap it on site and it's sorted by job with the date, time and location. Crew schedule, daily logs and job costs live in the same app.",
      v2_hero_line: "No credit card · 14-day Pro trial · From $49/mo billed yearly · Cancel anytime",
      v2_mock_project: "Miller New Home Build",
      v2_mock_addr: "123 East Main St · Columbus, OH",
      v2_mock_today: "Today · 6 photos",
      v2_mock_today_m: "Today · 2 photos",
      v2_mock_saved: "Saved to Miller New Home Build",
      v2_mock_photo_alt: "Jobsite photo with time and GPS stamp",
      v2_trust: "Built by a contractor in Ohio · English & Spanish · Your photos stay private · 3 users included",
      v2_ph_label: "Jobsite photos",
      v2_ph_h2: "Proof for every job. Found in seconds.",
      v2_ph_body: "Every photo lands on the right job with the date, time and location recorded. When the homeowner, inspector or insurance asks, you pull it up — no scrolling through your camera roll.",
      v2_ph_b1: "Switch jobs in the camera with one tap",
      v2_ph_b2: "Before & after, by date",
      v2_ph_b3: "Whole crew shoots to the same job",
      v2_sh_label: "Share with your customer",
      v2_sh_big: "Send a clean progress gallery. Stop the \"what's going on with my job?\" calls.",
      v2_sh_before: "Before",
      v2_sh_framing: "Framing",
      v2_sh_after: "After",
      v2_sh_small: "One tap sends a branded link. Your customer opens it on their phone — no app, no login.",
      v2_md_label: "Estimates, change orders & invoices",
      v2_md_h2: "From estimate to final invoice — every dollar tracked.",
      v2_md_body: "Send a branded estimate with photos, get it approved online, bill progress as the job moves, and let customers pay how they want. Change orders fold right into the contract total so nothing gets billed twice — or forgotten.",
      v2_md_s1_t: "Send the estimate", v2_md_s1_d: "Branded PDF or a text link with your job photos. You see exactly when the customer opens it.",
      v2_md_s2_t: "Get it approved", v2_md_s2_d: "Customers approve online or sign on paper on site. Change orders go through the same approve flow.",
      v2_md_s3_t: "Invoice and get paid", v2_md_s3_d: "Deposit, progress and final invoices with contract math done for you. Record check, cash, ACH, Zelle or Venmo — or turn on card payments when you're ready.",
      v2_md_pay: "Customers can pay by check, ACH, Zelle, Venmo or cash — or by card online when you turn on payments.",
      v2_md_cap_before: "Before", v2_md_cap_progress: "In progress", v2_md_cap_after: "After",
      v2_md_mock_no: "INV-0004 · Adams Kitchen Remodel", v2_md_mock_status: "Approved",
      v2_md_mock_contract: "Contract", v2_md_mock_invoiced: "Invoiced", v2_md_mock_left: "Left to bill",
      v2_md_mock_note: "Progress billing panel — live contract, invoiced and remaining on every job.",
      v2_jc_label: "Job costing",
      v2_jc_h2: "Snap the receipt. Know what every job really cost.",
      v2_jc_body: "Photograph a receipt on site — the 360 Assistant reads it and files it on the job. Materials, subs, rentals, fuel, equipment hours and mileage add up as you go, so you see the real cost before the final invoice.",
      v2_jc_pill1: "Receipt photo → cost on the job",
      v2_jc_pill2: "15 cost categories",
      v2_jc_pill3: "Equipment & mileage logs",
      v2_jc_card_title: "Actual costs so far",
      v2_jc_row_materials: "Materials",
      v2_jc_row_subs: "Subcontractor",
      v2_jc_row_rental: "Rental & equipment",
      v2_jc_row_disposal: "Disposal & delivery",
      v2_jc_read: "Receipt read: Lumber yard · Materials · added to job",
      v2_sc_label: "Crew schedule",
      v2_sc_h3: "Everyone knows where to be tomorrow.",
      v2_sc_body: "Put a job on the schedule in three taps — Tomorrow, Morning, crew. It shows on every phone the night before.",
      v2_sc_row1: "7 AM Framing · Miller New Home",
      v2_sc_row2: "12 PM Inspection · Johnson Roof",
      v2_a_label: "360 Assistant",
      v2_a_h3: "Say what happened. Approve the paperwork.",
      v2_a_quote: "Finished the tear-off, found six bad sheets. Schedule install tomorrow morning.",
      v2_a_chip1: "Daily log",
      v2_a_chip2: "Schedule",
      v2_a_chip3: "Customer update",
      v2_a_small: "Nothing is saved or sent until you approve it.",
      v2_pr_h2: "Two plans. Your whole crew.",
      v2_pr_per_month: "/month",
      v2_pr_seats: "3 users included · $5/month per extra user",
      v2_pr_note: "Most photo apps charge per user. You get three.",
      v2_pr_f1: "Unlimited projects & jobsite photos",
      v2_pr_f2: "Customer progress galleries",
      v2_pr_f3: "Job costing & receipts",
      v2_pr_f4: "Crew schedule, daily logs & timecards",
      v2_pr_f5: "360 Assistant · English & Spanish",
      v2_pr_under: "No credit card · Cancel anytime",
      v2_faq_h2: "Questions",
      v2_faq_q1: "How does the free trial work?",
      v2_faq_a1: "You get full access for 14 days — no credit card up front. When the trial ends, choose a plan to keep working; your photos and records stay in place.",
      v2_faq_q2: "What does it cost afterward?",
      v2_faq_a2: "Essentials: $59/month or $49/month billed yearly ($588), 3 users included. Pro: $129/month or $109/month billed yearly ($1,308), 5 users included. Extra users $10/month each.",
      v2_faq_q3: "Is photo storage limited?",
      v2_faq_a3: "Your plan sets no photo limit, and originals are preserved.",
      v2_faq_q4: "Who can see my photos?",
      v2_faq_a4: "Only people in your company. Customers see only what you share through a gallery link — no app, no login — and recorded photo locations stay inside your account.",
      v2_faq_q5: "How do I put it on my phone?",
      v2_faq_a5: "Open buildproject360.com in your phone's browser and choose 'Add to Home Screen' — it works like an app, no app store needed.",
      v2_faq_q6: "Can I get a refund?",
      v2_faq_a6: "If you're not satisfied, email us within 30 days of your first paid charge (monthly or yearly) and we'll refund that charge in full. After that, monthly charges aren't refunded, but you can cancel anytime and keep access until the end of the month. If a yearly plan renews and you email us within 7 days of the renewal charge, we'll refund it in full. Refunds go back to the original payment method.",
      v2_pr_guarantee: "30-day money-back guarantee on your first payment",
      billing_refund_note: "30-day money-back guarantee on your first payment · Cancel anytime — you keep access until the end of the paid period",
      footer_address: "BuildProject360 LLC, 2722 Erie Ave Ste 219 PMB 919133, Cincinnati, OH 45208",
      v2_fi_h2: "Every jobsite photo, dated and on file.",
      v2_fi_body: "Set up your first job in under a minute.",
      v2_fi_small: "No credit card · 3 users included",
      v2_fo_rights: "© 2026 BuildProject360",
      seo_login_title: "Sign In | BuildProject360",
      seo_login_desc: "Sign in to your BuildProject360 contractor workspace.",
      seo_signup_title: "Start Your 14-Day Free Trial | BuildProject360",
      seo_signup_desc: "Create your BuildProject360 account — no credit card required.",
      auth_pw_req: "At least 8 characters",
      auth_pw_show: "Show password",
      auth_pw_hide: "Hide password",
      auth_caps_lock: "Caps Lock is on",
      auth_email_invalid: "Enter a valid email address",
      auth_terms_notice_pre: "By creating an account, you agree to the ",
      auth_terms_link: "Terms of Service",
      auth_terms_notice_mid: " and acknowledge the ",
      auth_privacy_link: "Privacy Policy",
      auth_terms_notice_post: ".",
      footer_terms: "Terms of Service",
      footer_privacy: "Privacy Policy",
      crew_share_creds_pre: "Share these credentials with",
      crew_temp_password: "Temp password",
      hp_no_photos: "No photos yet",
      hp_no_updates: "No updates yet",
      ps_unpublished: "This page isn't published yet.",
      web_preview_title: "Preview",
      web_preview_desc: "Website preview",
      byl_desc: "End-of-day checklist",
      admin_attr_title: "Attribution (UTM)",
      admin_attr_accounts: "accounts attributed",
      admin_attr_source: "Source",
      admin_attr_medium: "Medium",
      admin_attr_campaign: "Campaign",
      admin_attr_signups: "Signups",
      auth_referral_link: "Have a referral code?",
      auth_signup_reassurance: "Start using BuildProject360 immediately. No sales call or required onboarding appointment.",
      pricing_honesty_line: "One straightforward plan. No required sales call. No setup fee. No hidden feature tiers.",
      auth_pw_strength: "Password strength",
      auth_pw_weak: "Weak",
      auth_pw_fair: "Fair",
      auth_pw_good: "Good",
      auth_pw_strong: "Strong",
      auth_pw_common: "That password is too common — choose a longer, unique one.",
      common_optional: "optional",
      np_addr_helper: "Search the job's street address — or tap \"Use my location\" while you're on site. Drag the pin to fine-tune.",
      nav_group_tools: "Settings & Tools",
      nav_help: "Help & Guides",
      welcome_title: "Get set up in minutes",
      welcome_sub: "An optional quick-start checklist — dismiss it anytime.",
      welcome_step_brand: "Add your company information",
      welcome_step_customer: "Create your first customer",
      welcome_step_project: "Create your first project",
      welcome_step_photo: "Add your first photo",
      welcome_step_share: "Share a customer gallery",
      welcome_skip: "Skip for now",
      welcome_progress: "{{done}} of {{total}} done",
      welcome_done_title: "All set — you're up and running",
      welcome_done_sub: "Everything's complete — this checklist will hide itself now.",
      help_title: "Help & Guides",
      help_search: "Search quick guides…",
      help_contact: "Need help? Search our quick guides or contact us.",
      help_contact_btn: "Contact support",
      help_video_t: "Watch: How to navigate BuildProject360",
      ep_title: "Edit project",
      ep_customer: "Customer",
      ep_remove_customer: "Remove customer",
      pd_add_customer: "+ Add customer",
      ep_name: "Project name",
      ep_address: "Address",
      ep_address_hint: "Optional. Search for the address, enter it manually, or confirm the pin on the map.",
      ep_remove_address: "Remove address",
      ep_name_required: "Project name is required.",
      ep_saved: "Project updated",
      ep_save: "Save changes",
      ep_cancel: "Cancel",
      sel_clear: "Clear selection",
      tc_acknowledge: "Acknowledge",
      tc_ack_hint: "Marks the warning as seen — hours are not changed.",
      u360_pick_worker: "Match each worker to a crew member",
      u360_pick_worker_ph: "Pick crew member",
      help_video_d: "A 3-minute tour — one job, start to finish.",
      help_watch_clip: "Watch clip",
      help_clip_schedule_t: "Schedule work",
      help_clip_assistant_t: "Speak a 360 Update",
      help_reopen_welcome: "Show the welcome checklist again",
      help_g1_t: "How to create a customer",
      help_g1_b: "Go to Customers, tap New customer. A name is enough to start — add phone, email and address whenever you have them.",
      help_g2_t: "How to create a project",
      help_g2_b: "Go to Projects, tap New Project. Only the project name is required — add a customer and job address when ready.",
      help_g3_t: "How to take and organize photos",
      help_g3_b: "Open a project and tap the Camera button. Every photo lands in the project's Photos tab with its date and author.",
      help_g4_t: "How to share with a customer",
      help_g4_b: "Open the project, tap Share with Customer, pick the photos and send the link. Your customer needs no account or app.",
      help_g5_t: "How to create an estimate",
      help_g5_b: "Go to Estimates & Invoices, tap New Estimate, add line items, save, then send or share the approval link.",
      help_g6_t: "How to invite crew members",
      help_g6_b: "Go to Crew, tap Invite. They get their own login and only see the projects you assign to them.",
      help_g7_t: "How billing works",
      help_g7_b: "Two plans: Essentials $59/mo or $49/mo billed yearly (3 users) and Pro $129/mo or $109/mo billed yearly (5 users). Extra users $10/mo. 14-day free trial of Pro, no credit card required. Manage it under Settings › Plan & Billing.",
      cta_trust_line: "No credit card required • Three users included • Cancel anytime",
      land_steps_title: "How it works",
      land_step_1_t: "Create your first project",
      land_step_1_d: "Add the customer, address and first photos — takes less than a minute.",
      land_step_2_t: "Capture updates from the field",
      land_step_2_d: "Snap photos, speak a voice note, and log the day's work right from the jobsite.",
      land_step_3_t: "Keep your crew and customer informed",
      land_step_3_d: "Share a clean, branded page your customer can open anytime — no account needed.",
      land_builtfor_title: "Built for",
      land_builtfor_1: "Remodelers",
      land_builtfor_2: "Roofers",
      land_builtfor_3: "General contractors",
      land_builtfor_4: "Small construction crews",
      land_testi_title: "What contractors say",
      land_testi_body: "We're collecting real reviews from our first customers.",
      land_testi_placeholder: "Designed with working contractors — not enterprise software committees.",
      land_sec_title: "Your data, protected",
      land_sec_1_t: "Private by default",
      land_sec_1_d: "Photos, customer details and finances are visible only to your company.",
      land_sec_2_t: "Nightly backups",
      land_sec_2_d: "Automatic backups with restore checks, plus originals preserved untouched.",
      land_sec_3_t: "Secure sharing",
      land_sec_3_d: "Short, revocable links with optional passwords and expiration.",
      land_faq_title: "Questions, answered",
      land_faq_1_q: "How does the 14-day trial work?",
      land_faq_1_a: "Full access for 14 days. No credit card required — we email you before it ends.",
      land_faq_2_q: "What does it cost after the trial?",
      land_faq_2_a: "$49/month or $490/year for the Complete plan. Extra users are $5/month each.",
      land_faq_3_q: "How many users are included?",
      land_faq_3_a: "3 users included. Extra users are $5/month each.",
      land_faq_4_q: "Is my photo storage limited?",
      land_faq_4_a: "No. Unlimited photos and video — originals are preserved untouched and thumbnails load fast even on large projects.",
      land_faq_5_q: "Can I cancel anytime?",
      land_faq_5_a: "Yes. Cancel from Plan & Billing in two taps — your data stays exportable.",
      land_faq_6_q: "How do I install it on my phone?",
      land_faq_6_a: "Open buildproject360.com, sign in, and use Install App — on iPhone: Share → Add to Home Screen.",
      land_cta_title: "Try BuildProject360 free for 14 days",
      land_cta_body: "Every job. Every photo. One app.",
      sel_del_title: "Delete {{count}} photos?",
      sel_del_body: "Photos are soft-deleted and can be restored from Project Trash.",
      zip_started: "Preparing your ZIP — we'll notify you when it's ready.",
      zip_ready: "Your ZIP is ready — downloading now.",
      share_title: "Share Photos",
      share_photos_count: "{{count}} photos",
      share_name: "Share title",
      share_message: "Message (optional)",
      share_message_ph: "Add a note for the recipient…",
      share_expires: "Link expiration",
      share_exp_7: "7 days",
      share_exp_30: "30 days",
      share_exp_never: "No expiration",
      share_password: "Password (optional)",
      share_optional: "Optional",
      share_allow_download: "Allow downloads",
      share_show_captions: "Include captions",
      share_watermark: "Add company watermark",
      share_privacy_note: "Shared pages never show GPS coordinates, internal notes or employee-only comments.",
      share_create_link: "Create Secure Link",
      share_copy_link: "Copy Link",
      share_text: "Text Message",
      share_email: "Email",
      share_email_ph: "customer@email.com",
      share_email_sent: "Email sent",
      share_preview_page: "Preview Shared Page",
      share_pw_title: "Password required",
      share_pw_body: "Enter the password to view this shared gallery.",
      share_pw_wrong: "Incorrect password — try again.",
      share_pw_open: "View Photos",
      share_invalid: "This link is no longer available",
      share_invalid_body: "It may have expired or been revoked. Ask your contractor for a new link.",
      share_powered_by: "Shared securely via",
      ms_title: "Manage Shared Links",
      ms_subtitle: "Copy, edit or revoke any link — changes apply instantly.",
      ms_empty: "No shared links yet. Use Share on the project page to create one.",
      ms_untitled: "Shared gallery",
      ms_by: "by {{name}}",
      ms_views: "{{count}} views",
      ms_last_opened: "Last opened",
      ms_never_opened: "Never opened",
      ms_expires: "Expires",
      ms_downloads_on: "Downloads allowed",
      ms_downloads_off: "Downloads off",
      ms_revoke: "Revoke",
      ms_revoked: "Link revoked",
      ms_revoked_badge: "Revoked",
      ms_expired_badge: "Expired",
      ms_active_badge: "Active",
      ms_active_links: "{{count}} active share links",
      ms_legacy_title: "Old long links (legacy)",
      ms_legacy_jwt: "Legacy portal link (long URL)",
      about_title: "About BuildProject360",
      about_version: "App version",
      about_build: "Build",
      about_updated: "Last update",
      about_trouble: "Troubleshooting",
      about_clear_hint: "Clears cached app files and reloads. Keeps you signed in; unsent photos and logs are preserved.",
      about_clear_cache: "Clear App Cache & Reload",
      action_see_how: "Explore Features",
      nav_product: "Product",
      nav_features: "Features",
      nav_pricing: "Pricing",
      nav_for_contractors: "For Contractors",
      footer_rights: "© 2026 BuildProject360. All rights reserved.",
      nav_financials: "Money",
      nav_reports: "Cost Reports",
      jr_title: "Cost Reports",
      jr_subtitle: "Company spend, assets and exports",
      jr_tab_company: "Company",
      jr_tab_assets: "Assets",
      jr_tab_export: "Export",
      jr_range: "Range",
      jr_no_data: "No cost data in this range yet",
      jr_total_spend: "Total spend",
      jr_receipts: "Receipts",
      jr_labor: "Labor",
      jr_equipment: "Equipment",
      jr_hours_short: "h",
      jr_labor_unpriced: "Labor hours are tracked but not priced — set an internal labor rate in a project's Cost Settings.",
      jr_monthly: "Month over month",
      jr_by_category: "Spend by category",
      jr_company_overhead: "Company overhead (unallocated)",
      jr_per_project: "Per project",
      jr_overhead: "Overhead",
      jr_with_overhead: "incl. overhead",
      jr_rented: "Rented",
      jr_owned: "Owned",
      jr_retired: "Retired",
      jr_total_cost: "Total cost",
      jr_hours: "Hours",
      jr_cost_per_hour: "Cost / hour",
      jr_utilization: "Days used (30d)",
      jr_linked_receipts: "Linked receipts",
      jr_miles: "Miles",
      jr_export_hint: "Download CSV files for your bookkeeper. Refunds export as negative amounts.",
      jr_from: "From",
      jr_to: "To",
      jr_project: "Project",
      jr_all_projects: "All projects",
      jr_download_receipts: "Receipts CSV",
      jr_download_costs: "Project costs CSV",
      jr_preparing: "Preparing…",
      fin_estimates: "Estimates",
      fin_estimate: "Estimate",
      fin_change_orders: "Change Orders",
      fin_invoices: "Invoices",
      fin_payments: "Payments",
      fin_products: "Products & Services",
      fin_settings: "Settings",
      fin_new_estimate: "New Estimate",
      fin_new_co: "New Change Order",
      fin_new_invoice: "New Invoice",
      fin_record_payment: "Record Payment",
      fin_status: "Status",
      fin_number: "Number",
      fin_customer: "Customer",
      fin_project: "Project",
      fin_total: "Total",
      fin_balance: "Balance",
      fin_send: "Send",
      fin_sent: "Sent",
      fin_viewed: "Viewed",
      fin_approved: "Approved",
      fin_declined: "Declined",
      fin_changes_requested: "Changes Requested",
      fin_draft: "Draft",
      fin_expired: "Expired",
      fin_converted: "Converted",
      fin_archived: "Archived",
      fin_voided: "Voided",
      fin_paid: "Paid",
      fin_partial: "Partially Paid",
      fin_partially_paid: "Partially Paid",
      fin_refunded: "Refunded",
      fin_overdue: "Overdue",
      fin_invoiced: "Invoiced",
      fin_invoiced_n: "Invoiced · {{n}}",
      fin_line_items: "Line items",
      fin_add_item: "Add item",
      fin_add_section: "Add section",
      fin_from_library: "From library",
      fin_from_pricebook: "From price book",
      fin_save_to_library: "Save to library",
      fin_item_name: "Item name",
      fin_description: "Description",
      fin_qty: "Qty",
      fin_unit: "Unit",
      fin_unit_price: "Unit price",
      fin_section: "Section",
      fin_optional: "Optional",
      fin_hide_qty: "Hide qty",
      fin_hide_price: "Hide price",
      fin_taxable: "Taxable",
      fin_subtotal: "Subtotal",
      fin_discount: "Discount",
      fin_tax: "Tax",
      fin_message: "Customer message",
      fin_internal_notes: "Internal notes (not visible to customer)",
      fin_terms: "Terms & conditions",
      fin_expires: "Expiration date",
      est_cust_switch: "Switch the customer to {{name}} (linked to {{project}})?",
      est_cust_switch_yes: "Switch customer",
      est_cust_switch_no: "Keep current",
      signup_welcome_sending: "Account ready — a welcome email is on its way to {{email}}.",
      est_loading: "Loading estimate…",
      est_load_failed: "We couldn't load this estimate. Check your connection and retry.",
      action_retry: "Retry",
      action_back: "Back",
      help_resend_welcome: "Resend welcome email",
      help_resend_sent: "Welcome email sent to {{email}}. Check your inbox and spam folder.",
      help_resend_failed: "Couldn't send the email right now. Try again in a few minutes or contact support.",
      fin_salesperson: "Salesperson",
      fin_title: "Title",
      fin_date: "Date",
      fin_save_draft: "Save draft",
      fin_preview: "Customer preview",
      fin_convert: "Convert to project",
      fin_version: "Version",
      fin_activity: "Activity",
      fin_awaiting: "Estimates awaiting approval",
      fin_approved_count: "Approved estimates",
      fin_open_value: "Open estimates value",
      fin_outstanding: "Outstanding invoices",
      fin_overdue_count: "Overdue invoices",
      fin_payments_month: "Payments this month",
      fin_co_awaiting: "Change orders awaiting approval",
      fin_active_contracts: "Active contract value",
      fin_original_contract: "Original contract",
      fin_approved_cos: "Approved change orders",
      fin_current_contract: "Current contract amount",
      fin_invoiced: "Invoiced",
      fin_paid_total: "Total paid",
      fin_remaining_invoice: "Remaining to invoice",
      fin_amount: "Amount",
      fin_method: "Method",
      fin_reference: "Reference / check #",
      fin_date_received: "Date received",
      fin_notes: "Notes",
      fin_receipt: "Receipt",
      fin_download_pdf: "Download PDF",
      fin_portal_approve: "Approve & Sign",
      fin_portal_decline: "Decline",
      fin_portal_request_changes: "Request changes",
      fin_portal_question: "Ask a question",
      fin_portal_fullname: "Your full legal name",
      fin_portal_signature: "Type your signature",
      fin_portal_consent_est: "By signing below, I confirm that I have reviewed and approve this estimate, including the selected work, pricing, terms, and payment schedule.",
      fin_portal_consent_co: "By signing below, I authorize this change to the project scope, contract amount, and schedule as described above.",
      fin_portal_approved_msg: "Thank you! Your approval has been recorded.",
      fin_empty_estimates: "No estimates yet",
      fin_empty_co: "No change orders yet",
      fin_empty_invoices: "No invoices yet",
      fin_empty_payments: "No payments yet",
      fin_empty_products: "No products or services yet",
      nav_time: "Time",
      tc_start_day: "Start My Day",
      tc_clock_in: "Clock In",
      tc_clock_out: "Clock Out",
      tc_break_start: "Start Break",
      tc_break_end: "End Break",
      tc_switch: "Switch Project",
      tc_morning_plan: "Morning Plan",
      tc_evening_update: "Evening Update",
      tc_day_update: "Update",
      tc_working_since: "Working since",
      tc_working: "Working",
      tc_on_break: "On break",
      tc_not_clocked: "Not clocked in",
      tc_suggested: "Closest project",
      tc_none_nearby: "No projects near your current location. Your manager can see your clock-in either way.",
      tc_pick_manual: "Choose your project",
      tc_no_projects: "No active projects yet — ask your manager to assign one.",
      viewer_favorite: "Favorite",
      viewer_unfavorite: "Remove favorite",
      pd_no_map: "We couldn't map this address — check the spelling or drop the pin manually.",
      pd_no_map_none: "No job address yet — add the address or drop a pin to map this project.",
      pd_add_address: "Add address",
      fin_unlinked: "Not linked to a customer or project",
      tc_confirm_project: "Confirm Project",
      tc_choose_other: "Choose Another Project",
      tc_away_title: "You appear to be away from the selected project",
      tc_away_distance: "Current distance from the project",
      tc_reason: "Reason",
      tc_reason_materials: "Picking up materials",
      tc_reason_shop: "Company shop",
      tc_reason_meeting: "Customer meeting",
      tc_reason_customer_meeting: "Customer meeting",
      tc_reason_driving: "Driving to project",
      tc_reason_remote: "Working remotely",
      tc_reason_inaccurate: "Location inaccurate",
      tc_reason_other: "Other",
      tc_loc_unavailable: "Location unavailable",
      tc_needs_review: "Needs Review",
      tc_missed_title: "Still working?",
      tc_missed_body: "You are still clocked in. Are you still working?",
      tc_still_working: "Yes, Still Working",
      tc_clock_out_now: "Clock Out Now",
      tc_request_correction: "Request Time Correction",
      tc_correction_reason: "Reason for correction",
      tc_correction_sent: "Correction requested",
      tc_privacy_title: "Location & Time Notice",
      tc_privacy_ack: "I Understand",
      tc_production: "Production (optional)",
      tc_prod_item: "Work item",
      tc_prod_qty: "Qty",
      tc_saved_morning_plan: "Morning plan saved", tc_saved_evening_update: "Evening update saved", tc_saved_day_update: "Update saved",
      cl_photo_required: "Photo required", pd_prod_of: "of",
      tc_prod_target: "Target",
      tc_all_local: "All times shown in the project's local timezone.",
      tc_proof_report: "Project Proof Report",
      tc_ai_summary: "AI Daily Summary",
      tc_ai_draft: "Draft — manager review required",
      tc_no_summaries: "No summaries yet.",
      tc_approve: "Approve",
      tc_share_customer: "Share with customer",
      tc_keep_internal: "Keep internal",
      tc_generate: "Generate summary",
      tc_labor_est: "Estimated hours",
      tc_labor_actual: "Actual hours",
      tc_labor_remaining: "Hours remaining",
      tc_on_track: "On Track",
      tc_watch: "Watch",
      tc_over: "Over Estimate",
      feat_customers: "Customer Management", feat_customers_d: "Every customer, phone, email, and address in one place.",
      feat_projects: "Project Management", feat_projects_d: "Track every job from first call to final photo.",
      feat_photos: "Jobsite Photos", feat_photos_d: "Rapid camera, before/after sets, and a full project timeline.",
      feat_schedule: "Scheduling", feat_schedule_d: "Today, week, and timeline views your whole crew can follow.",
      feat_crew: "Crew Management", feat_crew_d: "Invite your crew and assign them to projects in seconds.",
      feat_estimates: "Estimates & Invoices", feat_estimates_d: "Professional estimates and invoices without the paperwork.",
      feat_payments: "Customer Payments", feat_payments_d: "Get paid faster with simple online payments.",
      feat_website: "Contractor Website", feat_website_d: "A branded website with your work, reviews, and estimate requests.",
      feat_leads: "Leads & Referrals", feat_leads_d: "Capture website leads and grow with referrals.",
      why_1_title: "Photos with the job",
      why_1_desc: "Every photo tagged to a project with date, time, GPS and notes.",
      why_2_title: "Voice daily logs",
      why_2_desc: "Tap the mic, speak the log. Weather auto-attached.",
      why_3_title: "Customer portal",
      why_3_desc: "A branded, magic-link page with progress and photos.",
      why_4_title: "Bilingual EN / ES",
      why_4_desc: "Every screen, every button, day one.",
      // Auth
      auth_email: "Email",
      auth_password: "Password",
      auth_name: "Your name",
      crew_name: "Name",
      auth_company: "Company name",
      auth_login_title: "Sign in to BuildProject360",
      auth_register_title: "Create your BuildProject360 account",
      auth_have_account: "Already have an account?",
      auth_no_account: "New here?",
      auth_referral_code: "Referral code (optional)",
      auth_referral_placeholder: "e.g. BF-ACME-1A2B",
      auth_continue_google: "Continue with Google",
      auth_or: "or",
      auth_signing_in: "Signing you in…",
      auth_google_failed: "Google sign-in didn't complete. Please try again.",
      // Referrals
      ref_title: "Refer & earn",
      ref_subtitle: "Your $49 monthly base plan is free while three referred contractors stay active paying customers.",
      ref_your_code: "Your referral code",
      ref_copy: "Copy",
      ref_copied: "Copied!",
      ref_share_hint: "Share this link — it pre-fills your code at signup:",
      ref_how_title: "How it works",
      ref_how_1: "Share your link, code or QR with contractors you know",
      ref_how_2: "They get their first paid month free; they qualify for you after 60 paid days",
      ref_how_3: "Each qualified referral takes 1/3 off your base plan — 3 or more and it's free",
      ref_list_title: "Your referrals",
      ref_empty_title: "No referrals yet",
      ref_empty_hint: "Share your code with contractors you know. When three become active paying customers, your $49 base plan is free.",
      ref_monthly_total: "Monthly credits",
      ref_cap_note: "Credits are capped at your plan price ({{cap}}/mo on {{plan}}).",
      ref_offer: "Every contractor you refer who stays an active paying customer for 60+ days takes 1/3 off your base plan — one referral is 1/3 off, two is 2/3 off, three or more and your base plan is free.",
      ref_link: "Your referral link",
      ref_copy_link: "Copy Link",
      ref_share_text: "Share by text",
      ref_share_email: "Share by email",
      ref_share_subject: "Try BuildProject360",
      ref_share_body: "I've been using BuildProject360 for my jobs — photos, logs, estimates, the works. Try it free for 14 days: {{link}}",
      ref_total: "Total referrals",
      ref_pending: "Pending",
      ref_qualified: "Qualified active",
      ref_current_credit: "Referral reward",
      ref_reward_free: "FREE",
      ref_credit_off: "{{pct}}% off base",
      ref_of_3: "of 3",
      ref_progress_0: "0 of 3 referrals active",
      ref_progress_1: "You've referred 1 — 1/3 off your base plan now",
      ref_progress_2: "You've referred 2 — 1 more and BuildProject360 is free",
      ref_progress_3: "3 of 3 referrals active — Your $49 base plan is free",
      ref_status_pending: "Pending",
      ref_status_qualified: "Qualified",
      ref_status_canceled: "Canceled",
      ref_status_rejected: "Rejected",
      ref_status_disqualified: "Disqualified",
      ref_qualify_note: "A referral qualifies once the company has been an active paying customer for 60 days. The discount applies to the base plan only, never to extra seats. Referred companies get their first paid month free.",
      ref_status_active: "Active",
      ref_status_cancelled: "Cancelled",
      ref_since: "Since",
      // Leads
      leads_title: "Leads",
      leads_subtitle: "Track every opportunity from first call to signed contract.",
      lead_new: "New lead",
      lead_name: "Customer name",
      lead_phone: "Phone",
      lead_email_addr: "Email",
      lead_address: "Job address",
      lead_source: "Source (referral, yard sign…)",
      lead_notes: "Notes",
      lead_status_new: "New",
      lead_status_quoted: "Quoted",
      lead_status_won: "Won",
      lead_status_lost: "Lost",
      lead_convert: "Convert to project",
      lead_converted: "Converted",
      lead_empty_title: "No leads yet",
      lead_empty_hint: "Add your first lead — when it closes, convert it to a project in one tap.",
      // Schedule views
      sched_week: "Week",
      sched_list: "List",
      // Photo details / pairing
      photo_details: "Photo details",
      photo_pair_with: "Pair with…",
      photo_before: "Before",
      photo_after: "After",
      photo_unpair: "Remove pairing",
      photo_none: "No pair",
      photo_delete_confirm: "Delete this photo?",
      // Offline
      offline_saved: "Saved offline — will sync when you're back online",
      offline_synced: "Synced {{count}} offline item(s)",
      offline_synced_one: "Synced {{count}} offline item",
      // Crew assignment
      crew_assign: "Assign projects",
      crew_assigned_projects: "Assigned projects",
      crew_assign_hint: "Crew members only see their assigned projects.",
      nav_leads: "Leads",
      filter_all: "All",
      tab_logs: "Logs",
      tab_tasks: "Tasks",
      lead_followup: "Next follow-up",
      lead_value: "Estimated job value",
      lead_type: "Project type",
      lead_assigned: "Assigned salesperson",
      lead_last_contact: "Last contact",
      lead_activity: "Activity",
      lead_add_note: "Add note",
      lead_note_placeholder: "Called, left voicemail…",
      lead_call: "Call",
      lead_text: "Text",
      lead_email_btn: "Email",
      lead_more: "More details",
      lead_less: "Less details",
      lead_overdue: "Follow-up overdue",
      sched_prev: "Previous week",
      sched_next: "Next week",
      sched_today: "Today",
      cal_prefs_title: "Calendar preferences",
      cal_week_start: "Week starts on",
      cal_sunday: "Sunday",
      cal_monday: "Monday",
      cal_workweek: "Workweek",
      cal_workweek_5: "5 days (Mon–Fri)",
      cal_workweek_7: "7 days",
      cal_weekend_hint: "Weekend jobs always show — weekends are just dimmed.",
      sched_save_target: "Review before saving",
      sched_project_unavailable: "Selected project unavailable — pick another",
      sched_event_type: "Event type",
      sched_type_project: "For a job",
      sched_type_company: "Company-wide — meeting, day off, training, etc.",
      pd_schedule_this_job: "+ Schedule this job",
      sched_quick_today: "Today",
      sched_quick_tomorrow: "Tomorrow",
      sched_quick_pick: "Pick date",
      sched_time_allday: "All day",
      sched_time_morning: "Morning, 7:00 AM–12:00 PM",
      sched_time_afternoon: "Afternoon, 12:00 PM–5:00 PM",
      sched_time_custom: "Custom time",
      sched_time_label: "Time",
      sched_title_optional: "optional — defaults to the job name",
      action_navigate: "Navigate",
      sched_company_note: "Company event — not connected to a project",
      sched_pick_project_hint: "Select a project, or switch to Company event",
      sched_no_crew: "No crew",
      sched_no_projects_hint: "No projects yet — switch to Company event",
      photo_getting_loc: "Getting location…",
      photo_proof_title: "Photo proof",
      photo_captured: "Captured",
      photo_taken_by: "Taken by",
      photo_loc_none: "Location not captured for this photo",
      proof_verified: "GPS location recorded",
      proof_outside_project: "GPS recorded — outside project area",
      proof_low_accuracy: "Low-accuracy location",
      proof_imported: "Imported location (from file)",
      proof_project_only: "Project location only — this photo has no GPS of its own",
      proof_none: "Location not captured",
      proof_unverified: "Unverified photo — location was not captured",
      photo_loc_not_in_file: "Location not available in this file",
      proof_tz: "Timezone",
      proof_coords: "GPS coordinates",
      proof_loc_source: "Location source",
      proof_ls_gps: "Device GPS at capture",
      proof_ls_denied: "Permission denied",
      proof_ls_timeout: "GPS timed out",
      proof_ls_unavailable: "Location unavailable",
      proof_ls_exif: "File EXIF metadata",
      proof_ls_none: "Not captured",
      proof_privacy: "Customer sharing",
      proof_privacy_exact: "Customers see the exact location",
      proof_privacy_approx: "Customers see an approximate location",
      proof_privacy_project: "Customers see no photo location (project only)",
      proof_privacy_hidden: "Location hidden from customers",
      proof_download_stamped: "Download stamped copy",
      pp_gps_verified: "GPS location recorded",
      pp_gps_outside: "GPS recorded — outside project area",
      pp_project_short: "Project location only",
      pp_project_pin: "project location",
      proof_hidden: "Location recorded · details hidden",
      pp_accuracy: "Accuracy ±{{ft}} ft ({{m}} m)",
      viewer_close_photo: "Close photo",
      gallery_proof_title: "Gallery proof display",
      gallery_proof_below: "Below photo (recommended)",
      gallery_proof_on_photo: "On photo",
      gallery_proof_hidden: "Hidden from gallery",
      gallery_proof_note: "Controls only what viewers see — GPS data and verification status are never changed. Downloads and exports keep the proof stamp.",
      stamp_allow_original: "Allow office users to download untouched originals",
      projects_slow: "Projects are taking longer than expected",
      projects_offline: "You appear to be offline. Check your connection.",
      projects_load_error: "We couldn't load your projects.",
      projects_retry: "Retry",
      viewer_scroll_more: "Scroll for more proof details",
      sched_more_events: "Show all {{n}} more events for this day",
      sched_more_suffix: "more",
      queue_title: "Offline queue",
      queue_sync_now: "Sync now",
      queue_retry_failed: "Retry failed",
      queue_pending: "Pending",
      queue_uploading: "Uploading…",
      queue_uploaded: "Uploaded",
      queue_failed: "Failed",
      cam_gps_ok: "GPS ±{{m}} m",
      cam_gps_search: "Locating…",
      cam_gps_none: "No GPS — photo will be unverified",
      cam_gps_denied: "Location denied — photo will be unverified",
      stamp_title: "Photo Proof Stamp",
      stamp_body: "Burn a compact time-and-location proof bar onto stamped copies for customer galleries, downloads and reports. Original photos are never modified.",
      stamp_share_default: "Stamp customer-shared photos",
      stamp_show_logo: "Show 360 logo",
      stamp_show_company: "Show company name",
      stamp_show_project: "Show project name",
      stamp_show_photographer: "Show photographer",
      stamp_show_accuracy: "Show GPS accuracy",
      stamp_position: "Stamp position",
      stamp_pos_bar: "Full-width bottom bar",
      stamp_pos_bl: "Bottom-left",
      stamp_pos_bc: "Bottom-center",
      stamp_pos_br: "Bottom-right",
      stamp_download_default: "Downloads",
      stamp_dl_ask: "Ask each time",
      stamp_dl_always: "Stamped by default",
      stamp_dl_never: "Originals only",
      stamp_preview: "Preview stamp",
      stamp_reset: "Reset to recommended",
      stamp_none_hint: "Add a photo first to preview the stamp",
      stamp_on: "On",
      stamp_off: "Off",
      viewer_view_original: "Original",
      viewer_view_stamped: "Stamped",
      download_original: "Download original",
      sel_download_stamped: "Stamped copies",
      sel_proof_report: "Proof report",
      share_trust_verified: "{{v}} of {{t}} photos with GPS recorded",
      share_trust_low: "{{n}} photo(s) with low-accuracy GPS",
      share_trust_nocap: "{{n}} photo(s) without captured location",
      photo_accuracy: "GPS accuracy: ~{{ft}} ft",
      photo_distance: "{{d}} from project location",
      photo_distance_warn: "Photo was captured {{d}} from the project location",
      photo_open_maps: "Open photo location in Google Maps",
      photo_tech: "Technical details",
      photo_uploaded_at: "Uploaded",
      photo_source_camera: "In-app camera",
      photo_source_upload: "Device upload",
      photo_source_import: "Imported",
      photo_loc_privacy: "Photo location on customer links",
      photo_loc_exact: "Exact location",
      photo_loc_approx: "Approximate location",
      photo_loc_project: "Project name only",
      photo_loc_hidden: "Hidden",
      sched_start: "Start",
      sched_end: "End",
      sched_crew: "Assigned crew",
      sched_title_label: "Title",
      sched_work_title: "Schedule Work",
      sched_project_or_job: "Project or Job",
      sched_project_ph: "Choose a project",
      sched_no_project: "No project (company event)",
      sched_what_label: "What's scheduled?",
      sched_what_ph: "Roof installation, inspection, material delivery…",
      sched_what_required: "Enter what work is scheduled.",
      sched_add_time_optional: "Add Time (Optional)",
      sched_assigned_crew: "Assigned Crew",
      sched_add_action: "Add to Schedule",
      sched_date_label: "Date",
      sched_project_label: "Project",
      proj_phone: "Customer phone",
      proj_type: "Project type",
      proj_contract: "Contract value",
      proj_source: "Lead source",
      proj_more: "More details",
      proj_less: "Less details",
      proj_crew: "Assigned crew",
      proj_start: "Start date",
      proj_end: "Expected completion",
      task_due: "Due date",
      task_assignee: "Assignee",
      task_priority: "Priority",
      task_low: "Low",
      task_medium: "Medium",
      task_high: "High",
      task_overdue: "Overdue",
      task_add_placeholder: "Add a task…",
      task_add: "Add",
      task_empty: "No tasks yet",
      task_photo: "Attach photo",
      common_delete: "Delete",
      common_edit: "Edit",
      photos_search: "Search notes, tags…",
      photos_cat: "Category",
      photos_uploaded_by: "uploaded by",
      photos_progress: "Progress",
      photos_download: "Download",
      photos_report: "PDF report",
      photos_retry: "Retry offline uploads",
      log_transcribing: "Transcribing…",
      not_authorized: "Not authorized",
      not_authorized_leads: "Leads are visible to owners and admins only. Ask your owner for access.",
      see_all: "See all",
      share_generate: "Generate link",
      share_copy_link: "Copy link",
      sched_gantt: "Gantt",
      gantt_no_dates: "Set start/end dates on a project to see it here",
      gantt_timeline_empty: "Add tasks to a job to see it on the timeline",
      catchup_title: "Catch up",
      catchup_hint: "These were due on earlier days. Mark them done or move them.",
      catchup_mark_all: "Mark all done",
      catchup_empty: "All caught up — nothing past due.",
      catchup_done: "Done",
      catchup_today: "Move to today",
      catchup_reschedule: "Reschedule",
      catchup_home: "Catch up — {{count}} item(s) from past days. Were they done?",
      catchup_home_one: "Catch up — 1 item from past days. Was it done?",
      catchup_home_other: "Catch up — {{count}} items from past days. Were they done?",
      sched_showing: "Showing",
      sched_overdue_chip: "Overdue {{n}}d",
      sched_mark_done: "Done",
      pd_coming_up: "Coming up",
      gantt_col_task: "Task",
      gantt_col_start: "Start",
      gantt_col_days: "Days",
      status_not_started: "Not started",
      status_in_progress: "In progress",
      status_done: "Done",
      status_blocked: "Blocked",
      sheet_done: "Done",
      sheet_mark_not_done: "Undo done",
      sheet_reschedule: "Reschedule",
      sheet_resched_title: "Move to a new date", sheet_move_later: "Move later phases too",
      sheet_delay: "Delay",
      sheet_assign: "Assign",
      sheet_photos: "Photos",
      sheet_note: "Note",
      sheet_open_job: "Open job",
      sheet_done_marked: "Marked done",
      sheet_add_photos_q: "Add photos?",
      sheet_take_photo: "Take photo",
      sheet_skip: "Skip",
      sheet_reopened: "Marked not done",
      sheet_delay_by: "Delay by (days)",
      sheet_delay_hint: "Shifts this task and everything after it.",
      sheet_owner_only: "Owners/admins only",
      assign_crew: "Crew",
      assign_subs: "Subcontractors",
      assign_none: "None yet",
      assign_add_sub: "Add a subcontractor",
      sub_name: "Name",
      sub_trade: "Trade",
      sub_phone: "Phone",
      sub_add_btn: "Add sub",
      sub_added: "Subcontractor added",
      myday_tasks_title: "My tasks today",
      myday_navigate: "Navigate",
      action_take_photo: "Take photo",
      action_record_video: "Record video",
      photos_add_to: "Add to project",
      gantt_days: "Days",
      gantt_months: "Months",
      gantt_pick_project: "Pick a project first",
      gantt_title: "Project schedule (Gantt)",
      gantt_open: "Open Gantt",
      gantt_hide: "Hide Gantt",
      gantt_workdays: "workdays",
      gantt_unassigned: "Unassigned",
      gantt_mode_simple: "Simple",
      gantt_mode_advanced: "Advanced",
      gantt_critical: "Critical",
      gantt_templates_btn: "Start from template",
      gantt_tpl_title: "Phase templates",
      gantt_tpl_hint: "Pick a template to draft a phase schedule. Dates adjust to your work calendar.",
      gantt_phases_count: "phases",
      gantt_finish_by: "Finish date",
      gantt_plan_confirm: "Add to schedule",
      gantt_plan_added: "Phase schedule added",
      sched_need_project: "Pick a project first",
      tpl_roof: "Roof replacement",
      tpl_kitchen: "Kitchen remodel",
      tpl_bath: "Bathroom remodel",
      tpl_r_1: "Tear-off", tpl_r_2: "Deck check & repair", tpl_r_3: "Underlayment & flashing", tpl_r_4: "Shingle install", tpl_r_5: "Cleanup & walkthrough",
      tpl_k_1: "Demo", tpl_k_2: "Rough plumbing & electrical", tpl_k_3: "Drywall & paint", tpl_k_4: "Cabinets & counters", tpl_k_5: "Flooring", tpl_k_6: "Punch list",
      tpl_b_1: "Demo", tpl_b_2: "Rough-in", tpl_b_3: "Tile & waterproofing", tpl_b_4: "Fixtures & finishes",
      signup_trades_label: "What kind of work do you do?",
      signup_trades_hint: "Pick any — we'll line up the right templates for your jobs.",
      brand_trades_hint: "These power your recommended schedule templates.",
      gantt_tpl_recommended: "For your trade",
      gantt_tpl_all: "All templates",
      gantt_tpl_custom: "Your saved templates",
      gantt_tpl_size: "Job size",
      gantt_tpl_size_s: "Small", gantt_tpl_size_m: "Medium", gantt_tpl_size_l: "Large",
      gantt_tpl_start: "Start date", gantt_tpl_start_job: "Defaults to the job's start date ({{date}})",
      gantt_tpl_milestone: "Milestone",
      gantt_tpl_included: "Included", gantt_tpl_skipped: "Skipped",
      gantt_tpl_save_as: "Save this job's schedule as a template",
      gantt_tpl_save_name_ph: "Template name",
      gantt_tpl_saved: "Template saved",
      gantt_tpl_preview: "Preview dates",
      gantt_tpl_delete: "Delete template",
      gantt_tpl_no_phases: "This job has no phases yet",
      gantt_kind: "Type", gantt_kind_task: "Task", gantt_kind_wait: "Wait", gantt_kind_inspection: "Inspection", gantt_kind_delivery: "Delivery", gantt_kind_milestone: "Milestone",
      gantt_counts_weekends: "Counts weekends (curing/drying)",
      gantt_inspector_name: "Inspector name", gantt_inspector_phone: "Inspector phone", gantt_permit_no: "Permit #",
      gantt_supplier: "Supplier", gantt_po: "PO / order #", gantt_lead_days: "Lead time (business days)",
      gantt_baseline_behind: "{{n}} workdays behind", gantt_on_track: "On track",
      gantt_rebaseline: "Re-baseline", gantt_rebaseline_ph: "Reason (e.g. change order #2)", gantt_rebaseline_done: "Baseline updated",
      sheet_pass: "Pass", sheet_fail: "Fail", sheet_passed: "Inspection passed",
      sheet_fail_what: "What failed?", sheet_fix_days: "Fix takes (days)",
      sheet_fail_preview: "Preview impact", sheet_fail_apply: "Apply", sheet_fail_adjust: "I'll adjust myself",
      sheet_fail_impact: "Pushes {{n}} phase(s) · {{days}} workdays later · new finish {{date}}",
      sheet_fail_adds: "Fix", sheet_fail_reinspect: "Re-inspection",
      sheet_failed_flagged: "Failed — Fix + re-inspection added",
      sheet_received: "Received", sheet_order_by: "Order by",
      sheet_delay_reason: "Why the delay?", sheet_delay_caused: "Who caused it?",
      delay_reason_weather: "Weather", delay_reason_inspection: "Inspection", delay_reason_materials: "Materials",
      delay_reason_customer: "Customer / CO", delay_reason_sub_crew: "Sub / Crew", delay_reason_permit: "Permit", delay_reason_other: "Other",
      delay_cause_us: "Us", delay_cause_customer: "Customer", delay_cause_sub: "Sub", delay_cause_supplier: "Supplier", delay_cause_weather: "Weather / Act of God",
      sheet_delay_apply: "Apply delay", sheet_delayed: "Delayed +{{n}}d",
      filter_inspections: "Inspections", filter_deliveries: "Deliveries",
      myday_order_by: "Order by {{date}}",
      gantt_tpl_which_job: "Which job?",
      gantt_tpl_add_to: "Add to {{name}}",
      sheet_fail_type_ph: "Type what failed…",
      pd_start_from_template: "Start from template",
      pd_add_single_event: "Add a single event",
      cs_trades_none: "No trades picked yet",
      cs_trades_count: "{{count}} trades picked",
      wc_title: "Company Work Calendar",
      wc_body: "Set the default working days, hours and holidays. The 360 Assistant uses this for 'workdays only' schedules.",
      wc_workdays: "Working days",
      wc_start: "Day starts",
      wc_end: "Day ends",
      wc_holidays: "Company holidays / non-working days",
      wc_add: "Add",
      wc_mon: "Mon", wc_tue: "Tue", wc_wed: "Wed", wc_thu: "Thu", wc_fri: "Fri", wc_sat: "Sat", wc_sun: "Sun",
      aa_title: "360 Assistant Activity",
      aa_body: "Every assistant request, proposed action, confirmation and result — for owners and admins.",
      aa_empty: "No assistant activity yet.",
      aa_records: "Records affected",
      nav_activity: "Assistant Activity",
      // Billing
      billing_title: "Billing",
      billing_subtitle: "Pick the plan that fits your crew. Every plan starts with a 14-day free trial of Pro — no card required.",
      billing_current: "Current plan",
      billing_manage: "Manage billing",
      billing_popular: "Popular",
      billing_subscribe: "Start free trial",
      billing_current_plan: "Current plan",
      billing_feat_projects: "Unlimited projects & photos",
      billing_feat_portal: "Customer portal + voice logs",
      billing_feat_bilingual: "Bilingual EN/ES",
      billing_trial_ends: "Trial ends",
      billing_grace_until: "Read-only after",
      billing_trial_note: "Founding-customer lock: subscribe during beta and keep this price for 12 months. Cancel anytime from the billing portal.",
      billing_banner_past_due: "Payment issue — update your card to keep full access",
      billing_banner_canceled: "Subscription canceled — your account is read-only after the grace period",
      billing_complete_plan: "BuildProject360 Complete",
      billing_per_month: "/month",
      billing_per_year: "/year",
      billing_monthly: "Monthly",
      billing_annual: "Annual",
      billing_annual_save: "Save $98 — two months free",
      billing_trial_cta: "Start Free for 14 Days",
      billing_no_card: "No credit card required. Cancel anytime.",
      billing_users_included: "Up to {{n}} users included",
      billing_extra_user: "Only $5/month per additional user",
      billing_extra_user_year: "Additional users $50/year each",
      billing_subscribe_now: "Switch to this billing",
      billing_plan_essentials: "Essentials",
      billing_plan_pro: "Pro",
      billing_founding_badge: "Founding member · price locked for life",
      billing_most_popular: "Most popular",
      billing_save_two_months: "Save 2 months",
      billing_per_month_yearly: "/mo billed yearly",
      billing_upgrade_now: "Upgrade — prorated today",
      billing_downgrade_end: "Downgrade at period end",
      billing_downgrade_title: "Before you switch to Essentials",
      billing_downgrade_w1: "Website will be unpublished",
      billing_downgrade_w2: "Leads become read-only",
      billing_downgrade_w3: "Gantt becomes view-only",
      billing_downgrade_w4: "Pro money tools turn off (Good/Better/Best, price book, deposits, reminders)",
      billing_downgrade_keep: "Nothing is deleted — everything returns if you upgrade again.",
      billing_downgrade_confirm: "Confirm downgrade",
      billing_pending_change: "Changing to {{plan}} on {{date}}",
      billing_cancel_change: "Cancel change",
      billing_seats_line: "{{n}} users included · extra users $10/mo each",
      billing_change_failed: "Plan change failed",
      plan_ess_f1: "Unlimited photos & video, share galleries",
      plan_ess_f2: "360 Assistant (unlimited, fair use)",
      plan_ess_f3: "Schedule: Day/Week/Month + simple job timeline",
      plan_ess_f4: "Timecards, daily logs, tasks & checklists",
      plan_ess_f5: "Photo reports + proof report",
      plan_ess_f6: "Estimates, change orders, invoices + e-sign",
      plan_pro_f1: "Everything in Essentials",
      plan_pro_f2: "Full Gantt: drag, dependencies, delay notices, templates",
      plan_pro_f3: "Premium templates + Before & After + your branding",
      plan_pro_f4: "Good/Better/Best, price book, deposits, reminders",
      plan_pro_f5: "Job costing: budget vs actual, cost reports",
      plan_pro_f6: "Website + Leads · customer timeline · priority support",
      billing_choose_plan: "Choose Your Plan",
      v2_pr_founding: "Founding member pricing: {{n}} of 100 spots left",
      v2_pr_trial: "14-day free trial of Pro. No credit card.",
      v2_pr_compare: "Compare all features",
      v2_pr_vs: "CompanyCam's 3-user plan is $119–149/month and doesn't include scheduling. JobTread starts at $199/month. (Checked Oct 2026)",
      v2_cmp_feature: "Feature",
      v2_cmp_users: "Users included",
      v2_cmp_photos: "Photos, 360 Assistant, sharing",
      v2_cmp_sched: "Schedule + simple timeline",
      v2_cmp_money: "Estimates, COs, invoices, e-sign",
      v2_cmp_gantt: "Full Gantt + templates",
      v2_cmp_moneypro: "GBB, price book, deposits, cost reports",
      v2_cmp_web: "Website + Leads + customer timeline",
      v2_cmp_support: "Priority support",
      billing_days_left: "days left in your free trial",
      billing_seats_title: "Team seats",
      billing_billable_users: "Active billable users",
      billing_included: "Included users",
      billing_additional: "Additional users",
      billing_breakdown: "Cost breakdown",
      billing_base: "Complete base plan",
      billing_extra_charges: "Additional-user charges",
      billing_referral_credit: "Referral credit",
      billing_estimated_next: "Estimated next bill",
      billing_next_billing_date: "Next billing date",
      billing_payment_method: "Payment method",
      billing_no_payment_method: "No payment method on file",
      billing_invoices: "Invoice history",
      billing_no_invoices: "No invoices yet",
      billing_legacy_note: "You're on a legacy plan with full access. Confirm the new Complete plan whenever you're ready — you'll see the exact price at checkout and nothing is ever charged automatically.",
      billing_status_trialing: "Free trial",
      billing_status_active: "Active",
      billing_status_past_due: "Past due",
      billing_status_canceled: "Canceled",
      billing_status_trial_expired: "Trial expired",
      billing_status_grace: "Grace period",
      billing_status_expired: "Trial expired",
      billing_status_legacy: "Legacy",
      billing_status_none: "No subscription",
      billing_f1: "Customers and leads",
      billing_f2: "Unlimited projects",
      billing_f3: "Jobsite photos",
      billing_f4: "Daily logs and timecards",
      billing_f5: "Crew scheduling",
      billing_f6: "Estimates and invoices",
      billing_f7: "Change orders",
      billing_f8: "Payment tracking",
      billing_f14: "Online customer payments",
      billing_f9: "Customer portal",
      billing_f10: "Contractor website",
      billing_f11: "360 Assistant",
      billing_f12: "English and Spanish",
      billing_f13: "Three users included",
      trial_banner_left_one: "{{count}} day left in your free trial",
      trial_banner_left_other: "{{count}} days left in your free trial",
      trial_banner_cta: "View plans",
      trial_banner_grace: "Your trial ended — you're in the 3-day grace period. Choose a plan to keep creating records.",
      trial_banner_expired: "Your trial has ended. Your data is safe — choose a plan to restore full access.",
      trial_banner_suspended: "Your account access is currently suspended. Contact support for help.",
      trial_request_btn: "Request extension",
      trial_request_sent: "Extension request sent — we'll review it shortly.",
      trial_request_pending: "Extension request pending review",
      seat_confirm_title: "Add a paid seat?",
      seat_confirm_body: "This user will add $5/month to your subscription.",
      seat_confirm_yes: "Confirm & invite",
      crew_deactivate: "Deactivate",
      crew_reactivate: "Reactivate",
      crew_inactive: "Inactive",
      nav_profile_security: "Profile & Security",
      nav_company_brand: "Company Brand",
      prof_title: "Profile & Security",
      prof_sec_info: "Personal Information",
      prof_sec_photo: "Profile Photo",
      prof_sec_security: "Login & Security",
      prof_sec_notifications: "Notifications",
      prof_sec_prefs: "Preferences",
      prof_sec_about: "About",
      prof_tz_mismatch: "Your device is set to {{device}} but the account uses {{account}}.",
      prof_tz_use_device: "Use device timezone",
      photo_preparing: "Preparing your photo…",
      photo_preview_failed: "We couldn't preview that photo.",
      photo_error_code: "Error code: {{code}}",
      photo_retry: "Retry",
      photo_choose_another: "Choose Another Photo",
      photo_uploading: "Uploading… {{pct}}%",
      photo_save: "Save Photo",
      photo_use_full: "Use Full Photo",
      photo_zoom_out: "Zoom out",
      photo_zoom_in: "Zoom in",
      photo_rotate: "Rotate",
      photo_recenter: "Recenter",
      photo_updated: "Profile photo updated.",
      photo_public_label: "Display my profile photo on the public website",
      photo_public_hint: "Off by default. Your photo stays visible only to your company unless you turn this on.",
      tz_banner_company: "Your account is set to {{current}}. Based on your company location, {{suggested}} may be more appropriate.",
      tz_banner_note: "Changing the display timezone does not change your original stored timestamps.",
      tz_banner_change: "Change to {{tz}}",
      tz_banner_choose: "Choose another timezone",
      tz_banner_keep: "Keep {{tz}}",
      prof_first: "First name",
      prof_last: "Last name",
      prof_display: "Display name",
      prof_title_job: "Job title",
      prof_phone: "Mobile phone",
      prof_tz: "Time zone",
      prof_email: "Email address",
      prof_change_email: "Change email",
      prof_new_email: "New email address",
      prof_current_password: "Current password",
      prof_send_verify: "Send verification",
      prof_email_sent: "Verification sent — check your new email. Your current email stays active until verified.",
      prof_pending_email: "Verification pending for {{email}}",
      prof_email_flow_hint: "We'll email a verification link to the new address. Your current email stays active until you confirm.",
      prof_photo_hint: "Shown to your company on logs, timecards and the crew list. Private unless you display it on your public website.",
      prof_upload_photo: "Upload Photo",
      prof_replace_photo: "Replace Photo",
      prof_take_photo: "Take Photo",
      prof_remove_photo: "Remove Photo",
      prof_remove_confirm: "Remove your profile photo? Your initials will be shown instead.",
      prof_photo_privacy: "JPG, PNG, HEIC or WebP. Large photos are compressed automatically.",
      prof_change_pw: "Change password",
      prof_new_password: "New password",
      prof_new_password2: "Repeat new password",
      prof_pw_changed: "Password changed — other devices were signed out",
      prof_signout_others: "Sign out of other devices",
      prof_signed_out_others: "All other sessions were signed out",
      prof_sessions: "Active sessions",
      prof_revoke: "Sign out",
      prof_activity: "Recent login activity",
      prof_2fa_note: "Two-factor authentication is coming soon.",
      prof_coming_soon: "Soon",
      prof_pw_s0: "Too weak",
      prof_pw_s1: "Weak",
      prof_pw_s2: "Fair",
      prof_pw_s3: "Good",
      prof_pw_s4: "Strong",
      prof_date_format: "Date format",
      prof_clock: "Clock",
      prof_clock_12: "12-hour",
      prof_clock_24: "24-hour",
      prof_landing: "Default landing page",
      prof_theme: "Theme",
      prof_theme_system: "System",
      prof_theme_light: "Light",
      photo_edit_title: "Edit photo",
      notif_schedule_reminders: "Schedule reminders",
      notif_assigned_projects: "Assigned-project notifications",
      notif_tasks: "Task notifications",
      notif_estimate_approvals: "Estimate approvals",
      notif_invoice_payments: "Invoice payments",
      notif_morning_plan: "Morning-plan reminders",
      notif_evening_update: "Evening-update reminders",
      notif_buildguide_confirmations: "360 Assistant confirmations",
      notif_email: "Email notifications",
      notif_in_app: "In-app notifications",
      notif_sms: "SMS notifications",
      forgot_password: "Forgot password?",
      forgot_hint: "We'll email you a single-use reset link (valid 1 hour).",
      forgot_send: "Send reset link",
      forgot_sent: "If that email exists, a reset link is on its way.",
      reset_title: "Choose a new password",
      reset_invalid: "This reset link is invalid or has expired.",
      reset_done: "Password updated! Signing you in…",
      reset_submit: "Set new password",
      reset_back_login: "Back to sign in",
      verify_ok: "Email verified — you can sign in with your new address.",
      verify_error: "This verification link is invalid or has expired.",
      verify_checking: "Verifying your email…",
      brand_title: "Company Brand",
      brand_subtitle: "Your company identity — used on estimates, invoices and your public website.",
      brand_logo: "Company logo",
      brand_upload_logo: "Upload Logo",
      brand_replace_logo: "Replace Logo",
      brand_remove_logo: "Remove Logo",
      brand_remove_confirm: "Remove the company logo? This affects your website and documents.",
      brand_logo_empty: "No logo yet — upload one or create one with the AI assistant.",
      brand_prev_square: "Square",
      brand_prev_horizontal: "Horizontal",
      brand_prev_light: "Light bg",
      brand_prev_dark: "Dark bg",
      brand_prev_favicon: "Favicon",
      brand_show_on_site: "Show this logo on my public contractor website",
      brand_name: "Company name",
      brand_tagline: "Short tagline",
      brand_address: "Company address",
      brand_areas: "Service areas (comma separated)",
      brand_areas_ph: "Your city, nearby towns, …",
      brand_license: "License information",
      brand_insurance: "Insurance information",
      brand_domain: "Website domain",
      brand_primary: "Primary color",
      brand_accent: "Accent color",
      brand_description: "Company description",
      brand_social_facebook: "Facebook",
      brand_social_instagram: "Instagram",
      brand_social_tiktok: "TikTok",
      brand_social_youtube: "YouTube",
      brand_ai_logo: "AI Logo Assistant",
      brand_ai_hint: "Answer a few questions and get three logo concepts. Nothing is saved until you choose one.",
      brand_ai_trade: "What type of work do you do?",
      brand_ai_style: "Style",
      brand_ai_icon: "Icon",
      brand_ai_colors: "Preferred colors",
      brand_ai_generate: "Generate 3 Concepts",
      brand_ai_regenerate: "Regenerate Concepts",
      brand_ai_generating: "Generating concepts — this can take a minute…",
      brand_ai_selected: "Selected",
      brand_ai_previews: "Preview",
      brand_ai_save: "Save to Company Brand",
      brand_ai_download: "Download PNG",
      brand_style_modern: "Modern",
      brand_style_rugged: "Rugged",
      brand_style_traditional: "Traditional",
      brand_style_minimal: "Minimal",
      brand_icon_roof: "Roof",
      brand_icon_house: "House",
      brand_icon_hammer: "Hammer",
      brand_icon_shield: "Shield",
      brand_icon_building: "Building",
      brand_icon_initials: "Initials",
      web2_onboard_title: "Let 360 Assistant build your professional website.",
      web2_onboard_build: "Build It for Me",
      web2_onboard_design: "Start With a Design",
      web2_onboard_edit: "Edit My Current Website",
      web2_builder_questions: "Just a few details",
      web2_builder_work: "What type of work do you most want?",
      web2_builder_cities: "What cities or counties do you serve?",
      web2_builder_diff: "What makes your company different?",
      web2_builder_style: "Choose your preferred style",
      web2_builder_header: "Choose a header layout",
      web2_builder_photos: "Choose the project photos you want featured",
      web2_builder_generate: "Build My Website Draft",
      web2_builder_building: "Building your website draft…",
      web2_draft_ready: "Your draft is ready — review it below",
      web2_apply_draft: "Apply Draft",
      web2_pending_draft: "An AI draft is waiting for review",
      web2_header_hero_photo: "Photograph Hero",
      web2_header_split: "Split Hero",
      web2_header_collage: "Project Collage",
      web2_header_owner: "Owner-Led",
      web2_header_before_after: "Before-and-After",
      web2_style_local: "Local & Trusted",
      web2_logo_builder: "Create or Improve My Logo",
      web2_logo_trade: "Trade",
      web2_logo_initials: "Initials",
      web2_logo_colors: "Preferred colors",
      web2_logo_generate: "Generate 4 Logo Concepts",
      web2_logo_pick: "Choose this logo",
      web2_logo_note: "Icons are AI-generated; your company name is always real text. Review for trademark conflicts before use.",
      web2_stats_views: "Website views",
      web2_stats_calls: "Call clicks",
      web2_stats_starts: "Estimate starts",
      web2_stats_submits: "Estimate submissions",
      web2_stats_conv: "Conversion rate",
      web2_cmd_placeholder: "Tell me what to change — e.g. 'use a classy dark-blue header'",
      web2_cmd_run: "Apply Command",
      web2_cmd_changes: "What will change",
      web2_cmd_none: "I couldn't map that to a website change.",
      u360_helper: "Speak once and update the entire job.",
      u360_hold_to_talk: "Hold to talk",
      u360_tap_to_talk: "Tap the mic to start, tap again to stop.",
      u360_mic_denied: "Microphone permission was denied. Enable it in your browser settings, or type your update below.",
      u360_stt_failed: "Couldn't transcribe — your recording is safe. Retry or type instead.",
      u360_retry_stt: "Transcription failed. Your recording is safe.",
      u360_retry_stt_btn: "Retry transcription",
      u360_type_instead: "Or type your update",
      u360_placeholder: "Today we finished the tear-off. James, Mike and Carlos worked eight hours…",
      u360_continue: "Continue",
      u360_edit_transcript: "Your update — edit anything before processing",
      u360_process: "Prepare Actions",
      u360_processing: "Preparing your update…",
      u360_stage_read: "Reading your update…",
      u360_stage_log: "Drafting the daily log…",
      u360_stage_sched: "Drafting the schedule…",
      u360_stage_crew: "Checking crew and hours…",
      u360_processing_hint: "This can take up to a minute. Hang tight — we're drafting your update.",
      u360_processing_title: "Working on your update…",
      u360_original_label: "Original (Spanish):",
      u360_failed_title: "Some parts couldn't be saved.",
      u360_failed_label: "Couldn't save — try again",
      u360_perm_label: "Needs an admin to approve this part",
      u360_retry_failed: "Retry",
      setup_title: "Get set up",
      setup_progress: "{{done}} of {{total}} done",
      queue_pill_waiting: "{{count}} waiting to upload",
      queue_pill_progress: "{{done}} of {{total}} uploaded",
      queue_pill_failed: "{{count}} failed — tap to retry",
      queue_pill_done: "All photos uploaded ✓",
      queue_saving: "Saving {{count}} photos…",
      queue_save_failed: "Couldn't save a photo on this phone — please keep the app open and try again",
      queue_stuck_banner: "{{count}} photos haven't uploaded from {{device}} — waiting {{min}} min. Open the app on that phone.",
      queue_stuck_device: "a phone",
      reset_device_title: "Reset this device",
      reset_device_hint: "Fixes a stuck app without uninstalling: uploads everything it can, saves the rest to this phone, then clears local data and reloads.",
      reset_device_btn: "Reset this device",
      reset_device_confirm: "Upload + save photos, then clear this device's data? This can't be undone.",
      queue_attempts: "{{count}} tries",
      queue_pill_problem: "Upload problem — tap to retry",
      queue_pill_needs_job: "{{count}} photo(s) need a job — pick one",
      queue_job_deleted: "{{count}} photo(s): job deleted — move to another job?",
      queue_move_job: "Move to job…",
      queue_dismiss: "Dismiss",
      prof_delete_title: "Delete account",
      prof_delete_hint: "This permanently deletes your account and signs you out everywhere. Company data stays until the last owner deletes their account.",
      prof_delete_btn: "Delete account",
      prof_delete_confirm: "Enter your password to confirm. This can't be undone.",
      prof_password_ph: "Password",
      reset_device_running: "Resetting…",
      reset_device_done: "Reset done — {{uploaded}} uploaded, {{saved}} saved to phone. Reloading…",
      cam_mode_library: "Library",
      photos_uploading_now: "Uploading now",
      set_orig_wifi: "Upload full-size originals on Wi-Fi only",
      set_orig_wifi_hint: "On cellular, photos upload right away in a smaller size and the originals follow on Wi-Fi.",
      set_highres: "High-res photos (4K)",
      set_highres_hint: "Sharper photos, but heavier on the phone. Off is recommended for field work.",
      wt_banner_recording: "● WALKTHROUGH — recording",
      wt_ready_done: "Walkthrough ready ✓",
      photos_recovered: "Recovered {{count}} photo(s) from this phone — uploading now",
      wt_recovered: "Recovered a walkthrough — finishing it in the background",
      phone_photos_title: "Photos on this phone",
      phone_photos_hint: "Still stored on this device. Upload them now or save them to your phone.",
      phone_photos_empty: "Nothing stored on this phone",
      up_upload_now: "Upload now",
      queue_orphaned: "Job deleted",
      build_badge_label: "Build",
      build_update_to: "Update to {{v}}",
      queue_sign_in: "Sign in again to upload {{count}} photos",
      queue_st_auth: "Sign in needed",
      queue_st_needs_project: "Which job?",
      queue_st_unreadable: "Couldn't be read",
      queue_st_orphaned: "Job deleted",
      up_save_all: "Save all to phone (zip)",
      queue_sheet_title: "Upload queue",
      queue_retry: "Retry failed",
      queue_st_pending: "Waiting",
      queue_st_uploading: "Uploading…",
      queue_st_uploaded: "Uploaded",
      queue_st_failed: "Failed",
      queue_pill_health: "Will upload when signal improves.",
      queue_dead_toast: "A photo couldn't upload after several tries — tap to retry or save it to your phone.",
      queue_save_phone: "Save to phone",
      queue_saved_phone: "Saved to phone",
      queue_storage_full: "Phone storage is full — free up space so photos can queue safely. Photos already taken are safe.",
      queue_write_failed: "Couldn't save the photo on this device — check storage and retry.",
      u360_rec_kept: "Recording kept — send it when you're back.",
      u360_send_recording: "Send recording",
      setup_step_logo: "Add your logo",
      setup_step_first_job: "Create your first job",
      setup_step_three_photos: "Take 3 photos on it",
      setup_step_scheduled: "Put it on the schedule",
      setup_step_tried_360: "Try the 360",
      setup_step_crew_invited: "Invite one crew member",
      crew_phone_opt: "Phone (optional — to text the invite)",
      crew_text_invite: "Text the invite",
      crew_invite_ready: "Invite ready for {{name}} — send them this link (it sets their password):",
      crew_invite_link_label: "One-tap invite link",
      crew_copy_link: "Copy invite link",
      crew_invite_sms: "You're invited to join the crew on BuildProject360 — tap to set your password:",
      setup_done_title: "You're set up.",
      setup_done_sub: "Your crew will see tomorrow's job tonight.",
      setup_dismiss: "Dismiss",
      setup_install_row: "Install the app",
      setup_install_ios_1: "1. Open this app in Safari",
      setup_install_ios_2: "2. Tap Share",
      setup_install_ios_3: "3. Tap 'Add to Home Screen'",
      setup_install_android_manual: "In Chrome: menu ⋮ → Install app. Or use the button below.",
      help_setup_checklist: "Setup checklist",
      stuck_title: "Still stuck?",
      stuck_hint: "Tell us what happened — we attach the page, app version and your last 360 update automatically.",
      stuck_placeholder: "What were you trying to do?",
      stuck_send: "Send to support",
      stuck_sent: "Sent — we'll reply by email shortly.",
      stuck_failed: "Couldn't send. Email support@buildproject360.com",
      ap_do_it: "Do it for me",
      u360_guide_toggle: "What can I say?",
      empty_tip_projects: "Tip: create your first job with its real address — everything hangs off it.",
      empty_tip_photos: "Tip: photos are stamped with date and job — take the first one on site.",
      empty_tip_schedule: "Tip: put a job on the calendar and your crew sees it tonight.",
      empty_tip_crew: "Tip: invite a worker — they get a secure link to set their own password.",
      empty_tip_customers: "Tip: add a customer once; their jobs, estimates and invoices stay together.",
      empty_tip_estimates: "Tip: draft an estimate, send the approval link, convert to invoice when approved.",
      empty_tip_costs: "Tip: snap a receipt and the AI reads the vendor, date and total.",
      empty_tip_activity: "Tip: speak a 360 update at day's end — log, hours and tomorrow's plan in one go.",
      empty_tip_inbox: "Tip: photos without a job land here — assign them so nothing gets lost.",
      empty_tip_u360: "Tip: say it like you'd text your office — 'Finished tear-off, three guys eight hours'.",
      admin_setup_metrics: "Setup completion (new companies, 30 days)",
      cu_send_cta: "Send {{name}} today's update ({{count}} photos)",
      cu_send_cta_noname: "Send the customer today's update",
      cu_send_title: "Today's update",
      share_photos_menu: "Share photos", share_photos_all: "All photos", share_photos_pick: "Pick photos",
      share_progress_update: "Send progress update", share_invite_portal: "Invite to customer portal",
      cu_whats_next_label: "What's next", cu_sched_pdf: "Include schedule PDF link",
      cu_add_customer: "Add the customer's phone or email",
      cu_name_ph: "Customer name",
      cu_note_label: "Message",
      cu_link_label: "Private link (no login)",
      cu_send_text: "Send by text",
      cu_send_email: "Send by email",
      cu_sent: "Update sent",
      cu_missing_contact: "Add a phone or email first",
      cu_sent_log: "Update sent to {{name}}",
      cu_viewed: "Viewed by {{name}}",
      cu_via_text: "by text",
      cu_via_email: "by email",
      admin_setup_detail: "{{in24}}/{{total}} finished within 24 h · {{done}} finished total",
      cs_notifs_t: "Notifications",
      cs_notifs_d: "End-of-day 360 reminder — time and days",
      notif_eod_title: "End-of-day 360 reminder",
      notif_eod_hint: "We push you at the end of the workday to log the day's update — one tap and you're talking.",
      notif_eod_enabled: "Send the reminder",
      notif_eod_time: "Company end time",
      notif_eod_days: "Days",
      notif_eod_note: "iPhone: install the app first (Share › Add to Home Screen) — pushes only reach installed apps.",
      notif_eod_off: "Off",
      wt_mode_photo: "Photo",
      wt_mode_walkthrough: "Walkthrough",
      wt_mode_video: "Video",
      wt_video_soon: "Video walkthrough — coming soon",
      wt_hint: "Talk as you walk. Tap the shutter for photos.",
      wt_keep_open: "Keep the app open while recording",
      wt_pause: "Pause",
      wt_resume: "Resume",
      wt_new_area: "New area",
      wt_area_kitchen: "Kitchen",
      wt_area_bath: "Bath",
      wt_area_bedroom: "Bedroom",
      wt_area_living: "Living",
      wt_area_basement: "Basement",
      wt_area_exterior: "Exterior",
      wt_area_roof: "Roof",
      wt_area_deck: "Deck",
      wt_area_garage: "Garage",
      wt_area_other: "Other…",
      wt_area_ph: "Area name (e.g. Kitchen)",
      wt_area_add: "Mark area",
      wt_interrupted: "Recording paused — everything so far is kept.",
      wt_limit_warn: "2 minutes left — start wrapping up",
      wt_notice: "Your voice is recorded to write the report.",
      wt_notice_ok: "Got it",
      wt_building: "Building your walkthrough…",
      wt_stage_transcribing: "Transcribing…",
      wt_stage_sections: "Writing sections…",
      wt_stage_tasks: "Finding action items…",
      wt_summary: "Summary",
      wt_open_items: "Open items",
      wt_tasks: "Punch list",
      wt_approve: "Approve all",
      wt_approved: "Walkthrough approved",
      wt_share: "Share link",
      wt_pdf: "Download PDF",
      wt_to_checklist: "Turn into checklist",
      wt_transcript_show: "Show what I said",
      wt_transcript_hide: "Hide transcript",
      wt_failed: "Couldn't build the walkthrough",
      wt_start: "Start a walkthrough",
      wt_audio_label: "Walkthrough audio",
      wt_audio_keep: "Keep after approval",
      wt_audio_30: "Delete 30 days after approval",
      wt_copied: "Link copied",
      wt_saved_offline: "Walkthrough saved — it will build when you're back online",
      pd_tab_walkthroughs: "Walkthroughs",
      wt_ready: "Walkthrough ready to review",
      u360_photos_note: "Add a caption",
      photos_select_one: "Select photo",
      wt_discard_title: "Stop and discard this walkthrough?",
      wt_discard_yes: "Discard",
      wt_keep_recording: "Keep recording",
      wt_finish_failed: "Couldn't finish — photos and audio are safe on this device",
      wt_retry: "Retry",
      viewer_undo: "Undo",
      toast_photos_deleted: "{{count}} photo(s) deleted",
      toast_undone: "Restored",
      toast_deleted: "{{thing}} deleted",
      qa_title: "Add something", qa_add: "Add",
      qa_hint: "One tap. It lands on the job you pick.",
      qa_photo: "Photo", qa_note: "Note / log", qa_task: "Task", qa_receipt: "Receipt",
      qa_change_order: "Change order", qa_estimate: "Estimate", qa_invoice: "Invoice",
      qa_schedule: "Schedule it", qa_talk: "Talk",
      qa_adding_to: "Adding to", qa_this_job: "this job", qa_choose_job: "Which job?", qa_all_jobs: "All jobs…",
      qa_talk_hint: "Hold the mic and say it, e.g. “Add a change order on the Garcia basement for 2 extra outlets, $180”. I’ll show you a preview first — nothing saves until you tap Save.",
      qa_thinking: "Figuring it out…",
      qa_note_ph: "What happened on the job today?",
      qa_task_ph: "What needs doing?",
      sel_del2_title: "Really delete {{count}} photos?",
      sel_del2_body: "This is a bulk delete. You can undo for a few seconds, or restore from Trash within 30 days.",
      sel_del2_yes: "Yes, delete {{count}} photos",
      trash_no_project: "No project",
      trash_by: "by",
      mv2_documents: "Documents",
      mv2_doc_settings: "Document settings",
      mv2_design: "Design",
      mv2_design_classic: "Classic",
      dvp_all: "All",
      dvp_progress: "Progress",
      dvp_reorder_hint: "drag or use arrows to reorder",
      dvp_void: "VOID",
      dvp_approved: "APPROVED",
      dvp_paid_stamp: "PAID",
      mv2_co_photos: "Condition found",
      mv2_ds_preview: "Live preview (sample invoice)",
      mv2_ds_show_photos: "Show photos on documents",
      mv2_ds_photo_ts: "Show photo date & time in captions",
      mv2_ds_footer_note: "Footer note (appears on every document)",
      mv2_powered: "Powered by BuildProject360",
      mv2_design_modern: "Modern",
      mv2_design_photo: "Photo Proposal",
      mv2_design_classic_desc: "Clean traditional layout",
      mv2_design_modern_desc: "Bold color band, large company name",
      mv2_design_photo_desc: "Cover photo and project photo grid",
      mv2_design_packages: "Packages",
      mv2_design_packages_desc: "Good / Better / Best front and center",
      mv2_design_insurance: "Insurance",
      mv2_design_insurance_desc: "Claim details, license & insurance band",
      mv2_design_commercial: "Commercial",
      mv2_design_commercial_desc: "Formal layout with PO and billing contact",
      mv2_pro_badge: "Pro",
      mv2_upgrade_title: "Upgrade to Money Pro",
      mv2_upgrade_note_ph: "Anything we should know? (optional)",
      mv2_upgrade_request: "Request upgrade",
      mv2_upgrade_done: "Request received — we'll be in touch",
      mv2_claim_number: "Claim #",
      mv2_policy_number: "Policy #",
      mv2_adjuster: "Adjuster",
      mv2_po_number: "PO #",
      mv2_billing_contact: "Billing contact",
      mv2_retainage: "Retainage",
      mv2_retainage_pct: "Retainage %",
      mv2_less_retainage: "Less retainage ({{pct}}%)",
      mv2_retained_held: "Retainage held until completion",
      mv2_due_now: "Due now",
      mv2_budget_vs_actual: "Budget vs actual",
      mv2_bva_budget: "Budget",
      mv2_bva_actual: "Actual",
      mv2_bva_remaining: "Left",
      mv2_pay_online: "Pay online",
      mv2_pay_redirecting: "Redirecting to secure checkout…",
      mv2_pay_success: "Payment received — thank you!",
      mv2_stripe_title: "Online payments",
      mv2_stripe_desc: "Let customers pay invoices online by card. Test mode — no real charges.",
      mv2_stripe_connect: "Connect Stripe",
      mv2_stripe_active: "Active",
      mv2_stripe_pending: "Setup pending",
      mv2_stripe_none: "Not connected",
      mv2_stripe_pending_claim: "Online payments are being set up — we'll let you know when it's ready",
      mv2_default_per_type: "Default design per document",
      mv2_numbering: "Numbering",
      mv2_next_number: "Next number",
      mv2_expiration: "Default expiration (days)",
      mv2_deposit: "Default deposit %",
      mv2_payment_terms: "Payment terms",
      mv2_due_receipt: "Due on receipt",
      mv2_net15: "Net 15",
      mv2_net30: "Net 30",
      mv2_late_fee: "Late-fee text (display only)",
      mv2_pay_instructions: "Payment instructions",
      mv2_tax_rates: "Tax rates",
      mv2_add_tax: "Add tax rate",
      mv2_tax_name: "Name (e.g. State)",
      mv2_tax_materials_only: "Tax materials only",
      mv2_defaults_text: "Default terms, warranty & exclusions",
      mv2_warranty: "Warranty",
      mv2_exclusions: "Exclusions",
      mv2_spanish: "Spanish version",
      mv2_brand_color: "Brand color",
      mv2_pick_from_logo: "Pick from logo",
      mv2_preview: "Preview",
      mv2_add_photos: "Add photos",
      mv2_photos_selected: "{{count}} selected",
      mv2_blocks: "Content blocks",
      mv2_block_cover: "Cover",
      mv2_block_intro: "Intro letter",
      mv2_block_photos: "Photos",
      mv2_block_items: "Line items",
      mv2_block_schedule: "Payment schedule",
      mv2_block_warranty: "Warranty",
      mv2_block_terms: "Terms & conditions",
      mv2_block_signature: "Signature block",
      mv2_block_footer: "Footer",
      mv2_expires_notice: "This estimate expires {{date}}",
      mv2_revised: "Revised {{date}}",
      mv2_prepared_for: "Prepared for",
      mv2_your_project: "Your project",
      mv2_pricing: "Pricing",
      mv2_payment_schedule: "Payment schedule",
      ps_title: "Payment schedule",
      ps_deposit: "Deposit",
      ps_progress: "Progress",
      ps_final: "Final",
      ps_payment: "Payment",
      ps_due_signing: "at signing",
      ps_due_midpoint: "at midpoint",
      ps_due_completion: "on completion",
      ps_add: "Add row",
      ps_label_ph: "Label (e.g. Deposit)",
      ps_sum_ok: "Adds up to 100% ✓",
      ps_sum_bad: "Adds up to {{sum}}% — must equal 100%",
      ps_sum_error: "Payment schedule must add up to 100%",
      ps_save_default: "Save as company default",
      ps_no_company_default: "No company default yet — this becomes the default when you save the estimate",
      mv2_default_tax_rate: "Company default tax rate",
      mv2_default_tax_hint: "Prefilled on taxable lines in new estimates. Leave 0 if you don't charge homeowners tax (you can still override per line).",
      pf_contract_updated: "Contract updated to {{amount}} on approval — update the cost budget so profit is right.",
      sl_copy_manual: "Copy this link:",
      mv2_signed_line: "Signed electronically by {{name}} on {{when}} · IP {{ip}} · Document {{doc}}",
      mv2_doc_photos_empty: "No photos on this job yet",
      mv2_work_completed: "Work completed",
      mv2_before: "Before",
      mv2_after: "After",
      mv2_no_before: "No Before photos on this job — add from photos or skip",
      mv2_ba_toggle: "Show Before & After on invoices",
      mv2_ba_pairs_default: "Default number of pairs",
      mv2_ba_datetime: "Show photo date/time",
      mv2_condition_found: "Condition found",
      mv2_similar_work: "Similar finished work",
      mv2_open_photo: "Open full size",
      mv2_no_logo: "Upload a company logo first",
      fin_receipts: "Receipts",
      mv2_packages: "Packages (Good · Better · Best)",
      mv2_add_package: "Add package",
      mv2_package_name: "Package name",
      mv2_package_desc: "Short description",
      mv2_choose_package: "Choose your package",
      mv2_most_popular: "Most popular",
      mv2_draw_signature: "Draw",
      mv2_clear: "Clear",
      mv2_download_pdf: "Download PDF",
      mv2_deposit_invoice: "Create deposit invoice",
      mv2_convert_budget: "Convert to job budget",
      mv2_schedule_work: "Schedule the work",
      mv2_ba_empty: "No pairs yet — add one or tap Suggest pairs",
      mv2_no_suggestions: "Tag photos as Before/After on the job to get suggestions — or add a pair manually",
      mv2_photos_cleared: "Photos removed — they belong to the previous job",
      mv2_send_title: "Send estimate",
      mv2_send_msg_ph: "Short message (optional)…",
      mv2_send_text: "Text",
      mv2_send_email: "Email",
      mv2_dl_signed: "Download signed copy",
      mv2_tick_box: "Tick the box to agree before signing",
      mv2_send_default_msg: "Hi {{name}}, here's your estimate from {{company}}: {{url}}",
      mv2_pm_card: "Card · Apple/Google Pay",
      mv2_pm_ach: "ACH bank transfer",
      mv2_pay_methods_label: "Customer payment methods",
      mv2_start_template: "Start from template",
      mv2_tpl_applied: "Template applied — set your prices",
      mv2_optional: "Optional",
      mv2_progress_line: "Progress invoice",
      fin_invoice: "Invoice",
      fin_void: "Void",
      fin_doc_edit: "Edit",
      fin_doc_duplicate: "Duplicate",
      fin_doc_delete: "Delete",
      fin_doc_restore: "Restore",
      fin_doc_void_reason: "Reason (optional)",
      fin_doc_delete_q: "Delete {{n}}? It goes to Money trash and can be restored within 30 days.",
      fin_doc_void_q: "Void {{n}}? The number is kept, the PDF gets a VOID stamp, and it drops out of all totals.",
      fin_mark_approved: "Mark as approved (signed on paper)",
      fin_resend: "Resend",
      fin_needs_attention: "Needs attention",
      fin_timeline: "Timeline",
      fin_evt_created: "Created",
      fin_evt_sent: "Sent",
      fin_evt_viewed: "Viewed by customer",
      fin_evt_approved: "Approved",
      fin_evt_declined: "Declined",
      fin_evt_paid: "Paid in full",
      fin_evt_partial_payment: "Partial payment",
      fin_evt_voided: "Voided",
      fin_evt_revised: "Revised",
      fin_evt_edited: "Edited",
      fin_evt_deleted: "Moved to Trash",
      fin_evt_restored: "Restored",
      fin_evt_converted: "Converted to project",
      fin_evt_converted_invoice: "Converted to invoice {{n}}",
      fin_evt_deposit_invoice_created: "Deposit invoice created",
      fin_already_invoiced: "Already invoiced: {{list}}. Create the next invoice for the remaining {{amount}}?",
      fin_evt_reminder_sent: "Reminder sent",
      fin_evt_reminder_expiring: "Expiration reminder sent",
      fin_evt_reminder_invoice_overdue: "Overdue reminder sent",
      fin_evt_reminder_invoice_due_soon: "Due-soon reminder sent",
      fin_evt_inv_reminder_pre: "Due-soon reminder sent",
      fin_evt_inv_reminder_due: "Due-date reminder sent",
      fin_evt_inv_reminder_7: "7-day overdue reminder sent",
      fin_evt_inv_reminder_14: "14-day overdue reminder sent",
      fin_filter_all: "All",
      fin_filter_open: "Open",
      fin_back_to_money: "Money",
      fin_not_viewed: "Not viewed yet",
      fin_viewed_n: "Viewed {{n}}x",
      fin_last_viewed: "last viewed",
      fin_no_filtered: "No {{what}} invoices yet",
      fin_mark_approved: "Mark approved (signed in person)",
      fin_convert_to_invoice: "Convert to invoice",
      fin_deposit_pct: "Deposit %", fin_deposit_word: "deposit",
      mv2_online_payments: "Online payments (Stripe)", mv2_online_payments_desc: "Show a Pay online button on customer invoices and portal pages. Turn on after your Stripe account is connected.",
      mv2_how_to_pay: "How to pay", mv2_how_to_pay_hint: "Shown on invoices, customer pages and PDFs. Only the methods you turn on are listed.",
      mv2_payable_to: "Payable to", mv2_mail_to: "Mail to", mv2_bank_name: "Bank name",
      mv2_account_name: "Account name", mv2_routing: "Routing number", mv2_account: "Account number",
      mv2_pay_handle: "Handle / phone / email", mv2_pay_note: "Note (optional)",
      mv2_bank_masked_hint: "Bank numbers are stored securely and shown in full only on the customer's invoice and PDF.",
      demo_open: "Open demo workspace", demo_banner: "Demo workspace — sample data only", demo_back: "Back to my company",
      demo_reset: "Reset demo data", demo_reset_confirm: "Wipe and re-create the demo data with today\u2019s dates?", demo_reset_done: "Demo data reset",
      bp_title: "Progress billing", bp_contract: "Contract", bp_invoiced: "Invoiced", bp_paid: "Paid",
      bp_remaining: "Left to bill", bp_pending_cos: "Approved change orders waiting to bill",
      notif_money_digest: "Daily 8 AM money digest",
      notif_digest_test: "Send yourself today's digest", notif_digest_test_sent: "Digest email sent — check your inbox",
      mv2_copy_link: "Copy link", mv2_copied: "Link copied", mv2_text_link: "Text the link",
      fin_text_doc: "Text it",
      fin_text_doc_msg: "Hi, here's your {{kind}} {{number}} for {{amount}}: {{url}}",
      fin_kind_invoice: "invoice", fin_kind_estimate: "estimate",
      tw_title: "Timecards", tw_subtitle: "Weekly hours for payroll", tw_by_user: "By employee",
      tw_by_project: "By project", tw_employee: "Employee", tw_in: "In", tw_out: "Out",
      tw_approved: "Approved", tw_pending: "Pending", tw_export_csv: "Payroll CSV",
      tw_edit_title: "Edit timecard", tw_new_hours: "Correct hours",
      tw_reason_ph: "Reason (e.g. forgot to clock out)",
      tw_corrected_n: "{{count}} correction", tw_corrected_n_plural: "{{count}} corrections",
      tw_no_lines: "No timecards this week yet", tw_timecards_link: "Timecards", tw_manual_badge: "manual",
      jp_title: "Job profit",
      jp_sentence: "{{done}}% done · {{spent}}% of budget spent · projected profit {{profit}} ({{margin}}%)",
      jp_sentence_final: "Final profit {{profit}} ({{margin}}% margin)",
      jp_no_budget: "Add a budget to see profit",
      jp_no_contract: "Add a contract price to see profit",
      jp_set_budget: "Set budget",
      jp_done: "{{pct}}% done", jp_spent: "{{pct}}% of budget spent",
      jp_status_on_track: "On track", jp_status_watch: "Watch", jp_status_losing: "Losing money", jp_status_no_budget: "No budget",
      jp_budget_label: "Budget $ (manual)", jp_pct_label: "% done (manual)",
      jp_rate_unit: "/hr cost", jp_rate_hint: "What this person's hour costs you — used for job profit. Crew never see this.",
      fin_convert_full_hint: "Leave empty (or 100) to invoice the full amount.",
      fin_create_co: "Create change order",
      fin_co_empty_hint: "Create a change order from an approved estimate",
      fin_merge: "Merge",
      fin_merge_into: "Merge into…",
      fin_merged: "Merged",
      fin_dup_possible: "Possible duplicate",
      jc_credit: "Credit",
      jc_date_suspect: "This date looks off — please confirm", jc_check_date: "Check date",
      web2_versions_none_published: "No earlier versions — the live site is the current publish",
      sched_hide_delay: "Hide delay detail (customer copy)",
      proj_merge_title: "Merge project",
      cust_merge_title: "Merge customer",
      merge_keep_this: "Keep this record and move everything from the other one into it. The other record is archived.",
      fin_void_reason: "Reason (optional)",
      fin_actions: "Actions",
      fin_revise: "Revise (new version)",
      fin_create_invoice: "Create invoice",
      fin_signed_pdf: "Download signed PDF",
      fin_trash: "Trash",
      fin_trash_empty: "No deleted documents",
      fin_more: "More",
      fin_invoice: "Invoice",
      fin_change_order: "Change Order",
      fin_voided_banner: "This document was voided — it no longer counts.",
      mv2_viewed: "Viewed",
      mv2_common_items: "Items shared by all packages (Common)",
      mv2_reminders: "Automatic reminders",
      mv2_co_reason_customer_request: "Customer request",
      mv2_co_reason_hidden_condition: "Hidden condition",
      mv2_co_reason_code_requirement: "Code requirement",
      mv2_co_reason_design_change: "Design change",
      mv2_co_reason_other: "Other",
      mv2_co_impact: "Schedule {{days}} days",
      mv2_not_signed: "Not signed",
      mv2_co_payment_timing: "Payment timing",
      mv2_co_pay_next: "Add to the next invoice",
      mv2_co_pay_now: "Invoice now",
      mv2_co_pay_split: "Split across remaining schedule",
      mv2_co_create_from_item: "Create change order",
      mv2_pb_import_csv: "Import CSV",
      mv2_pb_import_result: "Added {{created}}, updated {{updated}}",
      mv2_pb_starter: "Starter items",
      mv2_pb_starter_done: "Added {{n}} starter items",
      mv2_pb_margin: "margin",
      mv2_pb_assemblies: "Assemblies",
      mv2_asm_new: "New assembly",
      mv2_asm_name: "Assembly name",
      mv2_asm_add: "Add product",
      mv2_asm_empty: "No assemblies yet",
      mv2_asm_items_label: "items",
      mv2_asm_missing: "No longer in price book",
      mv2_from_assembly: "From assembly",
      mv2_est_from_wt: "Create estimate",
      mv2_est_from_wt_done: "Estimate {{n}} created",
      mv2_trade_roofing: "Roofing",
      mv2_trade_remodeling: "Remodeling",
      mv2_trade_painting: "Painting",
      mv2_trade_concrete: "Concrete",
      mv2_co_waiting: "{{count}} change order waiting for {{name}} ({{amount}})",
      mv2_co_waiting_plural: "{{count}} change orders waiting for {{name}} ({{amount}})",
      mv2_co_description: "Description",
      mv2_co_verbal: "Customer approved verbally",
      mv2_co_verbal_note: "Who approved + note",
      mv2_co_reason_label: "Reason",
      mv2_contract: "Contract",
      mv2_billed_to_date: "Billed to date",
      mv2_this_invoice: "This invoice",
      mv2_remaining: "Remaining",
      mv2_balance_due: "Balance due",
      mv2_paid_to_date: "Paid to date",
      mv2_due: "Due {{date}}",
      mv2_suggest_pairs: "Suggest pairs",
      mv2_add_pair: "Add pair",
      mv2_swap_photo: "Swap",
      mv2_link_to_item: "Link to line item",
      mv2_no_link: "No link (block)",
      mv2_remind_now: "Send reminder now",
      mv2_receipt_auto: "Email a receipt automatically when a payment is recorded",
      mv2_aging: "Aging",
      mv2_aging_current: "Current",
      mv2_aging_30: "1–30 days",
      mv2_aging_60: "31–60 days",
      mv2_aging_60plus: "60+ days",
      mv2_win_rate: "Win rate (90 days)",
      mv2_cos_month: "Change orders approved this month",
      mv2_progress_invoice: "Progress invoice",
      mv2_final_invoice: "Final invoice",
      mv2_final_hint: "Contract minus everything previously billed",
      mv2_pct_complete: "% complete",
      mv2_fixed_amount: "Fixed amount",
      mv2_milestone: "Milestone",
      mv2_no_contract: "No contract amount on this project yet — approve an estimate first",
      mv2_pairs_frozen_note: "Photos are frozen with the invoice when sent",
      mv2_record_payment: "Record payment",
      mv2_pay_ref: "Check # / reference",
      mv2_pay_note: "Note",
      mv2_pm_check: "Check",
      mv2_pm_cash: "Cash",
      mv2_pm_zelle: "Zelle",
      mv2_pm_venmo: "Venmo",
      mv2_pm_card: "Card",
      mv2_pm_other: "Other",
      wt_filter_all: "All",
      portal_walkthroughs: "Walkthrough reports",
      u360_pick_crew: "Who worked? Pick {{count}} — {{hours}}h each (edit below)",
      u360_hours_short: "hrs",
      u360_pick_crew_hint: "Timecards only save for the people you pick.",
      u360_saved_summary: "{{saved}} of {{total}} saved",
      u360_saved_prefix: "Saved",
      u360_sum_daily_log_one: "log",
      u360_sum_daily_log_other: "{{count}} logs",
      u360_sum_timecards_one: "timecard",
      u360_sum_timecards_other: "{{count}} timecards",
      u360_sum_tasks_one: "task",
      u360_sum_tasks_other: "{{count}} tasks",
      u360_sum_schedule_one: "schedule entry",
      u360_sum_schedule_other: "{{count}} schedule entries",
      u360_sum_equipment_one: "equipment entry",
      u360_sum_equipment_other: "{{count}} equipment entries",
      u360_sum_receipt_one: "receipt",
      u360_sum_receipt_other: "{{count}} receipts",
      u360_sum_status_one: "status update",
      u360_sum_status_other: "status update",
      u360_sum_change_order_one: "change order draft",
      u360_sum_change_order_other: "{{count}} change order drafts",
      u360_sum_customer_message_one: "customer message",
      u360_sum_customer_message_other: "{{count}} customer messages",
      u360_sum_photos_one: "photo",
      u360_sum_photos_other: "{{count}} photos",
      u360_skipped: "Skipped",
      u360_review_title: "Review Your 360 Update",
      u360_which_project: "Which project is this for?",
      u360_approve: "Approve 360 Update",
      u360_approve_all: "Approve all",
      u360_approve_blocked_crew: "Pick who worked above, or turn off Timecards.",
      fv_share: "Share",
      fv_download: "Download",
      fv_print: "Print",
      jr_pending_review: "{{hours}} h pending review",
      jr_in_trash: "In Trash",
      u360_picker_loading: "Loading team…",
      u360_chat_saved: "Saved: {{list}}",
      proj_archived_toast: "Project archived",
      action_undo: "Undo",
      close: "Close",
      u360_add_worker: "Add worker",
      u360_worker_name_ph: "Name (no account needed)",
      u360_tc_skipped: "Timecards skipped — pick who worked",
      cs_tz_label: "Time zone",
      u360_edit_transcript_btn: "Edit Transcript",
      u360_done_title: "Your job has been updated.",
      u360_undo: "Undo 360 Update",
      u360_undone: "360 Update reversed.",
      u360_undo_failed: "Undo window expired or already reversed.",
      u360_approve_failed: "Couldn't apply — nothing was saved. Try again.",
      u360_extra_work_detected: "This sounds like possible additional work.",
      u360_extra_work_hint: "Review the draft change order below — nothing is sent without your approval.",
      u360_missing_info: "Missing details — tap Edit to fill in before approving.",
      u360_not_provided: "Not provided",
      u360_time_default: "(default hours)",
      loading: "Loading…",
      u360_sec_daily_log: "Daily Activity",
      u360_sec_checklist: "Checklist",
      u360_sec_equipment: "Equipment",
      u360_sec_receipt: "Receipt Expense",
      u360_expl_equipment: "Drafts equipment-hour logs on the Costs tab. Crew drafts wait for owner approval.",
      u360_expl_receipt: "Drafts an expense on the Costs tab — attach the receipt photo there for the record.",
      u360_pick_equipment: "Pick machine",
      u360_sec_timecards: "Timecards",
      u360_sec_status: "Project Status",
      u360_sec_tasks: "Tasks & Materials",
      u360_sec_schedule: "Schedule",
      u360_sec_change_order: "Change Order (draft)",
      u360_sec_customer_message: "Customer Update (draft)",
      u360_sec_photos: "Photos",
      u360_expl_daily_log: "Adds an entry to the project's Daily Activity.",
      u360_expl_checklist: "Adds the starter checklist to this job.",
      u360_expl_timecards: "Records hours on each worker's timecard.",
      u360_expl_status: "Updates the project's latest progress note.",
      u360_expl_tasks: "Creates tasks and material reminders for the team.",
      u360_expl_schedule: "Adds or moves work on the schedule.",
      u360_expl_change_order: "Creates a DRAFT change order — you review and send it yourself.",
      u360_expl_customer_message: "Prepares a DRAFT customer update — nothing is sent automatically.",
      u360_expl_photos: "Suggests today's best photos from this project.",
      u360_land_title: "Say it once. Update everything.",
      u360_land_sub: "Speak a quick job update and BuildProject360 prepares your daily log, crew time, schedule, tasks, customer update and change order — all for your review before anything is saved or sent.",
      u360_land_tagline: "Less paperwork. Fewer missed details. More time building.",
      u360_land_cta: "Start Free for 14 Days",
      u360_demo_quote: "Finished the Smith roof tear-off. Three guys, eight hours. Found six damaged sheets — draft a change order and schedule install tomorrow.",
      u360_demo_note: "Every action is prepared for your review first. Nothing saves or sends until you approve.",
      ewc_title: "Extra Work Catcher",
      ewc_sub: "Possible unbilled work spotted in daily logs from the last 14 days.",
      ewc_draft_cta: "Draft Change Order",
      ewc_drafted: "Draft change order created",
      aa360_title: "360 Impact",
      aa360_started: "Updates started",
      aa360_approved: "Updates approved",
      aa360_minutes: "Est. minutes saved",
      aa360_co: "Extra-work drafts",
      byl_title: "Before you leave {{address}}",
      byl_all_clear: "All set — nothing missing today.",
      byl_fix_now: "Fix Now",
      byl_finish_anyway: "Finish Anyway",
      byl_completed_photo: "Add one completed-work photo",
      byl_evening_update: "Finish your evening update",
      byl_open_tasks_today: "Open tasks due today",
      byl_damage_documented: "Document damage with a photo",
      byl_time_entry: "Missing time entry",
      byl_extra_work_submitted: "Review possible additional work",
      tr_title: "Tomorrow Ready",
      tr_ready: "Everything is ready",
      tr_issues: "{{count}} items need attention",
      tr_issues_one: "{{count}} item needs attention",
      tr_review: "Review Issues",
      tr_mark_ready: "Mark Ready",
      tr_send_cards: "Send Crew Cards",
      tr_no_jobs: "Nothing scheduled tomorrow.",
      tr_iss_missing_address: "Missing address — {{project}}",
      tr_iss_no_crew: "No crew assigned — {{project}}",
      tr_iss_missing_crew_card: "Missing Crew Card — {{project}}",
      tr_iss_weather: "Weather may affect {{project}} ({{detail}})",
      tr_iss_crew_conflict: "Schedule conflict — {{detail}}",
      tr_iss_open_tasks: "{{count}} open task(s) due",
      tr_iss_today_delay: "Today's work may delay {{project}}",
      cc_title: "Crew Cards",
      cc_create: "New Crew Card",
      cc_recipient: "Worker or sub name",
      cc_revoke: "Revoke",
      cc_copy: "Copy link",
      cc_copied: "Link copied",
      cc_empty: "No Crew Cards yet — send one to a worker or sub.",
      cc_hint: "They open a simple mobile card — no app or account needed.",
      cc_scope: "Assigned scope of work",
      cc_arrival: "Arrival time (e.g. 7:00 AM)",
      cc_pin: "Optional PIN",
      cc_perm_photos: "May upload job photos",
      cc_perm_notes: "May add field notes",
      cc_perm_clock: "May clock in/out",
      cc_perm_customer: "Show customer name",
      cc_ref_photos: "Reference photos",
      cc_create_go: "Create & Copy Link",
      cc_revoked: "Revoked",
      web2_onboard_hint: "Answer a few questions and 360 Assistant will create the first draft for you — nothing goes public until you say so.",
      web2_build: "Build My Website",
      web2_template: "Start With a Template",
      web2_later: "I'll Do This Later",
      web2_status_draft: "Draft",
      web2_status_published: "Published",
      web2_status_unpublished: "Unpublished",
      web2_address: "Public website address",
      web2_preview: "Preview Website",
      web2_edit: "Edit Website",
      web2_ai_improve: "Ask AI to Improve",
      web2_publish: "Publish Changes",
      web2_unpublish: "Unpublish Website",
      web2_publish_confirm: "Publish the current draft? It becomes visible at your public address immediately.",
      web2_unpublish_confirm: "Unpublish your website? Visitors will see a 'not published' page until you publish again.",
      web2_restore_confirm: "Restore this published version into your draft? Your live site stays untouched until you publish.",
      web2_leads: "Leads received",
      web2_last_updated: "Last updated",
      web2_views: "views",
      web2_versions: "Version history",
      web2_restore: "Restore",
      web2_no_versions: "Versions appear after your first publish.",
      web2_perf: "Mobile performance: images are auto-compressed, lazy-loaded and served over HTTPS.",
      web2_wizard_title: "Answer a few questions",
      web2_wizard_hint: "360 Assistant will write your first draft. You review everything before it goes public.",
      web2_q_name: "Company name",
      web2_q_services: "Services you offer (comma separated)",
      web2_q_area: "Primary service area",
      web2_q_phone: "Phone number",
      web2_q_email: "Email address",
      web2_q_years: "Years in business",
      web2_q_story: "Short company story",
      web2_q_style: "Preferred style",
      web2_q_colors: "Preferred colors",
      web2_q_cta: "Main call to action (e.g. Get My Free Estimate)",
      web2_generate: "Generate My Website Draft",
      web2_generating: "360 Assistant is writing your draft…",
      web2_sections_hint: "Show, hide, reorder and edit each section. Save stores a draft — Publish makes it live.",
      web2_desktop: "Desktop",
      web2_mobile: "Mobile",
      web2_hide: "Hide",
      web2_show: "Show",
      web2_edit_section: "Edit",
      web2_approve_photo: "Approve for public",
      web2_approve_confirm: "Mark this photo as 'Approved for Public Portfolio'? It may be shown on your public website.",
      web2_approved: "Photo approved for public display",
      web2_pick_photos: "Your photo library (approve photos before publishing them)",
      web2_no_approved: "No approved photos yet — approve photos in the Portfolio section below.",
      web2_before_after_hint: "Pick one before and one after photo (approved photos only).",
      web2_before: "Before",
      web2_after: "After",
      web2_ba_add: "Add before/after pair",
      web2_rewrite: "AI",
      web2_rw_shorter: "Shorter",
      web2_rw_professional: "More professional",
      web2_rw_friendlier: "Friendlier",
      web2_rw_confident: "More confident",
      web2_rw_translate_es: "Translate to Spanish",
      web2_rw_fix_grammar: "Fix grammar",
      web2_f_headline: "Headline",
      web2_f_subtext: "Supporting text",
      web2_f_cta: "Estimate button text",
      web2_f_hero_photo: "Hero photo (approved photos only)",
      web2_f_trust: "Trust items (one per line)",
      web2_f_service_name: "Service name",
      web2_f_service_desc: "Service description",
      web2_f_service_add: "Add service",
      web2_f_why: "Why choose us (one per line)",
      web2_f_about: "About the company",
      web2_f_review_perm: "The customer gave permission to publish this review",
      web2_f_review_add: "Add review",
      web2_f_areas: "Service areas (one per line)",
      web2_f_show_form: "Show the estimate request form",
      web2_f_proj_title: "Project title",
      web2_f_proj_desc: "Project description",
      sec_hero: "Hero",
      sec_trust_bar: "Trust Bar",
      sec_services: "Services",
      sec_why: "Why Choose Us",
      sec_portfolio: "Project Gallery",
      sec_before_after: "Before & After",
      sec_about: "About the Company",
      sec_reviews: "Reviews",
      sec_service_areas: "Service Areas",
      sec_estimate: "Estimate Request",
      sec_contact: "Contact",
      sec_team: "Meet the Team",
      sec_faq: "FAQ",
      sec_financing: "Financing",
      sec_warranty: "Warranty",
      web2_style_modern: "Modern",
      web2_style_bold: "Bold",
      web2_style_premium: "Premium",
      web2_style_traditional: "Traditional",
      web2_style_minimal: "Minimal",
      payment_checking: "Confirming your subscription…",
      payment_pending: "Still processing — check back in a minute",
      payment_thanks: "You're subscribed!",
      payment_success_hint: "Your 14-day free trial has started. You won't be charged until it ends.",
      payment_back: "Back to dashboard",
      payment_canceled: "Checkout canceled",
      payment_canceled_hint: "No charge was made. Pick a plan whenever you're ready.",
      payment_try_again: "Back to plans",
      // Admin
      admin_title: "Admin",
      admin_tenants: "companies",
      admin_tc_title: "Test companies", admin_tc_hint: "QA companies created by the test suite ('DELETE ME' / 'QA …'). Delete them here yourself.",
      admin_tc_empty: "No test companies right now", admin_tc_delete: "Delete permanently",
      admin_tc_users: "users", admin_tc_projects: "projects", admin_tc_photos: "photos",
      admin_tc_confirm_title: "Delete this test company?",
      admin_tc_confirm_body: "\"{{name}}\" and all of its data will be permanently deleted. This cannot be undone.",
      admin_tc_deleted: "\"{{name}}\" deleted",
      admin_support: "Support access",
      admin_support_hint: "Grants read-mostly access for 1 hour. Billing is redacted. Every action is logged.",
      admin_reason: "Reason for access (required — appears in audit log)",
      admin_grant: "Grant 1h access",
      admin_grant_link: "Support link (expires in 1 hour):",
      admin_revoke: "Revoke",
      admin_active_grants: "Active grants",
      admin_audit: "Audit log",
      admin_backups: "Backups",
      admin_last_backup: "Last backup",
      admin_no_backups: "No backups yet — first one runs tonight at 3 AM UTC",
      admin_archives: "archives kept (14-day retention)",
      // Website + markup + camera
      nav_website: "Website",
      ann_annotate: "Annotate",
      ann_draw: "Draw",
      ann_arrow: "Arrow",
      ann_text: "Text",
      ann_clear: "Clear",
      ann_save: "Save annotation",
      ann_hint: "Draw on the photo. Tap Text, tap the photo, then type.",
      ann_undo: "Undo",
      ann_redo: "Redo",
      ann_saved: "Marked up photo saved",
      ann_save_failed: "Couldn't save — Retry",
      ann_discard_title: "Discard markup?",
      ann_discard_body: "Your marks haven't been saved.",
      ann_keep_editing: "Keep editing",
      ann_discard: "Discard",
      ann_clear_confirm: "Clear all marks?",
      ann_marked_up: "Marked up",
      ann_original: "Original",
      ann_add: "Add",
      ann_offline_saved: "Saved on this phone — uploads when you're back online",
      ann_uploaded: "Uploaded",
      ann_color: "Color",
      ann_size: "Thickness",
      ann_size_s: "S",
      ann_size_m: "M",
      ann_size_l: "L",
      ann_edit: "Edit",
      ann_delete: "Delete",
      ann_move: "Drag to move",
      photo_voice_note: "Voice note",
      cam_burst: "Rapid camera",
      cam_capture: "Capture",
      cam_done: "Done",
      install_title: "Install BuildProject360",
      install_body: "One tap from your home screen — camera, photos and logs, even offline.",
      install_action: "Install app",
      install_ios_body: "Tap the Share button, then “Add to Home Screen” to install BuildProject360.",
      install_app_menu: "Install app",
      install_dismiss: "Not now",
      push_title: "Enable notifications",
      push_body: "Get instant alerts for new website leads and homeowner comments.",
      push_action: "Enable",
      push_dismiss: "Not now",
      push_enabled: "Notifications enabled",
      push_failed: "Could not enable notifications",
      field_mode: "Field mode",
      field_mode_on: "Field mode ON — high contrast for sunlight",
      field_mode_off: "Field mode off",
      cam_start_failed: "Camera unavailable — use Take photo instead",
      cam_captured: "captured",
      cam_close: "Close camera",
      dvp_close: "Close preview",
      dvp_signature_line: "Approval signature",
      dvp_signature_name: "Name",
      dvp_signature_date: "Date",
      cam_shutter: "Take photo",
      cam_switch: "Switch camera",
      cam_flash: "Toggle flash",
      cam_zoom: "Zoom",
      cam_permission_denied: "Camera access is blocked. Allow it in your browser settings, or use your phone camera app.",
      cam_use_phone: "Use phone camera instead",
      cam_preview: "Preview captured photo",
      cam_retake: "Retake",
      cam_keep: "Keep photo",
      cam_delete: "Delete this photo",
      cam_reset: "Reset view",
      cam_rotate_left: "Rotate left",
      cam_rotate_right: "Rotate right",
      cam_prev: "Previous photo",
      cam_next: "Next photo",
      photos_select_project: "Select project",
      photos_pick_first: "Pick a project above, then add photos",
      photos_choose_library: "Choose from Library",
      viewer_download: "Download",
      viewer_edit: "Edit details",
      viewer_deleted: "Photo deleted",
      viewer_delete_confirm: "Tap again to delete",
      viewer_restored: "Photo restored",
      viewer_more: "More options",
      viewer_retry: "Retry",
      viewer_load_failed: "This photo could not be loaded.",
      viewer_delete_title: "Delete this photo?",
      viewer_delete_body: "It'll be in Trash for 30 days — you can restore it anytime.",
      viewer_report: "Report a mistake",
      viewer_reported: "Reported to the owner",
      photos_del_body_one: "Delete 1 photo? It'll be in Trash for 30 days.",
      photos_del_body_other: "Delete {{count}} photos? They'll be in Trash for 30 days.",
      pd_act_photos_deleted_one: "1 photo deleted",
      pd_act_photos_deleted_other: "{{count}} photos deleted",
      pd_act_wt_deleted: "Walkthrough deleted",
      pd_act_photo_restored: "Photo restored",
      pd_ev_photo_restore: "restored",
      trash_media_title: "Photos & walkthroughs",
      wt_del_menu: "Delete walkthrough",
      wt_del_title: "Delete this walkthrough?",
      wt_del_photos: "Also delete its {{count}} photos",
      wt_del_tasks: "Also delete {{count}} task(s) it created",
      wt_deleted: "Walkthrough deleted",
      wt_show_open_items: "Show open items to customer",
      photo_progress: "Progress",
      nav_more: "More",
      nav_camera: "Camera",
      nav_settings: "Settings",
      settings_title: "Settings",
      cs_brand_t: "Company Profile & Brand",
      cs_brand_d: "Name, logo, colors, and contact info shown on documents.",
      cs_crew_t: "Crew & Access",
      cs_crew_d: "Invite people, set roles, assign projects.",
      cs_cal_t: "Work Calendar & Hours",
      cs_cal_d: "Working days, business hours, and holidays.",
      cs_mod_t: "Modules & Features",
      cs_mod_d: "Choose which parts of the app each role sees.",
      cs_billing_t: "Billing & Subscription",
      cs_billing_d: "Plan, seats, and invoices.",
      cs_trash_t: "Trash & Data Cleanup",
      cs_trash_d: "Restore or permanently remove deleted items.",
      cs_members: "{{count}} members",
      cs_members_one: "{{count}} member",
      cs_members_other: "{{count}} members",
      cs_cal_summary: "{{days}} days/week · {{start}}–{{end}}",
      cs_logo_ok: "Logo set",
      cs_logo_missing: "No logo yet",
      cs_trash_count: "{{count}} deleted items",
      cs_mod_summary: "Per-role app visibility",
      cs_mod_hint: "Owner always has access to everything.",
      cs_role_owner: "Owner",
      cs_role_admin: "Admin",
      cs_role_crew: "Crew",
      cs_mod_daily_logs: "Daily activity logs",
      cs_mod_photo_uploads: "Photos & camera",
      cs_mod_timeclock_gps: "Timeclock",
      cs_mod_invoicing_estimates: "Estimates & invoices",
      cs_mod_client_portal_sharing: "Customer sharing",
      cs_mod_equipment_tracking: "Job costs & equipment",
      settings_scheduling: "Scheduling",
      settings_scheduling_hint: "Working days, business hours and holidays",
      cc_customer_tab: "Customer",
      cc_tab_title: "Customer Confidence",
      cc_tab_hint: "Customer updates, decisions, project record and warranty — built from this project's photos and activity.",
      cc_sub_updates: "Updates",
      cc_dec_new: "New Decision",
      cc_pg_title: "Promise Guard",
      cc_pg_add: "Add promise",
      cc_pg_title_ph: "What did you promise? (e.g. Cabinets installed)",
      cc_pg_due: "Due date",
      cc_pg_kept: "Kept",
      cc_pg_snooze: "Snooze",
      cc_pg_dismiss: "Dismiss",
      cc_pg_reason_ph: "Reason (internal only)",
      cc_pg_snoozed_until: "Snoozed until {{date}}",
      cc_pg_none: "No promises tracked yet",
      cc_pg_closed: "closed",
      cc_pg_rule_overdue: "Due date passed and it is still open.",
      cc_pg_rule_due_soon: "Due within 2 days and still open.",
      cc_pg_rule_quiet: "No customer update sent in 7+ days while a promise is open.",
      cc_pg_rule_decision_overdue: "Decision request passed its needed-by date without a customer choice.",
      cc_pg_decision_warn: "Decision overdue",
      cc_st_open: "open",
      cc_rec_search_ph: "Search the record…",
      cc_rec_add: "Add record item",
      cc_rec_product: "Product",
      cc_rec_material: "Material selection",
      cc_rec_document: "Document",
      cc_rec_title_ph: "Title (e.g. Countertop — Quartz Calacatta Gold)",
      cc_rec_detail_ph: "Details (model, color, warranty…)",
      cc_rec_none: "The record builds itself as photos, updates and decisions happen.",
      cc_rec_no_match: "No matches",
      cc_rec_photos: "{{count}} photos",
      cc_rec_update: "Customer update",
      cc_rec_decision: "Signed decision",
      cc_acked_short: "Customer confirmed",
      cc_co_checklist: "Closeout checklist",
      cc_co_final_photos: "Final photos taken",
      cc_co_final_update: "Final customer update sent",
      cc_co_decisions_resolved: "All decisions resolved",
      cc_co_warranty_recorded: "Warranty info recorded",
      cc_co_walkthrough_confirmed: "Customer walkthrough done",
      cc_co_suggested: "suggested",
      cc_co_complete: "Complete closeout",
      cc_co_completed: "Closeout completed {{date}}",
      cc_co_completed_toast: "Closeout completed",
      cc_co_pdf: "Download closeout PDF",
      cc_co_share: "Copy warranty portal link",
      cc_co_remaining: "Complete all checklist items first",
      cc_w_title: "Warranty records",
      cc_w_add: "Add warranty",
      cc_w_none: "No warranty records yet",
      cc_w_item_ph: "Item (e.g. Roof shingles)",
      cc_w_provider_ph: "Provider / manufacturer",
      cc_w_start: "Start",
      cc_w_end: "End",
      cc_w_contact_ph: "Service contact",
      cc_w_notes_ph: "Notes (registration #, terms…)",
      cc_w_coverage: "Coverage",
      cc_sr_title: "Service requests",
      cc_sr_none: "No service requests",
      cc_sr_anonymous: "Customer",
      cc_sr_in_progress: "Mark in progress",
      cc_sr_resolved: "Mark resolved",
      cc_w_portal_title: "Warranty & Service",
      cc_w_completed_banner: "Project closeout completed on {{date}}",
      cc_sr_form_title: "Request service",
      cc_sr_name_ph: "Your name",
      cc_sr_contact_ph: "Phone or email",
      cc_sr_desc_ph: "Describe the issue…",
      cc_sr_submit: "Send service request",
      cc_sr_thanks: "Request received — we'll be in touch.",
      cc_sr_mine: "Your requests",
      cc_st_new: "new",
      cc_st_in_progress: "in progress",
      cc_st_resolved: "resolved",
      cc_ev_closeout_completed: "Closeout completed",
      cc_sub_reviews: "Reviews",
      cc_rev_share: "Copy review request link",
      cc_rev_none: "No reviews yet — share the link after closeout.",
      cc_rev_marketing: "Quote OK",
      cc_rev_photos: "Photos OK",
      cc_rev_publish: "Approve for website",
      cc_rev_unpublish: "Remove website approval",
      cc_rev_published: "Website approved",
      cc_ref_title: "Referrals",
      cc_ref_none: "No referrals yet",
      cc_rev_page_title: "How did we do?",
      cc_rev_text_ph: "Tell us about your experience (optional)",
      cc_rev_name_ph: "Your name",
      cc_rev_marketing_opt: "You may quote my review in your marketing",
      cc_rev_photos_opt: "You may share my project photos publicly",
      cc_rev_submit: "Submit review",
      cc_rev_thanks: "Thank you for your review!",
      cc_ref_form_title: "Know someone planning a project?",
      cc_ref_name_ph: "Their name",
      cc_ref_contact_ph: "Their phone or email",
      cc_ref_note_ph: "Note (optional)",
      cc_ref_submit: "Send referral",
      cc_ref_thanks: "Thanks for the referral!",
      cc_version_label: "v",
      cc_sent_meta: "Sent to {{name}} ({{email}}) on {{date}}",
      cc_history: "History",
      cc_acked_by: "Confirmed by {{name}}",
      cc_archived_toast: "Archived",
      cc_revoked_toast: "Link revoked",
      save: "Save",
      cancel: "Cancel",
      back: "Back",
      edit: "Edit",
      close: "Close",
      remove: "Remove",
      confirm: "Confirm",
      cc_announce_text: "New: Customer Confidence — send photo-backed updates, collect signed decisions, and hand over a branded closeout record.",
      cc_announce_learn: "Learn more",
      cc_replied_short: "Customer replied",
      cc_st_kept: "kept",
      cc_st_dismissed: "dismissed",
      cc_st_snoozed: "snoozed",
      cc_photo_note_label: "Description",
      cc_photos_label: "Project photos",
      cc_dec_none: "No decision requests yet",
      cc_dec_title_label: "Decision",
      cc_dec_title_ph: "What needs deciding? (e.g. Countertop material)",
      cc_dec_desc_ph: "Context for the customer (optional)",
      cc_dec_options: "Options",
      cc_dec_label_ph: "Option label",
      cc_dec_cost_ph: "Cost effect (e.g. +$450)",
      cc_dec_sched_ph: "Schedule effect (e.g. +2 days)",
      cc_dec_add: "Add option",
      cc_dec_due: "Needed by (optional)",
      cc_dec_send: "Send decision request",
      cc_dec_send_confirm: "The customer will receive a secure link to review the options and sign their choice. Send now?",
      cc_dec_choose: "Choose one option",
      cc_dec_sign_ph: "Type your full name to sign",
      cc_dec_submit: "Confirm my choice",
      cc_dec_thanks: "Thank you — your choice has been recorded.",
      cc_dec_decided: "Decided",
      cc_dec_your_choice: "Your choice",
      cc_dec_cost: "Cost",
      cc_dec_schedule: "Schedule",
      cc_dec_due_by: "Needed by",
      cc_dec_need_two: "Add at least two options before sending",
      cc_st_decided: "decided",
      cc_ev_decided: "Customer decided",
      cc_sub_decisions: "Decisions",
      cc_sub_record: "Project Record",
      cc_sub_warranty: "Warranty",
      cc_coming_soon: "Coming in a later phase",
      cc_open_settings: "Open Customer Confidence settings",
      cc_settings_title: "Customer Confidence",
      cc_settings_hint: "Configure the customer-facing experience for this company.",
      cc_enable_company: "Enable Customer Confidence for this company",
      cc_customer_name: "Customer-facing company name",
      cc_greeting: "Default customer greeting",
      cc_closing: "Default update closing",
      cc_link_days: "Secure-link expiration",
      cc_days: "{{count}} days",
      cc_delivery_title: "Delivery",
      cc_email_enabled: "Email delivery",
      cc_sms_soon: "Text messages (coming later)",
      cc_replies: "Allow customer replies",
      cc_ack: "Request customer acknowledgement",
      cc_advanced: "Advanced settings",
      cc_approval_reminder: "Approval reminder (hours)",
      cc_warranty_reminder: "Warranty reminder (days before expiration)",
      cc_review_req: "Review requests",
      cc_referral_req: "Referral requests",
      cc_roles_title: "Who can do what",
      cc_perm_create_drafts: "Create update drafts",
      cc_perm_send_updates: "Send updates",
      cc_perm_request_approvals: "Request approvals",
      cc_perm_manage_closeout: "Manage closeout records",
      cc_preview_exp: "Preview Customer Experience",
      cc_send_test: "Send Test Update",
      cc_phase2: "Available after Phase 2",
      ac_title: "Companies — Access & Billing",
      ac_search_ph: "Search by company name or owner email",
      ac_search_btn: "Search",
      ac_empty: "No companies match that search.",
      ac_back: "Back",
      ac_trial_start: "Trial start",
      ac_trial_end: "Trial end",
      ac_sub_status: "Subscription",
      ac_restriction: "Access",
      ac_full_access: "Full access",
      ac_read_only: "Read-only (restricted)",
      ac_override_active: "Active override",
      ac_until: "until",
      ac_action: "Action",
      ac_act_extend: "Extend trial by days",
      ac_act_set_end: "Set new trial end date",
      ac_act_comp: "Complimentary access",
      ac_act_discount: "Discounted access",
      ac_act_training: "Designate Training/Test",
      ac_act_suspend: "Suspend access",
      ac_act_clear: "Clear override (restore billing rules)",
      ac_days: "Days",
      ac_until_label: "Until (optional — blank = indefinite)",
      ac_amount: "Amount $/mo",
      ac_duration: "Duration (days)",
      ac_indefinite: "Indefinite",
      ac_reason: "Reason",
      ac_reason_ph: "Required — recorded in audit history",
      ac_reason_required: "A reason is required for every access change.",
      ac_confirm_required: "Please confirm this consequential change.",
      ac_confirm_text: "I confirm this access/billing change and understand it is recorded.",
      ac_apply: "Apply access change",
      ac_saved: "Access updated.",
      ac_history: "Access change history",
      ac_req_title: "Pending extension requests",
      ac_req_no_msg: "(no message)",
      ac_req_days_prompt: "Extend by how many days?",
      ac_req_decline_prompt: "Reason for declining:",
      ac_approve: "Approve",
      ac_decline: "Decline",
      ac_status_trial: "Trial",
      ac_status_paid: "Paid",
      ac_status_complimentary: "Complimentary",
      ac_status_training: "Training/Test",
      ac_status_expired: "Expired",
      ac_status_suspended: "Suspended",
      cc_admin_title: "Customer Confidence",
      cc_mode: "Rollout mode",
      cc_mode_off: "Off",
      cc_mode_pilot: "Pilot Accounts",
      cc_mode_all: "All Accounts",
      cc_confirm_all: "You are about to activate Customer Confidence for all active BuildProject360 companies. Existing company data will not be changed. Continue?",
      cc_confirm_mode: "Change the rollout mode? Existing company data will not be changed.",
      cc_emergency: "Emergency Disable",
      cc_emergency_hint: "Blocks all Customer Confidence access and background activity. Never deletes data.",
      cc_confirm_emergency_on: "Emergency-disable Customer Confidence for every company now? No data is deleted.",
      cc_confirm_emergency_off: "Lift the emergency disable? Companies return to their previous access.",
      cc_search_ph: "Search companies",
      cc_pilot_list: "Pilot companies",
      cc_no_pilots: "No pilot companies enabled",
      cc_enabled_by: "Enabled {{date}} by {{by}}",
      cc_company_on: "Company: on",
      cc_company_off: "Company: off",
      cc_enable: "Enable",
      cc_disable: "Disable",
      cc_stat_companies: "Participating companies",
      cc_stat_active: "Companies active",
      cc_stat_projects: "Projects using it",
      cc_stat_created: "Updates created",
      cc_stat_sent: "Updates sent",
      cc_stat_ack: "Acknowledgement rate",
      cc_stat_failed: "Failed deliveries",
      cc_audit: "Audit history",
      action_continue: "Continue",
      cc_new_update: "New Update",
      cc_no_updates: "No updates yet — create the first one.",
      cc_back: "Back",
      cc_photos_selected: "{{count}} photos selected",
      cc_select_photos: "Project photos",
      cc_date_from: "From",
      cc_date_to: "To",
      cc_recipient_name: "Customer name",
      cc_recipient_email: "Customer email",
      cc_note_label: "Note to customer (optional)",
      cc_draft_ai: "Draft with AI",
      cc_ai_label: "AI draft — review and edit every field before sending",
      cc_ai_flags: "Review this wording carefully before sending",
      cc_unchanged: "Project activity hasn't changed — showing the existing draft.",
      cc_field_work_completed: "Work completed",
      cc_field_progress_summary: "Progress summary",
      cc_field_what_next: "What happens next",
      cc_field_next_visit: "Next scheduled visit",
      cc_field_schedule_changes: "Schedule changes",
      cc_field_decisions_needed: "Decisions needed",
      cc_mark_ready: "Mark ready for review",
      cc_approve_internal: "Approve internally",
      cc_send_customer: "Send to customer",
      cc_send_confirm: "Send this update to the customer now? The secure link can be revoked later.",
      cc_sent_toast: "Update sent",
      cc_copy_link: "Copy secure link",
      cc_link_copied: "Secure link copied",
      cc_revoke_link: "Revoke link",
      cc_archive: "Archive",
      cc_test_sent: "Test email sent",
      cc_events_title: "Delivery & activity",
      cc_ev_created: "Draft created",
      cc_ev_draft_generated: "AI draft generated",
      cc_ev_edited: "Edited",
      cc_ev_approved: "Approved internally",
      cc_ev_status: "Status changed",
      cc_ev_sent: "Sent",
      cc_ev_viewed: "Viewed by customer",
      cc_ev_acknowledged: "Acknowledged by customer",
      cc_ev_replied: "Customer replied",
      cc_ev_delivery_failed: "Delivery failed",
      cc_ev_link_created: "Secure link created",
      cc_ev_link_revoked: "Link revoked",
      cc_ev_archived: "Archived",
      cc_ev_test_sent: "Test sent",
      cc_st_draft: "Draft",
      cc_st_ready: "Ready for review",
      cc_st_approved_internal: "Approved internally",
      cc_st_sent: "Sent",
      cc_st_viewed: "Viewed",
      cc_st_acknowledged: "Acknowledged",
      cc_st_replied: "Customer replied",
      cc_st_failed: "Delivery failed",
      cc_st_archived: "Archived",
      cc_sent_to: "Sent to {{email}}",
      cc_ack_btn: "Acknowledge this update",
      cc_ack_name_ph: "Your name (optional)",
      cc_acked_state: "Thank you — your acknowledgement was recorded.",
      cc_reply_title: "Questions or comments",
      cc_reply_ph: "Write a question or reply…",
      cc_reply_send: "Send reply",
      cc_link_gone: "This link has expired or is no longer available.",
      cc_customer_photos: "Project photos",
      cc_from_contractor: "Note from your contractor",
      cc_powered: "Powered by BuildProject360",
      cc_decisions_cta: "Your contractor will follow up on these items.",
      cc_move_up: "Move up",
      cc_move_down: "Move down",
      cc_create_first: "Create an update in a project first (Project → Customer tab).",
      nav_billing: "Billing",
      nav_referrals: "Refer & earn",
      nav_account: "Account",
      cam_choose_project: "Choose a project",
      upload_done: "Uploaded",
      action_open_camera: "Open Camera",
      home_continue: "Continue where you left off",
      home_today_schedule: "Today's schedule",
      home_overdue_tasks: "Overdue tasks",
      sched_view_today: "Today",
      sched_view_day: "Day",
      sched_view_month: "Month",
      sched_view_timeline: "Timeline",
      sched_timeline_hint: "Timeline (Gantt)",
      sched_all_projects: "All projects",
      sched_all_crew: "All crew",
      sched_conflict_title: "Schedule conflict",
      sched_conflict_body: "Already scheduled that day: {{names}}. Move anyway?",
      sched_move_anyway: "Move anyway",
      sched_view_week: "Week",
      sched_view_crew: "Crew",
      mb_rain_title: "Rain in the forecast",
      mb_outdoor_n: "{{n}} outdoor task(s) that day",
      mb_rain_cta: "Preview shift",
      ny_inspection_failed: "Failed inspection needs a plan",
      ny_order_by: "Time to order materials",
      ny_draw_invoice: "Invoice {{label}} — {{amount}}",
      draw_sheet_title: "Create draw invoice",
      draw_sheet_job: "Job",
      draw_sheet_draw: "Draw",
      draw_sheet_estimate: "From estimate",
      draw_sheet_amount: "Amount",
      draw_sheet_note: "Creates the invoice, then gets the customer link ready.",
      draw_create: "Create invoice",
      draw_created: "Invoice {{number}} created",
      draw_open: "Open",
      draw_send_title: "Send to customer",
      draw_sms_body: "{{label}} is ready — invoice attached",
      sheet_delay_applied: "Delay applied",
      sheet_delay_text_hint: "Let the customer know right away.",
      sheet_delay_text_btn: "Text the customer",
      delay_sms_body: "Heads up — {{title}} is delayed {{days}} day(s) ({{reason}}). New date: {{date}}.",
      fin_kickoff_text: "Text customer — kickoff",
      kickoff_sms_with_date: "Thanks for approving {{number}}! We're scheduled to start {{date}}. — {{company}}",
      kickoff_sms_no_date: "Thanks for approving {{number}}! We'll confirm your start date shortly. — {{company}}",
      dep_choose_pct: "Deposit amount",
      dep_create: "Create deposit invoice",
      dep_custom_ph: "Custom %",
      ny_sub_declined: "{{name}} can't make it",
      ny_sub_unanswered: "{{name}} hasn't confirmed",
      eod_title: "Today's recap",
      eod_line: "{{done}} done · {{photos}} photos · {{clock}} clock-ins",
      eod_slipped: "{{n}} not finished",
      eod_tomorrow: "First up tomorrow: {{title}}",
      wr_btn: "This week",
      wr_title: "Weekly report",
      wr_summary: "{{done}} done · {{delays}} delays",
      wr_done: "Tasks completed",
      wr_moves: "Schedule changes",
      wr_photos: "Photos",
      wr_delays: "Delays",
      wr_upcoming: "Scheduled next week",
      wr_causes: "Delays by cause",
      bgv_review_answer: "Answer",
      bgv_review_move_task: "Move task",
      bgv_review_delay_task: "Delay task",
      bgv_review_complete_task: "Complete task",
      bgv_review_rain_day: "Rain day",
      bgv_row_change: "Change",
      bgv_open_schedule: "Open Schedule",
      bgv_apply: "Apply",
      bgv_review_assign_task: "Assign task",
      bgv_review_add_delivery: "Add delivery",
      bgv_row_assignee: "Assign to",
      bgv_row_order_by: "Order by",
      jr_share_customer: "Share with customer",
      jr_share_hint: "A read-only customer-safe link — no notes, money or crew details.",
      jr_weekly_pdf: "Weekly owner report (PDF)",
      jr_weekly_hint: "Last week: tasks done, photos, schedule changes, delays by cause.",
      ap_undo: "Undo",
      ap_undone: "Undone",
      jr_tab_project: "Job report",
      jr_proj_title: "Project status report (PDF)",
      jr_proj_pick: "Pick a job",
      jr_audience_customer: "Customer-safe",
      jr_audience_internal: "Internal",
      jr_audience_hint: "Customer-safe hides internal notes, money and crew details.",
      jr_download_pdf: "Download PDF",
      wr_days_lost: "{{n}}d lost",
      vr_type_ph: "Type what happened",
      notif_weekly_label: "Weekly owner report (Monday email)",
      notif_weekly_hint: "A short summary of last week — tasks done, photos, delays by cause. Includes an unsubscribe link.",
      cb_empty: "No one is scheduled this week.",
      cb_member: "Crew",
      rain_title: "Rain day",
      rain_body: "Pick the rained-out day. Everything on it shifts to the next workday and the whole chain follows. Locked tasks stay put.",
      rain_preview: "Preview",
      rain_preview_moves: "{{n}} item(s) will move to {{date}}.",
      rain_none: "Nothing is scheduled that day.",
      rain_locked: "{{n}} locked task(s) will stay where they are.",
      rain_apply: "Shift everything",
      rain_done: "Moved {{n}} item(s) to {{date}}",
      rec_title: "Recurring visits",
      rec_title_ph: "e.g. Weekly mow — Smith",
      rec_byday: "Repeats on",
      rec_start: "First day",
      rec_until: "Until (optional)",
      rec_create: "Create visits",
      rec_created: "Created {{n}} visits",
      rec_deleted: "Deleted {{n}} visits",
      rec_existing: "Existing series",
      rec_count: "{{n}} visits",
      ical_title: "Calendar feed",
      ical_body: "Subscribe from Google or Apple Calendar with this private link. Anyone who has it can read it — reset it if it's shared by mistake.",
      ical_crew_note: "Your feed shows only tasks assigned to you.",
      ical_reset: "Reset link",
      ical_reset_sure: "Yes, reset",
      ical_reset_done: "New link created — the old one stopped working.",
      ical_scope_mine: "My assigned items", ical_scope_all: "All jobs (whole company)",
      ical_revoke: "Turn off this link", ical_revoke_done: "Link turned off — it no longer works anywhere.",
      integ_ical_feed_name: "Calendar subscribe link (ICS)",
      integ_ical_feed_body: "Private link that keeps Google, Apple or Outlook Calendar in sync with your schedule.",
      integ_outlook_name: "Outlook / Microsoft 365",
      integ_outlook_body: "Two-way sync with a dedicated BuildProject360 calendar in Outlook.",
      integ_get_link: "Get link",
      sl_send_text: "Send by text",
      sl_copy: "Copy link",
      share_sched_opts_hint: "Choose what the customer sees:",
      share_sched_show_badge: "Show on-track / behind badge",
      share_sched_show_delays: "Show delays list",
      sl_copied: "Copied",
      sl_send_email: "Send",
      sl_email_ph: "Email",
      sl_phone_ph: "Phone",
      sl_sent: "Sent",
      subc_action: "Confirm sub",
      subc_title: "Sub confirmations",
      subc_none: "Assign a sub first (Assign), then text them a confirmation link.",
      subc_get_link: "Get link",
      subc_status_pending: "Waiting",
      subc_status_confirmed: "Confirmed",
      subc_status_declined: "Declined",
      subc_msg: "Hi {{name}}, can you confirm this work? {{task}} on {{date}}:",
      wn_share: "Customer: What's next",
      wn_msg: "Here's the live schedule for {{project}} — it stays up to date automatically:",
      pd_tab_history: "History",
      hist_title: "Schedule history",
      hist_empty: "No schedule changes yet.",
      hist_by: "by {{name}}",
      hist_undone: "undone",
      hist_type_move: "Moved",
      hist_type_edit: "Edited",
      hist_type_rain_day: "Rain day",
      hist_type_delay: "Delay",
      hist_type_baseline: "Baseline",
      hist_type_inspection: "Inspection",
      hist_type_inspection_fail: "Inspection failed",
      hist_delay_line: "+{{days}}d · {{reason}}",
      sched_view_list: "List",
      sched_status_past: "Done",
      sched_status_today: "Today",
      sched_status_scheduled: "Scheduled",
      sched_nothing_today: "Nothing scheduled for today",
      sched_advanced: "Advanced view",
      sched_add_time: "Add time (optional)",
      sched_all_day: "All day",
      sched_time_not_set: "Time not set",
      web_progress: "Your website is {{pct}}% complete",
      web_save_draft: "Save draft",
      web_publish: "Publish",
      web_unpublish: "Unpublish",
      web_view_live: "View live website",
      web_copy_link: "Copy link",
      web_preview: "Preview",
      web_slug: "Website address",
      web_slug_ok: "Available",
      web_slug_taken: "Taken",
      web_sec_company: "Company",
      web_sec_about: "About",
      web_sec_services: "Services",
      web_sec_projects: "Projects",
      web_sec_reviews: "Reviews",
      web_sec_contact: "Contact",
      web_sec_design: "Design & Publish",
      web_share: "Share your website",
      web_share_text: "Text",
      web_share_disabled: "Publish your website before sharing",
      web_preview_draft: "Preview draft",
      web_check_name: "Company name",
      web_check_phone: "Phone",
      web_check_headline: "Headline",
      web_check_description: "Description",
      web_check_service_area: "Service area",
      web_check_about: "About text",
      web_check_services: "Services",
      web_check_portfolio: "Project photos",
      web_check_why: "Why choose you",
      web_check_reviews: "Reviews",
      web_write_for_me: "Write this for me",
      pub_call: "Call Now",
      pub_text: "Text Us",
      pub_estimate: "Request an Estimate",
      pub_view_work: "View Our Work",
      pub_sent: "Request sent! We'll be in touch soon.",
      pub_consent: "I agree to be contacted about my project.",
      pub_name: "Name",
      pub_phone: "Phone",
      pub_email: "Email",
      pub_address: "Project address",
      pub_work_type: "Type of work",
      pub_contact_pref: "Preferred contact",
      pub_description: "Tell us about your project",
      pub_photos: "Photos (optional)",
      pub_services: "Services",
      pub_work: "Our Work",
      pub_reviews: "Reviews",
      pub_why: "Why Choose Us",
      pub_about: "About Us",
      // Home
      home_hello: "Hi, {{name}}",
      home_today: "Today",
      home_stats_projects: "Active projects",
      home_stats_photos: "Photos captured",
      home_stats_logs: "Daily logs",
      home_recent_photos: "Recent photos",
      home_recent_logs: "Recent logs",
      home_upcoming: "Upcoming schedule",
      home_empty_cta: "Create your first project",
      // Projects
      project_name: "Project name",
      project_address: "Job address",
      project_homeowner_name: "Customer",
      project_homeowner_email: "Customer email",
      project_status: "Status",
      project_status_active: "Active",
      project_status_paused: "Paused",
      project_status_done: "Complete",
      project_empty_title: "No projects yet",
      project_empty_hint: "Every job starts with a project. Add the address, snap a cover photo, invite the homeowner.",
      // Photos
      photos_empty_title: "No photos yet",
      photos_add: "Add photos",
      cam_search: "Search projects",
      cam_new_project: "New project",
      cam_near: "Near you",
      photos_take_first: "Take first photo",
      uploading_progress: "Uploading {{done}} of {{total}}",
      offline_queued_count: "{{count}} photo(s) waiting for signal",
      photos_empty_hint: "Tap the orange button to add your first photo. It gets pinned to this project automatically.",
      ba_empty_title: "No before & after pairs yet",
      ba_empty_body: "Tag one photo as Before and another as After of the same spot — they pair up here automatically.",
      ba_empty_action: "Browse all photos",
      photo_note: "Note",
      photo_tag: "Tag",
      // Logs
      log_empty_title: "No daily logs yet",
      log_empty_hint: "Tap the mic and talk. We'll type it for you.",
      log_hold_to_talk: "Tap to speak",
      log_stop: "Stop",
      log_write_instead: "Type instead",
      log_speak: "Speak",
      log_type: "Type",
      log_weather: "Weather",
      // Schedule
      schedule_empty_title: "Nothing scheduled",
      schedule_empty_hint: "Add site visits, deliveries, and crew shifts.",
      schedule_add: "Add to schedule",
      // Crew
      crew_empty_title: "It's just you (for now)",
      crew_empty_hint: "Invite your foreman or crew. They see only their assigned projects.",
      // Portal
      portal_welcome: "Welcome, {{name}}",
      portal_project_of: "{{project}} by {{company}}",
      portal_progress: "Progress",
      portal_photo_timeline: "Photo timeline",
      portal_recent_logs: "Recent updates",
      portal_leave_comment: "Leave a message for the crew",
      portal_send: "Send message",
      portal_your_name: "Your name",
      // Weather (WMO codes)
      wx_0: "Clear", wx_1: "Mostly clear", wx_2: "Partly cloudy", wx_3: "Overcast",
      wx_45: "Fog", wx_48: "Icy fog", wx_51: "Light drizzle", wx_53: "Drizzle", wx_55: "Heavy drizzle",
      wx_61: "Light rain", wx_63: "Rain", wx_65: "Heavy rain", wx_66: "Freezing rain", wx_67: "Freezing rain",
      wx_71: "Light snow", wx_73: "Snow", wx_75: "Heavy snow", wx_77: "Snow grains",
      wx_80: "Light showers", wx_81: "Showers", wx_82: "Heavy showers",
      wx_85: "Snow showers", wx_86: "Snow showers", wx_95: "Thunderstorm", wx_96: "Storm + hail", wx_99: "Storm + hail",
      // Toasts / validation
      toast_saved: "Saved",
      toast_moved: "Moved",
      toast_copied: "Copied",
      toast_failed: "Something went wrong — try again",
      toast_upload_failed: "Upload failed",
      toast_mic_unavailable: "Microphone unavailable",
      toast_transcribe_failed: "Transcription failed — try typing instead",
      toast_log_saved: "Log saved",
      log_saving: "Saving…",
      log_save_failed: "Couldn't save. Your text is kept — try again.",
      task_empty_hint: "Use the field above to add your first task",
      task_due_label: "Due date (optional)",
      task_priority_label: "Task priority",
      toast_link_generated: "Link generated",
      toast_lead_added: "Lead added",
      toast_assign_saved: "Assignments saved",
      toast_msg_sent: "Message sent",
      toast_account_created: "Account created",
      toast_paired: "Paired",
      toast_nothing_sync: "Nothing to sync",
      toast_invite_created: "Invite created",
      toast_revoked: "Revoked",
      toast_project_created: "Project created",
      toast_published: "Published!",
      toast_unpublished: "Unpublished",
      toast_draft_saved: "Draft saved",
      toast_welcome_back: "Welcome back",
      home_new_lead_1: "New estimate request from your website",
      home_new_leads_n: "{{count}} new estimate requests from your website",
      // Customers + addresses (Parts 1-4)
      nav_customers: "Customers",
      cust_new: "New Customer",
      cust_edit: "Edit Customer",
      cust_search: "Search name, company, phone, email, address…",
      cust_select: "Select customer",
      cust_create_new: "Create New Customer",
      cust_add_typed: "+ Add “{{name}}” as a new customer",
      cust_no_results: "No customers found",
      cust_saved: "Customer saved",
      cust_individual: "Individual",
      cust_company: "Company",
      cust_name: "Customer name",
      cust_company_name: "Company name",
      cust_first_name: "First name",
      cust_last_name: "Last name",
      cust_display_name: "Display name",
      cust_phone2: "Secondary phone",
      cust_address: "Primary address",
      cust_site_addresses: "Job-site addresses",
      cust_add_address: "Add address",
      cust_notes: "Notes",
      cust_preferred: "Preferred contact",
      cust_lang: "Language",
      cust_projects: "Projects",
      cust_last_activity: "Last activity",
      cust_created: "Customer since",
      cust_empty_title: "No customers yet",
      cust_empty_hint: "Add your first customer — a homeowner, property manager, or business. Every project connects to a customer.",
      cust_no_matches: "No matches for \"{{q}}\"",
      cust_clear_search: "Clear search",
      nf_title: "Page not found",
      nf_hint: "This link doesn't match any page in the app.",
      nf_home: "Back to Home",
      cust_current_projects: "Current projects",
      cust_completed_projects: "Completed projects",
      cust_add_project: "Add Project",
      cust_required: "Pick a customer first",
      cust_use_this_address: "Use this address",
      cust_diff_address: "Use a different job-site address",
      cust_contact: "Contact",
      addr_search_ph: "Start typing the job address…",
      addr_use_my_location: "Use My Location",
      addr_loc_explain: "Your location is only used to find the job-site address. It is never stored or shared.",
      addr_continue: "Continue",
      addr_confirm_q: "Is this the correct project address?",
      addr_use_this: "Use This Address",
      addr_edit_address: "Edit Address",
      addr_move_pin_hint: "Drag the pin or tap the map to move it",
      addr_recenter: "Recenter",
      addr_open_map: "Open map",
      addr_close_map: "Close map",
      addr_manual_hint: "No matches — keep typing, or enter the address manually",
      err_loc_denied: "Location access is turned off. Search for an address or enable location access in your browser settings.",
      addr_finding: "Finding your location…",
      addr_adjust_pin: "Adjust Pin",
      addr_confirm: "Confirm",
      nav_group_business: "Business",
      photos_recent: "Recent Photos",
      photos_ba: "Before & After",
      photos_unassigned: "Unassigned",
      photos_archived: "Archived",
      discard_title: "Discard changes?",
      discard_keep: "Keep editing",
      discard_go: "Discard",
      draft_restore_q: "Restore your unsaved update from {{time}}?",
      draft_restore: "Restore",
      pd_spent: "Spent",
      pd_see_costs: "See costs",
      photo_date_unavailable: "Date unavailable",
      photo_issue: "Issue",
      photos_filter: "Filter",
      sel_assign: "Assign",
      sel_assign_title: "Assign to project",
      sel_tag: "Tag",
      sel_tag_title: "Tag selected photos",
      sel_tag_ph: "Tag",
      sel_share: "Share",
      sel_download: "Download",
      sel_delete: "Delete",
      sel_done: "Done",
      sel_share_mixed: "Share works when all selected photos are in one project",
      cam_saved: "{{count}} saved — keep shooting",
      cam_saved_to_one: "{{count}} photo saved to {{project}}",
      cam_saved_to_other: "{{count}} photos saved to {{project}}",
      cam_note: "Voice note",
      upload_retry: "Retry",
      photos_favorites: "Favorites",
      photos_map_view: "Map view",
      photos_grid_view: "Grid view",
      photos_timeline_view: "Timeline view",
      photos_ba_view: "Before & After",
      photos_projects_filter: "Projects",
      photos_tag_filter: "Tag",
      photos_all_tags: "All tags",
      photos_date_from: "From",
      photos_date_to: "To",
      photos_group_select: "Select this day",
      photos_sel_all_filtered: "Select all shown",
      photos_create_ba: "Create Before & After",
      photos_ba_created: "Before & After pair created",
      photos_ba_pick_two: "Select exactly 2 photos",
      np_more_options: "More Options",
      np_contract_value: "Contract value $", np_start_date: "Start date", np_end_date: "End date",
      np_assigned_crew: "Assigned Crew",
      np_recenter: "Recenter",
      np_satellite: "Satellite",
      np_map_std: "Map",
      np_adjust_pin: "Adjust Jobsite Pin",
      np_pin_done: "Done",
      pd_map_expand: "Expand Map",
      pd_map_adjust_hint: "Drag the pin to adjust the jobsite location",
      pd_map_save_pin: "Save Pin Location",
      pd_pin_saved: "Jobsite pin updated",
      photos_photographer: "Photographer",
      photos_date: "Date",
      photos_upload_btn: "Upload Photos",
      photos_no_gps: "No photos with GPS location in this view.",
      err_loc_unavailable: "Location unavailable — try again or type the address",
      err_addr_not_found: "Address not found — refine it or type it manually",
      gmap_manual_title: "Enter the address manually",
      gmap_f_street: "Street address",
      gmap_f_unit: "Unit / Suite (optional)",
      gmap_f_city: "City",
      gmap_f_state: "State",
      gmap_f_zip: "ZIP code",
      gmap_locate: "Locate on map",
      gmap_locating: "Locating…",
      gmap_locate_coarse: "Google found the area but not the exact address — drag the pin to the exact jobsite.",
      gmap_locate_fail: "Google couldn't confirm a map location for this address. You can still save it.",
      gmap_relocate_hint: "Address edited — tap “Locate on map” to refresh the pin.",
      gmap_unlocated_note: "Map location not confirmed",
      gmap_manual_lat: "Latitude (optional)",
      gmap_manual_lng: "Longitude (optional)",
      gmap_placeholder: "Start typing the job address…",
      gmap_no_results: "No addresses found",
      gmap_error_retry: "Address lookup failed — check your connection and retry",
      gmap_fallback_note: "Google Maps is unavailable here — you can still enter the address manually.",
      gmap_manual_toggle: "Can't find it? Enter manually",
      gmap_retry_google: "Try Google address search again",
      gmap_drag_hint: "Drag the pin to the exact building or jobsite",
      gmap_adjusted_title: "Adjusted location",
      gmap_adjusting: "Locating address…",
      gmap_loading: "Loading map…",
      gmap_load_failed: "The map could not load. Open this address in Google Maps or try again.",
      gmap_retry_map: "Retry Map",
      gmap_open_google: "Open in Google Maps",
      gmap_copy_address: "Copy Address",
      gmap_copied: "Address copied",
      gmap_try_search: "Try Address Search Again",
      gmap_continue_manual: "Continue with Manual Address",
      gmap_fail_reason: "Diagnostic code",
      np_name_hint: "Enter the job address to continue",
      np_use_my_location: "Use my location",
      home_copy_suffix: "copy",
      home_duplicate_last: "Duplicate last project",
      app_offline_banner: "You're offline — changes and photos will sync when you're back online",
      np_create_project: "Create Project",
      gmap_cant_place: "We couldn't place this address on the map. Check the address or continue without a confirmed map location.",
      gmap_try_again: "Try Again",
      gmap_edit_address: "Edit Address",
      gmap_create_unconfirmed: "Create Without Confirmed Map",
      gmap_use_adjusted: "Use adjusted address",
      gmap_keep_mailing: "Keep mailing address, use adjusted coordinates",
      gmap_no_addr_at_point: "No address found at this point — coordinates will be used",
      gmap_selected: "Selected address",
      gmap_change: "Change",
      gmap_powered: "Powered by Google",
      err_offline: "You're offline — enter the address manually",
      np_step_basics: "Project & Customer",
      np_step_location: "Location & Schedule",
      np_next: "Next",
      np_back: "Back",
      np_name_required: "Enter a project name",
    },
  },
  es: {
    translation: {
      brand: "BuildProject360",
      tagline: "Fotos, registros y toda la obra. Más simple. Más barato. Bilingüe.",
      nav_home: "Inicio",
      nav_projects: "Proyectos",
      nav_photos: "Fotos",
      nav_schedule: "Agenda",
      nav_crew: "Equipo",
      action_new_project: "Nuevo proyecto",
      action_add_photo: "Añadir foto",
      action_new_log: "Nuevo registro",
      action_share: "Compartir con el cliente",
      action_save: "Guardar",
      action_edit: "Editar",
      bg_title: "360 Assistant",
      bg_subtitle: "Tu asistente de proyectos con IA",
      bg_welcome: "Hola, {{name}}. Soy tu Asistente 360. Puedo responder preguntas, buscar información de proyectos, crear proyectos, armar horarios, preparar actualizaciones y ayudarte con las tareas diarias. Siempre revisarás los cambios antes de guardarlos. ¿En qué te ayudo?",
      bg_new_chat: "Nuevo chat",
      bg_no_history: "Sin chats anteriores",
      bg_empty: "Pregunta lo que sea sobre tus proyectos, agenda o la app. También puedo redactar actualizaciones para el cliente para que las revises.",
      bg_chip1: "Resume mis proyectos activos",
      bg_chip2: "Redacta una actualización para el cliente",
      bg_chip3: "¿Dónde encuentro las facturas?",
      bg_error: "360 Assistant no está disponible ahora. Inténtalo de nuevo.",
      bg_actions: "Borradores IA (revisa antes de guardar)",
      bg_pick_project: "Elige un proyecto…",
      bg_draft_morning_plan: "Plan de la mañana",
      bg_draft_evening_report: "Reporte de fin de día",
      bg_draft_customer_update: "Actualización para el cliente",
      bg_draft_badge: "Borrador",
      bg_draft_saved: "Guardado ✓",
      bg_confirm_save: "Confirmar y guardar",
      tc_offline_saved: "Guardado sin conexión — se sincronizará al volver",
      fin_labor_title: "Mano de obra vs Estimados",
      portal_ask_title: "Pregunta sobre tu proyecto",
      portal_ask_empty: "Pregunta lo que sea sobre este proyecto: avances, agenda, qué sigue.",
      portal_ask_placeholder: "Escribe tu pregunta…",
      bg_briefing_title: "Resumen de hoy",
      bg_briefing_none: "Sin trabajos programados hoy.",
      bg_briefing_reviews: "{{count}} tarjeta(s) por revisar",
      bgv_title: "Preguntar al Asistente",
      bgv_prompt: "¿Qué quieres que haga?",
      bgv_listening: "Escuchando… toca para detener",
      bgv_tap_to_speak: "Toca para hablar",
      bgv_transcript_ph: "Tu solicitud (edítala si hace falta)…",
      bgv_submit: "Enviar",
      bgv_try_again: "Intentar de nuevo",
      bgv_review_create_project: "Crear Proyecto Nuevo",
      bgv_review_create_customer: "Crear Cliente Nuevo",
      bgv_review_find_project: "Proyectos Encontrados",
      bgv_review_find_customer: "Clientes Encontrados",
      bgv_row_customer: "Cliente",
      bgv_row_new_customer: "Cliente nuevo",
      bgv_row_project: "Proyecto",
      bgv_row_project_type: "Tipo",
      bgv_row_address: "Dirección",
      bgv_row_start_date: "Fecha de inicio",
      bgv_row_notes: "Notas",
      bgv_row_customer_name: "Nombre del cliente",
      bgv_row_project_name: "Nombre del proyecto",
      bgv_choose_customer: "¿A qué cliente te refieres?",
      bgv_create_new_customer: "Crear cliente nuevo",
      bgv_confirm: "Confirmar",
      bgv_pending_approval: "Enviado para aprobación",
      bgv_review_delete_project: "Eliminar Proyecto",
      bgv_review_delete_customer: "Eliminar Cliente",
      bgv_review_delete_photos: "Eliminar Fotos",
      bgv_open_projects: "Abrir Proyectos",
      bgv_open_customers: "Abrir Clientes",
      bgv_open_photos: "Abrir Fotos",
      bgv_row_photo_date: "Fotos del",
      apr_title: "Aprobaciones Pendientes",
      apr_sub: "Solicitudes destructivas del asistente esperando decisión de un dueño/admin.",
      apr_approve: "Aprobar y Ejecutar",
      apr_reject: "Rechazar",
      apr_approved: "Aprobado y ejecutado",
      apr_rejected: "Solicitud rechazada",
      apr_requested_by: "Solicitado por",
      apr_already_decided: "Ya fue decidida por otro administrador",
      ref3_headline: "Refiere 3. El Tuyo Es Gratis.",
      ref3_desc: "Cada contratista que refieras y que siga siendo cliente de pago activo por más de 60 días te descuenta 1/3 de tu plan base: 1 referido = 1/3 de descuento, 2 = 2/3, 3 o más y tu plan base es gratis. Los asientos extra nunca se descuentan. Ellos reciben su primer mes de pago gratis.",
      ref3_of3: "{{n}} de 3 referidos activos",
      ref3_away: "Ahora tienes {{pct}}% de descuento en tu plan base — {{n}} referido(s) activo(s) más y BuildProject360 es gratis.",
      gantt_add_task: "Añadir tarea",
      gantt_timeline_empty: "Añade tareas a un trabajo para verlo en la línea de tiempo",
      catchup_title: "Ponerse al día",
      catchup_hint: "Esto vencía en días anteriores. Márcalo hecho o muévelo.",
      catchup_mark_all: "Marcar todo hecho",
      catchup_empty: "Al día — nada vencido.",
      catchup_done: "Hecho",
      catchup_today: "Mover a hoy",
      catchup_reschedule: "Reprogramar",
      catchup_home: "Ponerse al día — {{count}} elemento(s) de días pasados. ¿Se hicieron?",
      catchup_home_one: "Ponerse al día — 1 elemento de días pasados. ¿Se hizo?",
      catchup_home_other: "Ponerse al día — {{count}} elementos de días pasados. ¿Se hicieron?",
      sched_showing: "Mostrando",
      sched_overdue_chip: "Vencido {{n}}d",
      sched_mark_done: "Hecho",
      pd_coming_up: "Próximo",
      gantt_col_task: "Tarea",
      gantt_col_start: "Inicio",
      gantt_col_days: "Días",
      status_not_started: "Sin empezar",
      status_in_progress: "En curso",
      status_done: "Hecha",
      status_blocked: "Bloqueada",
      sheet_done: "Hecha",
      sheet_mark_not_done: "Deshacer",
      sheet_reschedule: "Reprogramar",
      sheet_resched_title: "Mover a otra fecha", sheet_move_later: "Mover también las fases siguientes",
      sheet_delay: "Retrasar",
      sheet_assign: "Asignar",
      sheet_photos: "Fotos",
      sheet_note: "Nota",
      sheet_open_job: "Abrir trabajo",
      sheet_done_marked: "Marcada como hecha",
      sheet_add_photos_q: "¿Añadir fotos?",
      sheet_take_photo: "Tomar foto",
      sheet_skip: "Omitir",
      sheet_reopened: "Marcada como no hecha",
      sheet_delay_by: "Retrasar (días)",
      sheet_delay_hint: "Mueve esta tarea y todas las siguientes.",
      sheet_owner_only: "Solo dueños/admin",
      assign_crew: "Equipo",
      assign_subs: "Subcontratistas",
      assign_none: "Ninguno aún",
      assign_add_sub: "Añadir subcontratista",
      sub_name: "Nombre",
      sub_trade: "Oficio",
      sub_phone: "Teléfono",
      sub_add_btn: "Añadir sub",
      sub_added: "Subcontratista añadido",
      myday_tasks_title: "Mis tareas de hoy",
      myday_navigate: "Navegar",
      gantt_new_task: "Nueva tarea",
      gantt_edit_task: "Editar tarea",
      gantt_task_name: "Nombre de la tarea",
      gantt_start_date: "Fecha de inicio",
      gantt_depends_on: "Depende de",
      gantt_no_dependency: "Ninguna (después de la anterior)",
      gantt_assignee_label: "Asignado a",
      gantt_locked_label: "Bloqueada — nunca se mueve en cascada",
      gantt_undo: "Deshacer",
      gantt_moved: "Movida — {{n}} tarea(s) dependiente(s) desplazada(s)",
      gantt_undone: "Cambio deshecho",
      gantt_delete_task: "Eliminar",
      gantt_delete_confirm: "Toca de nuevo para eliminar",
      gantt_empty: "Aún no hay tareas — añade una o aplica una plantilla.",
      tpl_deck: "Construcción de deck",
      tpl_d_1: "Demolición del deck anterior",
      tpl_d_2: "Zapatas y postes",
      tpl_d_3: "Estructura",
      tpl_d_4: "Tablas de la plataforma",
      tpl_d_5: "Barandillas y acabado",
      ref3_qualified: "¡Lo lograste! Tres contratistas se unieron con tu referido. Tu suscripción base de BuildProject360 ahora es gratis mientras las tres cuentas permanezcan activas.",
      ref3_share_msg: "He estado usando BuildProject360 para organizar fotos de proyectos, agendas, actualizaciones de trabajo, clientes y papeleo. Creo que también podría ayudar a tu empresa. Pruébalo aquí: {{link}}",
      ref3_facebook: "Facebook",
      ref3_grace: "Período de gracia activo: tu plan base gratis continúa hasta el {{date}}. Agrega un referido de reemplazo para mantenerlo gratis.",
      brand_logo_updated: "Logo actualizado — vistas previas actualizadas.",
      brand_logo_hint: "PNG, JPG, WebP, HEIC o SVG hasta 15 MB. PNG transparente compatible — tu proporción siempre se conserva.",
      brand_err_size: "Ese logo es demasiado grande (máx. 15 MB). Exporta una copia más pequeña.",
      brand_err_type: "Ese tipo de archivo no es compatible. Usa PNG, JPG, WebP, HEIC o SVG.",
      brand_err_decode: "No pudimos leer esa imagen. Intenta exportarla como PNG o JPG.",
      brand_err_storage: "La carga llegó pero el almacenamiento falló — tu logo actual no se tocó. Intenta de nuevo.",
      photo_err_too_large: "Esa foto es demasiado grande (máx. 25 MB). Prueba una copia más pequeña.",
      photo_err_type: "Ese tipo de archivo no es compatible. Usa JPG, PNG, HEIC o WebP.",
      photo_err_decode: "No pudimos leer esa imagen. Intenta exportarla como JPG o PNG.",
      photo_err_network: "Conexión interrumpida — no se guardó nada y tu recorte sigue aquí. Toca Reintentar.",
      billing_promo_discount: "Descuento promocional",
      billing_discount_expires: "El descuento termina",
      billing_comp_seats: "Asientos gratuitos",
      billing_referral_card_title: "3 & Gratis",
      billing_referral_card_body: "Refiere a tres contratistas. Cuando los tres sean clientes de pago, tu plan base es gratis.",
      billing_referral_card_cta: "Ver referidos",
      perms_title: "Permisos del Equipo",
      perms_sub: "Modifica los valores por defecto del rol por persona. Permitir otorga; Denegar bloquea.",
      perm_default: "Por defecto",
      perm_allow: "Permitir",
      perm_deny: "Denegar",
      perm_bg_use: "Usar Asistente",
      perm_customer_create: "Crear clientes",
      perm_project_create: "Crear proyectos",
      perm_project_update: "Editar proyectos",
      perm_schedule_view: "Ver agenda",
      perm_schedule_create: "Crear agenda",
      perm_crew_assign: "Asignar equipo",
      perm_project_update_create: "Publicar actualizaciones",
      perm_time_self: "Registrar entrada/salida",
      perm_correction_create: "Correcciones de tiempo",
      perm_message_draft: "Redactar mensajes",
      perm_message_send: "Enviar mensajes",
      perm_estimate_draft: "Redactar estimados",
      perm_co_draft: "Redactar órdenes de cambio",
      perm_fin_view: "Ver finanzas",
      perm_delete_records: "Eliminar registros (aprobación)",
      prof_theme_dark: "Oscuro",
      bgv_voice_confirm: "Di “Confirmar”",
      bgv_unclear: "No escuché bien la confirmación. Toca Confirmar o di Confirmar otra vez.",
      bgv_tap_required: "Esta acción requiere tocar Confirmar.",
      bgv_edit_hint: "Para cambiar algo, cancela y edita tu solicitud.",
      bgv_similar: "Es posible que ya exista un proyecto similar.",
      bgv_open_existing: "Abrir existente",
      bgv_warn_address: "No se pudo verificar la dirección — revísala.",
      bgv_warn_newcust: "Se creará un registro de cliente nuevo.",
      bgv_missing: "Aún falta",
      bgv_success: "Listo",
      bgv_failed: "La acción falló — no se guardó nada.",
      bgv_perm_denied: "No tienes permiso para esa acción.",
      bgv_done: "Listo",
      bgv_no_results: "Sin resultados.",
      bgv_open_project: "Abrir Proyecto",
      bgv_open_customer: "Abrir Cliente",
      bgv_open_shares: "Gestionar Enlaces",
      bgv_review_find_photos: "Buscar Fotos",
      bgv_review_share_photos: "Compartir Fotos",
      bgv_review_navigate: "Navegar",
      bgv_review_install_app: "Instalar App",
      bgv_row_photos: "Fotos",
      ap_title: "Asistente 360",
      ap_launcher: "Asistente 360",
      sched_prev_period: "Anterior",
      sched_next_period: "Siguiente",
      sched_saved_on: "Guardado para el {{date}}",
      np_name_optional_hint: "opcional — usa la calle por defecto",
      ap_welcome: "¡Hola! Puedo programar trabajo, buscar fotos, redactar estimados y más — desde esta página. ¿Qué necesitas?",
      ap_start_360: "Asistente 360",
      ap_back_chat: "Volver al chat",
      ap_helping: "Ayudando con: {{name}}",
      ap_general: "Asistencia general",
      ap_clear_context: "Quitar contexto",
      ap_placeholder: "Pregunta o dime qué hacer…",
      ap_send: "Enviar",
      ap_clear: "Limpiar conversación",
      ap_expand: "Abrir página completa del asistente",
      ap_close: "Cerrar asistente",
      action_done: "Listo",
      ap_stop: "Detener grabación",
      ap_tap_mic: "Hablar",
      ap_total: "{{count}} en total — abre la página para ver todas",
      ap_qa_create_project: "Crear Proyecto",
      ap_qa_create_project_sample: "Crea un proyecto para ",
      ap_qa_build_schedule: "Armar Horario",
      ap_qa_build_schedule_sample: "Arma un horario de solo días hábiles para este proyecto",
      ap_qa_add_update: "Agregar Actualización",
      ap_qa_add_update_sample: "Agrega una actualización: ",
      ap_qa_find_photos: "Buscar Fotos",
      ap_qa_find_photos_sample: "Busca fotos tomadas ayer",
      ap_qa_schedule_work: "Programar Trabajo",
      ap_qa_schedule_work_sample: "Programa trabajo para este proyecto el ",
      ap_qa_money_collected: "Cobrado este mes",
      ap_qa_money_collected_sample: "¿Cuánto cobré este mes?",
      ap_qa_money_who_owes: "Quién me debe",
      ap_qa_money_who_owes_sample: "¿Quién me debe dinero ahora y cuánto?",
      ap_qa_money_losing: "Trabajos perdiendo dinero",
      ap_qa_money_losing_sample: "¿Qué trabajos están perdiendo dinero y cuánto?",
      ap_qa_share_photos: "Compartir Fotos",
      ap_qa_share_photos_sample: "Comparte todas las fotos de este proyecto",
      ap_qa_create_task: "Crear Tarea",
      ap_qa_create_task_sample: "Agrega una tarea para ",
      ap_qa_assign_photos: "Asignar Fotos",
      ap_qa_assign_photos_sample: "Asigna las fotos seleccionadas a ",
      ap_qa_share_selected: "Compartir Selección",
      ap_qa_share_selected_sample: "Comparte las fotos seleccionadas",
      ap_qa_create_report: "Crear Reporte",
      ap_qa_create_report_sample: "Crea un reporte fotográfico para ",
      ap_qa_view_projects: "Ver Proyectos",
      ap_qa_view_projects_sample: "Muestra los proyectos activos de este cliente",
      ap_qa_draft_message: "Redactar Mensaje",
      ap_qa_draft_message_sample: "Redacta un mensaje al cliente: ",
      ap_qa_reschedule: "Reprogramar",
      ap_qa_reschedule_sample: "Mueve el trabajo programado a ",
      ap_qa_available_days: "Días Disponibles",
      ap_qa_available_days_sample: "Muestra los días disponibles esta semana",
      ap_qa_draft_estimate: "Redactar Estimado",
      ap_qa_draft_estimate_sample: "Redacta un estimado para ",
      ap_qa_find_invoice: "Buscar Factura",
      ap_qa_find_invoice_sample: "Busca la factura ",
      ap_qa_payment_reminder: "Recordatorio de Pago",
      ap_qa_payment_reminder_sample: "Redacta un recordatorio de pago para ",
      ap_qa_create_project_customer: "Crear Proyecto",
      ap_qa_create_project_customer_sample: "Crea un proyecto para este cliente",
      bgv_audit: "Historial de acciones",
      bgv_none: "Aún no hay acciones",
      bgv_chip_create_customer: "Crear Cliente",
      bgv_chip_create_project: "Crear Proyecto",
      bgv_chip_schedule: "Programar Trabajo",
      bgv_chip_job_update: "Agregar Actualización",
      bgv_chip_task: "Agregar Tarea",
      bgv_chip_find_project: "Buscar Proyecto",
      bgv_chip_start_day: "Iniciar Mi Día",
      bgv_chip_finish_day: "Terminar Mi Día",
      bgv_chip_estimate: "Redactar Estimado",
      bgv_chip_change_order: "Redactar Orden de Cambio",
      bgv_chip_customer_message: "Redactar Mensaje al Cliente",
      bgv_chip_create_customer_sample: "Crea un cliente llamado ",
      bgv_chip_create_project_sample: "Crea un proyecto nuevo para ",
      bgv_chip_schedule_sample: "Programa trabajo en ",
      bgv_chip_job_update_sample: "Agrega una actualización: ",
      bgv_chip_task_sample: "Agrega una tarea a ",
      bgv_chip_find_project_sample: "Busca el proyecto ",
      bgv_chip_start_day_sample: "Inicia mi día",
      bgv_chip_finish_day_sample: "Termina mi día",
      bgv_chip_estimate_sample: "Redacta un estimado para ",
      bgv_chip_change_order_sample: "Redacta una orden de cambio para ",
      bgv_chip_customer_message_sample: "Dile al cliente ",
      bgv_driving: "Modo Conducir",
      bgv_driving_note: "Modo Conducir: solo búsquedas y borradores. Las solicitudes se guardan como borradores — revísalas cuando te detengas de forma segura. Nunca uses el teléfono manejando.",
      bgv_draft_saved_msg: "Preparé esta solicitud como borrador. Revísala cuando te detengas de forma segura.",
      bgv_pending_drafts: "Borradores por revisar",
      bgv_choose: "¿A cuál te refieres?",
      bgv_need_ack: "Hay un conflicto de horario. Confirma de nuevo para duplicar la asignación.",
      bgv_ack_conflicts: "Mantener de todos modos",
      bgv_outside_geofence: "Pareces estar fuera del área del proyecto — usa la pantalla de Tarjeta de Tiempo con un motivo.",
      bgv_review_view_schedule: "Agenda",
      bgv_review_check_availability: "Disponibilidad",
      bgv_review_create_schedule: "Programar Trabajo",
      bgv_review_reschedule: "Reprogramar Trabajo",
      bgv_review_add_update: "Agregar Actualización",
      bgv_review_start_day: "Iniciar Mi Día",
      bgv_review_finish_day: "Terminar Mi Día",
      bgv_review_break_start: "Iniciar Descanso",
      bgv_review_break_end: "Terminar Descanso",
      bgv_review_switch_project: "Cambiar de Proyecto",
      bgv_review_correction_request: "Solicitud de Corrección",
      bgv_review_draft_message: "Enviar Mensaje al Cliente",
      bgv_review_draft_estimate: "Redactar Estimado",
      bgv_review_draft_change_order: "Redactar Orden de Cambio",
      bgv_row_date: "Fecha",
      bgv_row_end_date: "Fecha fin",
      bgv_row_time: "Hora",
      bgv_row_employees: "Equipo",
      bgv_row_update: "Actualización",
      bgv_row_message: "Mensaje",
      bgv_row_items: "Partidas",
      bgv_row_phases: "Fases",
      bgv_row_finish_date: "Fecha de término",
      bgv_review_help: "Guía",
      bgv_row_activity: "Actividad",
      bgv_row_project_name: "Nombre del proyecto",
      bgv_row_local_time: "Hora local",
      bgv_row_customer_name: "Nombre del cliente",
      bgv_open_schedule: "Abrir Agenda",
      bgv_open_timecard: "Abrir Tarjeta",
      bgv_open_financials: "Abrir estimados y facturas",
      nav_plan_billing: "Plan y Facturación",
      nav_my_day: "Mi Día",
      nav_help: "Ayuda",
      photos_filter_open: "Filtrar",
      photos_clear_filters: "Limpiar todo",
      action_done: "Listo",
      nav_group_work: "Trabajo",
      nav_group_team: "Equipo",
      nav_group_sales: "Ventas",
      nav_group_company: "Empresa",
      nav_group_account: "Cuenta",
      nav_assistant_activity: "Actividad del Asistente",
      nav_language: "Idioma",
      profile_menu: "Menú de cuenta",
      home_today_title: "Trabajos de hoy",
      home_coming_up: "Próximamente",
      home_start_day: "Iniciar Mi Día",
      home_finish_day: "Terminar Mi Día",
      home_clocked_in_at: "Trabajando en {{project}}",
      home_not_clocked: "Sin iniciar jornada",
      home_est_awaiting: "Estimados por aprobar",
      home_inv_overdue: "Facturas vencidas",
      home_missing_evening: "Faltan reportes de fin de día",
      home_all_clear: "Nada pendiente — buen trabajo.",
      home_ask_bg: "Preguntar al Asistente",
      home_add_update: "Agregar Actualización",
      home_next_up: "Lo siguiente",
      home_stats_title: "Resumen del negocio",
      proj_search_ph: "Buscar proyectos…",
      proj_filter_active: "Activos",
      proj_filter_completed: "Completados",
      proj_filter_archived: "Archivados",
      proj_sort_recent: "Recientes",
      proj_sort_name: "Nombre",
      proj_sort_customer: "Cliente",
      proj_sort_next: "Próxima fecha",
      proj_sort_label: "Ordenar",
      proj_filter_status: "Estado",
      proj_filter_my: "Mis proyectos",
      proj_filter_attention: "Atención",
      proj_badge_overdue: "Atrasado",
      proj_updated: "Actualizado",
      proj_more_filters: "Filtro",
      home_recent_progress: "Progreso reciente",
      home_needs_attention: "Necesita atención",
      home_add_schedule: "Añadir al horario",
      home_nothing_today: "Nada programado hoy",
      proj_view_list: "Vista de lista",
      proj_view_cards: "Vista de tarjetas",
      proj_view_detailed: "Lista detallada",
      proj_view_map: "Vista de mapa",
      proj_menu_open: "Abrir proyecto",
      proj_menu_photo: "Tomar foto",
      proj_menu_schedule: "Añadir a la agenda",
      proj_menu_task: "Añadir tarea",
      proj_menu_share: "Compartir con el cliente",
      proj_status_confirm_title: "Actualizar estado del proyecto",
      proj_status_confirm_ok: "Sí, continuar",
      proj_last_activity: "Última actividad",
      proj_open_tasks: "{{count}} tareas abiertas",
      proj_docs_count: "{{count}} archivos",
      proj_map_no_loc: "{{count}} proyectos aún no tienen ubicación en el mapa",
      proj_map_empty: "Aún no hay ubicaciones de proyectos para mostrar",
      proj_next_none: "Sin trabajo próximo",
      proj_next_prefix: "Próximo",
      proj_menu_duplicate: "Duplicar proyecto",
      nav_time_crew: "Horas y cuadrilla",
      notif_eod_uses_cal: "El recordatorio de fin de día usa la hora de salida de Horario laboral (Ajustes › Calendario laboral).",
      photos_loading_more: "Cargando más fotos…",
      brand_legal_name: "Nombre legal (se muestra en estimados y facturas)",
      proj_photos_count: "{{count}} Fotos",
      proj_logs_count: "{{count}} Registros",
      proj_menu_edit: "Editar",
      proj_menu_complete: "Completar",
      proj_menu_archive: "Archivar",
      proj_menu_restore: "Restaurar proyecto",
      proj_status_lead: "Prospecto",
      proj_status_scheduled: "Programado",
      proj_status_in_progress: "En curso",
      proj_status_on_hold: "En pausa",
      proj_status_done: "Completado",
      pd_complete_title: "Proyecto completado",
      pd_complete_body: "Buen trabajo. ¿Envías las fotos finales o creas el paquete de cierre?",
      pd_complete_photos: "Enviar fotos finales al cliente",
      pd_complete_closeout: "Crear paquete de cierre",
      viewer_report: "Reportar un error",
      viewer_reported: "Avisado al dueño",
      photos_del_body_one: "¿Eliminar 1 foto? Estará en la papelera 30 días.",
      photos_del_body_other: "¿Eliminar {{count}} fotos? Estarán en la papelera 30 días.",
      pd_act_photos_deleted_one: "1 foto eliminada",
      pd_act_photos_deleted_other: "{{count}} fotos eliminadas",
      pd_act_wt_deleted: "Recorrido eliminado",
      pd_act_photo_restored: "Foto restaurada",
      pd_ev_photo_restore: "restaurada",
      trash_media_title: "Fotos y recorridos",
      wt_del_menu: "Eliminar recorrido",
      wt_del_title: "¿Eliminar este recorrido?",
      wt_del_photos: "También eliminar sus {{count}} fotos",
      wt_del_tasks: "También eliminar {{count}} tarea(s) que creó",
      wt_deleted: "Recorrido eliminado",
      wt_show_open_items: "Mostrar pendientes al cliente",
      pd_complete_review: "Pedir una reseña de Google",
      proj_gone_title: "Este proyecto fue eliminado o archivado",
      proj_gone_body: "El enlace que abriste ya no está disponible.",
      proj_gone_back: "Volver a Proyectos",
      rev_title: "Pedir una reseña de Google",
      rev_subtitle: "Los clientes felices hacen crecer tu negocio. Envía una solicitud rápida.",
      rev_tab_text: "Texto",
      rev_tab_email: "Correo",
      rev_name_ph: "Nombre del cliente",
      rev_phone_ph: "Teléfono del cliente",
      rev_email_ph: "Correo del cliente",
      rev_link_label: "Tu enlace de reseñas de Google",
      rev_link_help: "Perfil de Negocio de Google › Pedir reseñas. Pega el enlace aquí — lo guardamos.",
      rev_msg_label: "Mensaje",
      rev_msg_default: "Hola {{name}}, ¡gracias por elegir a {{company}}! ¿Nos dejas una reseña rápida en Google? Toma un minuto y ayuda mucho a nuestro pequeño negocio. {{link}}",
      rev_send_text: "Abrir Mensajes para enviar",
      rev_send_email: "Enviar correo",
      rev_sent_email: "Solicitud de reseña enviada por correo",
      rev_no_link: "Agrega primero tu enlace de reseñas de Google",
      rev_no_phone: "Agrega primero el teléfono del cliente",
      rev_no_email: "Agrega primero el correo del cliente",
      cl_title: "Listas de verificación",
      cl_subtitle: "Agrega una lista probada a este proyecto. Marca los puntos aquí mismo en la página del trabajo.",
      cl_apply: "Agregar",
      cl_added_short: "Lista",
      cl_added: "Lista agregada — {{count}} tareas creadas",
      cl_already: "Esa lista ya está en este proyecto",
      cl_items: "{{count}} puntos",
      cl_photo_req: "Foto",
      cl_open: "Listas",
      cl_progress: "{{done}} de {{total}} listos",
      pd_act_checklist: "Lista iniciada: {{name}}",
      cl_photo_add: "Agregar foto",
      u360_expl_checklist: "Agrega la lista de verificación a este trabajo.",
      task_photo_chip: "Foto requerida",
      task_photo_required: "Adjunta una foto antes de marcarla como lista",
      ep_type: "Tipo de proyecto",
      ep_crew: "Cuadrilla asignada",
      ep_start: "Fecha de inicio",
      ep_end: "Fecha de fin",
      ep_status: "Estado",
      ep_notes: "Notas",
      ap_working: "Trabajando…",
      ap_opened_review: "Abrí la revisión 360 — aprueba para guardar.",
      u360_mic_blocked_type: "Micrófono bloqueado — escribe en su lugar",
      proj_restored_toast: "Proyecto restaurado",
      proj_archive_future: "Este trabajo tiene {{count}} elemento(s) próximo(s). ¿Eliminarlos?",
      proj_archive_future_one: "Este trabajo tiene {{count}} elemento próximo. ¿Eliminarlo?",
      proj_archive_remove: "Eliminar",
      proj_archive_keep: "Conservar",
      err_project_archived: "Este proyecto está archivado — restaúralo antes de programar trabajo nuevo.",
      proj_menu_delete: "Eliminar",
      proj_delete_title: "¿Eliminar proyecto?",
      proj_delete_body: "Esto elimina el proyecto permanentemente y no se puede deshacer.",
      proj_delete_confirm: "Sí, eliminar",
      dz_title: "Zona de peligro",
      dz_explain: "Eliminar un proyecto lo quita de tu espacio de trabajo activo. El proyecto se puede restaurar desde la Papelera durante 30 días antes de la eliminación permanente.",
      dz_move: "Mover proyecto a la Papelera",
      dz_confirm_title: "¿Mover el proyecto a la Papelera?",
      dz_type_hint: "Escribe el nombre exacto del proyecto para confirmar:",
      dz_share_warn: "Los enlaces para clientes se desactivarán.",
      dz_stats: "Fotos: {{photos}} · Documentos: {{docs}} · Estimados: {{est}} · Facturas: {{inv}}",
      dz_moved: "Proyecto movido a la Papelera",
      trash_title: "Papelera",
      trash_hint: "Los proyectos en la Papelera se pueden restaurar dentro de 30 días. La eliminación permanente solo es posible aquí y nunca elimina los registros financieros obligatorios.",
      trash_empty: "La papelera está vacía.",
      trash_deleted_on: "Eliminado",
      trash_days_left_one: "{{count}} día restante",
      trash_days_left_other: "{{count}} días restantes",
      trash_restore: "Restaurar",
      trash_restored: "Proyecto restaurado",
      trash_restore_note: "Los enlaces compartidos siguen desactivados — crea un enlace nuevo si lo necesitas.",
      trash_perm: "Eliminar permanentemente",
      trash_perm_title: "¿Eliminar el proyecto permanentemente?",
      trash_perm_body: "Esto no se puede deshacer. Las fotos, los documentos y los datos no financieros se eliminarán. Escribe DELETE para confirmar.",
      trash_perm_done: "Proyecto eliminado permanentemente",
      trash_retained_title: "Los registros financieros deben conservarse",
      trash_retained_body: "Este proyecto tiene facturas o pagos. Los registros financieros deben conservarse según los Términos y las normas de contabilidad, por lo que el proyecto no se puede eliminar permanentemente. Puede permanecer en la Papelera (oculto) o ser restaurado.",
      settings_tools: "Configuración y herramientas",
      settings_trash: "Papelera",
      settings_trash_hint: "Restaura o elimina permanentemente los proyectos en la Papelera.",
      photos_create_project: "Crear proyecto nuevo",
      photos_search_projects: "Buscar proyectos…",
      photos_no_matches: "Sin proyectos coincidentes",
      photos_select_to_add: "Selecciona un proyecto para agregar fotos.",
      share_link_ready: "Enlace creado",
      land_gps_hero_benefit: "Captura pruebas fotográficas con fecha, hora y ubicación GPS automáticas.",
      land_gps_hero_sub: "Cada foto del sitio de trabajo puede crear un registro confiable de cuándo y dónde se hizo el trabajo—ayudando a documentar el progreso, verificar la actividad en campo, apoyar reclamos de seguro y reducir disputas.",
      land_gps_title: "Prueba Fotográfica Confiable",
      land_gps_body: "Convierte cada foto del sitio de trabajo en documentación confiable del proyecto. BuildProject360 registra automáticamente la fecha, la hora y la ubicación GPS al capturar una foto, dando a los contratistas un registro claro del trabajo realizado en campo.",
      land_gps_b1_t: "Sello automático de fecha y hora",
      land_gps_b2_t: "Registro automático de ubicación GPS",
      land_gps_b3_t: "Organizado por cliente y proyecto",
      land_gps_b4_t: "Documentación confiable para progreso, seguros y disputas",
      land_gps_permission_note: "El registro de ubicación requiere que el usuario conceda permiso de ubicación en su dispositivo. Tú controlas si la ubicación registrada aparece en las galerías para clientes o enlaces compartidos — nunca se muestra públicamente por defecto.",
      feat_gps_photos: "Fotos con Fecha, Hora y Ubicación",
      feat_gps_photos_d: "Captura fotos organizadas del sitio de trabajo con registros automáticos de fecha, hora local y ubicación GPS.",
      land_gps_cta_callout: "Sabe qué pasó, cuándo pasó y dónde pasó.",
      land_gps_cta_sub: "Construye un registro visual confiable de cada proyecto de principio a fin.",
      land_gps_mock_badge: "Captura verificada",
      land_gps_mock_alt: "Foto de construcción dentro de la app BuildProject360 con su panel de detalles de captura",
      land_gps_mock_ontag: "Foto en sitio",
      land_gps_mock_project_lbl: "Proyecto",
      land_gps_mock_project_val: "Residencia Smith — Reemplazo de techo",
      land_gps_mock_captured_lbl: "Capturada",
      land_gps_mock_captured_val: "12 mar 2026 · 2:41 PM",
      land_gps_mock_location_lbl: "Ubicación",
      land_gps_mock_location_val: "Columbus, OH — ubicación registrada",
      land_gps_mock_by_lbl: "Tomada por",
      land_gps_mock_by_val: "Mike R. — Jefe de cuadrilla",
      land_gps_mock_note_lbl: "Nota",
      land_gps_mock_note: "Día 3 — plataforma del techo completa.",
      nav_questions: "Preguntas",
      hero2_h1: "Toma la foto. Mantén el trabajo en marcha.",
      hero2_sub: "Fotos de obra con datos de captura registrados, un horario de cuadrilla claro y actualizaciones que puedes revisar en un solo lugar.",
      cta_start_free: "Empieza gratis — 14 días",
      hero2_trust: "Sin tarjeta de crédito · 3 usuarios incluidos",
      hero2_shot_alt: "Pantalla de revisión del Asistente 360 con borradores de registro diario, tarea, horario y orden de cambio listos para aprobar",
      a360_eyebrow: "Asistente 360",
      a360_title: "Di el avance. Revisa los próximos pasos.",
      a360_shot_cap: "La pantalla de revisión real — con un proyecto de demostración.",
      a360_example: "Terminamos el desarmado del techo de Smith. Tres personas, ocho horas. Encontramos seis paneles dañados — prepara una orden de cambio y agenda la instalación para mañana.",
      a360_out_daily_log: "Registro diario",
      a360_out_crew_time: "Horas del equipo",
      a360_out_schedule: "Horario",
      a360_out_task: "Tarea",
      a360_out_customer: "Mensaje al cliente (borrador)",
      a360_out_co: "Orden de cambio (borrador)",
      a360_approval: "Revisa y edita cada borrador. Nada se guarda ni se envía sin tu aprobación.",
      photos3_title: "Un registro fotográfico claro para cada trabajo.",
      photos3_body: "Mantén las fotos organizadas por proyecto, con fecha y hora de captura y ubicación registrada cuando el usuario da permiso. Revisa los detalles antes de compartir el avance con un cliente.",
      photos3_gallery_cap: "Comparte una galería limpia con tu marca que tu cliente puede abrir sin cuenta.",
      photos3_privacy_note: "La ubicación se registra solo con el permiso del dispositivo y no se muestra públicamente por defecto.",
      sched3_title: "Un horario que el equipo puede encontrar y seguir.",
      sched3_body: "Ve el trabajo de hoy, planifica con anticipación y mantén los trabajos conectados al proyecto y al equipo correctos.",
      sched3_shot_alt: "Vista de día del horario de BuildProject360 con trabajos, horas, proyectos y equipo legibles",
      price3_title: "Un plan, precio claro.",
      price3_save: "Ahorra $98 al año",
      price3_seats: "3 usuarios incluidos · Usuarios extra $5/mes cada uno",
      price3_g1: "Proyectos, clientes y prospectos",
      price3_g2: "Fotos de obra y galerías para el cliente",
      price3_g3: "Horarios del equipo, registros diarios y tarjetas de tiempo",
      price3_g4: "Asistente 360, tareas y órdenes de cambio",
      price3_g5: "Presupuestos, facturas y registro de pagos",
      price3_g6: "Sitio web del contratista y soporte en inglés/español",
      price3_payments_cs: "Pagos en línea de clientes",
      price3_no_card: "Sin tarjeta de crédito · Cancela cuando quieras",
      faq3_title: "Preguntas",
      faq3_q1: "¿Cómo funciona la prueba de 14 días?",
      faq3_a1: "Tienes acceso completo por 14 días, sin tarjeta. Al terminar, elige un plan para seguir trabajando; tus fotos y registros se conservan.",
      faq3_q2: "¿Cuánto cuesta después?",
      faq3_a2: "Essentials: $59/mes o $49/mes facturado anual ($588), 3 usuarios incluidos. Pro: $129/mes o $109/mes facturado anual ($1,308), 5 usuarios incluidos. Usuarios extra $10/mes cada uno.",
      faq3_q3: "¿Cuántos usuarios incluye?",
      faq3_a3: "Tres — por ejemplo tú, alguien de oficina y un líder de cuadrilla. Agrega más por $5 al mes cada uno.",
      faq3_q4: "¿El almacenamiento de fotos tiene límite?",
      faq3_a4: "Tu plan no pone límite de fotos y los originales se conservan.",
      faq3_q5: "¿Mis datos son privados?",
      faq3_a5: "Sí. Solo tu empresa ve tus proyectos. Los clientes ven solo lo que compartes con un enlace de galería, y las ubicaciones registradas de las fotos permanecen dentro de tu cuenta.",
      faq3_q6: "¿Puedo cancelar cuando quiera?",
      faq3_a6: "Sí — cancela desde la página de Facturación en la app. Mantienes el acceso hasta el final del período pagado.",
      faq3_q7: "¿Cómo la instalo en mi teléfono?",
      faq3_a7: "Abre buildproject360.com en el navegador de tu teléfono y elige 'Añadir a pantalla de inicio' — funciona como una app, sin tienda de aplicaciones.",
      cta3_title: "¿Listo para documentar tu próximo trabajo?",
      cta3_body: "Empieza con un proyecto, una foto y un plan claro para tu equipo.",
      hero2_bg_alt_a: "Contratista en una obra de entramado de madera, casas en construcción detrás",
      hero2_bg_alt_b: "Casa nueva casi terminada con escalera y materiales aún en obra",
      hero2_card_loc_lbl: "Ubicación registrada",
      hero2_card_loc_val: "Columbus, OH",
      hero2_card360_ready: "Borradores listos para revisar",
      hero2_card360_note: "Nada se guarda sin tu aprobación",
      hero2_card360_example: "Ejemplo",
      hero2_card_photo_badge: "Foto con ubicación registrada",
      hero2_tag_time: "7:42 AM",
      hero2_tag_title: "Ejemplo de los datos que se registran con cada foto",
      pd_tab_overview: "Resumen",
      pd_tab_activity: "Actividad",
      pd_tab_schedule: "Agenda",
      pd_tab_financials: "Estimados y facturas",
      pd_tab_more: "Más",
      pd_tab_costs: "Costos",
      jc_total_label: "Costos reales hasta ahora",
      jc_summary_hint: "Toca un total o categoría para ver los recibos.",
      jc_overlap_badge: "¿Traslape?",
      jc_overlap_save: "Ojo: la tarifa de este activo ya incluye {{include}} — posible cargo doble.",
      jc_overlap_banner: "{{count}} recibo(s) podrían duplicarse — ya cubiertos por la tarifa de un activo.",
      jc_overlap_detail: "Esta categoría ya está incluida en la tarifa del activo vinculado. Contar ambos duplicaría este costo.",
      jc_alloc_enable: "Asignar gastos generales a proyectos",
      jc_alloc_hint: "Los gastos de empresa se reparten entre proyectos activos y se muestran aparte — nunca se mezclan con los costos directos.",
      jc_alloc_equal: "Repartir en partes iguales entre proyectos activos",
      jc_alloc_prorata: "Prorrateo según los gastos directos de cada proyecto",
      jc_alloc_chip: "Gastos generales asignados",
      jc_total_with_overhead: "Total con gastos generales asignados",
      jc_billable_row: "Valor facturable (mano de obra + equipo)",
      jc_pending_banner: "{{count}} recibo(s) esperando tu aprobación.",
      jc_add_receipt: "Agregar recibo",
      jc_empty: "Aún no hay recibos",
      jc_empty_hint: "Fotografía un recibo y el Asistente 360 lo leerá por ti.",
      jc_no_vendor: "Sin proveedor",
      jc_refund: "Reembolso",
      jc_dup: "Posible duplicado",
      jc_dup_detail: "Ya existe un recibo similar (mismo proveedor, fecha y total, o la misma imagen). Revísalo antes de guardar.",
      jc_status_pending: "Pendiente",
      jc_status_approved: "Aprobado",
      jc_status_rejected: "Rechazado",
      jc_cat_materials: "Materiales",
      jc_cat_equipment: "Equipo",
      jc_cat_rental: "Renta",
      jc_cat_subcontractor: "Subcontratista",
      jc_cat_fuel: "Combustible",
      jc_cat_other: "Otro",
      jc_cat_repairs: "Reparaciones",
      jc_cat_maintenance: "Mantenimiento",
      jc_cat_tools: "Herramientas",
      jc_cat_insurance: "Seguro",
      jc_cat_registration: "Registro",
      jc_cat_disposal: "Disposición",
      jc_cat_delivery: "Entrega",
      jc_cat_office: "Oficina",
      jc_scope: "¿A dónde pertenece este gasto?",
      jc_scope_project: "Gasto de proyecto",
      jc_scope_company: "Gasto de empresa",
      jc_asset_optional: "Camión / herramienta / máquina (opcional)",
      jc_asset_none: "Sin activo",
      jc_cat_search_ph: "Buscar o crear categoría…",
      jc_cat_create: "Crear categoría",
      jc_cat_exists: "Esa categoría ya existe.",
      jc_cat_archived_note: "Archivada — se conserva el historial",
      jc_cats_title: "Categorías personalizadas",
      jc_cats_hint: "Reutilizables en todos tus proyectos. Renombra o archiva cuando quieras — el historial se conserva.",
      jc_cat_name_ph: "Nombre de categoría",
      jc_cat_add: "Agregar categoría",
      jc_cat_rename: "Renombrar",
      jc_cat_archive: "Archivar",
      jc_cat_unarchive: "Restaurar",
      jc_cat_empty: "Aún no hay categorías personalizadas.",
      jc_expenses: "Gastos",
      fin_expenses: "Gastos",
      jc_filter_vendor: "Proveedor",
      jc_filter_from: "Desde",
      jc_filter_to: "Hasta",
      jc_filter_all_projects: "Todos los proyectos",
      jc_filter_all_cats: "Todas las categorías",
      jc_filter_all_status: "Todos los estados",
      jc_filter_all_assets: "Todos los activos",
      jc_filter_search: "Buscar proveedor, notas, #",
      jc_filter_apply: "Aplicar",
      jc_filter_clear: "Limpiar",
      fin_new_receipt: "Recibo / Gasto",
      jc_status_lbl: "Estado",
      jc_submitted_by: "Enviado por",
      jc_approved_by: "Aprobado por",
      jc_number: "Recibo #",
      jc_view_file: "Ver recibo",
      jc_edit: "Editar",
      jc_approve: "Aprobar",
      jc_reject: "Rechazar",
      jc_approved: "Recibo aprobado",
      jc_rejected: "Recibo rechazado",
      jc_saved: "Recibo guardado",
      jc_take_photo: "Tomar foto",
      jc_upload_file: "Subir imagen o PDF",
      jc_manual: "Ingresar manualmente",
      jc_reading: "Leyendo tu recibo…",
      jc_reading_hint: "El Asistente 360 extrae el proveedor, la fecha y el total.",
      jc_ocr_failed: "No pudimos leer este recibo con claridad. Ingresa los datos manualmente — no adivinamos nada.",
      jc_retry: "Reintentar",
      jc_reextract_ok: "Recibo releído — revisa los campos",
      jc_reextract_fail: "Aún no se pudo leer. Ingresa los datos manualmente.",
      jc_project: "Proyecto",
      jc_vendor: "Proveedor",
      jc_vendor_ph: "ej. Home Depot",
      jc_date: "Fecha",
      jc_category: "Categoría",
      jc_expense: "Gasto",
      jc_subtotal: "Subtotal",
      jc_tax: "Impuestos",
      jc_discount: "Descuento / ajuste",
      jc_total: "Total",
      jc_total_required: "Ingresa el total del recibo antes de guardar.",
      jc_total_confirm: "No estamos seguros del total — confírmalo por favor.",
      jc_notes: "Notas",
      jc_save: "Guardar recibo",
      jc_receipt_img_alt: "Foto del recibo",
      jc_file_attached: "Archivo del recibo adjunto",
      jc_eq_section: "Horas de equipo",
      jc_eq_log_btn: "Registrar equipo",
      jc_eq_manage: "Administrar equipo",
      jc_eq_empty: "Aún no hay horas de equipo registradas",
      jc_eq_empty_hint: "Registra horas o lecturas de medidor para equipo propio o rentado.",
      jc_eq_pending_banner: "{{count}} registro(s) de equipo esperando tu aprobación.",
      jc_eq_date: "Fecha de trabajo",
      jc_eq_hours: "Horas",
      jc_eq_mode_hours: "Horas",
      jc_eq_mode_meter: "Medidor",
      jc_eq_meter_start: "Medidor inicial",
      jc_eq_meter_end: "Medidor final",
      jc_eq_note: "Nota",
      jc_eq_save: "Guardar registro de equipo",
      jc_eq_saved: "Registro de equipo guardado",
      jc_eq_approved: "Registro de equipo aprobado",
      jc_eq_rejected: "Registro de equipo rechazado",
      jc_eq_deleted: "Eliminado",
      jc_eq_none: "Aún no hay equipo. Un dueño o administrador puede agregar máquinas en Administrar equipo.",
      jc_eq_none_fin: "Aún no hay equipo — agrega tu primera máquina para registrar horas.",
      jc_eq_none_machines: "Aún no hay máquinas — agrega la primera para registrar horas.",
      jc_eq_kind_personal: "Personal",
      jc_eq_odometer: "Odómetro",
      jc_eq_driver: "Conductor asignado",
      jc_eq_fuel_type: "Tipo de combustible",
      jc_eq_fuel_gas: "Gasolina",
      jc_eq_fuel_diesel: "Diésel",
      jc_eq_fuel_electric: "Eléctrico",
      jc_eq_fuel_hybrid: "Híbrido",
      jc_eq_payment_monthly: "Pago / renta (por mes)",
      jc_eq_insurance_monthly: "Seguro (por mes)",
      jc_eq_personal_vehicle: "Vehículo personal — paga la tarifa de millaje del IRS",
      jc_eq_add_truck_title: "Agregar camión",
      jc_trip_none_trucks: "Aún no hay camiones",
      jc_trip_add_truck: "Agregar un camión",
      jc_eq_truck_name: "Nombre del camión",
      jc_eq_truck_name_ph: "ej. F-250 blanca",
      jc_eq_save_truck: "Guardar camión",
      jc_eq_save_equipment: "Guardar equipo",
      ad_start_trip: "Iniciar viaje",
      ad_trip_in_progress: "Viaje en curso — Terminar viaje",
      ad_add_fuel: "Agregar combustible",
      ad_add_service: "Agregar servicio",
      jc_service_type: "Tipo de servicio",
      jc_service_oil_change: "Cambio de aceite",
      jc_service_tires: "Llantas",
      jc_service_repair: "Reparación",
      jc_service_other: "Otro",
      jc_service_oil_reset: "Reinicia el recordatorio de aceite a hoy + 5,000 mi.",
      myday_trip_in_progress: "Viaje en curso — Terminar viaje",
      nav_fleet: "Camiones y Equipo",
      nav_subs: "Subs",
      subs_subtitle: "Tus subcontratistas — seguros, W-9 y pagos en un solo lugar.",
      subs_add: "Agregar sub",
      subs_add_first: "Agrega tu primer sub",
      subs_empty: "Sin subs todavía — agrega uno y mándale su enlace privado por texto.",
      subs_add_title: "Agregar sub",
      subs_edit_title: "Editar sub",
      subs_name: "Nombre",
      subs_name_ph: "ej. Electricidad de Mike",
      subs_trade: "Oficio",
      subs_trade_ph: "ej. Electricista",
      subs_phone: "Teléfono",
      subs_email: "Correo",
      subs_company: "Compañía",
      subs_notes: "Notas",
      subs_liab: "Responsabilidad",
      subs_comp: "Comp. laboral",
      subs_liab_exp: "Vence responsabilidad",
      subs_comp_exp: "Vence comp. laboral",
      subs_w9_on: "W-9 en archivo",
      subs_w9_missing: "Falta W-9",
      subs_ins_missing: "Falta",
      subs_ins_expired: "Vencido",
      subs_ins_days: "{{days}}d restantes",
      subs_ins_ok: "OK",
      subs_paid_year: "Pagado {{year}}",
      subs_portal_title: "Enlace del portal del sub",
      subs_portal_hint: "Enlace privado — el sub sube su seguro y W-9 aquí. Sin contraseña.",
      subs_portal_msg: "Aquí está tu enlace privado. Guárdalo — sube tu seguro/W-9 cuando te lo pidamos:",
      subs_link_on: "Enlace activo",
      subs_link_off: "Enlace apagado",
      subs_share_link: "Texto / copiar enlace",
      subs_new_link: "Nuevo enlace",
      subs_turn_off: "Apagar",
      subs_link_rotated: "Nuevo enlace creado — el anterior dejó de funcionar",
      subs_link_off_done: "Enlace apagado",
      subs_deleted: "Sub eliminado",
      subp_hi: "¡Hola {{name}}!",
      subp_intro: "Este es tu enlace privado de {{company}}.",
      subp_empty: "Nada pendiente ahora — cuando {{company}} necesite tu seguro o W-9, lo subirás aquí mismo.",
      subp_keep: "Guarda este enlace. Por tu seguridad vence en 90 días; te enviaremos uno nuevo.",
      subs_link_expires: "El enlace vence el {{date}}",
      subs_send_new_link: "Enviar enlace nuevo",
      nb_title: "Notificaciones",
      nb_empty: "Nada nuevo — estás al día.",
      nb_mark_all: "Marcar todo como leído",
      subs_docs: "Documentos",
      subs_doc_liab: "COI de responsabilidad",
      subs_doc_comp: "Cert. comp. laboral",
      subs_doc_w9: "W-9",
      subs_doc_license: "Licencia",
      subs_doc_agreement: "Acuerdo",
      subs_doc_missing: "Falta",
      subs_doc_upload: "Subir",
      subs_doc_replace: "Reemplazar",
      subs_doc_uploaded: "Subido {{date}}",
      subs_doc_w9_note: "Los W-9 quedan privados — solo tú y los admins pueden abrirlos.",
      subs_doc_read_ai: "Leer con IA",
      subs_doc_no_read: "No se pudo leer — escribe las fechas tú mismo",
      subs_doc_confirm_title: "Revisa lo que leyó la IA",
      subs_doc_confirm_hint: "Corrige lo que haga falta y guarda.",
      subs_doc_insurer: "Aseguradora",
      subs_doc_policy: "Póliza #",
      subs_doc_expiry: "Vencimiento",
      subs_doc_confirm_save: "Guardar — está bien",
      subp_docs_title: "Documentos que {{company}} necesita",
      subp_upload: "Subir",
      subp_upload_hint: "Toca para tomar una foto o elegir un PDF.",
      subp_uploaded: "Recibido {{date}} — ¡gracias!",
      subp_doc_sent: "Recibido — ¡gracias!",
      subs_alert_title: "Seguro de subs",
      subs_ask_cert: "Pedir certificado nuevo",
      subs_cert_msg: "Hola — tu certificado de seguro con nosotros está por vencer o ya venció. Sube el nuevo aquí (toma un minuto):",
      assign_ins_missing: "sin seguro en archivo",
      assign_ins_expired: "seguro vencido",
      assign_ins_warn: "Problema de seguro — pide un certificado nuevo antes de que empiece.",
      subs_bills: "Facturas y pagos",
      subs_bill_add: "Agregar factura",
      subs_bill_job: "Trabajo",
      subs_bill_amount: "Monto",
      subs_bill_desc: "¿Por qué es?",
      subs_bill_retainage: "Retención %",
      subs_bill_ret_short: "retención",
      subs_bill_ret_held: "retención retenida",
      subs_release_retainage: "Liberar retención · {{amount}}",
      subs_w9_marked: "W-9 marcado recibido — sin archivo",
      subs_bill_none: "Sin facturas todavía — agrega una cuando el sub te cobre.",
      subs_bill_pending: "Falta aprobar",
      subs_bill_owed: "Pendiente",
      subs_bill_partial: "Parcial",
      subs_bill_paid: "Pagada",
      subs_bill_paid_of: "{{paid}} pagado",
      subs_bill_approve: "Aprobar",
      subs_bill_pay: "Registrar pago",
      subs_pay_method: "Cheque, Zelle…",
      subs_waiver_signed: "waiver firmado",
      subs_1099: "Reporte 1099",
      subs_1099_hint: "Umbral por año de pago: $600 hasta 2025, $2,000 desde 2026 (ley nueva). Pregunta a tu contador cada enero.",
      subs_1099_threshold: "Umbral para {{year}}",
      subs_1099_override_ph: "Ajuste ($, opcional)",
      subs_1099_over: "Presentar 1099",
      subs_1099_under: "Debajo",
      subs_1099_none: "Sin pagos a subs en {{year}}.",
      fin_subs_title: "Subs",
      fin_subs_owed: "Se debe a subs",
      fin_subs_paid: "Pagado {{year}}",
      fin_subs_unpaid: "{{count}} factura(s) sin pagar — toca para abrir Subs",
      subp_jobs_title: "Tus trabajos con {{company}}",
      subp_inv_title: "Enviar una factura",
      subp_inv_amount: "Monto ($)",
      subp_inv_job: "Trabajo",
      subp_inv_desc: "¿Por qué es?",
      subp_inv_photo: "Foto de la factura (opcional)",
      subp_inv_send: "Enviar factura",
      subp_inv_sent: "Factura enviada — {{company}} la revisará.",
      subp_bills_title: "Tus facturas y pagos",
      subp_st_pending: "En revisión",
      subp_st_owed: "Aprobada — aún no pagada",
      subp_st_partial: "Pagada parcialmente",
      subp_st_paid: "Pagada",
      subp_waiver_title: "Waiver de lien",
      subp_waiver_sign_btn: "Firmar waiver de lien",
      subp_waiver_name: "Escribe tu nombre legal completo para firmar",
      subp_waiver_consent: "Acepto firmar este waiver electrónicamente.",
      subp_waiver_sign: "Firmar waiver",
      subp_waiver_done: "Firmado {{date}}",
      subp_none: "Nada por aquí todavía.",
      subs_doc_each_occ: "Cada ocurrencia ($)",
      subs_doc_aggregate: "Agregado ($)",
      subp_inv_no_jobs: "Tu constructor aún no te asigna a un trabajo — pídele que te agregue antes de enviar una factura.",
      subs_bill_pick_job: "Elige un trabajo",
      subs_bill_due: "Fecha de vencimiento (opcional)",
      subs_bill_due_short: "vence",
      fin_subs_retainage: "Retención retenida",
      mn_coming_in: "Por cobrar",
      mn_overdue_line: "{{amount}} vencido",
      mn_going_out: "Por pagar",
      mn_going_out_sub: "A subs y facturas",
      mn_retainage_held: "{{amount}} de retención",
      mn_subbill_pick: "¿De quién es la factura?",
      mn_collected: "Cobrado este mes",
      mn_collected_sub: "{{count}} pagos",
      mn_needs_you: "Necesita tu atención",
      mn_all_caught_up: "Todo al día.",
      mn_ny_overdue: "{{count}} vencidas — {{names}}",
      mn_ny_est: "{{count}} estimados esperando aprobación",
      mn_ny_subs: "{{count}} facturas de subs por pagar",
      mn_ny_receipts: "{{count}} recibos sin asignar a un trabajo",
      mn_est_cos: "Estimados y órdenes de cambio",
      mn_no_budget: "{{count}} trabajos sin presupuesto — la ganancia no se puede medir.",
      mn_add_budgets: "Agregar presupuestos",
      mn_see_all: "Ver todos los trabajos",
      mn_show_less: "Ver menos",
      mn_rep_aging: "Quién me debe",
      mn_rep_1099: "Reporte 1099",
      mn_rep_mileage: "Registro de millaje",
      mn_rep_profit: "Ganancia por trabajo",
      mn_new_estimate_sub: "Cotiza un trabajo",
      mn_new_invoice_sub: "Cobra a un cliente",
      mn_new_co_sub: "Suma a un contrato",
      mn_new_expense_sub: "Fotografía un recibo",
      mn_new_subbill: "Factura de sub",
      mn_new_subbill_sub: "Un sub te cobró",
      mn_win_detail: "{{won}} de {{sent}} estimados ganados en los últimos 90 días",
      mn_st_owed: "Por pagar",
      mn_st_partial: "Parcialmente pagada",
      mn_st_pending: "Pendiente de aprobación",
      mn_subs_empty: "Aún no hay facturas de subs — aparecerán aquí cuando un sub te cobre.",
      mn_days_overdue: "{{n}}d vencida",
      mn_reports: "Reportes",
      mn_ny_overdue_one: "{{count}} factura vencida — {{names}}",
      mn_ny_overdue_other: "{{count}} facturas vencidas — {{names}}",
      mn_ny_est_one: "{{count}} estimado esperando aprobación",
      mn_ny_est_other: "{{count}} estimados esperando aprobación",
      mn_ny_subs_one: "{{count}} factura de sub por pagar",
      mn_ny_subs_other: "{{count}} facturas de subs por pagar",
      mn_ny_receipts_one: "{{count}} recibo sin asignar a un trabajo",
      mn_ny_receipts_other: "{{count}} recibos sin asignar a un trabajo",
      subp_waiver_disclaimer: "Los formularios de waiver de lien varían por estado — consulta a tu abogado. (Texto base pensado para Ohio.)",
      subp_waiver_type_conditional_progress: "Condicional — pago parcial",
      subp_waiver_type_unconditional_progress: "Incondicional — pago parcial",
      subp_waiver_type_conditional_final: "Condicional — pago final",
      subp_waiver_type_unconditional_final: "Incondicional — pago final",
      pjt_title: "Ganancia por trabajo",
      pjt_job: "Trabajo", pjt_contract: "Contrato", pjt_materials: "Materiales",
      pjt_labor: "Mano de obra", pjt_equipment: "Equipo", pjt_mileage: "Millaje",
      pjt_spent: "Gastado", pjt_profit: "Ganancia", pjt_margin: "Margen",
      pjt_csv: "Descargar CSV", pjt_empty: "Aún no hay trabajos con contrato",
      subp_expired: "Este enlace venció — pídele a {{company}} que te mande uno nuevo.",
      subp_verify_title: "Verificación rápida",
      subp_verify_body: "Para firmar o enviar facturas, te enviamos un código de 6 dígitos a tu correo registrado.",
      subp_verify_send: "Mándame el código",
      subp_verify_sent: "Código enviado a {{dest}} — válido por 10 minutos.",
      subp_verify_already: "Ya te enviamos un código — revisa tu correo (válido por 10 minutos).",
      subp_verify_ph: "Código de 6 dígitos",
      subp_verify_btn: "Verificar",
      subp_verify_wrong: "Código incorrecto — quedan {{left}} intentos",
      subp_verify_locked: "Demasiados intentos — espera 15 minutos y pide un código nuevo.",
      subp_verify_expired: "Ese código venció — pide uno nuevo.",
      subp_verify_sms_off: "Los códigos por texto aún no están activos — pídele a {{company}} que termine la configuración.",
      subp_no_phone: "Pídele a {{company}} que agregue tu teléfono para firmar",
      subp_no_email: "Pídele a {{company}} que agregue tu correo para firmar",
      subp_verified: "Dispositivo verificado por 30 días.",
      subs_agent_title: "Enlace para el agente de seguros",
      subs_agent_hint: "Para su agente de seguros — solo puede entregar un certificado. Nada más es visible.",
      subs_agent_on: "Enlace de agente activo",
      subs_agent_off: "Enlace de agente apagado",
      subs_agent_expired: "Enlace de agente vencido — manda uno nuevo",
      subs_link_expired: "Enlace vencido — manda uno nuevo",
      subs_share_agent: "Texto / copiar enlace de agente",
      subp_agent_title: "Entrega de certificado de seguro",
      subp_agent_hint: "Sube el certificado vigente de {{sub}}. Solo {{company}} puede verlo.",
      fleet_subtitle: "Tus vehículos, remolques, equipo y herramientas en un solo lugar.",
      fleet_add: "Agregar",
      fleet_add_first: "Agrega el primero",
      fleet_empty: "Nada aquí todavía — agrega un camión o máquina para empezar.",
      fleet_group_truck: "Camiones",
      fleet_group_trailer: "Remolques",
      fleet_group_equipment: "Equipo",
      fleet_group_tool: "Herramientas",
      cs_fleet_t: "Camiones y Equipo",
      cs_fleet_d: "Vehículos, remolques y máquinas",
      cs_vehicles_t: "Vehículos",
      cs_irs_rate: "Tarifa de millaje del IRS",
      cs_irs_rate_hint: "Revisa irs.gov cada enero.",
      cs_mileage_cost: "Costo de millaje",
      cs_mileage_irs: "Tarifa del IRS",
      cs_mileage_irs_d: "Automática por fecha del viaje ({{rate}}/mi ahora)",
      cs_mileage_custom: "Mi propio $ por milla",
      cs_mileage_custom_d: "Una tarifa fija que tú defines",
      cs_custom_rate: "Tu tarifa",
      cs_mileage_hint: "Tarifa IRS automática por fecha del viaje, o tu propio $/milla",
      cs_mileage_irs_hint: "Los viajes se calculan por fecha: 72.5¢ hasta jun 2026, 76¢ desde el 1 de jul de 2026. Revisa irs.gov cada enero.",
      jc_fuel_which_truck: "¿Combustible para qué camión?",
      jc_fuel_gallons: "Galones",
      jc_fuel_odometer: "Odómetro (opcional)",
      fleet_add_fuel: "Agregar combustible",
      jc_eq_this_month: "Este mes",
      jc_eq_this_year: "Este año",
      jc_eq_ad_miles: "Millas",
      jc_eq_ad_mpg: "MPG",
      jc_eq_ad_fuel: "Combustible",
      jc_eq_ad_maint: "Mantenimiento",
      jc_eq_ad_fixed: "Fijo",
      jc_eq_ad_total: "Total",
      jc_eq_cost_per_mile: "Costo por milla",
      jc_eq_trips: "Viajes",
      fin_trucks_month: "Camiones este mes",
      fin_tab_expenses: "Gastos",
      fleet_reports_title: "Reportes para tu contador",
      fleet_reports_hint: "Registro de millaje listo para el IRS y combustible + costos de vehículos. Elige las fechas y toca para descargar.",
      fleet_report_mileage_pdf: "Registro de millaje (PDF)",
      fleet_report_mileage: "Registro de millaje (CSV)",
      fleet_report_mileage_hint: "Fecha, conductor, odómetro inicial/final, millas, trabajo y propósito — listo para el IRS.",
      fleet_report_costs: "Combustible + costos de vehículos (CSV)",
      fleet_report_costs_hint: "Por camión: millas, MPG, combustible, mantenimiento, fijo, total, costo por milla.",
      fleet_report_all_trucks: "Todos los camiones",
      fleet_report_from: "Desde",
      fleet_report_to: "Hasta",
      myday_maintenance_title: "Recordatorios de camiones",
      jc_fuel_price_gal: "Precio / galón",
      jc_eq_add_title: "Agregar equipo",
      jc_eq_edit_title: "Editar equipo",
      jc_eq_name: "Nombre del equipo",
      jc_eq_name_ph: "ej. Minicargadora #2",
      jc_eq_identifier: "Identificador / placa",
      jc_eq_kind: "Tipo",
      jc_eq_kind_owned: "Propio",
      jc_eq_kind_rented: "Rentado",
      jc_eq_internal_rate: "Costo interno por hora",
      jc_eq_billable_rate: "Tarifa facturable por hora (opcional)",
      jc_eq_add: "Guardar equipo",
      jc_eq_added: "Equipo guardado",
      jc_eq_retire: "Archivar",
      jc_eq_type: "Tipo de activo",
      jc_eq_type_truck: "Camión / Van",
      jc_eq_type_trailer: "Remolque",
      jc_eq_type_equipment: "Equipo",
      jc_eq_type_tool: "Herramienta",
      jc_eq_more: "Más detalles (opcional)",
      jc_eq_less: "Ocultar detalles",
      jc_eq_plate: "Placa",
      jc_eq_purchase_date: "Fecha de compra",
      jc_eq_purchase_price: "Precio de compra $",
      jc_eq_rate_mile: "Interno $/milla",
      jc_eq_rate_includes: "Esta tarifa cubre",
      jc_eq_inc_fuel: "Combustible",
      jc_eq_inc_maintenance: "Mantenimiento",
      jc_eq_inc_insurance: "Seguro",
      jc_eq_rental_daily: "Renta $/día",
      jc_eq_rental_weekly: "Renta $/semana",
      jc_eq_assets_title: "Vehículos y Equipo",
      jc_eq_detail_title: "Detalles del activo",
      jc_eq_linked_receipts: "Recibos vinculados",
      jc_eq_maintenance: "Historial de mantenimiento",
      jc_eq_total_month: "Este mes",
      jc_eq_total_year: "Este año",
      jc_eq_total_lifetime: "Total histórico",
      jc_eq_current_project: "Proyecto actual",
      jc_eq_no_assignment: "Sin asignación registrada",
      jc_eq_total_hours: "Horas registradas",
      jc_eq_next_service: "Próximo servicio (fecha)",
      jc_eq_next_service_meter: "Próximo servicio (medidor)",
      jc_eq_oil_due: "Cambio de aceite en {{n}} mi",
      jc_eq_oil_overdue: "Cambio de aceite vencido {{n}} mi",
      jc_eq_archive_note: "Archivar conserva todo el historial.",
      jc_eq_on_job: "Equipo en este trabajo",
      jc_eq_dropoff: "Fecha de entrega",
      jc_eq_pickup: "Fecha de recogida",
      jc_eq_save_onjob: "Guardar — equipo en el trabajo",
      jc_eq_save_full: "Guardar registro completo",
      jc_eq_complete: "Completar registro de equipo",
      jc_eq_update_reading: "Actualizar lectura",
      jc_eq_record_pickup: "Registrar recogida",
      jc_eq_open_badge: "En el trabajo",
      jc_eq_pending_hours: "Horas pendientes",
      jc_eq_op_hours: "Horas de operación",
      jc_eq_days_site: "días en sitio",
      jc_eq_rental_cost: "Costo de renta",
      jc_eq_dup: "Este equipo ya tiene un registro abierto en un trabajo.",
      jc_eq_dup_override: "Iniciar de todos modos (explicar)",
      jc_eq_override_reason: "Motivo (obligatorio)",
      jc_eq_enter_now: "Ingresar horas completas ahora",
      jc_eq_quick: "Entrega rápida",
      jc_eq_review: "Revisa antes de completar",
      jc_trips_title: "Millaje",
      jc_log_mileage: "Registrar millaje",
      jc_trip_start: "Iniciar viaje",
      jc_trip_finish: "Terminar viaje",
      jc_trip_vehicle: "Vehículo",
      jc_trip_purpose: "Propósito del viaje (opcional)",
      jc_trip_odo_start: "Odómetro inicial (opcional)",
      jc_trip_odo_end: "Odómetro final",
      jc_trip_manual: "Ingresar millas manualmente",
      jc_trip_miles: "Millas",
      jc_trip_open_badge: "Viaje abierto",
      jc_trip_done_badge: "Completado",
      jc_trip_saved_open: "Viaje iniciado — termínalo al llegar.",
      jc_trip_saved_done: "Viaje completado.",
      jc_trip_none: "Aún no hay viajes.",
      jc_trip_company_use: "Uso de empresa",
      jc_trip_est_cost: "Costo interno estimado",
      jc_trip_err_odo: "El odómetro final debe ser mayor que el inicial.",
      jc_trip_err_miles: "Ingresa millas mayores a 0.",
      jc_trip_dup: "Este vehículo ya tiene un viaje abierto.",
      jc_trip_pick: "Elige un vehículo primero.",
      jc_trip_purpose_required: "La configuración de la empresa exige un propósito.",
      jc_set_require_purpose: "Exigir propósito en los viajes",
      jc_eq_retire_confirm: "¿Retirar este equipo? Sus horas registradas se conservan.",
      jc_eq_retired: "Equipo retirado",
      jc_eq_active: "Activo",
      jc_eq_inactive: "Inactivo",
      jc_eq_cost: "Costo",
      jc_eq_no_rate: "Sin tarifa interna — solo cuenta horas",
      jc_eq_owned_chip: "Equipo propio",
      jc_eq_equipment: "Equipo",
      jc_eq_pick: "Primero elige un equipo.",
      jc_eq_err_hours: "Ingresa horas mayores a 0.",
      jc_eq_err_hours_max: "Las horas deben ser 16 o menos por día.",
      jc_eq_err_meter: "Ingresa ambas lecturas del medidor.",
      jc_eq_err_meter_order: "La lectura final debe ser mayor que la inicial.",
      jc_eq_err_meter_max: "Las lecturas deben estar a 16 horas o menos de diferencia.",
      jc_eq_name_required: "Ingresa el nombre del equipo para guardar.",
      jc_eq_per_hour: "/hr",
      jc_delete: "Eliminar",
      jc_cat_labor: "Mano de obra",
      jc_bd_title: "Desglose de costos",
      jc_bd_empty: "Aún no hay registros en esta categoría.",
      jc_labor_no_rate: "Define una tarifa interna de mano de obra en Ajustes de costos para calcular las horas.",
      jc_settings_title: "Ajustes de costos",
      jc_labor_internal: "Costo interno de mano de obra por hora",
      jc_labor_billable: "Tarifa facturable de mano de obra por hora (opcional)",
      jc_settings_saved: "Ajustes de costos guardados",
      pd_customer: "Cliente",
      pd_crew_today: "Equipo de hoy",
      pd_next_activity: "Próxima actividad",
      pd_open_tasks: "Tareas abiertas",
      pd_latest_update: "Última actualización",
      pd_none_yet: "Nada aún",
      pd_today: "Hoy",
      pd_tomorrow: "Mañana",
      pd_co_gate_title: "Primero crea un estimado",
      pd_co_gate_body: "Las órdenes de cambio modifican un estimado o contrato aprobado. Primero crea un estimado para este proyecto.",
      pd_more_tasks: "Tareas",
      pd_more_sharing: "Compartir con Cliente",
      pd_more_reports: "Reportes",
      pd_more_settings: "Ajustes del Proyecto",
      pd_no_activity: "Aún sin actividad",
      pd_no_schedule: "Nada programado",
      pd_schedule_add: "Abrir Agenda",
      pd_ev_log: "registro",
      pd_ev_clock_in: "entrada",
      pd_ev_manual_entry: "Tarjeta de tiempo",
      pd_ev_clock_out: "salida",
      pd_ev_break_start: "inicio descanso",
      pd_ev_break_end: "fin descanso",
      pd_ev_day_update: "actualización",
      pd_ev_evening_update: "reporte de tarde",
      pd_ev_morning_plan: "plan de mañana",
      pd_ev_project_switch: "cambio de proyecto",
      pd_ev_correction_request: "corrección",
      tc_flagged: "marcado",
      task_attach: "Adjuntar foto",
      fin_more_details: "Más detalles financieros",
      fin_new: "Nuevo",
      fin_new_invoice: "Nueva Factura",
      fin_record_payment: "Registrar Pago",
      fin_settings_menu: "Ajustes financieros",
      fin_settings_title: "Ajustes Financieros",
      fin_products_menu: "Productos y Servicios",
      fin_pick_project: "Elige un proyecto",
      fin_record_hint: "Abre una factura para registrar un pago.",
      bgv_stage_interpret: "Solicitud entendida",
      bgv_stage_proposed: "Revisión mostrada",
      bgv_stage_answered: "Respondido",
      bgv_stage_choose: "Selección hecha",
      bgv_stage_cancel: "Cancelado",
      bgv_stage_draft_parked: "Guardado como borrador",
      bgv_stage_perm_change: "Permisos actualizados",
      bgv_stage_confirm: "Completado",
      bgv_result_failure: "Falló",
      bgv_dismiss: "Descartar",
      bgv_review_create_task: "Agregar Tarea",
      bgv_row_task: "Tarea",
      action_cancel: "Cancelar",
      action_delete: "Eliminar",
      action_invite: "Invitar al equipo",
      action_signout: "Cerrar sesión",
      action_get_started: "Prueba gratis 14 días",
      action_signin: "Iniciar sesión",
      action_open_app: "Abrir app",
      action_load_more: "Cargar más",
      showing_x_of_y: "Mostrando {{shown}} de {{total}}",
      action_create_account: "Crear cuenta",
      hero_headline: "Cada foto de obra. Cada agenda. Una sola app simple.",
      hero_sub: "Fotos de obra con prueba de hora y ubicación, una agenda que tu cuadrilla sí entiende, y un Asistente 360 que convierte una actualización hablada en tu bitácora, agenda y órdenes de cambio.",
      hero_support: "Hecho para contratistas que quieren un solo lugar simple para manejar cada cliente, cada proyecto y cada detalle.",
      action_start_free: "Empieza gratis por 14 días",
      feat_coming_soon: "Próximamente",
      feat_payments_d_coming: "Envía facturas y prepárate para aceptar pagos en línea seguros, todo desde BuildProject360.",
      payments_coming_toast: "Los pagos de clientes llegarán pronto.",
      nav_app_updates: "Actualizaciones",
      upd_available_title: "Actualización disponible",
      upd_available_body: "Hay una nueva versión de BuildProject360 lista.",
      upd_now: "Actualizar ahora",
      upd_later: "Después",
      upd_title: "Actualizaciones de la app",
      upd_subtitle: "Versión, actualizaciones y herramientas de reparación.",
      upd_version: "Versión",
      upd_build: "Compilación",
      upd_last_update: "Última actualización",
      upd_status: "Estado",
      upd_status_current: "Al día",
      upd_status_available: "Actualización disponible",
      upd_uptodate: "Ya tienes la última versión",
      upd_check: "Buscar actualizaciones",
      upd_refresh: "Recargar aplicación",
      upd_refresh_hint: "Recarga los archivos más recientes. Tus proyectos, fotos, borradores y cuenta no se tocan.",
      upd_connection: "Conexión",
      upd_online: "En línea",
      upd_offline: "Sin conexión",
      upd_offline_uploads: "Cargas sin conexión",
      upd_queue_empty: "Nada pendiente",
      upd_queue_count: "{{count}} pendientes",
      upd_repair: "Reparar app",
      upd_repair_confirm_title: "¿Reparar BuildProject360?",
      upd_repair_li1: "Cierra tu sesión y borra cachés antiguos.",
      upd_repair_li2: "Vuelve a registrar la app y te lleva al inicio de sesión.",
      upd_repair_li3: "Conserva las fotos en cola y los datos sin conexión.",
      upd_repair_go: "Reparar ahora",
      upd_repair_hint: "Usa Reparar solo si la app falla; no hace falta para actualizaciones normales.",
      login_trouble_title: "¿Problemas para entrar?",
      login_try_again: "Reintentar",
      login_check_connection: "Probar conexión",
      login_refresh_app: "Recargar aplicación",
      login_reset_password: "Restablecer contraseña",
      login_contact_support: "Contactar soporte",
      login_diag_code: "Código de soporte",
      login_online: "La conexión parece bien — intenta entrar de nuevo.",
      login_offline: "Parece que no tienes conexión. Revísala e inténtalo otra vez.",
      nav_admin: "Admin",
      admin_denied: "Se requiere acceso de administrador.",
      ob_checklist_title: "Empieza con BuildProject360",
      ob_progress: "{{done}} de {{total}} completados",
      ob_hide: "Ocultar",
      ob_step_company_info: "Completa la información de tu empresa",
      ob_step_first_customer: "Agrega tu primer cliente",
      ob_step_first_project: "Crea tu primer proyecto",
      ob_step_first_photo: "Toma tu primera foto del proyecto",
      ob_step_first_schedule: "Agenda tu primer trabajo",
      ob_step_buildguide_used: "Pide ayuda al Asistente",
      ob_reminder_first_project_one: "Te queda {{count}} día. Crea un proyecto para ver cómo BuildProject360 organiza tu trabajo.",
      ob_reminder_first_project_other: "Te quedan {{count}} días. Crea un proyecto para ver cómo BuildProject360 organiza tu trabajo.",
      ob_reminder_first_photo: "Creaste tu primer proyecto. Toma una foto para iniciar su línea de tiempo visual.",
      ob_reminder_trial_last_one: "Te queda {{count}} día. Elige un plan para mantener el acceso completo.",
      ob_reminder_trial_last_other: "Te quedan {{count}} días. Elige un plan para mantener el acceso completo.",
      ob_reminder_go: "Ir",
      bg_greeting: "¡Hola! Soy tu Asistente 360. Puedo responder preguntas, buscar información de proyectos, crear proyectos, armar horarios, preparar actualizaciones y ayudarte con las tareas diarias. Siempre revisarás los cambios antes de guardarlos. ¿En qué te ayudo?",
      bg_greeting_customer: "Crear un cliente",
      bg_greeting_project: "Crear un proyecto",
      bg_greeting_schedule: "Armar horario",
      bg_greeting_tour: "Muéstrame cómo",
      aob_title: "Emails de onboarding",
      aob_subtitle: "Estado de la secuencia de prueba, plantillas, pruebas y analíticas.",
      aob_pause: "Pausar secuencia",
      aob_resume: "Reanudar secuencia",
      aob_steps: "Pasos de la secuencia",
      aob_sent: "enviados",
      aob_failed: "fallidos",
      aob_suppressed: "{{count}} direcciones suprimidas (baja/rebote)",
      aob_funnel: "Embudo de conversión",
      aob_f_verify: "Registro → email verificado",
      aob_f_customer: "Registro → primer cliente",
      aob_f_project: "Registro → primer proyecto",
      aob_f_photo: "Registro → primera foto",
      aob_f_schedule: "Registro → primer evento",
      aob_f_paid: "Prueba → pago",
      aob_f_unsub: "Tasa de bajas",
      aob_f_bounce: "Tasa de rebote/fallo",
      aob_per_reminder: "Conversión por recordatorio (7 días)",
      aob_subjects: "Asuntos (personalizados)",
      aob_test_title: "Enviar email de prueba",
      aob_test_to: "Destinatario (por defecto: tú)",
      aob_test_send: "Enviar prueba",
      aob_test_sent: "Prueba enviada",
      aob_test_failed: "La prueba falló",
      aob_recent: "Entregas recientes",
      aob_none: "Aún no se han enviado emails de onboarding.",
      pd_tab_tasks: "Tareas e informes",
      pd_details: "Detalles del proyecto",
      pd_description: "Descripción",
      pd_collaborators: "Colaboradores y acceso de invitados",
      pm_group_project: "Proyecto",
      pm_group_photos: "Fotos",
      pm_group_access: "Acceso y compartir",
      pm_group_danger: "Zona de peligro",
      pm_edit: "Editar proyecto",
      pm_map: "Ver mapa",
      pm_time: "Ver registros de tiempo",
      pm_qr: "Código QR del proyecto",
      pm_archive: "Archivar proyecto",
      pm_trash: "Ver papelera del proyecto",
      pm_restore: "Restaurar",
      pm_download_all: "Descargar todas las fotos",
      pm_report: "Exportar reporte de fotos",
      pm_manage_links: "Administrar enlaces compartidos",
      pm_collaborators: "Administrar colaboradores",
      pm_delete: "Eliminar proyecto",
      pm_delete_title: "¿Eliminar este proyecto?",
      pm_delete_body: "Escribe el nombre del proyecto \"{{name}}\" para confirmar. Se elimina de forma segura y se puede restaurar desde la papelera.",
      pm_delete_soft: "Eliminación segura: restaurable desde la papelera por un dueño/admin.",
      photos_all: "Todas",
      photos_count: "{{count}} fotos",
      photos_unknown_date: "Fecha desconocida",
      photos_filter_date: "Filtrar por fecha",
      photos_filter_member: "Filtrar por miembro",
      photos_all_members: "Todos los miembros",
      photos_filter_tags: "Filtrar por etiqueta",
      photos_all_tags: "Todas las etiquetas",
      photos_sort: "Ordenar",
      photos_newest: "Más recientes",
      photos_oldest: "Más antiguas",
      photos_view: "Vista cuadrícula/lista",
      photos_more: "Desliza para más",
      photos_select_date: "Seleccionar todas las fotos del {{date}}",
      sel_all_project: "Todas las fotos ({{total}})",
      sel_all_filter: "Resultados del filtro actual ({{count}})",
      sel_filter_hint: "Selecciona todo lo que coincide con tus filtros.",
      sel_loaded_only: "{{count}} fotos seleccionadas de {{total}} en este proyecto.",
      sel_count: "{{count}} seleccionadas",
      sel_all_cross: "{{count}} fotos seleccionadas. ¿Seleccionar las {{total}} fotos de este proyecto?",
      sel_select_rest: "Seleccionar las {{total}}",
      sel_done: "Listo",
      sel_add_tags: "Agregar etiquetas",
      sel_set_cover: "Usar como portada",
      sel_cover_done: "Foto de portada establecida",
      sel_cover_soon: "Abre la foto para usarla como portada.",
      sel_mark_before: "Marcar como Antes",
      sel_mark_progress: "Marcar como Progreso",
      sel_mark_after: "Marcar como Después",
      sel_favorite: "Favorita",
      sel_move_copy: "Mover o copiar",
      sel_move_title: "Mover o copiar {{count}} fotos",
      sel_move_dest: "Proyecto de destino",
      sel_move_btn: "Mover",
      sel_copy_btn: "Copiar",
      photos_open_a11y: "Abrir foto {{index}} de {{total}}, tomada el {{date}} por {{by}}",
      pd_no_address: "Sin dirección",
      share_all_photos: "Compartir todas las fotos",
      share_select_photos: "Seleccionar fotos para compartir",
      share_select_hint: "Mantén presionado o usa las casillas para seleccionar fotos, luego toca Compartir.",
      share_customer_gallery: "Compartir galería del cliente",
      share_invite_guest: "Invitar cliente o invitado",
      share_manage_links: "Administrar enlaces",
      fin_search_doc: "Buscar estimado, factura, cliente, proyecto o número…",
      sched_delete_title: "¿Eliminar este evento?",
      sched_delete_body: "Puedes deshacerlo justo después de eliminar.",
      sched_undo: "Deshacer",
      sched_deleted: "Evento eliminado",
      cust_dup_title: "Ya existe un cliente similar.",
      cust_dup_body: "¿Usar este cliente o crear uno nuevo?",
      cust_dup_use: "Usar este cliente",
      cust_dup_create: "Crear nuevo de todos modos",
      cust_dup_reason_email: "mismo correo",
      cust_dup_reason_name: "mismo nombre",
      cust_dup_reason_company: "misma empresa",
      cust_dup_reason_phone: "mismo teléfono",
      tz_banner_text: "Tu cuenta usa {{account}}, pero este dispositivo está en {{device}}.",
      tz_banner_update: "Usar {{tz}}",
      tz_banner_dismiss: "Descartar",
      tz_banner_updated: "Zona horaria actualizada",
      brand_wm_title: "Marca de agua en fotos",
      brand_sec_company: "Datos de la empresa", brand_sec_photos: "Ajustes de fotos",
      brand_wm_body: "Elige qué aparece en las fotos que tomas. Los originales siempre se guardan sin marca de agua.",
      brand_wm_none: "Sin marca de agua",
      brand_wm_simple: "Simple (empresa · proyecto · hora local)",
      brand_wm_proof: "Prueba (agrega GPS, usuario, ID de foto)",
      pm_closeout: "Paquete de cierre",
      closeout_title: "Paquete de cierre del proyecto",
      closeout_body: "Elige qué incluir. Se genera un PDF con tu marca y un enlace seguro — nada se envía automáticamente.",
      closeout_sec_before: "Fotos de antes",
      closeout_sec_progress: "Fotos de progreso",
      closeout_sec_after: "Fotos de después",
      closeout_sec_logs: "Registros diarios",
      closeout_sec_estimate: "Estimado aprobado",
      closeout_sec_change_orders: "Órdenes de cambio aprobadas",
      closeout_sec_invoices: "Facturas pagadas",
      closeout_completion: "Fecha de finalización",
      closeout_warranty: "Información de garantía",
      closeout_warranty_ph: "Ej. garantía de mano de obra de 5 años…",
      closeout_message: "Mensaje listo para correo",
      closeout_message_ph: "Nota opcional para el cliente…",
      closeout_generate: "Vista previa y generar",
      closeout_ready: "Paquete de cierre listo",
      closeout_counts: "Incluye: {{photos}} fotos, {{logs}} registros, {{estimate}} estimado, {{change_orders}} órdenes de cambio, {{invoices}} facturas.",
      closeout_copy: "Copiar enlace",
      closeout_preview: "Vista previa",
      closeout_download: "Descargar PDF de cierre",
      closeout_public_body: "Tu contratista preparó este paquete de cierre para tus registros.",
      closeout_no_send_note: "No se envió ningún correo ni mensaje — comparte el enlace cuando estés listo.",
      ai_summary_btn: "Redactar resumen diario con 360 Assistant",
      ai_summary_label: "Borrador de IA",
      ai_summary_hint: "Revisa y edita antes de guardar. Nada se envía automáticamente.",
      ai_summary_working: "Leyendo las fotos, notas y horas de hoy — unos 30 segundos…",
      log_hours_offer: "¿Agregar {{hours}}h × {{crew}} al registro de horas?",
      log_hours_yes: "Agregar borrador",
      log_hours_added: "Borrador agregado — aprueba en Tiempo > Revisar",
      cs_adv_t: "Avanzado", cs_adv_d: "Restablecer dispositivo y opciones avanzadas",
      inbox_title: "Bandeja de fotos",
      inbox_count: "{{count}} fotos necesitan un proyecto",
      inbox_assign: "Asignar a proyecto",
      inbox_assign_done: "{{count}} fotos asignadas",
      inbox_suggested: "Sugerido",
      inbox_select_all: "Seleccionar todas",
      inbox_empty: "Bandeja vacía — cada foto tiene un proyecto.",
      nav_integrations: "Integraciones",
      integ_title: "Integraciones",
      integ_subtitle: "Conecta las herramientas que ya usas. Las conexiones usan inicio de sesión seguro — nunca pedimos tus contraseñas.",
      integ_companycam_name: "Importar de CompanyCam",
      integ_companycam_body: "Importa proyectos y fotos desde CompanyCam.",
      integ_quickbooks_name: "Sincronizar QuickBooks",
      integ_quickbooks_body: "Sincroniza clientes, facturas y pagos.",
      integ_google_calendar_name: "Google Calendar",
      integ_google_calendar_body: "Mira tu agenda en Google Calendar.",
      integ_roofr_name: "Roofr",
      integ_roofr_body: "Importa mediciones de Roofr donde sea compatible.",
      integ_connect: "Conectar",
      integ_coming_soon: "Esta conexión se abre cuando el proveedor apruebe nuestra app. Te avisaremos por correo.",
      integ_badge_coming_soon: "Próximamente",
      integ_oauth_note: "Las integraciones se conectan con inicio de sesión seguro (OAuth). BuildProject360 nunca guarda tus contraseñas.",
      ccam_title: "Cámbiate de CompanyCam",
      ccam_subtitle: "Trae tus proyectos y fotos contigo. Corre en segundo plano — puedes seguir trabajando.",
      ccam_tab_token: "Conectar cuenta",
      ccam_tab_zip: "Subir ZIP",
      ccam_token_label: "Token de acceso de CompanyCam",
      ccam_token_help: "En CompanyCam ve a Resources › Access Tokens, crea un token y pégalo aquí. Nunca lo guardamos.",
      ccam_token_placeholder: "Pega el token",
      ccam_zip_label: "Archivo ZIP de CompanyCam",
      ccam_zip_help: "En CompanyCam abre un proyecto, elige Download All Photos y sube el ZIP aquí.",
      ccam_zip_project: "Agregar fotos a",
      ccam_zip_choose: "Elige un proyecto",
      ccam_zip_new: "Nombre del proyecto nuevo",
      ccam_start_import: "Iniciar importación",
      ccam_importing: "Importando en segundo plano…",
      ccam_progress: "{{projects}} proyectos · {{photos}} fotos",
      ccam_can_close: "Puedes cerrar esto — te avisaremos cuando termine.",
      ccam_done_title: "Importación completa",
      ccam_summary: "Se importaron {{projects}} proyectos, {{photos}} fotos.",
      ccam_summary_matched: "{{count}} coincidieron con proyectos existentes.",
      ccam_skipped: "{{count}} omitidas",
      ccam_skip_duplicate: "ya importada",
      ccam_skip_no_file: "archivo no disponible",
      ccam_skip_not_photo: "no es una foto",
      ccam_skip_download: "descarga fallida",
      ccam_failed: "La importación falló",
      ccam_reauth: "El token venció o fue rechazado — pega uno nuevo.",
      ccam_bad_token: "Ese token no funcionó. Revísalo e inténtalo de nuevo.",
      ccam_too_large: "El ZIP es demasiado grande (máx. 400 MB).",
      ccam_bad_zip: "Ese archivo no es un ZIP de CompanyCam.",
      ccam_start_toast: "Importación iniciada — corre en segundo plano",
      imp_title: "Trae tus datos",
      imp_subtitle: "¿Vienes de otra app? Trae tus clientes, trabajos y fotos contigo.",
      imp_beta: "Beta",
      imp_opt_companycam_t: "Desde CompanyCam",
      imp_opt_companycam_d: "Pega tu token de acceso de CompanyCam — traemos proyectos y fotos por ti.",
      imp_opt_spreadsheet_t: "Desde una hoja de cálculo",
      imp_opt_spreadsheet_d: "Sube un CSV o Excel de clientes o trabajos. Emparejamos las columnas por ti.",
      imp_opt_photos_t: "Desde una carpeta de fotos",
      imp_opt_photos_d: "Elige fotos de tu teléfono — las agrupamos en trabajos por lugar y fecha.",
      imp_recent: "Importaciones recientes",
      imp_undo: "Deshacer esta importación",
      imp_undone: "Importación deshecha: {{photos}} fotos, {{projects}} trabajos, {{customers}} clientes eliminados.",
      imp_undo_expired: "Se puede deshacer durante 7 días después de importar — esta ya pasó.",
      imp_job_undone: "Deshecha",
      imp_kind_companycam: "Importación de CompanyCam",
      imp_kind_spreadsheet: "Importación de hoja de cálculo",
      imp_kind_photos: "Importación de fotos",
      imp_status_queued: "Esperando para empezar…",
      imp_status_running: "Importando…",
      imp_status_staging: "Recibiendo fotos…",
      imp_status_failed: "La importación falló",
      imp_status_complete: "Importación completa",
      imp_progress_jobs: "trabajos",
      imp_progress_photos: "fotos",
      imp_sheet_title: "Importar hoja de cálculo",
      imp_sheet_subtitle: "Clientes o trabajos de cualquier app — exporta un CSV o Excel y suéltalo aquí.",
      imp_sheet_pick: "Elige un archivo CSV o Excel",
      imp_reading: "Leyendo tu archivo…",
      imp_cant_read: "No pudimos leer ese archivo. Prueba con un CSV o Excel.",
      imp_file_large: "Ese archivo es muy grande (máx. 15 MB).",
      imp_no_name: "Necesitamos una columna de nombre — revisa que tu hoja la tenga.",
      imp_sheet_found: "{{count}} filas encontradas",
      imp_sheet_mapping_help: "Emparejamos tus columnas. Corrige lo que se vea mal:",
      imp_field_name: "Nombre",
      imp_field_email: "Correo",
      imp_field_phone: "Teléfono",
      imp_field_address: "Dirección",
      imp_field_project: "Trabajo",
      imp_field_notes: "Notas",
      imp_map_none: "— omitir —",
      imp_start: "Empezar importación",
      imp_photos_title: "Importar fotos",
      imp_photos_subtitle: "Elige fotos de tu teléfono o computadora. Leemos el lugar y la fecha de cada foto y las agrupamos en trabajos.",
      imp_photos_pick: "Elegir fotos",
      imp_photos_pick_hint: "Puedes elegir más de 200 a la vez",
      imp_photos_uploading: "Subiendo {{done}} de {{total}}…",
      imp_photos_lock_hint: "Sigue aunque se bloquee la pantalla — deja esta página abierta.",
      imp_too_many: "Demasiadas fotos — divídelas en grupos de 400.",
      imp_photos_grouped: "{{photos}} fotos agrupadas en {{groups}} {{jobsLabel}}",
      imp_photos_review_help: "Revisa los nombres de los trabajos, o une un grupo a un trabajo que ya tienes:",
      imp_photos_count: "fotos",
      imp_group_new: "Crear un trabajo nuevo",
      imp_group_name_ph: "Nombre del trabajo",
      imp_field_city: "Ciudad",
      imp_field_state: "Estado",
      imp_field_zip: "Código postal",
      imp_job_one: "trabajo",
      imp_job_many: "trabajos",
      jp_is_off: "Esta página del trabajo está apagada.",
      jp_reenable: "Volver a activarla",
      jp_try_later: "Algo salió mal — inténtalo de nuevo en un momento.",
      setup_import_row: "¿Vienes de otra app? Trae tus trabajos y fotos",
      jp_menu: "Página del trabajo para el cliente",
      pd_complete_referral: "Pedir una recomendación",
      jp_sheet_title: "Página del trabajo para el cliente",
      jp_sheet_subtitle: "Un enlace privado para este trabajo. Tu cliente ve el horario de la semana, fotos, documentos para firmar y facturas — sin iniciar sesión.",
      jp_copy: "Copiar enlace",
      jp_text: "Enviar por texto",
      jp_email: "Enviar por email", jp_preview: "Ver como cliente",
      jp_rotate: "Enlace nuevo",
      jp_disable: "Apagar",
      jp_link_copied: "Enlace copiado",
      jp_rotated: "Enlace nuevo creado — el anterior ya no funciona.",
      jp_disabled: "Página del trabajo apagada.",
      jp_text_msg: "Aquí está la página de {{name}} — horario, fotos y papeleo en un solo lugar: {{url}}",
      jp_not_found: "Este enlace no es válido.",
      jp_off: "Esta página ha sido desactivada.",
      jp_welcome: "Hola {{name}} — esta es la página de tu trabajo",
      jp_there: "",
      jp_this_week: "Esta semana",
      jp_week_empty: "Nada programado esta semana — vuelve pronto.",
      jp_photos: "Fotos",
      jp_photos_empty: "Aún no hay fotos — aparecerán aquí conforme avance el trabajo.",
      jp_docs: "Documentos para firmar",
      jp_docs_hint: "Toca para revisar y firmar — registramos la fecha automáticamente.",
      jp_sign: "Revisar y firmar",
      jp_invoices: "Facturas",
      jp_balance: "Saldo",
      jp_due: "Vence {{date}}",
      jp_how_to_pay: "Cómo pagar",
      jp_pay_check: "Cheque a nombre de {{to}}, enviar a {{at}}",
      jp_pay_ach: "Transferencia — {{bank}}, ruta {{routing}}, cuenta {{account}}",
      jp_pay_zelle: "Zelle: {{handle}}",
      jp_pay_venmo: "Venmo: {{handle}}",
      jp_pay_cash: "Se acepta efectivo",
      jp_review_t: "¿Cómo lo hicimos?",
      jp_review_d: "Una reseña rápida significa mucho para un negocio pequeño.",
      jp_review_btn: "Dejar una reseña de Google",
      jp_overdue: "Atrasada",
      jp_docs_empty: "Nada que firmar por ahora — los estimados y cambios nuevos aparecerán aquí.",
      jp_inv_empty: "No hay facturas abiertas por ahora.",
      jp_msg_t: "Escríbenos",
      jp_msg_ph: "¿Pregunta sobre el trabajo? Escríbela aquí…",
      jp_msg_send: "Enviar mensaje",
      jp_msg_sent: "¡Enviado! Te responderemos pronto.",
      jp_what_see: "Lo que tu cliente puede ver",
      jp_views: "{{count}} vistas",
      jp_last_viewed: "Visto por última vez {{date}}",
      jp_never_viewed: "Aún no lo abre",
      jp_approved: "Aprobado",
      near_youre_here: "Estás aquí",
      home_youre_at: "Estás en {{name}}",
      notif_nearby_first: "Poner primero el trabajo donde estoy",
      notif_nearby_first_hint: "Cuando abres la app cerca de un trabajo, ese trabajo aparece primero.",
      brand_review_link: "Enlace de reseña de Google",
      brand_review_hint: "Pega tu enlace de reseñas de Google — los clientes felices lo reciben al completar un trabajo.",
      ccam_done: "Listo",
      ccam_import_btn: "Importar",
      land_small_title: "Hecho para contratistas pequeños, no para complejidad empresarial.",
      land_small_body: "Sin módulos que configurar ni consultores. Abre la app, toma una foto, compártela. Esa es toda la curva de aprendizaje.",
      land_small_1_t: "Listo en minutos",
      land_small_1_d: "Crea un proyecto, toma fotos, comparte una galería — antes de que se enfríe tu café.",
      land_small_2_t: "Precio para cuadrillas",
      land_small_2_d: "Un plan simple. Sin ventas adicionales por función ni asientos que no necesitas.",
      land_small_3_t: "Funciona en campo",
      land_small_3_d: "Cola sin conexión, miniaturas rápidas y botones grandes — hecho para guantes y sol.",
      land_gallery_title: "Una galería que tu cliente sí abrirá",
      land_gallery_body: "Cada enlace es una página limpia con tu marca — tu cliente no necesita cuenta.",
      land_gallery_cap_1: "Cimentación",
      land_gallery_cap_2: "Estructura",
      land_gallery_cap_3: "Revestimiento",
      land_gallery_cap_4: "Avance exterior",
      land_gallery_cap_5: "Casi terminado",
      land_gallery_cap_6: "Casa terminada",
      land_gallery_demo_note: "Fotos reales de un proyecto — de principio a fin.",
      land_h1: "Gestión de proyectos de construcción simple para contratistas",
      land_h1_sub: "Gestiona clientes, proyectos, fotos de obra, horarios, cuadrillas, presupuestos y facturas desde una plataforma fácil.",
      seo_home_title: "BuildProject360 — Fotos de obra, costos de trabajo y horarios de cuadrilla",
      seo_home_desc: "Cada foto de obra, con fecha y archivada. Horario de cuadrilla, registros diarios y costos de trabajo en una sola app. Desde $49/mes facturado anual. Gratis por 14 días.",
      v2_nav_features: "Funciones",
      v2_nav_pricing: "Precios",
      v2_nav_login: "Entrar",
      v2_menu: "Menú",
      v2_cta: "Empieza gratis — 14 días",
      v2_cta_short: "Empieza gratis",
      v2_hero_pill: "Para contratistas y cuadrillas pequeñas",
      v2_hero_h1: "Cada foto de obra, con fecha y archivada — antes de que alguien la pida.",
      v2_hero_sub: "Tómala en el sitio y queda ordenada por trabajo con fecha, hora y ubicación. Horario de cuadrilla, registros diarios y costos del trabajo viven en la misma app.",
      v2_hero_line: "Sin tarjeta · Prueba Pro de 14 días · Desde $49/mes facturado anual · Cancela cuando quieras",
      v2_mock_project: "Miller New Home Build",
      v2_mock_addr: "123 East Main St · Columbus, OH",
      v2_mock_today: "Hoy · 6 fotos",
      v2_mock_today_m: "Hoy · 2 fotos",
      v2_mock_saved: "Guardado en Miller New Home Build",
      v2_mock_photo_alt: "Foto de obra con sello de hora y GPS",
      v2_trust: "Hecho por un contratista en Ohio · Inglés y español · Tus fotos son privadas · 3 usuarios incluidos",
      v2_ph_label: "Fotos de obra",
      v2_ph_h2: "Pruebas de cada trabajo. Se encuentran en segundos.",
      v2_ph_body: "Cada foto llega al trabajo correcto con la fecha, hora y ubicación registradas. Cuando el cliente, el inspector o el seguro pregunten, la sacas al momento — sin revisar todo tu carrete.",
      v2_ph_b1: "Cambia de trabajo en la cámara con un toque",
      v2_ph_b2: "Antes y después, por fecha",
      v2_ph_b3: "Toda la cuadrilla fotografía al mismo trabajo",
      v2_sh_label: "Comparte con tu cliente",
      v2_sh_big: "Envía una galería de avance impecable. Olvídate de las llamadas de \"¿cómo va mi trabajo?\".",
      v2_sh_before: "Antes",
      v2_sh_framing: "Estructura",
      v2_sh_after: "Después",
      v2_sh_small: "Un toque envía un enlace con tu marca. Tu cliente lo abre en su teléfono — sin app, sin contraseña.",
      v2_md_label: "Estimados, órdenes de cambio y facturas",
      v2_md_h2: "Del estimado a la factura final — cada dólar rastreado.",
      v2_md_body: "Envía un estimado con tu marca y fotos, obtén la aprobación en línea, factura por avance conforme avanza el trabajo y deja que el cliente pague como prefiera. Las órdenes de cambio se suman al total del contrato para que nada se facture dos veces — ni se olvide.",
      v2_md_s1_t: "Envía el estimado", v2_md_s1_d: "PDF con tu marca o enlace por texto con tus fotos del trabajo. Ves exactamente cuándo lo abre el cliente.",
      v2_md_s2_t: "Obtén la aprobación", v2_md_s2_d: "El cliente aprueba en línea o firma en papel en el sitio. Las órdenes de cambio pasan por el mismo flujo.",
      v2_md_s3_t: "Factura y cobra", v2_md_s3_d: "Facturas de anticipo, avance y fin de obra con las cuentas del contrato hechas por ti. Registra cheque, efectivo, ACH, Zelle o Venmo — o activa pagos con tarjeta cuando quieras.",
      v2_md_pay: "Tus clientes pueden pagar con cheque, ACH, Zelle, Venmo o efectivo — o con tarjeta en línea cuando actives los pagos.",
      v2_md_cap_before: "Antes", v2_md_cap_progress: "En progreso", v2_md_cap_after: "Después",
      v2_md_mock_no: "INV-0004 · Adams Kitchen Remodel", v2_md_mock_status: "Aprobado",
      v2_md_mock_contract: "Contrato", v2_md_mock_invoiced: "Facturado", v2_md_mock_left: "Por facturar",
      v2_md_mock_note: "Panel de facturación por avance — contrato, facturado y restante en vivo en cada trabajo.",
      v2_jc_label: "Costos de obra",
      v2_jc_h2: "Fotografía el recibo. Conoce el costo real de cada trabajo.",
      v2_jc_body: "Fotografía un recibo en el sitio — el Asistente 360 lo lee y lo archiva en el trabajo. Materiales, subcontratistas, rentas, combustible, horas de equipo y millaje se van sumando, para que veas el costo real antes de la factura final.",
      v2_jc_pill1: "Foto del recibo → costo en el trabajo",
      v2_jc_pill2: "15 categorías de costos",
      v2_jc_pill3: "Registros de equipo y millaje",
      v2_jc_card_title: "Costos reales hasta ahora",
      v2_jc_row_materials: "Materiales",
      v2_jc_row_subs: "Subcontratistas",
      v2_jc_row_rental: "Renta y equipo",
      v2_jc_row_disposal: "Limpieza y entregas",
      v2_jc_read: "Recibo leído: Lumber yard · Materiales · agregado al trabajo",
      v2_sc_label: "Horario de cuadrilla",
      v2_sc_h3: "Todos saben dónde estar mañana.",
      v2_sc_body: "Agenda un trabajo en tres toques — Mañana, por la mañana, cuadrilla. Aparece en cada teléfono la noche anterior.",
      v2_sc_row1: "7 AM Estructura · Miller New Home",
      v2_sc_row2: "12 PM Inspección · Johnson Roof",
      v2_a_label: "Asistente 360",
      v2_a_h3: "Di lo que pasó. Aprueba el papeleo.",
      v2_a_quote: "Terminamos el desprendimiento, encontramos seis paneles dañados. Agenda la instalación mañana por la mañana.",
      v2_a_chip1: "Registro diario",
      v2_a_chip2: "Horario",
      v2_a_chip3: "Actualización al cliente",
      v2_a_small: "Nada se guarda ni se envía hasta que lo apruebes.",
      v2_pr_h2: "Dos planes. Toda tu cuadrilla.",
      v2_pr_per_month: "/mes",
      v2_pr_seats: "3 usuarios incluidos · $5/mes por usuario extra",
      v2_pr_note: "La mayoría de las apps de fotos cobran por usuario. Tú recibes tres.",
      v2_pr_f1: "Proyectos y fotos de obra ilimitados",
      v2_pr_f2: "Galerías de avance para clientes",
      v2_pr_f3: "Costos de obra y recibos",
      v2_pr_f4: "Horario de cuadrilla, registros diarios y tarjetas de tiempo",
      v2_pr_f5: "Asistente 360 · Inglés y español",
      v2_pr_under: "Sin tarjeta · Cancela cuando quieras",
      v2_faq_h2: "Preguntas",
      v2_faq_q1: "¿Cómo funciona la prueba gratis?",
      v2_faq_a1: "Tienes acceso completo por 14 días — sin tarjeta por adelantado. Al terminar, elige un plan para seguir trabajando; tus fotos y registros se quedan en su lugar.",
      v2_faq_q2: "¿Cuánto cuesta después?",
      v2_faq_a2: "Essentials: $59/mes o $49/mes facturado anual ($588), 3 usuarios incluidos. Pro: $129/mes o $109/mes facturado anual ($1,308), 5 usuarios incluidos. Usuarios extra $10/mes cada uno.",
      v2_faq_q3: "¿El almacenamiento de fotos es limitado?",
      v2_faq_a3: "Tu plan no tiene límite de fotos y los originales se conservan.",
      v2_faq_q4: "¿Quién puede ver mis fotos?",
      v2_faq_a4: "Solo las personas de tu empresa. Los clientes ven únicamente lo que compartes con un enlace de galería — sin app, sin contraseña — y las ubicaciones registradas de las fotos permanecen dentro de tu cuenta.",
      v2_faq_q5: "¿Cómo la instalo en mi teléfono?",
      v2_faq_a5: "Abre buildproject360.com en el navegador de tu teléfono y elige 'Añadir a pantalla de inicio' — funciona como una app, sin tienda de aplicaciones.",
      v2_faq_q6: "¿Puedo pedir un reembolso?",
      v2_faq_a6: "Si no estás satisfecho, escríbenos dentro de los 30 días de tu primer cargo pagado (mensual o anual) y te lo devolvemos completo. Después, los cargos mensuales no se reembolsan, pero puedes cancelar cuando quieras y conservas el acceso hasta fin de mes. Si un plan anual se renueva y nos escribes dentro de los 7 días del cargo de renovación, te lo devolvemos completo. Los reembolsos vuelven al método de pago original.",
      v2_pr_guarantee: "Garantía de devolución de 30 días en tu primer pago",
      billing_refund_note: "Garantía de devolución de 30 días en tu primer pago · Cancela cuando quieras — conservas el acceso hasta el fin del período pagado",
      footer_address: "BuildProject360 LLC, 2722 Erie Ave Ste 219 PMB 919133, Cincinnati, OH 45208",
      v2_fi_h2: "Cada foto de obra, con fecha y archivada.",
      v2_fi_body: "Configura tu primer trabajo en menos de un minuto.",
      v2_fi_small: "Sin tarjeta · 3 usuarios incluidos",
      v2_fo_rights: "© 2026 BuildProject360",
      seo_login_title: "Iniciar sesión | BuildProject360",
      seo_login_desc: "Entra a tu espacio de trabajo de BuildProject360.",
      seo_signup_title: "Comienza tu prueba gratis de 14 días | BuildProject360",
      seo_signup_desc: "Crea tu cuenta de BuildProject360 — sin tarjeta de crédito.",
      auth_pw_req: "Al menos 8 caracteres",
      auth_pw_show: "Mostrar contraseña",
      auth_pw_hide: "Ocultar contraseña",
      auth_caps_lock: "Bloq Mayús está activado",
      auth_email_invalid: "Ingresa un correo electrónico válido",
      auth_terms_notice_pre: "Al crear una cuenta, aceptas los ",
      auth_terms_link: "Términos de Servicio",
      auth_terms_notice_mid: " y reconoces la ",
      auth_privacy_link: "Política de Privacidad",
      auth_terms_notice_post: ".",
      footer_terms: "Términos de Servicio",
      footer_privacy: "Política de Privacidad",
      sec_team: "Conoce al equipo",
      sec_faq: "Preguntas frecuentes",
      sec_financing: "Financiamiento",
      sec_warranty: "Garantía",
      crew_share_creds_pre: "Comparte estas credenciales con",
      crew_temp_password: "Contraseña temporal",
      hp_no_photos: "Aún no hay fotos",
      hp_no_updates: "Aún no hay actualizaciones",
      ps_unpublished: "Esta página aún no está publicada.",
      web_preview_title: "Vista previa",
      web_preview_desc: "Vista previa del sitio web",
      byl_desc: "Lista de cierre del día",
      admin_attr_title: "Atribución (UTM)",
      admin_attr_accounts: "cuentas atribuidas",
      admin_attr_source: "Fuente",
      admin_attr_medium: "Medio",
      admin_attr_campaign: "Campaña",
      admin_attr_signups: "Registros",
      auth_referral_link: "¿Tienes un código de referido?",
      auth_signup_reassurance: "Empieza a usar BuildProject360 de inmediato. Sin llamada de ventas ni cita de incorporación obligatoria.",
      pricing_honesty_line: "Un plan sencillo. Sin llamada de ventas obligatoria. Sin cargo de instalación. Sin niveles ocultos de funciones.",
      auth_pw_strength: "Seguridad de la contraseña",
      auth_pw_weak: "Débil",
      auth_pw_fair: "Regular",
      auth_pw_good: "Buena",
      auth_pw_strong: "Fuerte",
      auth_pw_common: "Esa contraseña es demasiado común — elige una más larga y única.",
      common_optional: "opcional",
      np_addr_helper: "Busca la dirección del trabajo, o toca \"Usar mi ubicación\" estando en el sitio. Arrastra el pin para ajustar.",
      nav_group_tools: "Configuración y herramientas",
      nav_help: "Ayuda y guías",
      welcome_title: "Configura en minutos",
      welcome_sub: "Una lista opcional de inicio rápido — puedes ocultarla cuando quieras.",
      welcome_step_brand: "Agrega la información de tu empresa",
      welcome_step_customer: "Crea tu primer cliente",
      welcome_step_project: "Crea tu primer proyecto",
      welcome_step_photo: "Agrega tu primera foto",
      welcome_step_share: "Comparte una galería con el cliente",
      welcome_skip: "Omitir por ahora",
      welcome_progress: "{{done}} de {{total}} listos",
      welcome_done_title: "Todo listo — ya estás en marcha",
      welcome_done_sub: "Todo está completo — esta lista se ocultará ahora.",
      help_title: "Ayuda y guías",
      help_search: "Buscar guías rápidas…",
      help_contact: "¿Necesitas ayuda? Busca en nuestras guías rápidas o contáctanos.",
      help_contact_btn: "Contactar soporte",
      help_video_t: "Mira: Cómo navegar BuildProject360",
      ep_title: "Editar proyecto",
      ep_customer: "Cliente",
      ep_remove_customer: "Quitar cliente",
      pd_add_customer: "+ Agregar cliente",
      ep_name: "Nombre del proyecto",
      ep_address: "Dirección",
      ep_address_hint: "Opcional. Busca la dirección, ingrésala manualmente o confirma el punto en el mapa.",
      ep_remove_address: "Quitar dirección",
      ep_name_required: "El nombre del proyecto es obligatorio.",
      ep_saved: "Proyecto actualizado",
      ep_save: "Guardar cambios",
      ep_cancel: "Cancelar",
      sel_clear: "Quitar selección",
      tc_acknowledge: "Confirmar leído",
      tc_ack_hint: "Marca la advertencia como vista — las horas no cambian.",
      u360_pick_worker: "Asigna cada trabajador a un miembro del equipo",
      u360_pick_worker_ph: "Elegir persona",
      help_video_d: "Un recorrido de 3 minutos — un trabajo, de principio a fin.",
      help_watch_clip: "Ver clip",
      help_clip_schedule_t: "Agendar trabajo",
      help_clip_assistant_t: "Dicta una Actualización 360",
      help_reopen_welcome: "Mostrar la lista de bienvenida de nuevo",
      help_g1_t: "Cómo crear un cliente",
      help_g1_b: "Ve a Clientes y toca Nuevo cliente. Un nombre es suficiente para empezar — agrega teléfono, correo y dirección cuando los tengas.",
      help_g2_t: "Cómo crear un proyecto",
      help_g2_b: "Ve a Proyectos y toca Nuevo proyecto. Solo el nombre es obligatorio — agrega cliente y dirección cuando quieras.",
      help_g3_t: "Cómo tomar y organizar fotos",
      help_g3_b: "Abre un proyecto y toca el botón Cámara. Cada foto llega a la pestaña Fotos del proyecto con su fecha y autor.",
      help_g4_t: "Cómo compartir con un cliente",
      help_g4_b: "Abre el proyecto, toca Compartir con el cliente, elige las fotos y envía el enlace. Tu cliente no necesita cuenta ni app.",
      help_g5_t: "Cómo crear un presupuesto",
      help_g5_b: "Ve a Presupuestos y facturas, toca Nuevo presupuesto, agrega partidas, guarda y envía o comparte el enlace de aprobación.",
      help_g6_t: "Cómo invitar a tu cuadrilla",
      help_g6_b: "Ve a Cuadrilla y toca Invitar. Reciben su propio acceso y solo ven los proyectos que les asignes.",
      help_g7_t: "Cómo funciona la facturación",
      help_g7_b: "Dos planes: Essentials $59/mes o $49/mes facturado anual (3 usuarios) y Pro $129/mes o $109/mes facturado anual (5 usuarios). Usuarios extra $10/mes. Prueba gratis de Pro por 14 días, sin tarjeta. Adminístralo en Ajustes › Plan y facturación.",
      cta_trust_line: "Sin tarjeta de crédito • Tres usuarios incluidos • Cancela cuando quieras",
      land_steps_title: "Cómo funciona",
      land_step_1_t: "Crea tu primer proyecto",
      land_step_1_d: "Agrega el cliente, la dirección y las primeras fotos — toma menos de un minuto.",
      land_step_2_t: "Captura avances desde el campo",
      land_step_2_d: "Toma fotos, dicta una nota de voz y registra el trabajo del día desde la obra.",
      land_step_3_t: "Mantén informados a tu cuadrilla y tu cliente",
      land_step_3_d: "Comparte una página limpia con tu marca que tu cliente puede abrir cuando quiera — sin cuenta.",
      land_builtfor_title: "Hecho para",
      land_builtfor_1: "Remodeladores",
      land_builtfor_2: "Techistas",
      land_builtfor_3: "Contratistas generales",
      land_builtfor_4: "Cuadrillas pequeñas",
      land_testi_title: "Lo que dicen los contratistas",
      land_testi_body: "Estamos reuniendo reseñas reales de nuestros primeros clientes.",
      land_testi_placeholder: "Diseñado con contratistas de obra — no con comités de software empresarial.",
      land_sec_title: "Tus datos, protegidos",
      land_sec_1_t: "Privado por defecto",
      land_sec_1_d: "Fotos, datos de clientes y finanzas visibles solo para tu empresa.",
      land_sec_2_t: "Respaldos nocturnos",
      land_sec_2_d: "Respaldos automáticos con verificación, y originales intactos.",
      land_sec_3_t: "Compartir seguro",
      land_sec_3_d: "Enlaces cortos y revocables con contraseña y expiración opcionales.",
      land_faq_title: "Preguntas frecuentes",
      land_faq_1_q: "¿Cómo funciona la prueba de 14 días?",
      land_faq_1_a: "Acceso completo por 14 días. Sin tarjeta — te avisamos antes de que termine.",
      land_faq_2_q: "¿Cuánto cuesta después de la prueba?",
      land_faq_2_a: "$49/mes o $490/año por el plan Completo. Usuarios extra: $5/mes cada uno.",
      land_faq_3_q: "¿Cuántos usuarios incluye?",
      land_faq_3_a: "Incluye 3 usuarios. Usuarios extra: $5/mes cada uno.",
      land_faq_4_q: "¿Hay límite de almacenamiento de fotos?",
      land_faq_4_a: "No. Fotos y video ilimitados — los originales se conservan intactos y las miniaturas cargan rápido en proyectos grandes.",
      land_faq_5_q: "¿Puedo cancelar cuando quiera?",
      land_faq_5_a: "Sí. Cancela desde Plan y facturación en dos toques — tus datos siguen exportables.",
      land_faq_6_q: "¿Cómo lo instalo en mi teléfono?",
      land_faq_6_a: "Abre buildproject360.com, inicia sesión y usa Instalar app — en iPhone: Compartir → Añadir a pantalla de inicio.",
      land_cta_title: "Prueba BuildProject360 gratis por 14 días",
      land_cta_body: "Cada trabajo. Cada foto. Una sola app.",
      sel_del_title: "¿Eliminar {{count}} fotos?",
      sel_del_body: "Las fotos se eliminan de forma segura y se pueden restaurar desde la papelera.",
      zip_started: "Preparando tu ZIP — te avisaremos cuando esté listo.",
      zip_ready: "Tu ZIP está listo — descargando.",
      share_title: "Compartir fotos",
      share_photos_count: "{{count}} fotos",
      share_name: "Título para compartir",
      share_message: "Mensaje (opcional)",
      share_message_ph: "Agrega una nota para el destinatario…",
      share_expires: "Expiración del enlace",
      share_exp_7: "7 días",
      share_exp_30: "30 días",
      share_exp_never: "Sin expiración",
      share_password: "Contraseña (opcional)",
      share_optional: "Opcional",
      share_allow_download: "Permitir descargas",
      share_show_captions: "Incluir descripciones",
      share_watermark: "Agregar marca de agua",
      share_privacy_note: "Las páginas compartidas nunca muestran GPS, notas internas ni comentarios de empleados.",
      share_create_link: "Crear enlace seguro",
      share_copy_link: "Copiar enlace",
      share_text: "Mensaje de texto",
      share_email: "Email",
      share_email_ph: "cliente@email.com",
      share_email_sent: "Email enviado",
      share_preview_page: "Vista previa",
      share_pw_title: "Se requiere contraseña",
      share_pw_body: "Ingresa la contraseña para ver esta galería compartida.",
      share_pw_wrong: "Contraseña incorrecta — inténtalo de nuevo.",
      share_pw_open: "Ver fotos",
      share_invalid: "Este enlace ya no está disponible",
      share_invalid_body: "Puede haber expirado o sido revocado. Pide un enlace nuevo a tu contratista.",
      share_powered_by: "Compartido de forma segura con",
      ms_title: "Administrar enlaces compartidos",
      ms_subtitle: "Copia, edita o revoca cualquier enlace — los cambios aplican al instante.",
      ms_empty: "Aún no hay enlaces. Usa Compartir en la página del proyecto para crear uno.",
      ms_untitled: "Galería compartida",
      ms_by: "por {{name}}",
      ms_views: "{{count}} vistas",
      ms_last_opened: "Última apertura",
      ms_never_opened: "Nunca abierto",
      ms_expires: "Expira",
      ms_downloads_on: "Descargas permitidas",
      ms_downloads_off: "Sin descargas",
      ms_revoke: "Revocar",
      ms_revoked: "Enlace revocado",
      ms_revoked_badge: "Revocado",
      ms_expired_badge: "Expirado",
      ms_active_badge: "Activo",
      ms_active_links: "{{count}} enlaces activos",
      ms_legacy_title: "Enlaces largos antiguos (legado)",
      ms_legacy_jwt: "Enlace de portal antiguo (URL larga)",
      about_title: "Acerca de BuildProject360",
      about_version: "Versión de la app",
      about_build: "Compilación",
      about_updated: "Última actualización",
      about_trouble: "Solución de problemas",
      about_clear_hint: "Borra los archivos en caché y recarga. Mantiene tu sesión; las fotos y notas sin enviar se conservan.",
      about_clear_cache: "Borrar caché y recargar",
      action_see_how: "Explora las funciones",
      nav_product: "Producto",
      nav_features: "Funciones",
      nav_pricing: "Precios",
      nav_for_contractors: "Para contratistas",
      footer_rights: "© 2026 BuildProject360. Todos los derechos reservados.",
      nav_financials: "Dinero",
      nav_reports: "Reportes de costos",
      jr_title: "Reportes de costos",
      jr_subtitle: "Gasto de la empresa, equipos y exportaciones",
      jr_tab_company: "Empresa",
      jr_tab_assets: "Equipos",
      jr_tab_export: "Exportar",
      jr_range: "Rango",
      jr_no_data: "Aún no hay datos de costos en este rango",
      jr_total_spend: "Gasto total",
      jr_receipts: "Recibos",
      jr_labor: "Mano de obra",
      jr_equipment: "Equipo",
      jr_hours_short: "h",
      jr_labor_unpriced: "Las horas están registradas pero sin precio — configura la tarifa interna en Ajustes de costos del proyecto.",
      jr_monthly: "Mes a mes",
      jr_by_category: "Gasto por categoría",
      jr_company_overhead: "Gastos generales (sin asignar)",
      jr_per_project: "Por proyecto",
      jr_overhead: "Gastos generales",
      jr_with_overhead: "incl. gastos generales",
      jr_rented: "Rentado",
      jr_owned: "Propio",
      jr_retired: "Retirado",
      jr_total_cost: "Costo total",
      jr_hours: "Horas",
      jr_cost_per_hour: "Costo / hora",
      jr_utilization: "Días en uso (30d)",
      jr_linked_receipts: "Recibos vinculados",
      jr_miles: "Millas",
      jr_export_hint: "Descarga archivos CSV para tu contador. Los reembolsos exportan como montos negativos.",
      jr_from: "Desde",
      jr_to: "Hasta",
      jr_project: "Proyecto",
      jr_all_projects: "Todos los proyectos",
      jr_download_receipts: "CSV de recibos",
      jr_download_costs: "CSV de costos por proyecto",
      jr_preparing: "Preparando…",
      fin_estimates: "Estimados",
      fin_estimate: "Estimado",
      fin_change_orders: "Órdenes de cambio",
      fin_invoices: "Facturas",
      fin_payments: "Pagos",
      fin_products: "Productos y servicios",
      fin_settings: "Ajustes",
      fin_new_estimate: "Nuevo estimado",
      fin_new_co: "Nueva orden de cambio",
      fin_new_invoice: "Nueva factura",
      fin_record_payment: "Registrar pago",
      fin_status: "Estado",
      fin_number: "Número",
      fin_customer: "Cliente",
      fin_project: "Proyecto",
      fin_total: "Total",
      fin_balance: "Saldo",
      fin_send: "Enviar",
      fin_sent: "Enviado",
      fin_viewed: "Visto",
      fin_approved: "Aprobado",
      fin_declined: "Rechazado",
      fin_changes_requested: "Cambios solicitados",
      fin_draft: "Borrador",
      fin_expired: "Vencido",
      fin_converted: "Convertido",
      fin_archived: "Archivado",
      fin_voided: "Anulado",
      fin_paid: "Pagado",
      fin_partial: "Parcialmente pagado",
      fin_partially_paid: "Parcialmente pagado",
      fin_refunded: "Reembolsada",
      fin_overdue: "Vencida",
      fin_invoiced: "Facturado",
      fin_invoiced_n: "Facturado · {{n}}",
      fin_line_items: "Partidas",
      fin_add_item: "Añadir partida",
      fin_add_section: "Añadir sección",
      fin_from_library: "De la biblioteca",
      fin_from_pricebook: "Del catálogo de precios",
      fin_save_to_library: "Guardar en biblioteca",
      fin_item_name: "Nombre del artículo",
      fin_description: "Descripción",
      fin_qty: "Cant.",
      fin_unit: "Unidad",
      fin_unit_price: "Precio unitario",
      fin_section: "Sección",
      fin_optional: "Opcional",
      fin_hide_qty: "Ocultar cant.",
      fin_hide_price: "Ocultar precio",
      fin_taxable: "Gravable",
      fin_subtotal: "Subtotal",
      fin_discount: "Descuento",
      fin_tax: "Impuesto",
      fin_message: "Mensaje para el cliente",
      fin_internal_notes: "Notas internas (el cliente no las ve)",
      fin_terms: "Términos y condiciones",
      fin_expires: "Fecha de vencimiento",
      est_cust_switch: "¿Cambiar el cliente a {{name}} (vinculado a {{project}})?",
      est_cust_switch_yes: "Cambiar cliente",
      est_cust_switch_no: "Mantener actual",
      signup_welcome_sending: "Cuenta lista — un correo de bienvenida va en camino a {{email}}.",
      est_loading: "Cargando estimado…",
      est_load_failed: "No pudimos cargar este estimado. Revisa tu conexión e inténtalo de nuevo.",
      action_retry: "Reintentar",
      action_back: "Volver",
      help_resend_welcome: "Reenviar correo de bienvenida",
      help_resend_sent: "Correo de bienvenida enviado a {{email}}. Revisa tu bandeja de entrada y spam.",
      help_resend_failed: "No se pudo enviar el correo ahora. Inténtalo de nuevo en unos minutos o contacta soporte.",
      fin_salesperson: "Vendedor",
      fin_title: "Título",
      fin_date: "Fecha",
      fin_save_draft: "Guardar borrador",
      fin_preview: "Vista previa del cliente",
      fin_convert: "Convertir en proyecto",
      fin_version: "Versión",
      fin_activity: "Actividad",
      fin_awaiting: "Estimados pendientes de aprobación",
      fin_approved_count: "Estimados aprobados",
      fin_open_value: "Valor de estimados abiertos",
      fin_outstanding: "Facturas pendientes",
      fin_overdue_count: "Facturas vencidas",
      fin_payments_month: "Pagos de este mes",
      fin_co_awaiting: "Órdenes de cambio pendientes",
      fin_active_contracts: "Valor de contratos activos",
      fin_original_contract: "Contrato original",
      fin_approved_cos: "Órdenes de cambio aprobadas",
      fin_current_contract: "Contrato actual",
      fin_invoiced: "Facturado",
      fin_paid_total: "Total pagado",
      fin_remaining_invoice: "Restante por facturar",
      fin_amount: "Monto",
      fin_method: "Método",
      fin_reference: "Referencia / # de cheque",
      fin_date_received: "Fecha recibida",
      fin_notes: "Notas",
      fin_receipt: "Recibo",
      fin_download_pdf: "Descargar PDF",
      fin_portal_approve: "Aprobar y firmar",
      fin_portal_decline: "Rechazar",
      fin_portal_request_changes: "Solicitar cambios",
      fin_portal_question: "Hacer una pregunta",
      fin_portal_fullname: "Tu nombre legal completo",
      fin_portal_signature: "Escribe tu firma",
      fin_portal_consent_est: "Al firmar abajo, confirmo que revisé y apruebo este estimado, incluyendo el trabajo seleccionado, precios, términos y calendario de pagos.",
      fin_portal_consent_co: "Al firmar abajo, autorizo este cambio al alcance del proyecto, monto del contrato y calendario como se describe arriba.",
      fin_portal_approved_msg: "¡Gracias! Tu aprobación ha sido registrada.",
      fin_empty_estimates: "Sin estimados aún",
      fin_empty_co: "Sin órdenes de cambio aún",
      fin_empty_invoices: "Sin facturas aún",
      fin_empty_payments: "Sin pagos aún",
      fin_empty_products: "Sin productos o servicios aún",
      nav_time: "Tiempo",
      tc_start_day: "Empezar mi día",
      tc_clock_in: "Registrar entrada",
      tc_clock_out: "Registrar salida",
      tc_break_start: "Iniciar descanso",
      tc_break_end: "Terminar descanso",
      tc_switch: "Cambiar de proyecto",
      tc_morning_plan: "Plan de la mañana",
      tc_evening_update: "Resumen de la tarde",
      tc_day_update: "Actualización",
      tc_working_since: "Trabajando desde",
      tc_working: "Trabajando",
      tc_on_break: "En descanso",
      tc_not_clocked: "Sin registrar entrada",
      tc_suggested: "Proyecto más cercano",
      tc_none_nearby: "No hay proyectos cerca de tu ubicación actual. Tu supervisor verá tu registro de todas formas.",
      tc_pick_manual: "Elige tu proyecto",
      tc_no_projects: "Aún no hay proyectos activos — pide a tu supervisor que te asigne uno.",
      viewer_favorite: "Favorita",
      viewer_unfavorite: "Quitar favorita",
      pd_no_map: "No pudimos ubicar esta dirección — revisa la escritura o ajusta el pin manualmente.",
      pd_no_map_none: "Aún no hay dirección del trabajo — agrega la dirección o suelta un pin para ubicar este proyecto.",
      pd_add_address: "Agregar dirección",
      fin_unlinked: "Sin cliente ni proyecto vinculado",
      tc_confirm_project: "Confirmar proyecto",
      tc_choose_other: "Elegir otro proyecto",
      tc_away_title: "Parece que no estás en el proyecto seleccionado",
      tc_away_distance: "Distancia actual al proyecto",
      tc_reason: "Motivo",
      tc_reason_materials: "Recogiendo materiales",
      tc_reason_shop: "Taller de la empresa",
      tc_reason_meeting: "Reunión con el cliente",
      tc_reason_customer_meeting: "Reunión con el cliente",
      tc_reason_driving: "En camino al proyecto",
      tc_reason_remote: "Trabajo remoto",
      tc_reason_inaccurate: "Ubicación imprecisa",
      tc_reason_other: "Otro",
      tc_loc_unavailable: "Ubicación no disponible",
      tc_needs_review: "Necesita revisión",
      tc_missed_title: "¿Sigues trabajando?",
      tc_missed_body: "Aún tienes la entrada registrada. ¿Sigues trabajando?",
      tc_still_working: "Sí, sigo trabajando",
      tc_clock_out_now: "Registrar salida ahora",
      tc_request_correction: "Solicitar corrección",
      tc_correction_reason: "Motivo de la corrección",
      tc_correction_sent: "Corrección solicitada",
      tc_privacy_title: "Aviso de ubicación y tiempo",
      tc_privacy_ack: "Entendido",
      tc_production: "Producción (opcional)",
      tc_prod_item: "Partida de trabajo",
      tc_prod_qty: "Cantidad",
      tc_saved_morning_plan: "Plan de la mañana guardado", tc_saved_evening_update: "Resumen de la tarde guardado", tc_saved_day_update: "Actualización guardada",
      cl_photo_required: "Foto requerida", pd_prod_of: "de",
      tc_prod_target: "Meta",
      tc_all_local: "Todos los horarios se muestran en la zona horaria local del proyecto.",
      tc_proof_report: "Informe de prueba del proyecto",
      tc_ai_summary: "Resumen diario IA",
      tc_ai_draft: "Borrador — requiere revisión del gerente",
      tc_no_summaries: "Aún no hay resúmenes.",
      tc_approve: "Aprobar",
      tc_share_customer: "Compartir con el cliente",
      tc_keep_internal: "Mantener interno",
      tc_generate: "Generar resumen",
      tc_labor_est: "Horas estimadas",
      tc_labor_actual: "Horas reales",
      tc_labor_remaining: "Horas restantes",
      tc_on_track: "En tiempo",
      tc_watch: "Atención",
      tc_over: "Sobre lo estimado",
      feat_customers: "Gestión de clientes", feat_customers_d: "Cada cliente, teléfono, correo y dirección en un solo lugar.",
      feat_projects: "Gestión de proyectos", feat_projects_d: "Sigue cada trabajo desde la primera llamada hasta la foto final.",
      feat_photos: "Fotos de obra", feat_photos_d: "Cámara rápida, antes/después y la línea de tiempo completa del proyecto.",
      feat_schedule: "Agenda", feat_schedule_d: "Vistas de hoy, semana y cronograma que toda la cuadrilla entiende.",
      feat_crew: "Gestión de cuadrilla", feat_crew_d: "Invita a tu equipo y asígnalo a proyectos en segundos.",
      feat_estimates: "Estimados y facturas", feat_estimates_d: "Estimados y facturas profesionales sin papeleo.",
      feat_payments: "Pagos de clientes", feat_payments_d: "Cobra más rápido con pagos en línea simples.",
      feat_website: "Sitio web del contratista", feat_website_d: "Un sitio web con tu marca, tus trabajos, reseñas y solicitudes de estimado.",
      feat_leads: "Prospectos y referidos", feat_leads_d: "Captura prospectos de tu sitio web y crece con referidos.",
      why_1_title: "Fotos con la obra",
      why_1_desc: "Cada foto vinculada a un proyecto con fecha, hora, GPS y notas.",
      why_2_title: "Registros por voz",
      why_2_desc: "Presiona el micrófono y habla. El clima se adjunta solo.",
      why_3_title: "Portal del cliente",
      why_3_desc: "Página con enlace privado, con avances y fotos.",
      why_4_title: "Bilingüe EN / ES",
      why_4_desc: "Toda la app, desde el día uno.",
      auth_email: "Correo",
      auth_password: "Contraseña",
      auth_name: "Tu nombre",
      crew_name: "Nombre",
      auth_company: "Nombre de la empresa",
      auth_login_title: "Inicia sesión en BuildProject360",
      auth_register_title: "Crea tu cuenta de BuildProject360",
      auth_have_account: "¿Ya tienes cuenta?",
      auth_no_account: "¿Nuevo aquí?",
      auth_referral_code: "Código de referido (opcional)",
      auth_referral_placeholder: "ej. BF-ACME-1A2B",
      auth_continue_google: "Continuar con Google",
      auth_or: "o",
      auth_signing_in: "Iniciando sesión…",
      auth_google_failed: "No se pudo completar el inicio de sesión con Google. Inténtalo de nuevo.",
      ref_title: "Refiere y gana",
      ref_subtitle: "Tu plan base mensual de $49 es gratis mientras tres contratistas referidos sigan como clientes de pago activos.",
      ref_your_code: "Tu código de referido",
      ref_copy: "Copiar",
      ref_copied: "¡Copiado!",
      ref_share_hint: "Comparte este enlace — precarga tu código al registrarse:",
      ref_how_title: "Cómo funciona",
      ref_how_1: "Comparte tu enlace, código o QR con contratistas que conozcas",
      ref_how_2: "Ellos reciben su primer mes de pago gratis; califican para ti tras 60 días de pago",
      ref_how_3: "Cada referido calificado descuenta 1/3 de tu plan base — 3 o más y es gratis",
      ref_list_title: "Tus referidos",
      ref_empty_title: "Sin referidos aún",
      ref_empty_hint: "Comparte tu código con contratistas que conozcas. Cuando tres sean clientes de pago activos, tu plan base de $49 es gratis.",
      ref_monthly_total: "Créditos mensuales",
      ref_cap_note: "Los créditos tienen un tope del precio de tu plan ({{cap}}/mes en {{plan}}).",
      ref_offer: "Cada contratista que refieras y que siga siendo cliente de pago activo por más de 60 días te descuenta 1/3 de tu plan base — 1 referido = 1/3 de descuento, 2 = 2/3, 3 o más y tu plan base es gratis.",
      ref_link: "Tu enlace de referido",
      ref_copy_link: "Copiar enlace",
      ref_share_text: "Compartir por texto",
      ref_share_email: "Compartir por correo",
      ref_share_subject: "Prueba BuildProject360",
      ref_share_body: "Uso BuildProject360 para mis obras — fotos, bitácoras, estimados, todo. Pruébalo gratis 14 días: {{link}}",
      ref_total: "Referidos totales",
      ref_pending: "Pendientes",
      ref_qualified: "Calificados activos",
      ref_current_credit: "Recompensa de referido",
      ref_reward_free: "GRATIS",
      ref_credit_off: "{{pct}}% dto. en plan base",
      ref_of_3: "de 3",
      ref_progress_0: "0 de 3 referidos activos",
      ref_progress_1: "Has referido 1 — 1/3 de descuento en tu plan base",
      ref_progress_2: "Has referido 2 — 1 más y BuildProject360 es gratis",
      ref_progress_3: "3 de 3 referidos activos — Tu plan base de $49 es gratis",
      ref_status_pending: "Pendiente",
      ref_status_qualified: "Calificado",
      ref_status_canceled: "Cancelado",
      ref_status_rejected: "Rechazado",
      ref_status_disqualified: "Descalificado",
      ref_qualify_note: "Un referido califica cuando la empresa ha sido cliente de pago activo durante 60 días. El descuento aplica solo al plan base, nunca a asientos extra. Las empresas referidas reciben su primer mes de pago gratis.",
      ref_status_active: "Activo",
      ref_status_cancelled: "Cancelado",
      ref_since: "Desde",
      leads_title: "Prospectos",
      leads_subtitle: "Sigue cada oportunidad desde la primera llamada hasta el contrato.",
      lead_new: "Nuevo prospecto",
      lead_name: "Nombre del cliente",
      lead_phone: "Teléfono",
      lead_email_addr: "Correo",
      lead_address: "Dirección de la obra",
      lead_source: "Origen (referido, letrero…)",
      lead_notes: "Notas",
      lead_status_new: "Nuevo",
      lead_status_quoted: "Cotizado",
      lead_status_won: "Ganado",
      lead_status_lost: "Perdido",
      lead_convert: "Convertir a proyecto",
      lead_converted: "Convertido",
      lead_empty_title: "Sin prospectos aún",
      lead_empty_hint: "Añade tu primer prospecto — al cerrarlo, conviértelo en proyecto con un toque.",
      sched_week: "Semana",
      sched_list: "Lista",
      photo_details: "Detalles de la foto",
      photo_pair_with: "Emparejar con…",
      photo_before: "Antes",
      photo_after: "Después",
      photo_unpair: "Quitar emparejamiento",
      photo_none: "Sin pareja",
      photo_delete_confirm: "¿Eliminar esta foto?",
      offline_saved: "Guardado sin conexión — se sincronizará al volver en línea",
      offline_synced: "{{count}} elemento(s) sincronizados",
      offline_synced_one: "{{count}} elemento sincronizado",
      crew_assign: "Asignar proyectos",
      crew_assigned_projects: "Proyectos asignados",
      crew_assign_hint: "El equipo solo ve sus proyectos asignados.",
      nav_leads: "Prospectos",
      filter_all: "Todos",
      tab_logs: "Registros",
      tab_tasks: "Tareas",
      lead_followup: "Próximo seguimiento",
      lead_value: "Valor estimado",
      lead_type: "Tipo de proyecto",
      lead_assigned: "Vendedor asignado",
      lead_last_contact: "Último contacto",
      lead_activity: "Actividad",
      lead_add_note: "Añadir nota",
      lead_note_placeholder: "Llamé, dejé mensaje…",
      lead_call: "Llamar",
      lead_text: "Mensaje",
      lead_email_btn: "Correo",
      lead_more: "Más detalles",
      lead_less: "Menos detalles",
      lead_overdue: "Seguimiento vencido",
      sched_prev: "Semana anterior",
      sched_next: "Semana siguiente",
      sched_today: "Hoy",
      cal_prefs_title: "Preferencias del calendario",
      cal_week_start: "La semana empieza el",
      cal_sunday: "domingo",
      cal_monday: "lunes",
      cal_workweek: "Semana laboral",
      cal_workweek_5: "5 días (lun–vie)",
      cal_workweek_7: "7 días",
      cal_weekend_hint: "Los trabajos de fin de semana siempre se muestran — solo se atenúan.",
      sched_save_target: "Revisa antes de guardar",
      sched_project_unavailable: "Proyecto no disponible — elige otro",
      sched_event_type: "Tipo de evento",
      sched_type_project: "Para un trabajo",
      sched_type_company: "Toda la empresa — reunión, día libre, capacitación, etc.",
      pd_schedule_this_job: "+ Agendar este trabajo",
      sched_quick_today: "Hoy",
      sched_quick_tomorrow: "Mañana",
      sched_quick_pick: "Elegir fecha",
      sched_time_allday: "Todo el día",
      sched_time_morning: "Mañana, 7:00 AM–12:00 PM",
      sched_time_afternoon: "Tarde, 12:00 PM–5:00 PM",
      sched_time_custom: "Hora personalizada",
      sched_time_label: "Hora",
      sched_title_optional: "opcional — usa el nombre del trabajo",
      action_navigate: "Navegar",
      sched_company_note: "Evento de empresa — no vinculado a un proyecto",
      sched_pick_project_hint: "Elige un proyecto o cambia a Evento de empresa",
      sched_no_crew: "Sin cuadrilla",
      sched_no_projects_hint: "Aún no hay proyectos — cambia a Evento de empresa",
      photo_getting_loc: "Obteniendo ubicación…",
      photo_proof_title: "Prueba de la foto",
      photo_captured: "Capturada",
      photo_taken_by: "Tomada por",
      photo_loc_none: "Ubicación no capturada para esta foto",
      proof_verified: "Ubicación GPS registrada",
      proof_outside_project: "GPS registrado — fuera del área del proyecto",
      proof_low_accuracy: "Ubicación de baja precisión",
      proof_imported: "Ubicación importada (del archivo)",
      proof_project_only: "Solo ubicación del proyecto — esta foto no tiene GPS propio",
      proof_none: "Ubicación no capturada",
      proof_unverified: "Foto no verificada — no se capturó la ubicación",
      photo_loc_not_in_file: "Ubicación no disponible en este archivo",
      proof_tz: "Zona horaria",
      proof_coords: "Coordenadas GPS",
      proof_loc_source: "Fuente de ubicación",
      proof_ls_gps: "GPS del dispositivo al capturar",
      proof_ls_denied: "Permiso denegado",
      proof_ls_timeout: "Se agotó el tiempo del GPS",
      proof_ls_unavailable: "Ubicación no disponible",
      proof_ls_exif: "Metadatos EXIF del archivo",
      proof_ls_none: "No capturada",
      proof_privacy: "Compartir con clientes",
      proof_privacy_exact: "Los clientes ven la ubicación exacta",
      proof_privacy_approx: "Los clientes ven una ubicación aproximada",
      proof_privacy_project: "Los clientes no ven la ubicación de la foto (solo proyecto)",
      proof_privacy_hidden: "Ubicación oculta para los clientes",
      proof_download_stamped: "Descargar copia sellada",
      pp_gps_verified: "Ubicación GPS registrada",
      pp_gps_outside: "GPS registrado — fuera del área del proyecto",
      pp_project_short: "Solo ubicación del proyecto",
      pp_project_pin: "ubicación del proyecto",
      proof_hidden: "Ubicación registrada · detalles ocultos",
      pp_accuracy: "Precisión ±{{ft}} pies ({{m}} m)",
      viewer_close_photo: "Cerrar foto",
      gallery_proof_title: "Presentación de prueba en galería",
      gallery_proof_below: "Debajo de la foto (recomendado)",
      gallery_proof_on_photo: "Sobre la foto",
      gallery_proof_hidden: "Oculta en la galería",
      gallery_proof_note: "Controla solo lo que ven los visitantes: los datos GPS y el estado de verificación nunca cambian. Las descargas y exportaciones conservan el sello de prueba.",
      stamp_allow_original: "Permitir que usuarios de oficina descarguen originales intactos",
      projects_slow: "Los proyectos tardan más de lo esperado",
      projects_offline: "Parece que estás sin conexión. Revisa tu conexión.",
      projects_load_error: "No pudimos cargar tus proyectos.",
      projects_retry: "Reintentar",
      viewer_scroll_more: "Desplázate para ver más detalles de prueba",
      sched_more_events: "Mostrar los {{n}} eventos más de este día",
      sched_more_suffix: "más",
      queue_title: "Cola sin conexión",
      queue_sync_now: "Sincronizar ahora",
      queue_retry_failed: "Reintentar fallidos",
      queue_pending: "Pendiente",
      queue_uploading: "Subiendo…",
      queue_uploaded: "Subido",
      queue_failed: "Falló",
      cam_gps_ok: "GPS ±{{m}} m",
      cam_gps_search: "Localizando…",
      cam_gps_none: "Sin GPS — la foto no estará verificada",
      cam_gps_denied: "Ubicación denegada — la foto no estará verificada",
      stamp_title: "Sello de prueba de foto",
      stamp_body: "Graba una barra compacta de prueba de hora y ubicación en las copias selladas para galerías de clientes, descargas e informes. Las fotos originales nunca se modifican.",
      stamp_share_default: "Sellar fotos compartidas con clientes",
      stamp_show_logo: "Mostrar logo 360",
      stamp_show_company: "Mostrar nombre de la empresa",
      stamp_show_project: "Mostrar nombre del proyecto",
      stamp_show_photographer: "Mostrar fotógrafo",
      stamp_show_accuracy: "Mostrar precisión GPS",
      stamp_position: "Posición del sello",
      stamp_pos_bar: "Barra inferior completa",
      stamp_pos_bl: "Abajo a la izquierda",
      stamp_pos_bc: "Abajo al centro",
      stamp_pos_br: "Abajo a la derecha",
      stamp_download_default: "Descargas",
      stamp_dl_ask: "Preguntar cada vez",
      stamp_dl_always: "Selladas por defecto",
      stamp_dl_never: "Solo originales",
      stamp_preview: "Vista previa del sello",
      stamp_reset: "Restablecer recomendados",
      stamp_none_hint: "Agrega una foto primero para ver el sello",
      stamp_on: "Sí",
      stamp_off: "No",
      viewer_view_original: "Original",
      viewer_view_stamped: "Sellada",
      download_original: "Descargar original",
      sel_download_stamped: "Copias selladas",
      sel_proof_report: "Informe de prueba",
      share_trust_verified: "{{v}} de {{t}} fotos con GPS registrado",
      share_trust_low: "{{n}} foto(s) con GPS de baja precisión",
      share_trust_nocap: "{{n}} foto(s) sin ubicación capturada",
      photo_accuracy: "Precisión GPS: ~{{ft}} pies",
      photo_distance: "a {{d}} de la ubicación del proyecto",
      photo_distance_warn: "La foto se capturó a {{d}} de la ubicación del proyecto",
      photo_open_maps: "Abrir la ubicación de la foto en Google Maps",
      photo_tech: "Detalles técnicos",
      photo_uploaded_at: "Subida",
      photo_source_camera: "Cámara de la app",
      photo_source_upload: "Subida desde el dispositivo",
      photo_source_import: "Importada",
      photo_loc_privacy: "Ubicación de fotos en enlaces de cliente",
      photo_loc_exact: "Ubicación exacta",
      photo_loc_approx: "Ubicación aproximada",
      photo_loc_project: "Solo nombre del proyecto",
      photo_loc_hidden: "Oculta",
      sched_start: "Inicio",
      sched_end: "Fin",
      sched_crew: "Equipo asignado",
      sched_title_label: "Título",
      sched_work_title: "Programar trabajo",
      sched_project_or_job: "Proyecto o trabajo",
      sched_project_ph: "Elige un proyecto",
      sched_no_project: "Sin proyecto (evento de la empresa)",
      sched_what_label: "¿Qué está programado?",
      sched_what_ph: "Instalación de techo, inspección, entrega de material…",
      sched_what_required: "Ingresa el trabajo programado.",
      sched_add_time_optional: "Añadir hora (opcional)",
      sched_assigned_crew: "Equipo asignado",
      sched_add_action: "Añadir a la agenda",
      sched_date_label: "Fecha",
      sched_project_label: "Proyecto",
      proj_phone: "Teléfono del cliente",
      proj_type: "Tipo de proyecto",
      proj_contract: "Valor del contrato",
      proj_source: "Origen del prospecto",
      proj_more: "Más detalles",
      proj_less: "Menos detalles",
      proj_crew: "Equipo asignado",
      proj_start: "Fecha de inicio",
      proj_end: "Finalización prevista",
      task_due: "Fecha límite",
      task_assignee: "Asignado a",
      task_priority: "Prioridad",
      task_low: "Baja",
      task_medium: "Media",
      task_high: "Alta",
      task_overdue: "Vencida",
      task_add_placeholder: "Añade una tarea…",
      task_add: "Añadir",
      task_empty: "Sin tareas aún",
      task_photo: "Adjuntar foto",
      common_delete: "Eliminar",
      common_edit: "Editar",
      photos_search: "Buscar notas, etiquetas…",
      photos_cat: "Categoría",
      photos_uploaded_by: "subido por",
      photos_progress: "Avance",
      photos_download: "Descargar",
      photos_report: "Reporte PDF",
      photos_retry: "Reintentar subidas pendientes",
      log_transcribing: "Transcribiendo…",
      not_authorized: "No autorizado",
      not_authorized_leads: "Los prospectos son visibles solo para dueños y administradores.",
      see_all: "Ver todo",
      share_generate: "Generar enlace",
      share_copy_link: "Copiar enlace",
      sched_gantt: "Gantt",
      gantt_no_dates: "Define fechas de inicio/fin en el proyecto para verlo aquí",
      action_take_photo: "Tomar foto",
      action_record_video: "Grabar video",
      photos_add_to: "Añadir al proyecto",
      gantt_days: "Días",
      gantt_months: "Meses",
      gantt_pick_project: "Elige un proyecto primero",
      gantt_title: "Horario del proyecto (Gantt)",
      gantt_open: "Abrir Gantt",
      gantt_hide: "Ocultar Gantt",
      gantt_workdays: "días hábiles",
      gantt_unassigned: "Sin asignar",
      gantt_mode_simple: "Simple",
      gantt_mode_advanced: "Avanzado",
      gantt_critical: "Crítica",
      gantt_templates_btn: "Empezar desde plantilla",
      gantt_tpl_title: "Plantillas de fases",
      gantt_tpl_hint: "Elige una plantilla para generar un cronograma por fases. Las fechas se ajustan a tu calendario de trabajo.",
      gantt_phases_count: "fases",
      gantt_finish_by: "Fecha de finalización",
      gantt_plan_confirm: "Agregar al cronograma",
      gantt_plan_added: "Cronograma de fases agregado",
      sched_need_project: "Elige un proyecto primero",
      tpl_roof: "Reemplazo de techo",
      tpl_kitchen: "Remodelación de cocina",
      tpl_bath: "Remodelación de baño",
      tpl_r_1: "Demolición", tpl_r_2: "Revisión y reparación de entablado", tpl_r_3: "Membrana y tapajuntas", tpl_r_4: "Instalación de tejas", tpl_r_5: "Limpieza y recorrido final",
      tpl_k_1: "Demolición", tpl_k_2: "Plomería y electricidad preliminar", tpl_k_3: "Drywall y pintura", tpl_k_4: "Gabinetes y cubiertas", tpl_k_5: "Pisos", tpl_k_6: "Lista de pendientes",
      tpl_b_1: "Demolición", tpl_b_2: "Instalación preliminar", tpl_b_3: "Azulejos e impermeabilización", tpl_b_4: "Accesorios y acabados",
      signup_trades_label: "¿Qué tipo de trabajo haces?",
      signup_trades_hint: "Elige los que apliquen — prepararemos las plantillas adecuadas para tus trabajos.",
      brand_trades_hint: "Estas selecciones impulsan las plantillas de cronograma recomendadas.",
      gantt_tpl_recommended: "Para tu oficio",
      gantt_tpl_all: "Todas las plantillas",
      gantt_tpl_custom: "Tus plantillas guardadas",
      gantt_tpl_size: "Tamaño del trabajo",
      gantt_tpl_size_s: "Chico", gantt_tpl_size_m: "Mediano", gantt_tpl_size_l: "Grande",
      gantt_tpl_start: "Fecha de inicio", gantt_tpl_start_job: "Usa la fecha de inicio del trabajo ({{date}})",
      gantt_tpl_milestone: "Hito",
      gantt_tpl_included: "Incluida", gantt_tpl_skipped: "Omitida",
      gantt_tpl_save_as: "Guardar el cronograma de este trabajo como plantilla",
      gantt_tpl_save_name_ph: "Nombre de la plantilla",
      gantt_tpl_saved: "Plantilla guardada",
      gantt_tpl_preview: "Vista previa de fechas",
      gantt_tpl_delete: "Eliminar plantilla",
      gantt_tpl_no_phases: "Este trabajo aún no tiene fases",
      gantt_kind: "Tipo", gantt_kind_task: "Tarea", gantt_kind_wait: "Espera", gantt_kind_inspection: "Inspección", gantt_kind_delivery: "Entrega", gantt_kind_milestone: "Hito",
      gantt_counts_weekends: "Cuenta fines de semana (curado/secado)",
      gantt_inspector_name: "Nombre del inspector", gantt_inspector_phone: "Teléfono del inspector", gantt_permit_no: "Permiso #",
      gantt_supplier: "Proveedor", gantt_po: "PO / pedido #", gantt_lead_days: "Tiempo de entrega (días hábiles)",
      gantt_baseline_behind: "{{n}} días hábiles de atraso", gantt_on_track: "En tiempo",
      gantt_rebaseline: "Nueva línea base", gantt_rebaseline_ph: "Motivo (ej. orden de cambio #2)", gantt_rebaseline_done: "Línea base actualizada",
      sheet_pass: "Aprobar", sheet_fail: "Reprobar", sheet_passed: "Inspección aprobada",
      sheet_fail_what: "¿Qué falló?", sheet_fix_days: "La corrección toma (días)",
      sheet_fail_preview: "Ver impacto", sheet_fail_apply: "Aplicar", sheet_fail_adjust: "Lo ajusto yo",
      sheet_fail_impact: "Empuja {{n}} fase(s) · {{days}} días hábiles más · nuevo fin {{date}}",
      sheet_fail_adds: "Corrección", sheet_fail_reinspect: "Reinspección",
      sheet_failed_flagged: "Reprobada — Corrección + reinspección agregadas",
      sheet_received: "Recibido", sheet_order_by: "Pedir antes de",
      sheet_delay_reason: "¿Por qué el retraso?", sheet_delay_caused: "¿Quién lo causó?",
      delay_reason_weather: "Clima", delay_reason_inspection: "Inspección", delay_reason_materials: "Materiales",
      delay_reason_customer: "Cliente / CO", delay_reason_sub_crew: "Sub / Cuadrilla", delay_reason_permit: "Permiso", delay_reason_other: "Otro",
      delay_cause_us: "Nosotros", delay_cause_customer: "Cliente", delay_cause_sub: "Subcontratista", delay_cause_supplier: "Proveedor", delay_cause_weather: "Clima / Fuerza mayor",
      sheet_delay_apply: "Aplicar retraso", sheet_delayed: "Retrasado +{{n}}d",
      filter_inspections: "Inspecciones", filter_deliveries: "Entregas",
      myday_order_by: "Pedir antes de {{date}}",
      gantt_tpl_which_job: "¿En qué trabajo?",
      gantt_tpl_add_to: "Agregar a {{name}}",
      sheet_fail_type_ph: "Escribe qué falló…",
      pd_start_from_template: "Empezar desde plantilla",
      pd_add_single_event: "Agregar un evento suelto",
      cs_trades_none: "Aún sin oficios elegidos",
      cs_trades_count: "{{count}} oficios elegidos",
      wc_title: "Calendario laboral de la empresa",
      wc_body: "Define los días, horarios y feriados. El Asistente 360 lo usa para horarios de 'solo días hábiles'.",
      wc_workdays: "Días laborales",
      wc_start: "Inicio del día",
      wc_end: "Fin del día",
      wc_holidays: "Feriados / días no laborales",
      wc_add: "Agregar",
      wc_mon: "Lun", wc_tue: "Mar", wc_wed: "Mié", wc_thu: "Jue", wc_fri: "Vie", wc_sat: "Sáb", wc_sun: "Dom",
      aa_title: "Actividad del Asistente",
      aa_body: "Cada solicitud, acción propuesta, confirmación y resultado — para dueños y administradores.",
      aa_empty: "Aún no hay actividad del asistente.",
      aa_records: "Registros afectados",
      nav_activity: "Actividad del Asistente",
      billing_title: "Facturación",
      billing_subtitle: "Elige el plan que le quede a tu cuadrilla. Cada plan empieza con 14 días gratis de Pro — sin tarjeta.",
      billing_current: "Plan actual",
      billing_manage: "Administrar facturación",
      billing_popular: "Popular",
      billing_subscribe: "Prueba gratis",
      billing_current_plan: "Plan actual",
      billing_feat_projects: "Proyectos y fotos ilimitados",
      billing_feat_portal: "Portal del cliente + registros por voz",
      billing_feat_bilingual: "Bilingüe EN/ES",
      billing_trial_ends: "La prueba termina",
      billing_grace_until: "Solo lectura después del",
      billing_trial_note: "Precio fundador: suscríbete durante la beta y conserva este precio por 12 meses. Cancela cuando quieras.",
      billing_banner_past_due: "Problema con el pago — actualiza tu tarjeta para mantener el acceso",
      billing_banner_canceled: "Suscripción cancelada — tu cuenta será de solo lectura tras el periodo de gracia",
      billing_complete_plan: "BuildProject360 Complete",
      billing_per_month: "/mes",
      billing_per_year: "/año",
      billing_monthly: "Mensual",
      billing_annual: "Anual",
      billing_annual_save: "Ahorra $98 — dos meses gratis",
      billing_trial_cta: "Empieza gratis por 14 días",
      billing_no_card: "Sin tarjeta. Cancela cuando quieras.",
      billing_users_included: "Tres usuarios incluidos",
      billing_extra_user: "Solo $5/mes por usuario adicional",
      billing_extra_user_year: "Usuarios adicionales $50/año cada uno",
      billing_subscribe_now: "Cambiar a esta facturación",
      billing_plan_essentials: "Essentials",
      billing_plan_pro: "Pro",
      billing_founding_badge: "Miembro fundador · precio fijo de por vida",
      billing_most_popular: "El más popular",
      billing_save_two_months: "Ahorra 2 meses",
      billing_per_month_yearly: "/mes facturado anualmente",
      billing_upgrade_now: "Mejorar — prorrateado hoy",
      billing_downgrade_end: "Bajar al final del período",
      billing_downgrade_title: "Antes de cambiar a Essentials",
      billing_downgrade_w1: "El sitio web se despublicará",
      billing_downgrade_w2: "Los prospectos quedan de solo lectura",
      billing_downgrade_w3: "El Gantt pasa a solo lectura",
      billing_downgrade_w4: "Las herramientas Pro de dinero se apagan (Bueno/Mejor/Óptimo, lista de precios, depósitos, recordatorios)",
      billing_downgrade_keep: "Nada se borra — todo vuelve si mejoras de nuevo.",
      billing_downgrade_confirm: "Confirmar cambio",
      billing_pending_change: "Cambio a {{plan}} el {{date}}",
      billing_cancel_change: "Cancelar cambio",
      billing_seats_line: "{{n}} usuarios incluidos · usuarios extra $10/mes cada uno",
      billing_change_failed: "No se pudo cambiar el plan",
      plan_ess_f1: "Fotos y video ilimitados, galerías para compartir",
      plan_ess_f2: "Asistente 360 (ilimitado, uso justo)",
      plan_ess_f3: "Calendario: Día/Semana/Mes + línea de tiempo simple",
      plan_ess_f4: "Tarjetas de tiempo, bitácoras, tareas",
      plan_ess_f5: "Reportes de fotos + reporte de prueba",
      plan_ess_f6: "Estimados, órdenes de cambio, facturas + firma",
      plan_pro_f1: "Todo lo de Essentials",
      plan_pro_f2: "Gantt completo: arrastrar, dependencias, avisos, plantillas",
      plan_pro_f3: "Plantillas premium + Antes y Después + tu marca",
      plan_pro_f4: "Bueno/Mejor/Óptimo, lista de precios, depósitos, recordatorios",
      plan_pro_f5: "Costos de obra: presupuesto vs real, reportes",
      plan_pro_f6: "Sitio web + Prospectos · línea de tiempo al cliente · soporte prioritario",
      billing_choose_plan: "Elige tu plan",
      v2_pr_founding: "Precio de miembro fundador: quedan {{n}} de 100 lugares",
      v2_pr_trial: "Prueba gratis de Pro por 14 días. Sin tarjeta.",
      v2_pr_compare: "Comparar todas las funciones",
      v2_pr_vs: "El plan de 3 usuarios de CompanyCam cuesta $119–149/mes y no incluye calendario. JobTread empieza en $199/mes. (Verificado oct 2026)",
      v2_cmp_feature: "Función",
      v2_cmp_users: "Usuarios incluidos",
      v2_cmp_photos: "Fotos, Asistente 360, compartir",
      v2_cmp_sched: "Calendario + línea de tiempo simple",
      v2_cmp_money: "Estimados, órdenes de cambio, facturas, firma",
      v2_cmp_gantt: "Gantt completo + plantillas",
      v2_cmp_moneypro: "B/M/Ó, lista de precios, depósitos, reportes de costos",
      v2_cmp_web: "Sitio web + Prospectos + línea de tiempo al cliente",
      v2_cmp_support: "Soporte prioritario",
      billing_days_left: "días restantes de prueba gratis",
      billing_seats_title: "Asientos del equipo",
      billing_billable_users: "Usuarios facturables activos",
      billing_included: "Usuarios incluidos",
      billing_additional: "Usuarios adicionales",
      billing_breakdown: "Desglose de costos",
      billing_base: "Plan base Complete",
      billing_extra_charges: "Cargos por usuarios adicionales",
      billing_referral_credit: "Crédito por referidos",
      billing_estimated_next: "Próxima factura estimada",
      billing_next_billing_date: "Próxima fecha de facturación",
      billing_payment_method: "Método de pago",
      billing_no_payment_method: "Sin método de pago registrado",
      billing_invoices: "Historial de facturas",
      billing_no_invoices: "Aún no hay facturas",
      billing_legacy_note: "Estás en un plan heredado con acceso completo. Confirma el nuevo plan Complete cuando quieras — verás el precio exacto antes de pagar y nunca se cobra automáticamente.",
      billing_status_trialing: "Prueba gratis",
      billing_status_active: "Activo",
      billing_status_past_due: "Pago vencido",
      billing_status_canceled: "Cancelado",
      billing_status_trial_expired: "Prueba vencida",
      billing_status_grace: "Periodo de gracia",
      billing_status_expired: "Prueba vencida",
      billing_status_legacy: "Heredado",
      billing_status_none: "Sin suscripción",
      billing_f1: "Clientes y prospectos",
      billing_f2: "Proyectos ilimitados",
      billing_f3: "Fotos de obra",
      billing_f4: "Bitácoras y tarjetas de tiempo",
      billing_f5: "Programación de cuadrillas",
      billing_f6: "Estimados y facturas",
      billing_f7: "Órdenes de cambio",
      billing_f8: "Registro de pagos",
      billing_f14: "Pagos en línea de clientes",
      billing_f9: "Portal del cliente",
      billing_f10: "Sitio web del contratista",
      billing_f11: "360 Assistant",
      billing_f12: "Inglés y español",
      billing_f13: "Tres usuarios incluidos",
      trial_banner_left_one: "{{count}} día restante de tu prueba gratis",
      trial_banner_left_other: "{{count}} días restantes de tu prueba gratis",
      trial_banner_cta: "Ver planes",
      trial_banner_grace: "Tu prueba terminó — estás en el periodo de gracia de 3 días. Elige un plan para seguir creando registros.",
      trial_banner_expired: "Tu prueba ha terminado. Tus datos están seguros — elige un plan para restaurar el acceso completo.",
      trial_banner_suspended: "El acceso de tu cuenta está suspendido. Contacta a soporte.",
      trial_request_btn: "Solicitar extensión",
      trial_request_sent: "Solicitud de extensión enviada — la revisaremos pronto.",
      trial_request_pending: "Solicitud de extensión pendiente de revisión",
      seat_confirm_title: "¿Agregar un asiento de pago?",
      seat_confirm_body: "Este usuario agregará $5/mes a tu suscripción.",
      seat_confirm_yes: "Confirmar e invitar",
      crew_deactivate: "Desactivar",
      crew_reactivate: "Reactivar",
      crew_inactive: "Inactivo",
      nav_profile_security: "Perfil y seguridad",
      nav_company_brand: "Marca de la empresa",
      prof_title: "Perfil y seguridad",
      prof_sec_info: "Información personal",
      prof_sec_photo: "Foto de perfil",
      prof_sec_security: "Acceso y seguridad",
      prof_sec_notifications: "Notificaciones",
      prof_sec_prefs: "Preferencias",
      prof_sec_about: "Acerca de",
      prof_tz_mismatch: "Tu dispositivo está en {{device}} pero la cuenta usa {{account}}.",
      prof_tz_use_device: "Usar zona del dispositivo",
      photo_preparing: "Preparando tu foto…",
      photo_preview_failed: "No pudimos mostrar esa foto.",
      photo_error_code: "Código de error: {{code}}",
      photo_retry: "Reintentar",
      photo_choose_another: "Elegir Otra Foto",
      photo_uploading: "Subiendo… {{pct}}%",
      photo_save: "Guardar Foto",
      photo_use_full: "Usar Foto Completa",
      photo_zoom_out: "Alejar",
      photo_zoom_in: "Acercar",
      photo_rotate: "Rotar",
      photo_recenter: "Recentrar",
      photo_updated: "Foto de perfil actualizada.",
      photo_public_label: "Mostrar mi foto de perfil en el sitio web público",
      photo_public_hint: "Desactivado por defecto. Tu foto solo la ve tu empresa a menos que actives esto.",
      tz_banner_company: "Tu cuenta está en {{current}}. Según la ubicación de tu empresa, {{suggested}} podría ser mejor.",
      tz_banner_note: "Cambiar la zona horaria de visualización no altera las marcas de tiempo guardadas.",
      tz_banner_change: "Cambiar a {{tz}}",
      tz_banner_choose: "Elegir otra zona horaria",
      tz_banner_keep: "Mantener {{tz}}",
      prof_first: "Nombre",
      prof_last: "Apellido",
      prof_display: "Nombre visible",
      prof_title_job: "Puesto",
      prof_phone: "Teléfono móvil",
      prof_tz: "Zona horaria",
      prof_email: "Correo electrónico",
      prof_change_email: "Cambiar correo",
      prof_new_email: "Nuevo correo electrónico",
      prof_current_password: "Contraseña actual",
      prof_send_verify: "Enviar verificación",
      prof_email_sent: "Verificación enviada — revisa tu nuevo correo. Tu correo actual sigue activo hasta verificar.",
      prof_pending_email: "Verificación pendiente para {{email}}",
      prof_email_flow_hint: "Enviaremos un enlace de verificación al nuevo correo. Tu correo actual sigue activo hasta que confirmes.",
      prof_photo_hint: "Visible para tu empresa en bitácoras, tarjetas de tiempo y la lista de cuadrilla. Privada salvo que la publiques en tu sitio web.",
      prof_upload_photo: "Subir foto",
      prof_replace_photo: "Reemplazar foto",
      prof_take_photo: "Tomar foto",
      prof_remove_photo: "Quitar foto",
      prof_remove_confirm: "¿Quitar tu foto de perfil? Se mostrarán tus iniciales.",
      prof_photo_privacy: "JPG, PNG, HEIC o WebP. Las fotos grandes se comprimen automáticamente.",
      prof_change_pw: "Cambiar contraseña",
      prof_new_password: "Nueva contraseña",
      prof_new_password2: "Repite la nueva contraseña",
      prof_pw_changed: "Contraseña cambiada — se cerraron las demás sesiones",
      prof_signout_others: "Cerrar sesión en otros dispositivos",
      prof_signed_out_others: "Se cerraron las demás sesiones",
      prof_sessions: "Sesiones activas",
      prof_revoke: "Cerrar sesión",
      prof_activity: "Actividad de inicio de sesión",
      prof_2fa_note: "La autenticación de dos factores llegará pronto.",
      prof_coming_soon: "Pronto",
      prof_pw_s0: "Muy débil",
      prof_pw_s1: "Débil",
      prof_pw_s2: "Regular",
      prof_pw_s3: "Buena",
      prof_pw_s4: "Fuerte",
      prof_date_format: "Formato de fecha",
      prof_clock: "Reloj",
      prof_clock_12: "12 horas",
      prof_clock_24: "24 horas",
      prof_landing: "Página de inicio predeterminada",
      prof_theme: "Tema",
      prof_theme_system: "Sistema",
      prof_theme_light: "Claro",
      photo_edit_title: "Editar foto",
      notif_schedule_reminders: "Recordatorios de agenda",
      notif_assigned_projects: "Notificaciones de proyectos asignados",
      notif_tasks: "Notificaciones de tareas",
      notif_estimate_approvals: "Aprobaciones de estimados",
      notif_invoice_payments: "Pagos de facturas",
      notif_morning_plan: "Recordatorios del plan matutino",
      notif_evening_update: "Recordatorios de actualización nocturna",
      notif_buildguide_confirmations: "Confirmaciones del Asistente",
      notif_email: "Notificaciones por correo",
      notif_in_app: "Notificaciones en la app",
      notif_sms: "Notificaciones por SMS",
      forgot_password: "¿Olvidaste tu contraseña?",
      forgot_hint: "Te enviaremos un enlace de un solo uso (válido 1 hora).",
      forgot_send: "Enviar enlace",
      forgot_sent: "Si ese correo existe, el enlace va en camino.",
      reset_title: "Elige una nueva contraseña",
      reset_invalid: "Este enlace es inválido o ha expirado.",
      reset_done: "¡Contraseña actualizada! Iniciando sesión…",
      reset_submit: "Guardar contraseña",
      reset_back_login: "Volver a iniciar sesión",
      verify_ok: "Correo verificado — ya puedes iniciar sesión con tu nueva dirección.",
      verify_error: "Este enlace de verificación es inválido o ha expirado.",
      verify_checking: "Verificando tu correo…",
      brand_title: "Marca de la empresa",
      brand_subtitle: "La identidad de tu empresa — usada en estimados, facturas y tu sitio web público.",
      brand_logo: "Logotipo de la empresa",
      brand_upload_logo: "Subir logotipo",
      brand_replace_logo: "Reemplazar logotipo",
      brand_remove_logo: "Quitar logotipo",
      brand_remove_confirm: "¿Quitar el logotipo de la empresa? Afecta tu sitio web y documentos.",
      brand_logo_empty: "Aún no hay logotipo — sube uno o créalo con el asistente de IA.",
      brand_prev_square: "Cuadrado",
      brand_prev_horizontal: "Horizontal",
      brand_prev_light: "Fondo claro",
      brand_prev_dark: "Fondo oscuro",
      brand_prev_favicon: "Favicon",
      brand_show_on_site: "Mostrar este logotipo en mi sitio web público",
      brand_name: "Nombre de la empresa",
      brand_tagline: "Eslogan corto",
      brand_address: "Dirección de la empresa",
      brand_areas: "Áreas de servicio (separadas por comas)",
      brand_areas_ph: "Tu ciudad, pueblos cercanos, …",
      brand_license: "Información de licencia",
      brand_insurance: "Información de seguro",
      brand_domain: "Dominio del sitio web",
      brand_primary: "Color principal",
      brand_accent: "Color de acento",
      brand_description: "Descripción de la empresa",
      brand_social_facebook: "Facebook",
      brand_social_instagram: "Instagram",
      brand_social_tiktok: "TikTok",
      brand_social_youtube: "YouTube",
      brand_ai_logo: "Asistente de logotipos IA",
      brand_ai_hint: "Responde unas preguntas y obtén tres conceptos de logotipo. Nada se guarda hasta que elijas uno.",
      brand_ai_trade: "¿Qué tipo de trabajo haces?",
      brand_ai_style: "Estilo",
      brand_ai_icon: "Ícono",
      brand_ai_colors: "Colores preferidos",
      brand_ai_generate: "Generar 3 conceptos",
      brand_ai_regenerate: "Regenerar conceptos",
      brand_ai_generating: "Generando conceptos — puede tardar un minuto…",
      brand_ai_selected: "Seleccionado",
      brand_ai_previews: "Vista previa",
      brand_ai_save: "Guardar en marca",
      brand_ai_download: "Descargar PNG",
      brand_style_modern: "Moderno",
      brand_style_rugged: "Rudo",
      brand_style_traditional: "Tradicional",
      brand_style_minimal: "Minimalista",
      brand_icon_roof: "Techo",
      brand_icon_house: "Casa",
      brand_icon_hammer: "Martillo",
      brand_icon_shield: "Escudo",
      brand_icon_building: "Edificio",
      brand_icon_initials: "Iniciales",
      web2_onboard_title: "Deja que el Asistente 360 construya tu sitio web profesional.",
      web2_onboard_build: "Construirlo por Mí",
      web2_onboard_design: "Empezar con un Diseño",
      web2_onboard_edit: "Editar Mi Sitio Actual",
      web2_builder_questions: "Solo unos detalles",
      web2_builder_work: "¿Qué tipo de trabajo quieres más?",
      web2_builder_cities: "¿Qué ciudades o condados atiendes?",
      web2_builder_diff: "¿Qué hace diferente a tu empresa?",
      web2_builder_style: "Elige tu estilo preferido",
      web2_builder_header: "Elige un diseño de encabezado",
      web2_builder_photos: "Elige las fotos de proyectos a destacar",
      web2_builder_generate: "Crear Borrador de Mi Sitio",
      web2_builder_building: "Creando el borrador de tu sitio…",
      web2_draft_ready: "Tu borrador está listo — revísalo abajo",
      web2_apply_draft: "Aplicar Borrador",
      web2_pending_draft: "Hay un borrador de IA esperando revisión",
      web2_header_hero_photo: "Héroe con Foto",
      web2_header_split: "Héroe Dividido",
      web2_header_collage: "Collage de Proyectos",
      web2_header_owner: "Dueño al Frente",
      web2_header_before_after: "Antes y Después",
      web2_style_local: "Local y Confiable",
      web2_logo_builder: "Crear o Mejorar Mi Logo",
      web2_logo_trade: "Oficio",
      web2_logo_initials: "Iniciales",
      web2_logo_colors: "Colores preferidos",
      web2_logo_generate: "Generar 4 Conceptos de Logo",
      web2_logo_pick: "Elegir este logo",
      web2_logo_note: "Los íconos son generados por IA; el nombre de tu empresa siempre es texto real. Revisa conflictos de marca antes de usar.",
      web2_stats_views: "Visitas al sitio",
      web2_stats_calls: "Clics en llamar",
      web2_stats_starts: "Formularios iniciados",
      web2_stats_submits: "Estimados enviados",
      web2_stats_conv: "Tasa de conversión",
      web2_cmd_placeholder: "Dime qué cambiar — ej. 'usa un encabezado azul oscuro elegante'",
      web2_cmd_run: "Aplicar Comando",
      web2_cmd_changes: "Qué va a cambiar",
      web2_cmd_none: "No pude traducir eso a un cambio del sitio.",
      u360_helper: "Habla una vez y actualiza todo el trabajo.",
      u360_hold_to_talk: "Mantén para hablar",
      u360_tap_to_talk: "Toca el micrófono para empezar, toca otra vez para parar.",
      u360_mic_denied: "Se negó el permiso del micrófono. Actívalo en tu navegador, o escribe tu actualización abajo.",
      u360_stt_failed: "No se pudo transcribir — tu grabación está a salvo. Reintenta o escribe.",
      u360_retry_stt: "Falló la transcripción. Tu grabación está a salvo.",
      u360_retry_stt_btn: "Reintentar transcripción",
      u360_type_instead: "O escribe tu actualización",
      u360_placeholder: "Hoy terminamos el techo. James, Mike y Carlos trabajaron ocho horas…",
      u360_continue: "Continuar",
      u360_edit_transcript: "Tu actualización — edita antes de procesar",
      u360_process: "Preparar Acciones",
      u360_processing: "Preparando tu actualización…",
      u360_stage_read: "Leyendo tu actualización…",
      u360_stage_log: "Redactando la bitácora…",
      u360_stage_sched: "Redactando el horario…",
      u360_stage_crew: "Revisando cuadrilla y horas…",
      u360_processing_hint: "Puede tardar hasta un minuto. Un momento — estamos preparando tu reporte.",
      u360_processing_title: "Procesando tu actualización…",
      u360_original_label: "Original (español):",
      u360_failed_title: "Algunas partes no se pudieron guardar.",
      u360_failed_label: "No se pudo guardar — inténtalo de nuevo",
      u360_perm_label: "Un administrador debe aprobar esta parte",
      u360_retry_failed: "Reintentar",
      setup_title: "Configura tu app",
      setup_progress: "{{done}} de {{total}} listas",
      queue_pill_waiting: "{{count}} por subir",
      queue_pill_progress: "{{done}} de {{total}} subidas",
      queue_pill_failed: "{{count}} fallaron — toca para reintentar",
      queue_pill_done: "Todas las fotos subidas ✓",
      queue_saving: "Guardando {{count}} fotos…",
      queue_save_failed: "No se pudo guardar una foto en este teléfono — mantén la app abierta e inténtalo de nuevo",
      queue_stuck_banner: "{{count}} fotos no han subido desde {{device}} — llevan {{min}} min. Abre la app en ese teléfono.",
      queue_stuck_device: "un teléfono",
      reset_device_title: "Restablecer este dispositivo",
      reset_device_hint: "Arregla una app atascada sin desinstalar: sube todo lo que pueda, guarda el resto en este teléfono, luego borra los datos locales y recarga.",
      reset_device_btn: "Restablecer este dispositivo",
      reset_device_confirm: "¿Subir y guardar las fotos, y luego borrar los datos de este dispositivo? Esto no se puede deshacer.",
      queue_attempts: "{{count}} intentos",
      queue_pill_problem: "Problema al subir — toca para reintentar",
      queue_pill_needs_job: "{{count}} foto(s) necesitan un trabajo — elige uno",
      queue_job_deleted: "{{count}} foto(s): trabajo eliminado — ¿mover a otro trabajo?",
      queue_move_job: "Mover al trabajo…",
      queue_dismiss: "Ocultar",
      prof_delete_title: "Eliminar cuenta",
      prof_delete_hint: "Esto elimina tu cuenta permanentemente y cierra sesión en todos lados. Los datos de la empresa se conservan hasta que el último dueño elimine su cuenta.",
      prof_delete_btn: "Eliminar cuenta",
      prof_delete_confirm: "Escribe tu contraseña para confirmar. Esto no se puede deshacer.",
      prof_password_ph: "Contraseña",
      reset_device_running: "Restableciendo…",
      reset_device_done: "Listo — {{uploaded}} subidas, {{saved}} guardadas en el teléfono. Recargando…",
      cam_mode_library: "Biblioteca",
      photos_uploading_now: "Subiendo ahora",
      set_orig_wifi: "Subir originales a tamaño completo solo con Wi-Fi",
      set_orig_wifi_hint: "Con datos móviles, las fotos suben al instante en tamaño menor y los originales llegan con Wi-Fi.",
      set_highres: "Fotos en alta resolución (4K)",
      set_highres_hint: "Fotos más nítidas, pero más pesadas para el teléfono. Recomendado: apagado en campo.",
      wt_banner_recording: "● RECORRIDO — grabando",
      wt_ready_done: "Recorrido listo ✓",
      photos_recovered: "Recuperamos {{count}} foto(s) de este teléfono — subiendo ahora",
      wt_recovered: "Recuperamos un recorrido — terminándolo en segundo plano",
      phone_photos_title: "Fotos en este teléfono",
      phone_photos_hint: "Aún guardadas en este dispositivo. Súbelas ahora o guárdalas en tu teléfono.",
      phone_photos_empty: "No hay nada guardado en este teléfono",
      up_upload_now: "Subir ahora",
      queue_orphaned: "Trabajo eliminado",
      build_badge_label: "Versión",
      build_update_to: "Actualizar a {{v}}",
      queue_sign_in: "Inicia sesión para subir {{count}} fotos",
      queue_st_auth: "Inicia sesión",
      queue_st_needs_project: "¿Qué trabajo?",
      queue_st_unreadable: "No se pudo leer",
      queue_st_orphaned: "Trabajo eliminado",
      up_save_all: "Guardar todo en el teléfono (zip)",
      queue_sheet_title: "Cola de subida",
      queue_retry: "Reintentar fallidas",
      queue_st_pending: "En espera",
      queue_st_uploading: "Subiendo…",
      queue_st_uploaded: "Subida",
      queue_st_failed: "Falló",
      queue_pill_health: "Se subirá cuando mejore la señal.",
      queue_dead_toast: "Una foto no se pudo subir tras varios intentos — toca para reintentar o guardarla en tu teléfono.",
      queue_save_phone: "Guardar en el teléfono",
      queue_saved_phone: "Guardada en el teléfono",
      queue_storage_full: "Almacenamiento lleno — libera espacio para guardar fotos. Las fotos ya tomadas están a salvo.",
      queue_write_failed: "No se pudo guardar la foto en este dispositivo — revisa el almacenamiento.",
      u360_rec_kept: "Grabación guardada — envíala cuando vuelvas.",
      u360_send_recording: "Enviar grabación",
      setup_step_logo: "Agrega tu logo",
      setup_step_first_job: "Crea tu primer trabajo",
      crew_phone_opt: "Teléfono (opcional — para enviar el enlace por texto)",
      crew_text_invite: "Enviar por SMS",
      crew_invite_ready: "Invitación lista para {{name}} — envíale este enlace (ahí crea su contraseña):",
      crew_invite_link_label: "Enlace de invitación de un toque",
      crew_copy_link: "Copiar enlace de invitación",
      crew_invite_sms: "Te invitaron a unirte al equipo en BuildProject360 — toca para crear tu contraseña:",
      setup_step_three_photos: "Tómale 3 fotos",
      setup_step_scheduled: "Ponlo en la agenda",
      setup_step_tried_360: "Prueba el 360",
      setup_step_crew_invited: "Invita a un miembro del equipo",
      setup_done_title: "Ya estás listo.",
      setup_done_sub: "Tu equipo verá el trabajo de mañana esta noche.",
      setup_dismiss: "Ocultar",
      setup_install_row: "Instala la app",
      setup_install_ios_1: "1. Abre esta app en Safari",
      setup_install_ios_2: "2. Toca Compartir",
      setup_install_ios_3: "3. Toca 'Añadir a pantalla de inicio'",
      setup_install_android_manual: "En Chrome: menú ⋮ → Instalar app. O usa el botón de abajo.",
      help_setup_checklist: "Lista de configuración",
      stuck_title: "¿Sigues atascado?",
      stuck_hint: "Cuéntanos qué pasó — adjuntamos la página, la versión de la app y tu último 360 automáticamente.",
      stuck_placeholder: "¿Qué intentabas hacer?",
      stuck_send: "Enviar a soporte",
      stuck_sent: "Enviado — te respondemos por correo en breve.",
      stuck_failed: "No se pudo enviar. Escribe a support@buildproject360.com",
      ap_do_it: "Hazlo por mí",
      u360_guide_toggle: "¿Qué puedo decir?",
      empty_tip_projects: "Consejo: crea tu primer trabajo con su dirección real — todo se organiza desde ahí.",
      empty_tip_photos: "Consejo: las fotos llevan fecha y trabajo — toma la primera en la obra.",
      empty_tip_schedule: "Consejo: pon un trabajo en la agenda y tu equipo lo verá esta noche.",
      empty_tip_crew: "Consejo: invita a un trabajador — recibirá un enlace seguro para crear su contraseña.",
      empty_tip_customers: "Consejo: agrega un cliente una vez; sus trabajos, estimados y facturas quedan juntos.",
      empty_tip_estimates: "Consejo: crea un estimado, envía el enlace de aprobación y conviértelo en factura al aprobarse.",
      empty_tip_costs: "Consejo: fotografía un recibo y la IA lee el proveedor, la fecha y el total.",
      empty_tip_activity: "Consejo: dicta un 360 al final del día — bitácora, horas y plan de mañana de una vez.",
      empty_tip_inbox: "Consejo: las fotos sin trabajo llegan aquí — asígnalas para que nada se pierda.",
      empty_tip_u360: "Consejo: dilo como si escribieras a tu oficina — 'Terminamos el techo, tres hombres ocho horas'.",
      admin_setup_metrics: "Configuración completada (empresas nuevas, 30 días)",
      cu_send_cta: "Envía a {{name}} el reporte de hoy ({{count}} fotos)",
      cu_send_cta_noname: "Enviar el reporte de hoy al cliente",
      cu_send_title: "Reporte de hoy",
      share_photos_menu: "Compartir fotos", share_photos_all: "Todas las fotos", share_photos_pick: "Elegir fotos",
      share_progress_update: "Enviar actualización de progreso", share_invite_portal: "Invitar al portal del cliente",
      cu_whats_next_label: "Qué sigue", cu_sched_pdf: "Incluir enlace al PDF del cronograma",
      cu_add_customer: "Agrega el teléfono o correo del cliente",
      cu_name_ph: "Nombre del cliente",
      cu_note_label: "Mensaje",
      cu_link_label: "Enlace privado (sin contraseña)",
      cu_send_text: "Enviar por SMS",
      cu_send_email: "Enviar por correo",
      cu_sent: "Reporte enviado",
      cu_missing_contact: "Agrega primero un teléfono o correo",
      cu_sent_log: "Reporte enviado a {{name}}",
      cu_viewed: "Visto por {{name}}",
      cu_via_text: "por SMS",
      cu_via_email: "por correo",
      admin_setup_detail: "{{in24}}/{{total}} en 24 h · {{done}} completadas en total",
      cs_notifs_t: "Notificaciones",
      cs_notifs_d: "Recordatorio 360 de fin de día — hora y días",
      notif_eod_title: "Recordatorio 360 de fin de día",
      notif_eod_hint: "Te avisamos al terminar la jornada para registrar el reporte del día — un toque y estás hablando.",
      notif_eod_enabled: "Enviar el recordatorio",
      notif_eod_time: "Hora de fin de jornada",
      notif_eod_days: "Días",
      notif_eod_note: "iPhone: instala la app primero (Compartir › Añadir a pantalla de inicio) — los avisos solo llegan a apps instaladas.",
      notif_eod_off: "Desactivado",
      wt_mode_photo: "Foto",
      wt_mode_walkthrough: "Recorrido",
      wt_mode_video: "Video",
      wt_video_soon: "Video del recorrido — próximamente",
      wt_hint: "Habla mientras caminas. Toca el obturador para fotos.",
      wt_keep_open: "Mantén la app abierta mientras grabas",
      wt_pause: "Pausar",
      wt_resume: "Continuar",
      wt_new_area: "Nueva área",
      wt_area_kitchen: "Cocina",
      wt_area_bath: "Baño",
      wt_area_bedroom: "Recámara",
      wt_area_living: "Sala",
      wt_area_basement: "Sótano",
      wt_area_exterior: "Exterior",
      wt_area_roof: "Techo",
      wt_area_deck: "Terraza",
      wt_area_garage: "Cochera",
      wt_area_other: "Otra…",
      wt_area_ph: "Nombre del área (ej. Cocina)",
      wt_area_add: "Marcar área",
      wt_interrupted: "Grabación en pausa — todo lo grabado está a salvo.",
      wt_limit_warn: "Quedan 2 minutos — ve cerrando",
      wt_notice: "Tu voz se graba para redactar el reporte.",
      wt_notice_ok: "Entendido",
      wt_building: "Preparando tu recorrido…",
      wt_stage_transcribing: "Transcribiendo…",
      wt_stage_sections: "Redactando secciones…",
      wt_stage_tasks: "Buscando acciones…",
      wt_summary: "Resumen",
      wt_open_items: "Pendientes",
      wt_tasks: "Lista de pendientes",
      wt_approve: "Aprobar todo",
      wt_approved: "Recorrido aprobado",
      wt_share: "Compartir enlace",
      wt_pdf: "Descargar PDF",
      wt_to_checklist: "Convertir en checklist",
      wt_transcript_show: "Ver lo que dije",
      wt_transcript_hide: "Ocultar transcripción",
      wt_failed: "No se pudo generar el recorrido",
      wt_start: "Iniciar un recorrido",
      wt_audio_label: "Audio del recorrido",
      wt_audio_keep: "Conservar tras aprobar",
      wt_audio_30: "Borrar 30 días tras aprobar",
      wt_copied: "Enlace copiado",
      wt_saved_offline: "Recorrido guardado — se generará cuando vuelva la señal",
      pd_tab_walkthroughs: "Recorridos",
      wt_ready: "Recorrido listo para revisar",
      u360_photos_note: "Agregar una nota",
      photos_select_one: "Seleccionar foto",
      wt_discard_title: "¿Detener y descartar este recorrido?",
      wt_discard_yes: "Descartar",
      wt_keep_recording: "Seguir grabando",
      wt_finish_failed: "No se pudo terminar — las fotos y el audio están a salvo en este dispositivo",
      wt_retry: "Reintentar",
      viewer_undo: "Deshacer",
      toast_photos_deleted: "{{count}} foto(s) eliminada(s)",
      toast_undone: "Restaurado",
      toast_deleted: "{{thing}} eliminado",
      qa_title: "Agregar algo", qa_add: "Agregar",
      qa_hint: "Un toque. Cae en el trabajo que elijas.",
      qa_photo: "Foto", qa_note: "Nota / bitácora", qa_task: "Tarea", qa_receipt: "Recibo",
      qa_change_order: "Orden de cambio", qa_estimate: "Estimado", qa_invoice: "Factura",
      qa_schedule: "Programar", qa_talk: "Hablar",
      qa_adding_to: "Agregando a", qa_this_job: "este trabajo", qa_choose_job: "¿Cuál trabajo?", qa_all_jobs: "Todos los trabajos…",
      qa_talk_hint: "Mantén el micrófono y dilo, ej. “Agrega una orden de cambio en el sótano de García por 2 contactos extra, $180”. Te muestro una vista previa — nada se guarda hasta que toques Guardar.",
      qa_thinking: "Entendiendo…",
      qa_note_ph: "¿Qué pasó hoy en el trabajo?",
      qa_task_ph: "¿Qué hay que hacer?",
      sel_del2_title: "¿Eliminar de verdad {{count}} fotos?",
      sel_del2_body: "Es una eliminación masiva. Puedes deshacer unos segundos, o restaurar desde la Papelera en 30 días.",
      sel_del2_yes: "Sí, eliminar {{count}} fotos",
      trash_no_project: "Sin proyecto",
      trash_by: "por",
      mv2_documents: "Documentos",
      mv2_doc_settings: "Configuración de documentos",
      mv2_design: "Diseño",
      mv2_design_classic: "Clásico",
      dvp_all: "Todas",
      dvp_progress: "Progreso",
      dvp_reorder_hint: "arrastra o usa las flechas para reordenar",
      dvp_void: "ANULADO",
      dvp_approved: "APROBADO",
      dvp_paid_stamp: "PAGADA",
      mv2_co_photos: "Condición encontrada",
      mv2_ds_preview: "Vista previa en vivo (factura de muestra)",
      mv2_ds_show_photos: "Mostrar fotos en los documentos",
      mv2_ds_photo_ts: "Mostrar fecha y hora en las fotos",
      mv2_ds_footer_note: "Nota de pie (aparece en cada documento)",
      mv2_powered: "Con tecnología de BuildProject360",
      mv2_design_modern: "Moderno",
      mv2_design_photo: "Propuesta con fotos",
      mv2_design_classic_desc: "Diseño tradicional y limpio",
      mv2_design_modern_desc: "Banda de color, nombre grande",
      mv2_design_photo_desc: "Foto de portada y cuadrícula de fotos",
      mv2_design_packages: "Paquetes",
      mv2_design_packages_desc: "Bueno / Mejor / Óptimo al frente",
      mv2_design_insurance: "Seguro",
      mv2_design_insurance_desc: "Datos del reclamo, licencia y seguro",
      mv2_design_commercial: "Comercial",
      mv2_design_commercial_desc: "Formato formal con PO y contacto de pago",
      mv2_pro_badge: "Pro",
      mv2_upgrade_title: "Mejora a Money Pro",
      mv2_upgrade_note_ph: "¿Algo que debamos saber? (opcional)",
      mv2_upgrade_request: "Solicitar mejora",
      mv2_upgrade_done: "Solicitud recibida — te contactaremos",
      mv2_claim_number: "Reclamo #",
      mv2_policy_number: "Póliza #",
      mv2_adjuster: "Ajustador",
      mv2_po_number: "PO #",
      mv2_billing_contact: "Contacto de pago",
      mv2_retainage: "Retención",
      mv2_retainage_pct: "Retención %",
      mv2_less_retainage: "Menos retención ({{pct}}%)",
      mv2_retained_held: "Retención guardada hasta completar",
      mv2_due_now: "Pagar ahora",
      mv2_budget_vs_actual: "Presupuesto vs real",
      mv2_bva_budget: "Presupuesto",
      mv2_bva_actual: "Real",
      mv2_bva_remaining: "Restante",
      mv2_pay_online: "Pagar en línea",
      mv2_pay_redirecting: "Redirigiendo al pago seguro…",
      mv2_pay_success: "Pago recibido — ¡gracias!",
      mv2_stripe_title: "Pagos en línea",
      mv2_stripe_desc: "Deja que tus clientes paguen facturas en línea con tarjeta. Modo de prueba — sin cargos reales.",
      mv2_stripe_connect: "Conectar Stripe",
      mv2_stripe_active: "Activo",
      mv2_stripe_pending: "Configuración pendiente",
      mv2_stripe_none: "No conectado",
      mv2_stripe_pending_claim: "Los pagos en línea se están configurando — te avisaremos cuando esté listo",
      mv2_default_per_type: "Diseño por tipo de documento",
      mv2_numbering: "Numeración",
      mv2_next_number: "Próximo número",
      mv2_expiration: "Vencimiento por defecto (días)",
      mv2_deposit: "Depósito por defecto %",
      mv2_payment_terms: "Condiciones de pago",
      mv2_due_receipt: "Pago contra entrega",
      mv2_net15: "Neto 15",
      mv2_net30: "Neto 30",
      mv2_late_fee: "Texto de cargos por mora (solo informativo)",
      mv2_pay_instructions: "Instrucciones de pago",
      mv2_tax_rates: "Impuestos",
      mv2_add_tax: "Agregar impuesto",
      mv2_tax_name: "Nombre (p. ej. Estatal)",
      mv2_tax_materials_only: "Impuestos solo a materiales",
      mv2_defaults_text: "Términos, garantía y exclusiones por defecto",
      mv2_warranty: "Garantía",
      mv2_exclusions: "Exclusiones",
      mv2_spanish: "Versión en español",
      mv2_brand_color: "Color de marca",
      mv2_pick_from_logo: "Tomar del logo",
      mv2_preview: "Vista previa",
      mv2_add_photos: "Agregar fotos",
      mv2_photos_selected: "{{count}} seleccionadas",
      mv2_blocks: "Bloques de contenido",
      mv2_block_cover: "Portada",
      mv2_block_intro: "Carta de presentación",
      mv2_block_photos: "Fotos",
      mv2_block_items: "Partidas",
      mv2_block_schedule: "Calendario de pagos",
      mv2_block_warranty: "Garantía",
      mv2_block_terms: "Términos y condiciones",
      mv2_block_signature: "Bloque de firma",
      mv2_block_footer: "Pie de página",
      mv2_expires_notice: "Este estimado vence el {{date}}",
      mv2_revised: "Revisado el {{date}}",
      mv2_prepared_for: "Preparado para",
      mv2_your_project: "Su proyecto",
      mv2_pricing: "Precios",
      mv2_payment_schedule: "Calendario de pagos",
      ps_title: "Calendario de pagos",
      ps_deposit: "Anticipo",
      ps_progress: "Avance",
      ps_final: "Final",
      ps_payment: "Pago",
      ps_due_signing: "a la firma",
      ps_due_midpoint: "a la mitad",
      ps_due_completion: "al terminar",
      ps_add: "Agregar fila",
      ps_label_ph: "Etiqueta (ej. Anticipo)",
      ps_sum_ok: "Suma 100% ✓",
      ps_sum_bad: "Suma {{sum}}% — debe ser 100%",
      ps_sum_error: "El calendario de pagos debe sumar 100%",
      ps_save_default: "Guardar como predeterminado de la empresa",
      ps_no_company_default: "Aún no hay predeterminado — este se guarda al guardar el presupuesto",
      mv2_default_tax_rate: "Impuesto predeterminado de la empresa",
      mv2_default_tax_hint: "Se precarga en partidas gravables de presupuestos nuevos. Déjalo en 0 si no cobras impuesto al cliente (puedes ajustarlo por partida).",
      dvp_close: "Cerrar vista previa",
      dvp_signature_line: "Firma de aprobación",
      dvp_signature_name: "Nombre",
      dvp_signature_date: "Fecha",
      mv2_signed_line: "Firmado electrónicamente por {{name}} el {{when}} · IP {{ip}} · Documento {{doc}}",
      mv2_doc_photos_empty: "Aún no hay fotos en este trabajo",
      mv2_work_completed: "Trabajo realizado",
      mv2_before: "Antes",
      mv2_after: "Después",
      mv2_no_before: "No hay fotos de Antes en este trabajo — agrégalas u omite",
      mv2_ba_toggle: "Mostrar Antes y Después en facturas",
      mv2_ba_pairs_default: "Número de pares por defecto",
      mv2_ba_datetime: "Mostrar fecha/hora de las fotos",
      mv2_condition_found: "Condición encontrada",
      mv2_similar_work: "Trabajo similar terminado",
      mv2_open_photo: "Ver en tamaño completo",
      mv2_no_logo: "Sube primero el logo de la empresa",
      fin_receipts: "Recibos",
      mv2_packages: "Paquetes (Bueno · Mejor · Óptimo)",
      mv2_add_package: "Agregar paquete",
      mv2_package_name: "Nombre del paquete",
      mv2_package_desc: "Descripción corta",
      mv2_choose_package: "Elija su paquete",
      mv2_most_popular: "Más popular",
      mv2_draw_signature: "Dibujar",
      mv2_clear: "Borrar",
      mv2_download_pdf: "Descargar PDF",
      mv2_deposit_invoice: "Crear factura de depósito",
      mv2_convert_budget: "Convertir a presupuesto",
      mv2_schedule_work: "Programar el trabajo",
      mv2_ba_empty: "Sin pares aún — agrega uno o toca Sugerir pares",
      mv2_no_suggestions: "Etiqueta fotos como Antes/Después en el trabajo para ver sugerencias — o agrega un par manualmente",
      mv2_photos_cleared: "Fotos quitadas — pertenecen al trabajo anterior",
      mv2_send_title: "Enviar estimado",
      mv2_send_msg_ph: "Mensaje corto (opcional)…",
      mv2_send_text: "Texto",
      mv2_send_email: "Correo",
      mv2_dl_signed: "Descargar copia firmada",
      mv2_tick_box: "Marca la casilla para aceptar antes de firmar",
      mv2_send_default_msg: "Hola {{name}}, aquí está tu estimado de {{company}}: {{url}}",
      mv2_pm_card: "Tarjeta · Apple/Google Pay",
      mv2_pm_ach: "Transferencia ACH",
      mv2_pay_methods_label: "Métodos de pago del cliente",
      mv2_start_template: "Empezar desde plantilla",
      mv2_tpl_applied: "Plantilla aplicada — pon tus precios",
      mv2_optional: "Opcional",
      mv2_progress_line: "Factura de progreso",
      fin_invoice: "Factura",
      fin_void: "Anular",
      fin_doc_edit: "Editar",
      fin_doc_duplicate: "Duplicar",
      fin_doc_delete: "Eliminar",
      fin_doc_restore: "Restaurar",
      fin_doc_void_reason: "Motivo (opcional)",
      fin_doc_delete_q: "¿Eliminar {{n}}? Va a la papelera de Money y se puede restaurar dentro de 30 días.",
      fin_doc_void_q: "¿Anular {{n}}? Se conserva el número, el PDF se marca ANULADO y sale de todos los totales.",
      fin_mark_approved: "Marcar aprobado (firmado en papel)",
      fin_resend: "Reenviar",
      fin_needs_attention: "Necesita atención",
      fin_timeline: "Historial",
      fin_evt_created: "Creado",
      fin_evt_sent: "Enviado",
      fin_evt_viewed: "Visto por el cliente",
      fin_evt_approved: "Aprobado",
      fin_evt_declined: "Rechazado",
      fin_evt_paid: "Pagado por completo",
      fin_evt_partial_payment: "Pago parcial",
      fin_evt_voided: "Anulado",
      fin_evt_revised: "Revisado",
      fin_evt_edited: "Editado",
      fin_evt_deleted: "Movido a la papelera",
      fin_evt_restored: "Restaurado",
      fin_evt_converted: "Convertido a proyecto",
      fin_evt_converted_invoice: "Convertido a factura {{n}}",
      fin_evt_deposit_invoice_created: "Factura de depósito creada",
      fin_already_invoiced: "Ya facturado: {{list}}. ¿Crear la próxima factura por el resto de {{amount}}?",
      fin_evt_reminder_sent: "Recordatorio enviado",
      fin_evt_reminder_expiring: "Recordatorio de vencimiento enviado",
      fin_evt_reminder_invoice_overdue: "Recordatorio de atraso enviado",
      fin_evt_reminder_invoice_due_soon: "Recordatorio de próximo vencimiento enviado",
      fin_evt_inv_reminder_pre: "Recordatorio de próximo vencimiento enviado",
      fin_evt_inv_reminder_due: "Recordatorio de vencimiento enviado",
      fin_evt_inv_reminder_7: "Recordatorio de 7 días de atraso enviado",
      fin_evt_inv_reminder_14: "Recordatorio de 14 días de atraso enviado",
      fin_filter_all: "Todos",
      fin_filter_open: "Abiertos",
      fin_back_to_money: "Dinero",
      fin_not_viewed: "Aún no visto",
      fin_viewed_n: "Visto {{n}}×",
      fin_last_viewed: "última vista",
      fin_no_filtered: "Aún no hay facturas ({{what}})",
      fin_mark_approved: "Marcar aprobado (firmado en persona)",
      fin_convert_to_invoice: "Convertir a factura",
      fin_deposit_pct: "% de depósito", fin_deposit_word: "depósito",
      mv2_online_payments: "Pagos en línea (Stripe)", mv2_online_payments_desc: "Muestra un botón Pagar en línea en las facturas del cliente. Actívalo después de conectar tu cuenta de Stripe.",
      mv2_how_to_pay: "Cómo pagar", mv2_how_to_pay_hint: "Se muestra en facturas, páginas del cliente y PDFs. Solo se listan los métodos que actives.",
      mv2_payable_to: "A nombre de", mv2_mail_to: "Enviar a", mv2_bank_name: "Banco",
      mv2_account_name: "Nombre de la cuenta", mv2_routing: "Número de ruta", mv2_account: "Número de cuenta",
      mv2_pay_handle: "Usuario / teléfono / correo", mv2_pay_note: "Nota (opcional)",
      mv2_bank_masked_hint: "Los datos bancarios se guardan de forma segura y solo se muestran completos en la factura y el PDF del cliente.",
      demo_open: "Abrir espacio de demostración", demo_banner: "Espacio de demostración — solo datos de muestra", demo_back: "Volver a mi empresa",
      demo_reset: "Restablecer datos de muestra", demo_reset_confirm: "¿Borrar y recrear los datos de muestra con las fechas de hoy?", demo_reset_done: "Datos de muestra restablecidos",
      bp_title: "Facturación por avance", bp_contract: "Contrato", bp_invoiced: "Facturado", bp_paid: "Cobrado",
      bp_remaining: "Por facturar", bp_pending_cos: "Órdenes de cambio aprobadas por facturar",
      notif_money_digest: "Resumen de dinero diario (8 AM)",
      notif_digest_test: "Envíate el resumen de hoy", notif_digest_test_sent: "Resumen enviado — revisa tu correo",
      mv2_copy_link: "Copiar enlace", mv2_copied: "Enlace copiado", mv2_text_link: "Enviar por texto",
      fin_text_doc: "Enviar por texto",
      fin_text_doc_msg: "Hola, aquí está tu {{kind}} {{number}} por {{amount}}: {{url}}",
      fin_kind_invoice: "factura", fin_kind_estimate: "estimado",
      tw_title: "Tarjetas de horas", tw_subtitle: "Horas semanales para nómina", tw_by_user: "Por empleado",
      tw_by_project: "Por proyecto", tw_employee: "Empleado", tw_in: "Entrada", tw_out: "Salida",
      tw_approved: "Aprobado", tw_pending: "Pendiente", tw_export_csv: "CSV de nómina",
      tw_edit_title: "Editar tarjeta de horas", tw_new_hours: "Horas correctas",
      tw_reason_ph: "Motivo (ej. olvidó registrar salida)",
      tw_corrected_n: "{{count}} corrección", tw_corrected_n_plural: "{{count}} correcciones",
      tw_no_lines: "Sin tarjetas de horas esta semana", tw_timecards_link: "Tarjetas de horas", tw_manual_badge: "manual",
      jp_title: "Ganancia del trabajo",
      jp_sentence: "{{done}}% terminado · {{spent}}% del presupuesto gastado · ganancia proyectada {{profit}} ({{margin}}%)",
      jp_sentence_final: "Ganancia final {{profit}} (margen {{margin}}%)",
      jp_no_budget: "Pon un presupuesto para ver la ganancia",
      jp_no_contract: "Pon el precio del contrato para ver la ganancia",
      jp_set_budget: "Poner presupuesto",
      jp_done: "{{pct}}% terminado", jp_spent: "{{pct}}% del presupuesto gastado",
      jp_status_on_track: "En orden", jp_status_watch: "Vigilar", jp_status_losing: "Perdiendo dinero", jp_status_no_budget: "Sin presupuesto",
      jp_budget_label: "Presupuesto $ (manual)", jp_pct_label: "% terminado (manual)",
      jp_rate_unit: "/h costo", jp_rate_hint: "Lo que te cuesta la hora de esta persona — se usa para la ganancia. La cuadrilla nunca lo ve.",
      fin_convert_full_hint: "Déjalo vacío (o 100) para facturar el monto total.",
      fin_create_co: "Crear orden de cambio",
      fin_co_empty_hint: "Crea una orden de cambio desde un estimado aprobado",
      fin_merge: "Combinar",
      fin_merge_into: "Combinar en…",
      fin_merged: "Combinado",
      fin_dup_possible: "Posible duplicado",
      jc_credit: "Crédito",
      jc_date_suspect: "Esta fecha parece incorrecta — confírmala", jc_check_date: "Revisar fecha",
      web2_versions_none_published: "No hay versiones anteriores — el sitio en vivo es la publicación actual",
      sched_hide_delay: "Ocultar detalle de retrasos (copia del cliente)",
      proj_merge_title: "Combinar proyecto",
      cust_merge_title: "Combinar cliente",
      merge_keep_this: "Conserva este registro y mueve todo lo del otro. El otro registro se archiva.",
      fin_void_reason: "Motivo (opcional)",
      fin_actions: "Acciones",
      fin_revise: "Revisar (nueva versión)",
      fin_create_invoice: "Crear factura",
      fin_signed_pdf: "Descargar PDF firmado",
      fin_trash: "Papelera",
      fin_trash_empty: "No hay documentos eliminados",
      fin_more: "Más",
      fin_invoice: "Factura",
      fin_change_order: "Orden de cambio",
      fin_voided_banner: "Este documento fue anulado — ya no cuenta.",
      mv2_viewed: "Visto",
      mv2_common_items: "Partidas compartidas por todos los paquetes (Común)",
      mv2_reminders: "Recordatorios automáticos",
      mv2_co_reason_customer_request: "Solicitud del cliente",
      mv2_co_reason_hidden_condition: "Condición oculta",
      mv2_co_reason_code_requirement: "Requisito de código",
      mv2_co_reason_design_change: "Cambio de diseño",
      mv2_co_reason_other: "Otro",
      mv2_co_impact: "Calendario {{days}} días",
      mv2_not_signed: "Sin firmar",
      mv2_co_payment_timing: "Momento de cobro",
      mv2_co_pay_next: "Agregar a la próxima factura",
      mv2_co_pay_now: "Facturar ahora",
      mv2_co_pay_split: "Dividir en el calendario restante",
      mv2_co_create_from_item: "Crear orden de cambio",
      mv2_pb_import_csv: "Importar CSV",
      mv2_pb_import_result: "Agregados {{created}}, actualizados {{updated}}",
      mv2_pb_starter: "Artículos base",
      mv2_pb_starter_done: "Se agregaron {{n}} artículos",
      mv2_pb_margin: "margen",
      mv2_pb_assemblies: "Conjuntos",
      mv2_asm_new: "Nuevo conjunto",
      mv2_asm_name: "Nombre del conjunto",
      mv2_asm_add: "Agregar producto",
      mv2_asm_empty: "Sin conjuntos aún",
      mv2_asm_items_label: "artículos",
      mv2_asm_missing: "Ya no está en el catálogo",
      mv2_from_assembly: "Desde conjunto",
      mv2_est_from_wt: "Crear estimado",
      mv2_est_from_wt_done: "Estimado {{n}} creado",
      mv2_trade_roofing: "Techos",
      mv2_trade_remodeling: "Remodelación",
      mv2_trade_painting: "Pintura",
      mv2_trade_concrete: "Concreto",
      mv2_co_waiting: "{{count}} orden de cambio esperando a {{name}} ({{amount}})",
      mv2_co_waiting_plural: "{{count}} órdenes de cambio esperando a {{name}} ({{amount}})",
      mv2_co_description: "Descripción",
      mv2_co_verbal: "El cliente aprobó verbalmente",
      mv2_co_verbal_note: "Quién aprobó + nota",
      mv2_co_reason_label: "Motivo",
      mv2_contract: "Contrato",
      mv2_billed_to_date: "Facturado hasta hoy",
      mv2_this_invoice: "Esta factura",
      mv2_remaining: "Restante",
      mv2_balance_due: "Saldo pendiente",
      mv2_paid_to_date: "Pagado hasta hoy",
      mv2_due: "Vence {{date}}",
      mv2_suggest_pairs: "Sugerir pares",
      mv2_add_pair: "Agregar par",
      mv2_swap_photo: "Cambiar",
      mv2_link_to_item: "Vincular a partida",
      mv2_no_link: "Sin vínculo (bloque)",
      mv2_remind_now: "Enviar recordatorio ahora",
      mv2_receipt_auto: "Enviar recibo por email automáticamente al registrar un pago",
      mv2_aging: "Antigüedad",
      mv2_aging_current: "Al corriente",
      mv2_aging_30: "1–30 días",
      mv2_aging_60: "31–60 días",
      mv2_aging_60plus: "Más de 60 días",
      mv2_win_rate: "Tasa de cierre (90 días)",
      mv2_cos_month: "Órdenes de cambio aprobadas este mes",
      mv2_progress_invoice: "Factura de avance",
      mv2_final_invoice: "Factura final",
      mv2_final_hint: "Contrato menos todo lo facturado antes",
      mv2_pct_complete: "% completado",
      mv2_fixed_amount: "Monto fijo",
      mv2_milestone: "Hito",
      mv2_no_contract: "Aún no hay contrato en este trabajo — aprueba un estimado primero",
      mv2_pairs_frozen_note: "Las fotos se congelan con la factura al enviarla",
      mv2_record_payment: "Registrar pago",
      mv2_pay_ref: "N° de cheque / referencia",
      mv2_pay_note: "Nota",
      mv2_pm_check: "Cheque",
      mv2_pm_cash: "Efectivo",
      mv2_pm_zelle: "Zelle",
      mv2_pm_venmo: "Venmo",
      mv2_pm_card: "Tarjeta",
      mv2_pm_other: "Otro",
      wt_filter_all: "Todo",
      portal_walkthroughs: "Reportes de recorrido",
      u360_pick_crew: "¿Quién trabajó? Elige {{count}} — {{hours}}h cada uno (edita abajo)",
      u360_hours_short: "hrs",
      u360_pick_crew_hint: "Las horas solo se guardan para quien elijas.",
      u360_saved_summary: "{{saved}} de {{total}} guardados",
      u360_saved_prefix: "Guardado",
      u360_sum_daily_log_one: "registro",
      u360_sum_daily_log_other: "{{count}} registros",
      u360_sum_timecards_one: "tarjeta de horas",
      u360_sum_timecards_other: "{{count}} tarjetas de horas",
      u360_sum_tasks_one: "tarea",
      u360_sum_tasks_other: "{{count}} tareas",
      u360_sum_schedule_one: "entrada de horario",
      u360_sum_schedule_other: "{{count}} entradas de horario",
      u360_sum_equipment_one: "registro de equipo",
      u360_sum_equipment_other: "{{count}} registros de equipo",
      u360_sum_receipt_one: "recibo",
      u360_sum_receipt_other: "{{count}} recibos",
      u360_sum_status_one: "actualización de estado",
      u360_sum_status_other: "actualización de estado",
      u360_sum_change_order_one: "borrador de orden de cambio",
      u360_sum_change_order_other: "{{count}} borradores de orden de cambio",
      u360_sum_customer_message_one: "mensaje al cliente",
      u360_sum_customer_message_other: "{{count}} mensajes al cliente",
      u360_sum_photos_one: "foto",
      u360_sum_photos_other: "{{count}} fotos",
      u360_skipped: "Omitido",
      u360_review_title: "Revisa Tu 360 Update",
      u360_which_project: "¿Para cuál proyecto es?",
      u360_approve: "Aprobar 360 Update",
      u360_approve_all: "Aprobar todo",
      u360_approve_blocked_crew: "Elige quién trabajó arriba, o desactiva Tarjetas de tiempo.",
      fv_share: "Compartir",
      fv_download: "Descargar",
      fv_print: "Imprimir",
      jr_pending_review: "{{hours}} h pendiente de revisión",
      jr_in_trash: "En la papelera",
      u360_picker_loading: "Cargando equipo…",
      u360_chat_saved: "Guardado: {{list}}",
      proj_archived_toast: "Proyecto archivado",
      action_undo: "Deshacer",
      close: "Cerrar",
      u360_add_worker: "Agregar trabajador",
      u360_worker_name_ph: "Nombre (sin cuenta)",
      u360_tc_skipped: "Horas omitidas — elige quién trabajó",
      cs_tz_label: "Zona horaria",
      u360_edit_transcript_btn: "Editar Transcripción",
      u360_done_title: "Tu trabajo ha sido actualizado.",
      u360_undo: "Deshacer 360 Update",
      u360_undone: "360 Update revertido.",
      u360_undo_failed: "La ventana para deshacer expiró o ya fue revertido.",
      u360_approve_failed: "No se pudo aplicar — no se guardó nada. Intenta de nuevo.",
      u360_extra_work_detected: "Esto suena a posible trabajo adicional.",
      u360_extra_work_hint: "Revisa el borrador de orden de cambio abajo — nada se envía sin tu aprobación.",
      u360_missing_info: "Faltan detalles — toca Editar antes de aprobar.",
      u360_not_provided: "No proporcionado",
      u360_time_default: "(horario predeterminado)",
      loading: "Cargando…",
      u360_sec_daily_log: "Actividad Diaria",
      u360_sec_checklist: "Lista de verificación",
      u360_sec_equipment: "Equipo",
      u360_sec_receipt: "Gasto de Recibo",
      u360_expl_equipment: "Prepara registros de horas de equipo en la pestaña Costos. Los de la cuadrilla esperan aprobación.",
      u360_expl_receipt: "Prepara un gasto en la pestaña Costos — adjunta la foto del recibo ahí para el registro.",
      u360_pick_equipment: "Elegir máquina",
      u360_sec_timecards: "Tarjetas de Tiempo",
      u360_sec_status: "Estado del Proyecto",
      u360_sec_tasks: "Tareas y Materiales",
      u360_sec_schedule: "Agenda",
      u360_sec_change_order: "Orden de Cambio (borrador)",
      u360_sec_customer_message: "Actualización al Cliente (borrador)",
      u360_sec_photos: "Fotos",
      u360_expl_daily_log: "Agrega una entrada a la Actividad Diaria del proyecto.",
      u360_expl_timecards: "Registra horas en la tarjeta de tiempo de cada trabajador.",
      u360_expl_status: "Actualiza la nota de progreso del proyecto.",
      u360_expl_tasks: "Crea tareas y recordatorios de materiales para el equipo.",
      u360_expl_schedule: "Agrega o mueve trabajo en la agenda.",
      u360_expl_change_order: "Crea una orden de cambio en BORRADOR — tú la revisas y envías.",
      u360_expl_customer_message: "Prepara un BORRADOR de mensaje al cliente — nada se envía solo.",
      u360_expl_photos: "Sugiere las mejores fotos de hoy de este proyecto.",
      u360_land_title: "Dilo una vez. Actualiza todo.",
      u360_land_sub: "Habla una actualización rápida y BuildProject360 prepara tu registro diario, horas del equipo, agenda, tareas, mensaje al cliente y orden de cambio — todo para tu revisión antes de guardar o enviar.",
      u360_land_tagline: "Menos papeleo. Menos detalles perdidos. Más tiempo construyendo.",
      u360_land_cta: "Empieza gratis por 14 días",
      u360_demo_quote: "Terminamos el techo de los Smith. Tres personas, ocho horas. Seis láminas dañadas — haz borrador de orden de cambio y programa la instalación mañana.",
      u360_demo_note: "Cada acción se prepara para tu revisión primero. Nada se guarda ni se envía hasta que apruebes.",
      ewc_title: "Detector de Trabajo Extra",
      ewc_sub: "Posible trabajo no facturado detectado en registros diarios de los últimos 14 días.",
      ewc_draft_cta: "Crear Orden de Cambio",
      ewc_drafted: "Borrador de orden de cambio creado",
      aa360_title: "Impacto 360",
      aa360_started: "Actualizaciones iniciadas",
      aa360_approved: "Actualizaciones aprobadas",
      aa360_minutes: "Minutos ahorrados (est.)",
      aa360_co: "Borradores de trabajo extra",
      byl_title: "Antes de irte de {{address}}",
      byl_all_clear: "Todo listo — no falta nada hoy.",
      byl_fix_now: "Arreglar Ahora",
      byl_finish_anyway: "Terminar de Todos Modos",
      byl_completed_photo: "Agrega una foto del trabajo terminado",
      byl_evening_update: "Termina tu actualización de la tarde",
      byl_open_tasks_today: "Tareas pendientes de hoy",
      byl_damage_documented: "Documenta el daño con una foto",
      byl_time_entry: "Falta registro de tiempo",
      byl_extra_work_submitted: "Revisa posible trabajo adicional",
      tr_title: "Mañana Listo",
      tr_ready: "Todo está listo",
      tr_issues: "{{count}} puntos necesitan atención",
      tr_issues_one: "{{count}} punto necesita atención",
      tr_review: "Revisar Problemas",
      tr_mark_ready: "Marcar Listo",
      tr_send_cards: "Enviar Crew Cards",
      tr_no_jobs: "Nada programado para mañana.",
      tr_iss_missing_address: "Falta dirección — {{project}}",
      tr_iss_no_crew: "Sin equipo asignado — {{project}}",
      tr_iss_missing_crew_card: "Falta Crew Card — {{project}}",
      tr_iss_weather: "El clima puede afectar {{project}} ({{detail}})",
      tr_iss_crew_conflict: "Conflicto de agenda — {{detail}}",
      tr_iss_open_tasks: "{{count}} tarea(s) pendientes",
      tr_iss_today_delay: "El trabajo de hoy puede retrasar {{project}}",
      cc_title: "Crew Cards",
      cc_create: "Nueva Crew Card",
      cc_recipient: "Nombre del trabajador o sub",
      cc_revoke: "Revocar",
      cc_copy: "Copiar enlace",
      cc_copied: "Enlace copiado",
      cc_empty: "Sin Crew Cards — envía una a un trabajador o sub.",
      cc_hint: "Abren una tarjeta móvil simple — sin app ni cuenta.",
      cc_scope: "Trabajo asignado",
      cc_arrival: "Hora de llegada (ej. 7:00 AM)",
      cc_pin: "PIN opcional",
      cc_perm_photos: "Puede subir fotos del trabajo",
      cc_perm_notes: "Puede agregar notas de campo",
      cc_perm_clock: "Puede registrar entrada/salida",
      cc_perm_customer: "Mostrar nombre del cliente",
      cc_ref_photos: "Fotos de referencia",
      cc_create_go: "Crear y Copiar Enlace",
      cc_revoked: "Revocada",
      web2_onboard_hint: "Responde unas preguntas y 360 Assistant creará el primer borrador — nada se publica hasta que tú lo digas.",
      web2_build: "Crear mi sitio web",
      web2_template: "Empezar con plantilla",
      web2_later: "Lo haré después",
      web2_status_draft: "Borrador",
      web2_status_published: "Publicado",
      web2_status_unpublished: "No publicado",
      web2_address: "Dirección pública del sitio",
      web2_preview: "Vista previa",
      web2_edit: "Editar sitio",
      web2_ai_improve: "Mejorar con IA",
      web2_publish: "Publicar cambios",
      web2_unpublish: "Despublicar sitio",
      web2_publish_confirm: "¿Publicar el borrador actual? Será visible en tu dirección pública de inmediato.",
      web2_unpublish_confirm: "¿Despublicar tu sitio web? Los visitantes verán una página de 'no publicado' hasta que lo publiques de nuevo.",
      web2_restore_confirm: "¿Restaurar esta versión publicada a tu borrador? Tu sitio en vivo no cambia hasta que publiques.",
      web2_leads: "Prospectos recibidos",
      web2_last_updated: "Última actualización",
      web2_views: "visitas",
      web2_versions: "Historial de versiones",
      web2_restore: "Restaurar",
      web2_no_versions: "Las versiones aparecen tras tu primera publicación.",
      web2_perf: "Rendimiento móvil: las imágenes se comprimen, cargan de forma diferida y se sirven por HTTPS.",
      web2_wizard_title: "Responde unas preguntas",
      web2_wizard_hint: "360 Assistant escribirá tu primer borrador. Tú revisas todo antes de publicar.",
      web2_q_name: "Nombre de la empresa",
      web2_q_services: "Servicios que ofreces (separados por comas)",
      web2_q_area: "Área de servicio principal",
      web2_q_phone: "Número de teléfono",
      web2_q_email: "Correo electrónico",
      web2_q_years: "Años en el negocio",
      web2_q_story: "Breve historia de la empresa",
      web2_q_style: "Estilo preferido",
      web2_q_colors: "Colores preferidos",
      web2_q_cta: "Llamado a la acción principal (ej. Quiero mi estimado gratis)",
      web2_generate: "Generar el borrador de mi sitio",
      web2_generating: "360 Assistant está escribiendo tu borrador…",
      web2_sections_hint: "Muestra, oculta, reordena y edita cada sección. Guardar almacena un borrador — Publicar lo pone en vivo.",
      web2_desktop: "Escritorio",
      web2_mobile: "Móvil",
      web2_hide: "Ocultar",
      web2_show: "Mostrar",
      web2_edit_section: "Editar",
      web2_approve_photo: "Aprobar para público",
      web2_approve_confirm: "¿Marcar esta foto como 'Aprobada para portafolio público'? Podrá mostrarse en tu sitio web público.",
      web2_approved: "Foto aprobada para exhibición pública",
      web2_pick_photos: "Tu biblioteca de fotos (aprueba fotos antes de publicarlas)",
      web2_no_approved: "Aún no hay fotos aprobadas — aprueba fotos en la sección Portafolio.",
      web2_before_after_hint: "Elige una foto de antes y una de después (solo fotos aprobadas).",
      web2_before: "Antes",
      web2_after: "Después",
      web2_ba_add: "Agregar par antes/después",
      web2_rewrite: "IA",
      web2_rw_shorter: "Más corto",
      web2_rw_professional: "Más profesional",
      web2_rw_friendlier: "Más amigable",
      web2_rw_confident: "Más seguro",
      web2_rw_translate_es: "Traducir al español",
      web2_rw_fix_grammar: "Corregir gramática",
      web2_f_headline: "Titular",
      web2_f_subtext: "Texto de apoyo",
      web2_f_cta: "Texto del botón de estimado",
      web2_f_hero_photo: "Foto principal (solo fotos aprobadas)",
      web2_f_trust: "Puntos de confianza (uno por línea)",
      web2_f_service_name: "Nombre del servicio",
      web2_f_service_desc: "Descripción del servicio",
      web2_f_service_add: "Agregar servicio",
      web2_f_why: "Por qué elegirnos (uno por línea)",
      web2_f_about: "Sobre la empresa",
      web2_f_review_perm: "El cliente dio permiso para publicar esta reseña",
      web2_f_review_add: "Agregar reseña",
      web2_f_areas: "Áreas de servicio (una por línea)",
      web2_f_show_form: "Mostrar el formulario de estimado",
      web2_f_proj_title: "Título del proyecto",
      web2_f_proj_desc: "Descripción del proyecto",
      sec_hero: "Portada",
      sec_trust_bar: "Barra de confianza",
      sec_services: "Servicios",
      sec_why: "Por qué elegirnos",
      sec_portfolio: "Galería de proyectos",
      sec_before_after: "Antes y después",
      sec_about: "Sobre la empresa",
      sec_reviews: "Reseñas",
      sec_service_areas: "Áreas de servicio",
      sec_estimate: "Solicitud de estimado",
      sec_contact: "Contacto",
      web2_style_modern: "Moderno",
      web2_style_bold: "Audaz",
      web2_style_premium: "Premium",
      web2_style_traditional: "Tradicional",
      web2_style_minimal: "Minimalista",
      payment_checking: "Confirmando tu suscripción…",
      payment_pending: "Aún procesando — vuelve en un minuto",
      payment_thanks: "¡Suscripción activa!",
      payment_success_hint: "Tu prueba de 14 días ha comenzado. No se cobrará hasta que termine.",
      payment_back: "Volver al inicio",
      payment_canceled: "Pago cancelado",
      payment_canceled_hint: "No se realizó ningún cargo. Elige un plan cuando quieras.",
      payment_try_again: "Volver a los planes",
      admin_title: "Administración",
      admin_tenants: "empresas",
      admin_tc_title: "Empresas de prueba", admin_tc_hint: "Empresas QA creadas por las pruebas ('DELETE ME' / 'QA …'). Eliminalas aquí tú mismo.",
      admin_tc_empty: "No hay empresas de prueba ahora", admin_tc_delete: "Eliminar permanentemente",
      admin_tc_users: "usuarios", admin_tc_projects: "proyectos", admin_tc_photos: "fotos",
      admin_tc_confirm_title: "¿Eliminar esta empresa de prueba?",
      admin_tc_confirm_body: "\"{{name}}\" y todos sus datos se eliminarán permanentemente. Esto no se puede deshacer.",
      admin_tc_deleted: "\"{{name}}\" eliminada",
      admin_support: "Acceso de soporte",
      admin_support_hint: "Otorga acceso de lectura por 1 hora. La facturación está oculta. Cada acción queda registrada.",
      admin_reason: "Motivo del acceso (obligatorio — aparece en el registro)",
      admin_grant: "Otorgar acceso 1h",
      admin_grant_link: "Enlace de soporte (expira en 1 hora):",
      admin_revoke: "Revocar",
      admin_active_grants: "Accesos activos",
      admin_audit: "Registro de auditoría",
      admin_backups: "Respaldos",
      admin_last_backup: "Último respaldo",
      admin_no_backups: "Sin respaldos aún — el primero corre esta noche a las 3 AM UTC",
      admin_archives: "archivos guardados (retención de 14 días)",
      nav_website: "Mi sitio",
      ann_annotate: "Anotar",
      ann_draw: "Dibujar",
      ann_arrow: "Flecha",
      ann_text: "Texto",
      ann_clear: "Borrar",
      ann_save: "Guardar anotación",
      ann_hint: "Dibuja en la foto. Toca Texto, toca la foto y escribe.",
      ann_undo: "Deshacer",
      ann_redo: "Rehacer",
      ann_saved: "Foto marcada guardada",
      ann_save_failed: "No se pudo guardar — Reintentar",
      ann_discard_title: "¿Descartar marcado?",
      ann_discard_body: "Tus marcas no se han guardado.",
      ann_keep_editing: "Seguir editando",
      ann_discard: "Descartar",
      ann_clear_confirm: "¿Borrar todas las marcas?",
      ann_marked_up: "Marcada",
      ann_original: "Original",
      ann_add: "Agregar",
      ann_offline_saved: "Guardada en este teléfono — se sube cuando vuelva internet",
      ann_uploaded: "Subida",
      ann_color: "Color",
      ann_size: "Grosor",
      ann_size_s: "P",
      ann_size_m: "M",
      ann_size_l: "G",
      ann_edit: "Editar",
      ann_delete: "Eliminar",
      ann_move: "Arrastra para mover",
      photo_voice_note: "Nota de voz",
      cam_burst: "Cámara rápida",
      cam_capture: "Capturar",
      cam_done: "Listo",
      install_title: "Instala BuildProject360",
      install_body: "Un toque desde tu pantalla de inicio — cámara, fotos y registros, incluso sin conexión.",
      install_action: "Instalar app",
      install_ios_body: "Toca el botón Compartir y luego “Añadir a pantalla de inicio” para instalar BuildProject360.",
      install_app_menu: "Instalar app",
      install_dismiss: "Ahora no",
      push_title: "Activa las notificaciones",
      push_body: "Recibe alertas al instante de nuevos clientes potenciales y comentarios de clientes.",
      push_action: "Activar",
      push_dismiss: "Ahora no",
      push_enabled: "Notificaciones activadas",
      push_failed: "No se pudieron activar las notificaciones",
      field_mode: "Modo campo",
      field_mode_on: "Modo campo ACTIVADO — alto contraste para el sol",
      field_mode_off: "Modo campo desactivado",
      cam_start_failed: "Cámara no disponible — usa Tomar foto",
      cam_captured: "capturadas",
      cam_close: "Cerrar cámara",
      cam_shutter: "Tomar foto",
      cam_switch: "Cambiar cámara",
      cam_flash: "Activar flash",
      cam_zoom: "Zoom",
      cam_permission_denied: "El acceso a la cámara está bloqueado. Permítelo en los ajustes del navegador o usa la app de cámara de tu teléfono.",
      cam_use_phone: "Usar la cámara del teléfono",
      cam_preview: "Vista previa de la foto",
      cam_retake: "Retomar",
      cam_keep: "Guardar foto",
      cam_delete: "Eliminar esta foto",
      cam_reset: "Restablecer vista",
      cam_rotate_left: "Girar a la izquierda",
      cam_rotate_right: "Girar a la derecha",
      cam_prev: "Foto anterior",
      cam_next: "Foto siguiente",
      photos_select_project: "Selecciona proyecto",
      photos_pick_first: "Elige un proyecto arriba y luego agrega fotos",
      photos_choose_library: "Elegir de la galería",
      viewer_download: "Descargar",
      viewer_edit: "Editar detalles",
      viewer_deleted: "Foto eliminada",
      viewer_delete_confirm: "Toca de nuevo para eliminar",
      viewer_restored: "Foto restaurada",
      viewer_more: "Más opciones",
      viewer_retry: "Reintentar",
      viewer_load_failed: "No se pudo cargar esta foto.",
      viewer_delete_title: "¿Eliminar esta foto?",
      viewer_delete_body: "Se mueve a la papelera del proyecto. Puedes restaurarla cuando quieras.",
      photo_progress: "Progreso",
      nav_more: "Más",
      nav_camera: "Cámara",
      nav_settings: "Ajustes",
      settings_title: "Ajustes",
      cs_brand_t: "Perfil de Empresa y Marca",
      cs_brand_d: "Nombre, logo, colores y datos de contacto en los documentos.",
      cs_crew_t: "Personal y Accesos",
      cs_crew_d: "Invita personas, define roles, asigna proyectos.",
      cs_cal_t: "Calendario de Trabajo y Horarios",
      cs_cal_d: "Días laborales, horario y días festivos.",
      cs_mod_t: "Módulos y Funciones",
      cs_mod_d: "Elige qué partes de la app ve cada rol.",
      cs_billing_t: "Facturación y Suscripción",
      cs_billing_d: "Plan, asientos y facturas.",
      cs_trash_t: "Papelera y Depuración de Datos",
      cs_trash_d: "Restaura o elimina definitivamente elementos borrados.",
      cs_members: "{{count}} miembros",
      cs_members_one: "{{count}} miembro",
      cs_members_other: "{{count}} miembros",
      cs_cal_summary: "{{days}} días/sem · {{start}}–{{end}}",
      cs_logo_ok: "Logo listo",
      cs_logo_missing: "Sin logo aún",
      cs_trash_count: "{{count}} elementos eliminados",
      cs_mod_summary: "Visibilidad por rol",
      cs_mod_hint: "El dueño siempre tiene acceso a todo.",
      cs_role_owner: "Dueño",
      cs_role_admin: "Admin",
      cs_role_crew: "Cuadrilla",
      cs_mod_daily_logs: "Registros de actividad diaria",
      cs_mod_photo_uploads: "Fotos y cámara",
      cs_mod_timeclock_gps: "Reloj de tiempo",
      cs_mod_invoicing_estimates: "Estimados y facturas",
      cs_mod_client_portal_sharing: "Compartir con el cliente",
      cs_mod_equipment_tracking: "Costos y equipo",
      settings_scheduling: "Programación",
      settings_scheduling_hint: "Días laborales, horarios y días festivos",
      cc_customer_tab: "Cliente",
      cc_tab_title: "Confianza del Cliente",
      cc_tab_hint: "Actualizaciones, decisiones, registro del proyecto y garantía — creados con las fotos y la actividad de este proyecto.",
      cc_sub_updates: "Actualizaciones",
      cc_dec_new: "Nueva decisión",
      cc_pg_title: "Guardián de promesas",
      cc_pg_add: "Añadir promesa",
      cc_pg_title_ph: "¿Qué prometiste? (p. ej. Gabinetes instalados)",
      cc_pg_due: "Fecha de vencimiento",
      cc_pg_kept: "Cumplida",
      cc_pg_snooze: "Posponer",
      cc_pg_dismiss: "Descartar",
      cc_pg_reason_ph: "Motivo (solo interno)",
      cc_pg_snoozed_until: "Pospuesta hasta {{date}}",
      cc_pg_none: "Aún no hay promesas registradas",
      cc_pg_closed: "cerradas",
      cc_pg_rule_overdue: "La fecha de vencimiento pasó y sigue abierta.",
      cc_pg_rule_due_soon: "Vence en 2 días y sigue abierta.",
      cc_pg_rule_quiet: "Sin actualizaciones al cliente en más de 7 días con una promesa abierta.",
      cc_pg_rule_decision_overdue: "Una solicitud de decisión pasó su fecha límite sin elección del cliente.",
      cc_pg_decision_warn: "Decisión vencida",
      cc_st_open: "abierta",
      cc_rec_search_ph: "Buscar en el registro…",
      cc_rec_add: "Añadir elemento",
      cc_rec_product: "Producto",
      cc_rec_material: "Selección de material",
      cc_rec_document: "Documento",
      cc_rec_title_ph: "Título (p. ej. Encimera — Cuarzo Calacatta Gold)",
      cc_rec_detail_ph: "Detalles (modelo, color, garantía…)",
      cc_rec_none: "El registro se construye solo con fotos, actualizaciones y decisiones.",
      cc_rec_no_match: "Sin resultados",
      cc_rec_photos: "{{count}} fotos",
      cc_rec_update: "Actualización al cliente",
      cc_rec_decision: "Decisión firmada",
      cc_acked_short: "Cliente confirmó",
      cc_co_checklist: "Lista de cierre",
      cc_co_final_photos: "Fotos finales tomadas",
      cc_co_final_update: "Actualización final enviada al cliente",
      cc_co_decisions_resolved: "Todas las decisiones resueltas",
      cc_co_warranty_recorded: "Información de garantía registrada",
      cc_co_walkthrough_confirmed: "Recorrido final con el cliente hecho",
      cc_co_suggested: "sugerido",
      cc_co_complete: "Completar cierre",
      cc_co_completed: "Cierre completado el {{date}}",
      cc_co_completed_toast: "Cierre completado",
      cc_co_pdf: "Descargar PDF de cierre",
      cc_co_share: "Copiar enlace del portal de garantía",
      cc_co_remaining: "Completa primero toda la lista",
      cc_w_title: "Registros de garantía",
      cc_w_add: "Añadir garantía",
      cc_w_none: "Aún no hay garantías registradas",
      cc_w_item_ph: "Elemento (p. ej. Tejas del tejado)",
      cc_w_provider_ph: "Proveedor / fabricante",
      cc_w_start: "Inicio",
      cc_w_end: "Fin",
      cc_w_contact_ph: "Contacto de servicio",
      cc_w_notes_ph: "Notas (n.º de registro, condiciones…)",
      cc_w_coverage: "Cobertura",
      cc_sr_title: "Solicitudes de servicio",
      cc_sr_none: "Sin solicitudes de servicio",
      cc_sr_anonymous: "Cliente",
      cc_sr_in_progress: "Marcar en curso",
      cc_sr_resolved: "Marcar resuelta",
      cc_w_portal_title: "Garantía y servicio",
      cc_w_completed_banner: "Cierre del proyecto completado el {{date}}",
      cc_sr_form_title: "Solicitar servicio",
      cc_sr_name_ph: "Tu nombre",
      cc_sr_contact_ph: "Teléfono o correo",
      cc_sr_desc_ph: "Describe el problema…",
      cc_sr_submit: "Enviar solicitud",
      cc_sr_thanks: "Solicitud recibida — te contactaremos.",
      cc_sr_mine: "Tus solicitudes",
      cc_st_new: "nueva",
      cc_st_in_progress: "en curso",
      cc_st_resolved: "resuelta",
      cc_ev_closeout_completed: "Cierre completado",
      cc_sub_reviews: "Reseñas",
      cc_rev_share: "Copiar enlace de solicitud de reseña",
      cc_rev_none: "Aún no hay reseñas — comparte el enlace tras el cierre.",
      cc_rev_marketing: "Cita permitida",
      cc_rev_photos: "Fotos permitidas",
      cc_rev_publish: "Aprobar para el sitio web",
      cc_rev_unpublish: "Quitar aprobación web",
      cc_rev_published: "Aprobada para web",
      cc_ref_title: "Referencias",
      cc_ref_none: "Aún no hay referencias",
      cc_rev_page_title: "¿Cómo lo hicimos?",
      cc_rev_text_ph: "Cuéntanos tu experiencia (opcional)",
      cc_rev_name_ph: "Tu nombre",
      cc_rev_marketing_opt: "Pueden citar mi reseña en su marketing",
      cc_rev_photos_opt: "Pueden compartir fotos de mi proyecto públicamente",
      cc_rev_submit: "Enviar reseña",
      cc_rev_thanks: "¡Gracias por tu reseña!",
      cc_ref_form_title: "¿Conoces a alguien que planea un proyecto?",
      cc_ref_name_ph: "Su nombre",
      cc_ref_contact_ph: "Su teléfono o correo",
      cc_ref_note_ph: "Nota (opcional)",
      cc_ref_submit: "Enviar referencia",
      cc_ref_thanks: "¡Gracias por la referencia!",
      cc_version_label: "v",
      cc_sent_meta: "Enviado a {{name}} ({{email}}) el {{date}}",
      cc_history: "Historial",
      cc_acked_by: "Confirmado por {{name}}",
      cc_archived_toast: "Archivado",
      cc_revoked_toast: "Enlace revocado",
      save: "Guardar",
      cancel: "Cancelar",
      back: "Atrás",
      edit: "Editar",
      close: "Cerrar",
      remove: "Quitar",
      confirm: "Confirmar",
      cc_announce_text: "Nuevo: Customer Confidence — envía actualizaciones con fotos, recoge decisiones firmadas y entrega un cierre profesional.",
      cc_announce_learn: "Más información",
      cc_replied_short: "Cliente respondió",
      cc_st_kept: "cumplida",
      cc_st_dismissed: "descartada",
      cc_st_snoozed: "pospuesta",
      cc_photo_note_label: "Descripción",
      cc_photos_label: "Fotos del proyecto",
      cc_dec_none: "Aún no hay solicitudes de decisión",
      cc_dec_title_label: "Decisión",
      cc_dec_title_ph: "¿Qué hay que decidir? (p. ej. Material de encimera)",
      cc_dec_desc_ph: "Contexto para el cliente (opcional)",
      cc_dec_options: "Opciones",
      cc_dec_label_ph: "Nombre de la opción",
      cc_dec_cost_ph: "Efecto en costo (p. ej. +$450)",
      cc_dec_sched_ph: "Efecto en plazo (p. ej. +2 días)",
      cc_dec_add: "Añadir opción",
      cc_dec_due: "Fecha límite (opcional)",
      cc_dec_send: "Enviar solicitud de decisión",
      cc_dec_send_confirm: "El cliente recibirá un enlace seguro para revisar las opciones y firmar su elección. ¿Enviar ahora?",
      cc_dec_choose: "Elige una opción",
      cc_dec_sign_ph: "Escribe tu nombre completo para firmar",
      cc_dec_submit: "Confirmar mi elección",
      cc_dec_thanks: "Gracias — tu elección ha sido registrada.",
      cc_dec_decided: "Decidido",
      cc_dec_your_choice: "Tu elección",
      cc_dec_cost: "Costo",
      cc_dec_schedule: "Plazo",
      cc_dec_due_by: "Fecha límite",
      cc_dec_need_two: "Añade al menos dos opciones antes de enviar",
      cc_st_decided: "decidida",
      cc_ev_decided: "El cliente decidió",
      cc_sub_decisions: "Decisiones",
      cc_sub_record: "Registro del proyecto",
      cc_sub_warranty: "Garantía",
      cc_coming_soon: "Disponible en una fase próxima",
      cc_open_settings: "Abrir ajustes de Confianza del Cliente",
      cc_settings_title: "Confianza del Cliente",
      cc_settings_hint: "Configura la experiencia de tus clientes para esta empresa.",
      cc_enable_company: "Activar Confianza del Cliente para esta empresa",
      cc_customer_name: "Nombre de la empresa para el cliente",
      cc_greeting: "Saludo predeterminado",
      cc_closing: "Cierre predeterminado",
      cc_link_days: "Vencimiento del enlace seguro",
      cc_days: "{{count}} días",
      cc_delivery_title: "Entrega",
      cc_email_enabled: "Entrega por correo",
      cc_sms_soon: "Mensajes de texto (próximamente)",
      cc_replies: "Permitir respuestas del cliente",
      cc_ack: "Solicitar confirmación del cliente",
      cc_advanced: "Ajustes avanzados",
      cc_approval_reminder: "Recordatorio de aprobación (horas)",
      cc_warranty_reminder: "Recordatorio de garantía (días antes del vencimiento)",
      cc_review_req: "Solicitudes de reseñas",
      cc_referral_req: "Solicitudes de referidos",
      cc_roles_title: "Quién puede hacer qué",
      cc_perm_create_drafts: "Crear borradores de actualización",
      cc_perm_send_updates: "Enviar actualizaciones",
      cc_perm_request_approvals: "Solicitar aprobaciones",
      cc_perm_manage_closeout: "Gestionar registros de cierre",
      cc_preview_exp: "Vista previa del cliente",
      cc_send_test: "Enviar actualización de prueba",
      cc_phase2: "Disponible después de la Fase 2",
      ac_title: "Empresas — Acceso y Facturación",
      ac_search_ph: "Buscar por nombre de empresa o correo del dueño",
      ac_search_btn: "Buscar",
      ac_empty: "Ninguna empresa coincide con la búsqueda.",
      ac_back: "Volver",
      ac_trial_start: "Inicio de prueba",
      ac_trial_end: "Fin de prueba",
      ac_sub_status: "Suscripción",
      ac_restriction: "Acceso",
      ac_full_access: "Acceso completo",
      ac_read_only: "Solo lectura (restringido)",
      ac_override_active: "Override activo",
      ac_until: "hasta",
      ac_action: "Acción",
      ac_act_extend: "Extender prueba por días",
      ac_act_set_end: "Fijar nueva fecha de fin de prueba",
      ac_act_comp: "Acceso gratuito (complimentary)",
      ac_act_discount: "Acceso con descuento",
      ac_act_training: "Designar Entrenamiento/Prueba",
      ac_act_suspend: "Suspender acceso",
      ac_act_clear: "Quitar override (restaurar reglas de cobro)",
      ac_days: "Días",
      ac_until_label: "Hasta (opcional — vacío = indefinido)",
      ac_amount: "Monto $/mes",
      ac_duration: "Duración (días)",
      ac_indefinite: "Indefinido",
      ac_reason: "Motivo",
      ac_reason_ph: "Obligatorio — se registra en el historial",
      ac_reason_required: "Se requiere un motivo para cada cambio de acceso.",
      ac_confirm_required: "Confirma este cambio importante.",
      ac_confirm_text: "Confirmo este cambio de acceso/facturación y entiendo que queda registrado.",
      ac_apply: "Aplicar cambio de acceso",
      ac_saved: "Acceso actualizado.",
      ac_history: "Historial de cambios de acceso",
      ac_req_title: "Solicitudes de extensión pendientes",
      ac_req_no_msg: "(sin mensaje)",
      ac_req_days_prompt: "¿Extender cuántos días?",
      ac_req_decline_prompt: "Motivo del rechazo:",
      ac_approve: "Aprobar",
      ac_decline: "Rechazar",
      ac_status_trial: "Prueba",
      ac_status_paid: "Pagado",
      ac_status_complimentary: "Gratuito",
      ac_status_training: "Entrenamiento/Prueba",
      ac_status_expired: "Expirado",
      ac_status_suspended: "Suspendido",
      cc_admin_title: "Confianza del Cliente",
      cc_mode: "Modo de despliegue",
      cc_mode_off: "Apagado",
      cc_mode_pilot: "Cuentas piloto",
      cc_mode_all: "Todas las cuentas",
      cc_confirm_all: "Estás a punto de activar Confianza del Cliente para todas las empresas activas de BuildProject360. Los datos existentes de las empresas no cambiarán. ¿Continuar?",
      cc_confirm_mode: "¿Cambiar el modo de despliegue? Los datos existentes de las empresas no cambiarán.",
      cc_emergency: "Desactivación de emergencia",
      cc_emergency_hint: "Bloquea todo el acceso y la actividad en segundo plano de Confianza del Cliente. Nunca elimina datos.",
      cc_confirm_emergency_on: "¿Desactivar de emergencia Confianza del Cliente para todas las empresas ahora? No se elimina ningún dato.",
      cc_confirm_emergency_off: "¿Levantar la desactivación de emergencia? Las empresas recuperan su acceso anterior.",
      cc_search_ph: "Buscar empresas",
      cc_pilot_list: "Empresas piloto",
      cc_no_pilots: "No hay empresas piloto",
      cc_enabled_by: "Activada {{date}} por {{by}}",
      cc_company_on: "Empresa: activa",
      cc_company_off: "Empresa: inactiva",
      cc_enable: "Activar",
      cc_disable: "Desactivar",
      cc_stat_companies: "Empresas participantes",
      cc_stat_active: "Empresas activas",
      cc_stat_projects: "Proyectos usándolo",
      cc_stat_created: "Actualizaciones creadas",
      cc_stat_sent: "Actualizaciones enviadas",
      cc_stat_ack: "Tasa de confirmación",
      cc_stat_failed: "Entregas fallidas",
      cc_audit: "Historial de auditoría",
      action_continue: "Continuar",
      cc_new_update: "Nueva actualización",
      cc_no_updates: "Aún no hay actualizaciones — crea la primera.",
      cc_back: "Volver",
      cc_photos_selected: "{{count}} fotos seleccionadas",
      cc_select_photos: "Fotos del proyecto",
      cc_date_from: "Desde",
      cc_date_to: "Hasta",
      cc_recipient_name: "Nombre del cliente",
      cc_recipient_email: "Correo del cliente",
      cc_note_label: "Nota para el cliente (opcional)",
      cc_draft_ai: "Redactar con IA",
      cc_ai_label: "Borrador de IA — revisa y edita cada campo antes de enviar",
      cc_ai_flags: "Revisa esta redacción con cuidado antes de enviar",
      cc_unchanged: "La actividad del proyecto no ha cambiado — se muestra el borrador existente.",
      cc_field_work_completed: "Trabajo completado",
      cc_field_progress_summary: "Resumen del avance",
      cc_field_what_next: "Qué sigue",
      cc_field_next_visit: "Próxima visita programada",
      cc_field_schedule_changes: "Cambios de horario",
      cc_field_decisions_needed: "Decisiones necesarias",
      cc_mark_ready: "Marcar listo para revisión",
      cc_approve_internal: "Aprobar internamente",
      cc_send_customer: "Enviar al cliente",
      cc_send_confirm: "¿Enviar esta actualización al cliente ahora? El enlace seguro se puede revocar después.",
      cc_sent_toast: "Actualización enviada",
      cc_copy_link: "Copiar enlace seguro",
      cc_link_copied: "Enlace seguro copiado",
      cc_revoke_link: "Revocar enlace",
      cc_archive: "Archivar",
      cc_test_sent: "Correo de prueba enviado",
      cc_events_title: "Entrega y actividad",
      cc_ev_created: "Borrador creado",
      cc_ev_draft_generated: "Borrador de IA generado",
      cc_ev_edited: "Editado",
      cc_ev_approved: "Aprobado internamente",
      cc_ev_status: "Estado cambiado",
      cc_ev_sent: "Enviado",
      cc_ev_viewed: "Visto por el cliente",
      cc_ev_acknowledged: "Confirmado por el cliente",
      cc_ev_replied: "El cliente respondió",
      cc_ev_delivery_failed: "Entrega fallida",
      cc_ev_link_created: "Enlace seguro creado",
      cc_ev_link_revoked: "Enlace revocado",
      cc_ev_archived: "Archivado",
      cc_ev_test_sent: "Prueba enviada",
      cc_st_draft: "Borrador",
      cc_st_ready: "Listo para revisión",
      cc_st_approved_internal: "Aprobado internamente",
      cc_st_sent: "Enviado",
      cc_st_viewed: "Visto",
      cc_st_acknowledged: "Confirmado",
      cc_st_replied: "Cliente respondió",
      cc_st_failed: "Entrega fallida",
      cc_st_archived: "Archivado",
      cc_sent_to: "Enviado a {{email}}",
      cc_ack_btn: "Confirmar esta actualización",
      cc_ack_name_ph: "Tu nombre (opcional)",
      cc_acked_state: "Gracias — tu confirmación fue registrada.",
      cc_reply_title: "Preguntas o comentarios",
      cc_reply_ph: "Escribe una pregunta o respuesta…",
      cc_reply_send: "Enviar respuesta",
      cc_link_gone: "Este enlace ha vencido o ya no está disponible.",
      cc_customer_photos: "Fotos del proyecto",
      cc_from_contractor: "Nota de tu contratista",
      cc_powered: "Con tecnología de BuildProject360",
      cc_decisions_cta: "Tu contratista te contactará sobre estos puntos.",
      cc_move_up: "Subir",
      cc_move_down: "Bajar",
      cc_create_first: "Crea primero una actualización en un proyecto (Proyecto → pestaña Cliente).",
      nav_billing: "Facturación",
      nav_referrals: "Refiere y gana",
      nav_account: "Cuenta",
      cam_choose_project: "Elige un proyecto",
      upload_done: "Subido",
      action_open_camera: "Abrir cámara",
      home_continue: "Continúa donde lo dejaste",
      home_today_schedule: "Agenda de hoy",
      home_overdue_tasks: "Tareas vencidas",
      sched_view_today: "Hoy",
      sched_view_day: "Día",
      sched_view_month: "Mes",
      sched_view_timeline: "Cronograma",
      sched_timeline_hint: "Cronograma (Gantt)",
      sched_all_projects: "Todos los proyectos",
      sched_all_crew: "Todo el equipo",
      sched_conflict_title: "Conflicto de horario",
      sched_conflict_body: "Ya tiene trabajo ese día: {{names}}. ¿Mover igualmente?",
      sched_move_anyway: "Mover igualmente",
      sched_view_week: "Semana",
      sched_view_crew: "Equipo",
      mb_rain_title: "Lluvia en el pronóstico",
      mb_outdoor_n: "{{n}} tarea(s) al aire libre ese día",
      mb_rain_cta: "Ver cambio",
      ny_inspection_failed: "Inspección fallida necesita un plan",
      ny_order_by: "Hora de pedir materiales",
      ny_draw_invoice: "Facturar {{label}} — {{amount}}",
      draw_sheet_title: "Crear factura de pago parcial",
      draw_sheet_job: "Trabajo",
      draw_sheet_draw: "Pago",
      draw_sheet_estimate: "Del presupuesto",
      draw_sheet_amount: "Monto",
      draw_sheet_note: "Crea la factura y luego prepara el enlace para el cliente.",
      draw_create: "Crear factura",
      draw_created: "Factura {{number}} creada",
      draw_open: "Abrir",
      draw_send_title: "Enviar al cliente",
      draw_sms_body: "{{label}} listo — factura adjunta",
      sheet_delay_applied: "Retraso aplicado",
      sheet_delay_text_hint: "Avise al cliente de inmediato.",
      sheet_delay_text_btn: "Enviar texto al cliente",
      delay_sms_body: "Aviso — {{title}} se retrasa {{days}} día(s) ({{reason}}). Nueva fecha: {{date}}.",
      fin_kickoff_text: "Texto al cliente — inicio",
      kickoff_sms_with_date: "¡Gracias por aprobar {{number}}! Empezamos el {{date}}. — {{company}}",
      kickoff_sms_no_date: "¡Gracias por aprobar {{number}}! Le confirmaremos la fecha de inicio pronto. — {{company}}",
      dep_choose_pct: "Monto del depósito",
      dep_create: "Crear factura de depósito",
      dep_custom_ph: "% personalizado",
      ny_sub_declined: "{{name}} no puede",
      ny_sub_unanswered: "{{name}} no ha confirmado",
      eod_title: "Resumen de hoy",
      eod_line: "{{done}} hechas · {{photos}} fotos · {{clock}} entradas",
      eod_slipped: "{{n}} sin terminar",
      eod_tomorrow: "Mañana primero: {{title}}",
      wr_btn: "Esta semana",
      wr_title: "Reporte semanal",
      wr_summary: "{{done}} hechas · {{delays}} retrasos",
      wr_done: "Tareas completadas",
      wr_moves: "Cambios de agenda",
      wr_photos: "Fotos",
      wr_delays: "Retrasos",
      wr_upcoming: "Agendadas próxima semana",
      wr_causes: "Retrasos por causa",
      bgv_review_answer: "Respuesta",
      bgv_review_move_task: "Mover tarea",
      bgv_review_delay_task: "Retrasar tarea",
      bgv_review_complete_task: "Completar tarea",
      bgv_review_rain_day: "Día de lluvia",
      bgv_row_change: "Cambio",
      bgv_open_schedule: "Abrir agenda",
      bgv_apply: "Aplicar",
      bgv_review_assign_task: "Asignar tarea",
      bgv_review_add_delivery: "Agregar entrega",
      bgv_row_assignee: "Asignar a",
      bgv_row_order_by: "Pedir antes del",
      jr_share_customer: "Compartir con el cliente",
      jr_share_hint: "Un enlace de solo lectura para el cliente — sin notas, dinero ni datos del equipo.",
      jr_weekly_pdf: "Reporte semanal (PDF)",
      jr_weekly_hint: "La semana pasada: tareas hechas, fotos, cambios de agenda, retrasos por causa.",
      ap_undo: "Deshacer",
      ap_undone: "Deshecho",
      jr_tab_project: "Reporte de obra",
      jr_proj_title: "Reporte de estado del proyecto (PDF)",
      jr_proj_pick: "Elige una obra",
      jr_audience_customer: "Para el cliente",
      jr_audience_internal: "Interno",
      jr_audience_hint: "La versión para el cliente oculta notas internas, dinero y datos del equipo.",
      jr_download_pdf: "Descargar PDF",
      wr_days_lost: "{{n}}d perdidos",
      vr_type_ph: "Escribe lo que pasó",
      notif_weekly_label: "Reporte semanal (correo del lunes)",
      notif_weekly_hint: "Un resumen corto de la semana pasada — tareas, fotos, retrasos por causa. Incluye enlace para cancelar.",
      cb_empty: "Nadie tiene trabajo esta semana.",
      cb_member: "Equipo",
      rain_title: "Día de lluvia",
      rain_body: "Elige el día de lluvia. Todo lo de ese día pasa al siguiente día laboral y la cadena completa lo sigue. Las tareas bloqueadas no se mueven.",
      rain_preview: "Vista previa",
      rain_preview_moves: "{{n}} elemento(s) pasarán al {{date}}.",
      rain_none: "No hay nada programado ese día.",
      rain_locked: "{{n}} tarea(s) bloqueada(s) no se moverán.",
      rain_apply: "Mover todo",
      rain_done: "{{n}} elemento(s) movidos al {{date}}",
      rec_title: "Visitas recurrentes",
      rec_title_ph: "ej. Corte semanal — Smith",
      rec_byday: "Se repite",
      rec_start: "Primer día",
      rec_until: "Hasta (opcional)",
      rec_create: "Crear visitas",
      rec_created: "{{n}} visitas creadas",
      rec_deleted: "{{n}} visitas eliminadas",
      rec_existing: "Series existentes",
      rec_count: "{{n}} visitas",
      ical_title: "Feed de calendario",
      ical_body: "Suscríbete desde Google o Apple Calendar con este enlace privado. Cualquiera con el enlace puede verlo — restablécelo si se comparte por error.",
      ical_crew_note: "Tu feed muestra solo las tareas asignadas a ti.",
      ical_reset: "Restablecer enlace",
      ical_reset_sure: "Sí, restablecer",
      ical_reset_done: "Nuevo enlace creado — el anterior dejó de funcionar.",
      ical_scope_mine: "Mis asignaciones", ical_scope_all: "Todos los trabajos (toda la empresa)",
      ical_revoke: "Desactivar este enlace", ical_revoke_done: "Enlace desactivado — ya no funciona.",
      integ_ical_feed_name: "Enlace de suscripción al calendario (ICS)",
      integ_ical_feed_body: "Enlace privado que mantiene Google, Apple u Outlook sincronizados con tu agenda.",
      integ_outlook_name: "Outlook / Microsoft 365",
      integ_outlook_body: "Sincronización bidireccional con un calendario BuildProject360 en Outlook.",
      integ_get_link: "Obtener enlace",
      sl_send_text: "Enviar por texto",
      sl_copy: "Copiar enlace",
      share_sched_opts_hint: "Elija lo que verá el cliente:",
      share_sched_show_badge: "Mostrar insignia de avance o atraso",
      share_sched_show_delays: "Mostrar lista de retrasos",
      sl_copied: "Copiado",
      sl_send_email: "Enviar",
      sl_email_ph: "Correo",
      sl_phone_ph: "Teléfono",
      sl_sent: "Enviado",
      subc_action: "Confirmar sub",
      subc_title: "Confirmaciones de subs",
      subc_none: "Primero asigna un sub (Asignar) y luego envíale un enlace de confirmación.",
      subc_get_link: "Obtener enlace",
      subc_status_pending: "Pendiente",
      subc_status_confirmed: "Confirmado",
      subc_status_declined: "Rechazado",
      subc_msg: "Hola {{name}}, ¿puedes confirmar este trabajo? {{task}} el {{date}}:",
      wn_share: "Cliente: Qué sigue",
      wn_msg: "Aquí está el calendario en vivo de {{project}} — se actualiza automáticamente:",
      pd_tab_history: "Historial",
      hist_title: "Historial del cronograma",
      hist_empty: "Aún no hay cambios en el cronograma.",
      hist_by: "por {{name}}",
      hist_undone: "deshecho",
      hist_type_move: "Movido",
      hist_type_edit: "Editado",
      hist_type_rain_day: "Día de lluvia",
      hist_type_delay: "Retraso",
      hist_type_baseline: "Línea base",
      hist_type_inspection: "Inspección",
      hist_type_inspection_fail: "Inspección fallida",
      hist_delay_line: "+{{days}}d · {{reason}}",
      sched_view_list: "Lista",
      sched_status_past: "Hecho",
      sched_status_today: "Hoy",
      sched_status_scheduled: "Programado",
      sched_nothing_today: "Nada programado para hoy",
      sched_advanced: "Vista avanzada",
      sched_add_time: "Añadir hora (opcional)",
      sched_all_day: "Todo el día",
      sched_time_not_set: "Hora no definida",
      web_progress: "Tu sitio está {{pct}}% completo",
      web_save_draft: "Guardar borrador",
      web_publish: "Publicar",
      web_unpublish: "Despublicar",
      web_view_live: "Ver sitio en vivo",
      web_copy_link: "Copiar enlace",
      web_preview: "Vista previa",
      web_slug: "Dirección del sitio",
      web_slug_ok: "Disponible",
      web_slug_taken: "Ocupado",
      web_sec_company: "Empresa",
      web_sec_about: "Nosotros",
      web_sec_services: "Servicios",
      web_sec_projects: "Proyectos",
      web_sec_reviews: "Reseñas",
      web_sec_contact: "Contacto",
      web_sec_design: "Diseño y publicar",
      web_share: "Comparte tu sitio web",
      web_share_text: "Mensaje",
      web_share_disabled: "Publica tu sitio web antes de compartir",
      web_preview_draft: "Vista previa del borrador",
      web_check_name: "Nombre de empresa",
      web_check_phone: "Teléfono",
      web_check_headline: "Titular",
      web_check_description: "Descripción",
      web_check_service_area: "Zona de servicio",
      web_check_about: "Texto de nosotros",
      web_check_services: "Servicios",
      web_check_portfolio: "Fotos de proyectos",
      web_check_why: "Por qué elegirte",
      web_check_reviews: "Reseñas",
      web_write_for_me: "Escríbelo por mí",
      pub_call: "Llamar",
      pub_text: "Mensaje",
      pub_estimate: "Solicitar estimado",
      pub_view_work: "Ver trabajos",
      pub_sent: "¡Solicitud enviada! Te contactaremos pronto.",
      pub_consent: "Acepto ser contactado sobre mi proyecto.",
      pub_name: "Nombre",
      pub_phone: "Teléfono",
      pub_email: "Correo",
      pub_address: "Dirección del proyecto",
      pub_work_type: "Tipo de trabajo",
      pub_contact_pref: "Contacto preferido",
      pub_description: "Cuéntanos de tu proyecto",
      pub_photos: "Fotos (opcional)",
      pub_services: "Servicios",
      pub_work: "Nuestros trabajos",
      pub_reviews: "Reseñas",
      pub_why: "Por qué elegirnos",
      pub_about: "Sobre nosotros",
      home_hello: "Hola, {{name}}",
      home_today: "Hoy",
      home_stats_projects: "Proyectos activos",
      home_stats_photos: "Fotos tomadas",
      home_stats_logs: "Registros diarios",
      home_recent_photos: "Fotos recientes",
      home_recent_logs: "Registros recientes",
      home_upcoming: "Próximos eventos",
      home_empty_cta: "Crea tu primer proyecto",
      project_name: "Nombre del proyecto",
      project_address: "Dirección de la obra",
      project_homeowner_name: "Nombre del cliente",
      project_homeowner_email: "Correo del cliente",
      project_status: "Estado",
      project_status_active: "Activo",
      project_status_paused: "En pausa",
      project_status_done: "Completado",
      project_empty_title: "Sin proyectos aún",
      project_empty_hint: "Cada obra empieza con un proyecto. Añade la dirección, sube una foto e invita al cliente.",
      photos_empty_title: "Sin fotos aún",
      photos_add: "Añadir fotos",
      cam_search: "Buscar proyectos",
      cam_new_project: "Proyecto nuevo",
      cam_near: "Cerca de ti",
      photos_take_first: "Tomar primera foto",
      uploading_progress: "Subiendo {{done}} de {{total}}",
      offline_queued_count: "{{count}} foto(s) esperando señal",
      photos_empty_hint: "Toca el botón naranja para añadir tu primera foto. Se guarda con este proyecto.",
      ba_empty_title: "Aún no hay pares de antes y después",
      ba_empty_body: "Etiqueta una foto como Antes y otra como Después del mismo lugar — se emparejan aquí automáticamente.",
      ba_empty_action: "Ver todas las fotos",
      photo_note: "Nota",
      photo_tag: "Etiqueta",
      log_empty_title: "Sin registros aún",
      log_empty_hint: "Toca el micrófono y habla. Nosotros lo escribimos.",
      log_hold_to_talk: "Toca para hablar",
      log_stop: "Detener",
      log_write_instead: "Escribir",
      log_speak: "Hablar",
      log_type: "Escribir",
      log_weather: "Clima",
      schedule_empty_title: "Nada agendado",
      schedule_empty_hint: "Agenda visitas, entregas y turnos.",
      schedule_add: "Añadir a la agenda",
      crew_empty_title: "Solo tú (por ahora)",
      crew_empty_hint: "Invita a tu capataz o equipo. Solo verán sus proyectos asignados.",
      portal_welcome: "Bienvenido, {{name}}",
      portal_project_of: "{{project}} por {{company}}",
      portal_progress: "Avance",
      portal_photo_timeline: "Línea de fotos",
      portal_recent_logs: "Actualizaciones recientes",
      portal_leave_comment: "Deja un mensaje para el equipo",
      portal_send: "Enviar mensaje",
      portal_your_name: "Tu nombre",
      // Clima (códigos WMO)
      wx_0: "Despejado", wx_1: "Mayormente despejado", wx_2: "Parcialmente nublado", wx_3: "Nublado",
      wx_45: "Niebla", wx_48: "Niebla helada", wx_51: "Llovizna ligera", wx_53: "Llovizna", wx_55: "Llovizna intensa",
      wx_61: "Lluvia ligera", wx_63: "Lluvia", wx_65: "Lluvia intensa", wx_66: "Lluvia helada", wx_67: "Lluvia helada",
      wx_71: "Nieve ligera", wx_73: "Nieve", wx_75: "Nieve intensa", wx_77: "Granos de nieve",
      wx_80: "Chubascos ligeros", wx_81: "Chubascos", wx_82: "Chubascos intensos",
      wx_85: "Chubascos de nieve", wx_86: "Chubascos de nieve", wx_95: "Tormenta", wx_96: "Tormenta con granizo", wx_99: "Tormenta con granizo",
      // Avisos / validación
      toast_saved: "Guardado",
      toast_moved: "Movido",
      toast_copied: "Copiado",
      toast_failed: "Algo salió mal — inténtalo de nuevo",
      toast_upload_failed: "Error al subir",
      toast_mic_unavailable: "Micrófono no disponible",
      toast_transcribe_failed: "Error al transcribir — escribe el texto",
      toast_log_saved: "Registro guardado",
      log_saving: "Guardando…",
      log_save_failed: "No se pudo guardar. Tu texto se conserva — inténtalo de nuevo.",
      task_empty_hint: "Usa el campo de arriba para agregar tu primera tarea",
      task_due_label: "Fecha límite (opcional)",
      task_priority_label: "Prioridad de la tarea",
      toast_link_generated: "Enlace generado",
      toast_lead_added: "Prospecto añadido",
      toast_assign_saved: "Asignaciones guardadas",
      toast_msg_sent: "Mensaje enviado",
      toast_account_created: "Cuenta creada",
      toast_paired: "Emparejado",
      toast_nothing_sync: "Nada para sincronizar",
      toast_invite_created: "Invitación creada",
      toast_revoked: "Revocado",
      toast_project_created: "Proyecto creado",
      toast_published: "¡Publicado!",
      toast_unpublished: "Despublicado",
      toast_draft_saved: "Borrador guardado",
      toast_welcome_back: "Bienvenido de nuevo",
      home_new_lead_1: "Nueva solicitud de estimado de tu sitio web",
      home_new_leads_n: "{{count}} nuevas solicitudes de estimado de tu sitio web",
      // Clientes + direcciones
      nav_customers: "Clientes",
      cust_new: "Nuevo cliente",
      cust_edit: "Editar cliente",
      cust_search: "Buscar nombre, empresa, teléfono, correo, dirección…",
      cust_select: "Selecciona cliente",
      cust_create_new: "Crear nuevo cliente",
      cust_add_typed: "+ Agregar “{{name}}” como cliente nuevo",
      cust_no_results: "Sin clientes encontrados",
      cust_saved: "Cliente guardado",
      cust_individual: "Persona",
      cust_company: "Empresa",
      cust_name: "Nombre del cliente",
      cust_company_name: "Nombre de la empresa",
      cust_first_name: "Nombre",
      cust_last_name: "Apellido",
      cust_display_name: "Nombre visible",
      cust_phone2: "Teléfono secundario",
      cust_address: "Dirección principal",
      cust_site_addresses: "Direcciones de obra",
      cust_add_address: "Añadir dirección",
      cust_notes: "Notas",
      cust_preferred: "Contacto preferido",
      cust_lang: "Idioma",
      cust_projects: "Proyectos",
      cust_last_activity: "Última actividad",
      cust_created: "Cliente desde",
      cust_empty_title: "Sin clientes aún",
      cust_empty_hint: "Añade tu primer cliente — propietario, administrador o empresa. Cada proyecto se conecta a un cliente.",
      cust_no_matches: "Sin resultados para \"{{q}}\"",
      cust_clear_search: "Limpiar búsqueda",
      nf_title: "Página no encontrada",
      nf_hint: "Este enlace no corresponde a ninguna página de la aplicación.",
      nf_home: "Volver al inicio",
      cust_current_projects: "Proyectos actuales",
      cust_completed_projects: "Proyectos completados",
      cust_add_project: "Añadir proyecto",
      cust_required: "Elige un cliente primero",
      cust_use_this_address: "Usar esta dirección",
      cust_diff_address: "Usar otra dirección de obra",
      cust_contact: "Contacto",
      addr_search_ph: "Escribe la dirección de la obra…",
      addr_use_my_location: "Usar mi ubicación",
      addr_loc_explain: "Tu ubicación solo se usa para encontrar la dirección de la obra. Nunca se guarda ni se comparte.",
      addr_continue: "Continuar",
      addr_confirm_q: "¿Es esta la dirección correcta del proyecto?",
      addr_use_this: "Usar esta dirección",
      addr_edit_address: "Editar dirección",
      addr_move_pin_hint: "Arrastra el pin o toca el mapa para moverlo",
      addr_recenter: "Recentrar",
      addr_open_map: "Abrir mapa",
      addr_close_map: "Cerrar mapa",
      addr_manual_hint: "Sin coincidencias — sigue escribiendo o ingresa la dirección manualmente",
      err_loc_denied: "El acceso a la ubicación está desactivado. Busca una dirección o actívalo en los ajustes de tu navegador.",
      addr_finding: "Buscando tu ubicación…",
      addr_adjust_pin: "Ajustar pin",
      addr_confirm: "Confirmar",
      nav_group_business: "Negocio",
      photos_recent: "Fotos recientes",
      photos_ba: "Antes y después",
      photos_unassigned: "Sin asignar",
      photos_archived: "Archivado",
      discard_title: "¿Descartar los cambios?",
      discard_keep: "Seguir editando",
      discard_go: "Descartar",
      draft_restore_q: "¿Restaurar tu actualización sin guardar de las {{time}}?",
      draft_restore: "Restaurar",
      pd_spent: "Gastado",
      pd_see_costs: "Ver costos",
      photo_date_unavailable: "Fecha no disponible",
      photo_issue: "Problema",
      photos_filter: "Filtro",
      sel_assign: "Asignar",
      sel_assign_title: "Asignar al proyecto",
      sel_tag: "Etiquetar",
      sel_tag_title: "Etiquetar fotos seleccionadas",
      sel_tag_ph: "Etiqueta",
      sel_share: "Compartir",
      sel_download: "Descargar",
      sel_delete: "Eliminar",
      sel_done: "Listo",
      sel_share_mixed: "Compartir funciona cuando todas las fotos están en un proyecto",
      cam_saved: "{{count}} guardadas — sigue capturando",
      cam_saved_to_one: "{{count}} foto guardada en {{project}}",
      cam_saved_to_other: "{{count}} fotos guardadas en {{project}}",
      cam_note: "Nota de voz",
      upload_retry: "Reintentar",
      photos_favorites: "Favoritas",
      photos_map_view: "Vista de mapa",
      photos_grid_view: "Vista de cuadrícula",
      photos_timeline_view: "Vista cronológica",
      photos_ba_view: "Antes y después",
      photos_projects_filter: "Proyectos",
      photos_tag_filter: "Etiqueta",
      photos_all_tags: "Todas las etiquetas",
      photos_date_from: "Desde",
      photos_date_to: "Hasta",
      photos_group_select: "Seleccionar este día",
      photos_sel_all_filtered: "Seleccionar todas las visibles",
      photos_create_ba: "Crear Antes y Después",
      photos_ba_created: "Par de antes y después creado",
      photos_ba_pick_two: "Selecciona exactamente 2 fotos",
      np_more_options: "Más opciones",
      np_contract_value: "Valor del contrato $", np_start_date: "Fecha de inicio", np_end_date: "Fecha de fin",
      np_assigned_crew: "Equipo asignado",
      np_recenter: "Recentrar",
      np_satellite: "Satélite",
      np_map_std: "Mapa",
      np_adjust_pin: "Ajustar marcador del sitio",
      np_pin_done: "Listo",
      pd_map_expand: "Ampliar mapa",
      pd_map_adjust_hint: "Arrastra el marcador para ajustar la ubicación del sitio",
      pd_map_save_pin: "Guardar ubicación del marcador",
      pd_pin_saved: "Ubicación del sitio actualizada",
      photos_photographer: "Fotógrafo",
      photos_date: "Fecha",
      photos_upload_btn: "Subir fotos",
      photos_no_gps: "No hay fotos con ubicación GPS en esta vista.",
      err_loc_unavailable: "Ubicación no disponible — inténtalo de nuevo o escribe la dirección",
      err_addr_not_found: "Dirección no encontrada — escríbela manualmente",
      gmap_manual_title: "Ingresa la dirección manualmente",
      gmap_f_street: "Calle y número",
      gmap_f_unit: "Unidad / Suite (opcional)",
      gmap_f_city: "Ciudad",
      gmap_f_state: "Estado",
      gmap_f_zip: "Código postal",
      gmap_locate: "Ubicar en el mapa",
      gmap_locating: "Ubicando…",
      gmap_locate_coarse: "Google encontró la zona pero no la dirección exacta — arrastra el marcador al sitio exacto.",
      gmap_locate_fail: "Google no pudo confirmar la ubicación en el mapa para esta dirección. Aún puedes guardarla.",
      gmap_relocate_hint: "Dirección editada — toca «Ubicar en el mapa» para actualizar el marcador.",
      gmap_unlocated_note: "Ubicación no confirmada en el mapa",
      gmap_manual_lat: "Latitud (opcional)",
      gmap_manual_lng: "Longitud (opcional)",
      gmap_placeholder: "Empieza a escribir la dirección del trabajo…",
      gmap_no_results: "No se encontraron direcciones",
      gmap_error_retry: "Error al buscar la dirección — revisa tu conexión e inténtalo de nuevo",
      gmap_fallback_note: "Google Maps no está disponible aquí — aún puedes ingresar la dirección manualmente.",
      gmap_manual_toggle: "¿No la encuentras? Ingrésala manualmente",
      gmap_retry_google: "Intentar con la búsqueda de Google de nuevo",
      gmap_drag_hint: "Arrastra el marcador al edificio o sitio exacto",
      gmap_adjusted_title: "Ubicación ajustada",
      gmap_adjusting: "Buscando dirección…",
      gmap_loading: "Cargando mapa…",
      gmap_load_failed: "No se pudo cargar el mapa. Abre esta dirección en Google Maps o inténtalo de nuevo.",
      gmap_retry_map: "Reintentar mapa",
      gmap_open_google: "Abrir en Google Maps",
      gmap_copy_address: "Copiar dirección",
      gmap_copied: "Dirección copiada",
      gmap_try_search: "Intentar la búsqueda de direcciones de nuevo",
      gmap_continue_manual: "Continuar con la dirección manual",
      gmap_fail_reason: "Código de diagnóstico",
      np_name_hint: "Ingresa la dirección del trabajo para continuar",
      np_use_my_location: "Usar mi ubicación",
      home_copy_suffix: "copia",
      home_duplicate_last: "Duplicar último proyecto",
      app_offline_banner: "Sin conexión — los cambios y fotos se sincronizarán cuando vuelvas a estar en línea",
      np_create_project: "Crear proyecto",
      gmap_cant_place: "No pudimos ubicar esta dirección en el mapa. Revisa la dirección o continúa sin una ubicación confirmada en el mapa.",
      gmap_try_again: "Intentar de nuevo",
      gmap_edit_address: "Editar dirección",
      gmap_create_unconfirmed: "Crear sin ubicación confirmada",
      gmap_use_adjusted: "Usar la dirección ajustada",
      gmap_keep_mailing: "Mantener la dirección postal, usar las coordenadas ajustadas",
      gmap_no_addr_at_point: "No se encontró dirección en este punto — se usarán las coordenadas",
      gmap_selected: "Dirección seleccionada",
      gmap_change: "Cambiar",
      gmap_powered: "Con tecnología de Google",
      err_offline: "Sin conexión — escribe la dirección manualmente",
      np_step_basics: "Proyecto y cliente",
      np_step_location: "Ubicación y horario",
      np_next: "Siguiente",
      np_back: "Atrás",
      np_name_required: "Escribe el nombre del proyecto",
    },
  },
};

const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

i18n.use(initReactI18next).init({
  resources,
  lng: saved || "en",
  fallbackLng: "en",
  compatibilityJSON: "v4",
  interpolation: { escapeValue: false },
});

export const changeLang = (lng) => {
  i18n.changeLanguage(lng);
  try { localStorage.setItem(STORAGE_KEY, lng); } catch (e) { /* ignore */ }
};

export default i18n;
